webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(58);



var crudAPI = {
  dfsResourceAll: function dfsResourceAll(resource) {
    var url = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.config.api_host + '/api/' + resource;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.axios.get(url).then(function (response) {
        resolve(response.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  },
  dfsResourceIndex: function dfsResourceIndex(resource) {
    var url = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.config.api_host + '/api/' + resource;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.axios.get(url).then(function (response) {
        resolve(response.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  },
  dfsResourceShow: function dfsResourceShow(resource, itemId) {
    var url = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.config.api_host + '/api/' + resource + '/' + itemId;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.axios.get(url).then(function (response) {
        resolve(response.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  },
  dfsResourceStore: function dfsResourceStore(resource, payload) {
    var url = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.config.api_host + '/api/' + resource;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.axios.post(url, payload).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  dfsResourceDestroy: function dfsResourceDestroy(resource, itemId) {
    var url = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.config.api_host + '/api/' + resource + '/' + itemId;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.axios.delete(url).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  dfsResourceUpdate: function dfsResourceUpdate(resource, itemId, payload) {
    var additionalApiPath = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    var url = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.config.api_host + '/api/' + resource + '/' + itemId + additionalApiPath;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.axios.put(url, payload).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (crudAPI);

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_consts__ = __webpack_require__(90);


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    inventoryTypeID: function inventoryTypeID() {
      return __WEBPACK_IMPORTED_MODULE_0__config_consts__["a" /* default */].schedules.INVENTORY_TYPE_ID;
    },
    serviceTypeID: function serviceTypeID() {
      return __WEBPACK_IMPORTED_MODULE_0__config_consts__["a" /* default */].schedules.SERVICE_TYPE_ID;
    },
    caseManagerTypeID: function caseManagerTypeID() {
      return __WEBPACK_IMPORTED_MODULE_0__config_consts__["a" /* default */].schedules.CASEMANAGER_TYPE_ID;
    }
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(58);




var casesAPI = {
  // specific cases api
  resource: 'cases',
  url_query: '/api/cases',

  loadCase: function loadCase(id) {
    var _this = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var cases = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceShow(_this.resource, id);

      cases.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  sendQuotationMailToClient: function sendQuotationMailToClient(caseId) {
    var _this2 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var data = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceStore(_this2.resource + '/' + caseId + '/client/quotation/email', {});

      data.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  markInvoiceAsPaid: function markInvoiceAsPaid(caseId) {
    var _this3 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var data = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceStore(_this3.resource + '/' + caseId + '/invoice/mark-paid', {});

      data.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  attachServicesPlanCasketToCase: function attachServicesPlanCasketToCase(caseId, selectedProducts) {
    var discount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var selectedPlan = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var tagAndRemarks = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var wakeDateStart = arguments[5];

    var _this4 = this;

    var wakeDateEnd = arguments[6];
    var remarks = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;

    var promises = [];

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var selectedServicesIds = selectedProducts.filter(function (item) {
        return item;
      }).map(function (mapping) {
        return {
          service_id: mapping.id,
          amount: mapping.amount
        };
      });

      var payload = {
        plans_id: selectedPlan.id,
        embalmers_remarks: tagAndRemarks,
        wake_start: wakeDateStart,
        wake_end: wakeDateEnd,
        services: selectedServicesIds,
        discount: discount,
        remarks: remarks
      };

      _this4.updateCase(caseId, payload).then(function () {
        resolve(promises);
      }, function (error) {
        reject(error);
      });
    });
  },
  attachVendorServicesToCase: function attachVendorServicesToCase(caseId, selectedProducts) {
    var _this5 = this;

    var promises = [];

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var selectedServicesIds = selectedProducts.map(function (mapping) {
        return {
          service_id: mapping.id,
          amount: mapping.amount
        };
      });

      _this5.updateCase(caseId, {
        services: selectedServicesIds
      }).then(function () {
        resolve(promises);
      }, function (error) {
        reject(error);
      });
    });
  },
  attachUserToCase: function attachUserToCase(caseId, userId) {
    var _this6 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      var payload = {
        users_id: userId
      };

      __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceUpdate(_this6.resource, caseId, payload).then(function (result) {
        resolve(result);
      });
    });
  },
  uploadPhotoForEmbalmers: function uploadPhotoForEmbalmers(caseId, data) {
    var url = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_host + '/api/cases/' + caseId + '/embalmers-photo';

    var config = {
      headers: {
        'Content-type': 'multipart/form-data'
      }
    };

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.axios.post(url, data, config).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  attachChatToCase: function attachChatToCase(caseId, chatId) {
    var _this7 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var payload = {
        chats_id: chatId
      };

      __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceUpdate(_this7.resource, caseId, payload).then(function (result) {
        resolve(result);
      });
    });
  },
  attachDefaultChecklistToCase: function attachDefaultChecklistToCase(caseId, serviceId) {
    var _this8 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var payload = {
        services_id: serviceId
      };

      __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceStore(_this8.resource + '/' + caseId + '/checklist', payload).then(function (result) {
        resolve(result);
      });
    });
  },
  attachPlanToCase: function attachPlanToCase(caseId, planId) {
    var _this9 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var payload = {
        plans_id: planId
      };

      __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceUpdate(_this9.resource, caseId, payload).then(function (result) {
        resolve(result);
      });
    });
  },
  attachClientToCase: function attachClientToCase(caseId, clientId) {
    var _this10 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var payload = {
        clients_id: clientId
      };

      __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceUpdate(_this10.resource, caseId, payload).then(function (result) {
        resolve(result);
      });
    });
  },
  attachInventoriesToCase: function attachInventoriesToCase(caseId, inventories) {
    var _this11 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var payload = {
        inventories: inventories
      };

      __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceUpdate(_this11.resource, caseId, payload).then(function (result) {
        resolve(result);
      });
    });
  },
  attachServicesToCase: function attachServicesToCase(caseId, services, discount) {
    var _this12 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var payload = {
        services: services,
        discount: discount
      };

      __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceUpdate(_this12.resource, caseId, payload).then(function (result) {
        resolve(result);
      });
    });
  },
  getLinkedInvoices: function getLinkedInvoices(caseId) {
    var url = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_host + this.url_query + '/' + caseId + '/invoices';

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.axios.get(url).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  getQuotationTotalPrice: function getQuotationTotalPrice(caseId) {
    var url = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_host + this.url_query + '/' + caseId + '/quotation';

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.axios.get(url).then(function (response) {
        resolve(response.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  },
  getLinkedAnswers: function getLinkedAnswers(caseId) {
    var url = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_host + this.url_query + '/' + caseId + '/answers';

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.axios.get(url).then(function (response) {
        resolve(response.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  },
  getLinkedChat: function getLinkedChat(caseId) {
    var url = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_host + this.url_query + '/' + caseId + '/chat';

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.axios.get(url).then(function (response) {
        resolve(response !== undefined ? response.data.additional_data[0] : reject());
      }, function (error) {
        reject(error);
      });
    });
  },
  loadPDF: function loadPDF(answersId) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var pdf = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceShow('pdf', answersId);

      pdf.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  loadPDFFeedback: function loadPDFFeedback(answersId) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var pdf = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceShow('pdf/feedback', answersId);

      pdf.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  loadPDFAgreement: function loadPDFAgreement(answersId) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var pdf = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceShow('pdf/agreement', answersId);

      pdf.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  loadCases: function loadCases() {
    var _this13 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var cases = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex(_this13.resource);

      cases.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  loadCasesWithEmbalming: function loadCasesWithEmbalming() {
    var _this14 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var cases = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex(_this14.resource + '/embalming');

      cases.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  loadLogForCase: function loadLogForCase(itemId) {
    var url = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_host + this.url_query + '/' + itemId + '/actions';

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.axios.get(url).then(function (response) {
        resolve(response.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  },
  loadCaseManager: function loadCaseManager(itemId) {
    var url = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_host + this.url_query + '/' + itemId + '/casemanager';

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.axios.get(url).then(function (response) {
        resolve(response.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  },
  updateCaseManager: function updateCaseManager(caseId, managerId) {
    var url = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_host + this.url_query + '/' + caseId + '/casemanager/' + managerId;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.axios.post(url).then(function (response) {
        resolve(response.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  },
  changeCaseManagerCommissions: function changeCaseManagerCommissions(caseId, payload) {
    var url = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_host + this.url_query + '/' + caseId + '/casemanager-commissions';

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.axios.post(url, payload).then(function (response) {
        resolve(response.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  },
  closeCase: function closeCase(itemId) {
    var _this15 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var payload = {
        status: 'closed'
      };

      var cases = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceUpdate(_this15.resource, itemId, payload);

      cases.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  approveCase: function approveCase(itemId) {
    var _this16 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var payload = {
        status: 'approved'
      };

      var cases = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceUpdate(_this16.resource, itemId, payload);

      cases.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  loadActiveCases: function loadActiveCases() {
    var _this17 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var cases = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex(_this17.resource);

      cases.then(function (result) {
        result.forEach(function (item, i) {
          item.text = item.id;
          item.value = item.id;
        });

        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  getLinkedServices: function getLinkedServices(itemId) {
    var url = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_host + this.url_query + '/' + itemId + '/services';

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.axios.get(url).then(function (response) {
        resolve(response.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  },
  getLinkedVendors: function getLinkedVendors(itemId) {
    var url = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_host + this.url_query + '/' + itemId + '/vendors';

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.axios.get(url).then(function (response) {
        resolve(response.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  },
  getVendorProducts: function getVendorProducts(itemId, userId) {
    var url = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_host + this.url_query + '/' + itemId + '/vendors/' + userId + '/products';

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.axios.get(url).then(function (response) {
        resolve(response.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  },
  getLinkedInventories: function getLinkedInventories(itemId) {
    var url = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_host + this.url_query + '/' + itemId + '/inventories';

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.axios.get(url).then(function (response) {
        resolve(response.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  },
  getCaseItems: function getCaseItems(caseId) {
    var _this18 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var items = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex(_this18.resource + '/' + caseId + '/items');

      items.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  getLead: function getLead(caseId) {
    var _this19 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var items = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex(_this19.resource + '/' + caseId + '/lead');

      items.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  saveCase: function saveCase(_ref) {
    var _this20 = this;

    var name = _ref.name;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var payload = {
        name: name
      };

      var schedules = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceStore(_this20.resource + '/withid', payload);

      schedules.then(function (result) {
        resolve(result.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  },
  updateCase: function updateCase(caseId, payload) {
    var _this21 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var caseUpdate = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceUpdate(_this21.resource, caseId, payload);

      caseUpdate.then(function (result) {
        resolve(result);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (casesAPI);

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(972),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_resources_crud__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loadingInProgress: true,
      loadingItemsText: 'Loading items...',
      items: []
    };
  },

  watch: {
    items: function items(newItems) {
      this.loadingInProgress = false;
      if (newItems.length === 0) {
        this.loadingItemsText = 'No items';
      }
    }
  },
  methods: {
    loadListing: function loadListing() {
      var result = __WEBPACK_IMPORTED_MODULE_0__api_resources_crud__["a" /* default */].dfsResourceIndex(this.resources);

      this.items = [];

      result.then(this.loadListingSuccess, this.loadListingError);
    },
    loadListingSuccess: function loadListingSuccess(result) {
      this.items = result;
    },
    loadListingError: function loadListingError(error) {
      this.items = [];

      var handle = error; // eslint-disable-line

      this.setNoItemsLoaded();
    },
    deleteElement: function deleteElement(itemId) {
      var result = __WEBPACK_IMPORTED_MODULE_0__api_resources_crud__["a" /* default */].dfsResourceDestroy(this.resources, itemId);

      result.then(this.deleteElementSuccess, this.deleteElementError);
    },
    deleteElementSuccess: function deleteElementSuccess(result) {
      this.$bus.$emit('resource-deleted');
    },
    deleteElementError: function deleteElementError(error) {
      var handle = error; // eslint-disable-line
    },
    editElement: function editElement(itemId) {
      this.$store.dispatch('setEditItemId', itemId);
    },
    setNoItemsLoaded: function setNoItemsLoaded() {
      this.loadingInProgress = false;
      this.loadingItemsText = 'No items';
    }
  },
  mounted: function mounted() {
    this.$bus.$emit('component-loaded');
  },
  created: function created() {
    var _this = this;

    this.$bus.$on(['resource-added', 'resource-deleted', 'resource-updated', 'component-loaded'], function () {
      _this.$store.dispatch('setEditItemId', 0);

      _this.loadListing();
    });

    this.$bus.$on('dialog-closed', function () {
      _this.$store.dispatch('setEditItemId', 0);
    });
  }
});

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__ = __webpack_require__(9);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dialogResult: false,
      itemLoaded: false,
      itemData: {},
      resource: ''
    };
  },

  computed: {
    itemId: function itemId() {
      return this.$store.getters.editItemId;
    }
  },
  watch: {
    itemId: function itemId(newVal) {
      this.changedItemIdAction(newVal);
    }
  },
  methods: {
    changedItemIdAction: function changedItemIdAction(itemId) {
      var _this = this;

      if (itemId > 0) {
        this.loadItemData(itemId).then(function () {
          _this.itemLoaded = true;
        }, function () {});

        this.dialogResult = true;
      }
    },
    loadItemData: function loadItemData(itemId) {
      var _this2 = this;

      var result = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceShow(this.resource, itemId);

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        result.then(function (result) {
          _this2.itemData = result;

          if (_this2.itemData.password) {
            _this2.itemData.password = '';
          }

          resolve(_this2.itemData);
        }, function (error) {
          reject(error);
        });
      });
    },
    editItemData: function editItemData() {
      var _this3 = this;

      var customItemId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var id = customItemId > 0 ? customItemId : this.itemId;

      var result = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceUpdate(this.resource, id, this.itemData);

      result.then(function (result) {
        _this3.$bus.$emit('resource-updated');

        _this3.dialogResult = false;

        _this3.afterEditCallback();
      }, function () {});
    },
    dialogClose: function dialogClose() {
      this.dialogResult = false;

      this.itemLoaded = false;

      this.$bus.$emit('dialog-closed');
    },
    setEditItemIdZero: function setEditItemIdZero() {
      this.$store.dispatch('setEditItemId', 0);
    },
    afterEditCallback: function afterEditCallback() {}
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(519),
  /* template */
  __webpack_require__(1022),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





var userAPI = {
  // combine two legacy vars to one
  resource: 'users',
  url_query: '/api/users',

  auth: function auth(credentials) {
    var url = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_host + __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_oauth_url_token;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.axios.post(url, {
        username: credentials.userLogin,
        password: credentials.userPassword,
        client_id: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_oauth_client_id,
        client_secret: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_oauth_client_secret,
        grant_type: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_oauth_grant_type,
        scope: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_oauth_default_scope
      }).then(function (response) {
        if (!response || !response.data) reject();
        resolve(response.data);
      }, function (error) {
        reject(error);
      });
    });
  },
  loadUsers: function loadUsers() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var users = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex('users');

      users.then(function (result) {
        result.forEach(function (item, i) {
          item.text = item.name;
          item.value = item.id;
        });

        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  getStats: function getStats() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.axios.get(__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_host + '/api/user/stats').then(function (response) {
        resolve(response.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  },
  loadCaseManagers: function loadCaseManagers() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var users = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex('users/casemanagers');

      users.then(function (result) {
        result.forEach(function (item, i) {
          item.text = item.name;
          item.value = item.id;
        });

        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  loadUser: function loadUser(userId) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var user = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceShow('users', userId);

      user.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  loadVendors: function loadVendors() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var users = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex('users/vendors');

      users.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  getLinkedRoles: function getLinkedRoles(itemId) {
    var url = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_host + this.url_query + '/' + itemId + '/roles';

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.axios.get(url).then(function (response) {
        resolve(response.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  },
  getLinkedInventories: function getLinkedInventories(itemId) {
    var url = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_host + this.url_query + '/' + itemId + '/inventories';

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.axios.get(url).then(function (response) {
        resolve(response.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  },
  getLinkedServices: function getLinkedServices(itemId) {
    var url = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_host + this.url_query + '/' + itemId + '/services';

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.axios.get(url).then(function (response) {
        resolve(response.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  },
  getLinkedProducts: function getLinkedProducts(itemId) {
    var url = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_host + this.url_query + '/' + itemId + '/products';

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.axios.get(url).then(function (response) {
        resolve(response.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  },
  getCaseManagersLinkedCasesAndProducts: function getCaseManagersLinkedCasesAndProducts(itemId) {
    var url = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_host + this.url_query + '/' + itemId + '/casemanager/cases/products';
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.axios.get(url).then(function (response) {
        resolve(response.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  },
  getCurrentUser: function getCurrentUser() {
    var url = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_host + this.url_query + '/current';

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.axios.get(url).then(function (response) {
        resolve(response.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  },
  getCurrentUserRoles: function getCurrentUserRoles() {
    var url = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_host + this.url_query + '/current/roles';

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.axios.get(url).then(function (response) {
        resolve(response.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  },
  add: function add(payload) {
    var _this = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var result = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceStore(_this.resource + '/withid', payload);

      result.then(function (result) {
        resolve(result.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  },
  uploadAvatar: function uploadAvatar(userId, event) {
    var _this2 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var form = new FormData();
      var result = null;

      form.append('avatar', event.target.files[0]);

      result = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_host + '/api/' + _this2.resource + '/' + userId + '/avatar', form, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      result.then(function (result) {
        resolve(result.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (userAPI);

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      savedItemId: null
    };
  },

  methods: {
    saveNewSuccess: function saveNewSuccess(result) {
      this.$bus.$emit('resource-added');

      this.savedItemId = undefined !== result && undefined !== result.inserted_id ? result.inserted_id : null;

      this.dialog = false;

      this.dialogMessage = 'Successfully added';
      this.dialogOpen = true;
    },
    saveNewError: function saveNewError(error) {
      var handle = error; // eslint-disable-line
    }
  }
});

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(815)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(466),
  /* template */
  __webpack_require__(948),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-05fe9e22",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(58);




var servicesAPI = {
  // specific services api
  resource: 'services',

  loadService: function loadService(id) {
    var _this = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var service = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceShow(_this.resource, id);

      service.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  loadAllServices: function loadAllServices() {
    var _this2 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var services = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex(_this2.resource);

      services.then(function (result) {
        result.forEach(function (item, i) {
          item.text = item.name;
          item.value = item.id;
        });

        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  loadServices: function loadServices() {
    var _this3 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var services = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex(_this3.resource);

      services.then(function (result) {
        result.forEach(function (item, i) {
          item.text = item.name;
          item.value = item.id;
        });

        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  getReportQuantitiesSold: function getReportQuantitiesSold(from, to) {
    var _this4 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var services = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex(_this4.resource + '/statistics/quantitiesSold/from/' + from + '/to/' + to);

      services.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  loadProducts: function loadProducts() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var products = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex('products');

      products.then(function (result) {
        result.forEach(function (item, i) {
          item.text = item.name;
          item.value = item.id;
        });

        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  uploadProductsWithCsv: function uploadProductsWithCsv(formData) {
    var url = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_host + '/api/products/csv';

    var config = {
      headers: {
        'Content-type': 'multipart/form-data'
      }
    };

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.axios.post(url, formData, config).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  loadNotAssociatedVendorsServices: function loadNotAssociatedVendorsServices() {
    var _this5 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var services = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex(_this5.resource + '/vendors/notassociated');

      services.then(function (result) {
        result.forEach(function (item, i) {
          item.text = item.name;
          item.value = item.id;
        });

        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  loadCheckList: function loadCheckList(itemId) {
    var _this6 = this;

    var casesId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var checklist = null;

      if (casesId > 0) {
        checklist = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex(_this6.resource + '/' + itemId + '/case/' + casesId + '/checklist');
      } else {
        checklist = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex(_this6.resource + '/' + itemId + '/checklist');
      }

      checklist.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  searchAvailableServicesForDate: function searchAvailableServicesForDate(date) {
    var _this7 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var services = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex(_this7.resource + '/available/' + date);

      services.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  searchAppointmentsForDate: function searchAppointmentsForDate(date) {
    var _this8 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var services = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex(_this8.resource + '/appointments/' + date);

      services.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  add: function add(payload) {
    var _this9 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var result = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceStore(_this9.resource + '/withid', payload);

      result.then(function (result) {
        resolve(result.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  },
  delete: function _delete(serviceId) {
    var _this10 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var result = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceDestroy(_this10.resource, serviceId);

      result.then(function (result) {
        resolve(result.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  },
  edit: function edit(serviceId, description, price, name) {
    var _this11 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var result = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceUpdate(_this11.resource, serviceId, { description: description, price: price, name: name });

      result.then(function (result) {
        resolve(result.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (servicesAPI);

/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cases__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plans__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__products__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__users__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__roles__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__clients__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(441);












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  state: {
    isLogged: Boolean(localStorage.getItem('oauthToken')) || false,
    mainMenuDrawer: true,
    editItemId: 0,
    editItemIdPermissions: 0,
    dfsConfig: {},
    axios: {},
    createCaseOfflineRequestsPool: [],
    loggedUserEmail: localStorage.getItem('loggedUserEmail') || '',
    currentUser: JSON.parse(localStorage.getItem('currentUser')) || {},
    currentUserRoles: JSON.parse(localStorage.getItem('currentUserRoles')) || [],
    appIsLoaded: false
  },
  mutations: {
    logIn: function logIn(state) {
      state.isLogged = true;
    },
    logOut: function logOut(state) {
      state.loggedUserEmail = '';
      state.currentUser = {};
      state.currentUserRoles = [];
      state.isLogged = false;
    },
    toggleMainMenuDrawer: function toggleMainMenuDrawer(state) {
      state.mainMenuDrawer = !state.mainMenuDrawer;
    },
    setAxios: function setAxios(state, axios) {
      state.axios = axios;
    },
    setConfig: function setConfig(state, config) {
      state.dfsConfig = config;
    },
    setEditItemId: function setEditItemId(state, itemId) {
      state.editItemId = itemId;
    },
    setEditItemIdPermissions: function setEditItemIdPermissions(state, itemId) {
      state.editItemIdPermissions = itemId;
    },
    setLoggedUserEmail: function setLoggedUserEmail(state, email) {
      state.loggedUserEmail = email;
    },
    setCurrentUser: function setCurrentUser(state, user) {
      state.currentUser = user;
    },
    setCurrentUserRoles: function setCurrentUserRoles(state, roles) {
      state.currentUserRoles = roles;
    },
    setAppIsLoaded: function setAppIsLoaded(state, status) {
      state.appIsLoaded = status;
    }
  },
  actions: {
    logIn: function logIn(context) {
      context.commit('logIn');
    },
    logOut: function logOut(context) {
      context.commit('logOut');
    },
    toggleMainMenuDrawer: function toggleMainMenuDrawer(_ref) {
      var commit = _ref.commit;

      commit('toggleMainMenuDrawer');
    },
    setAxios: function setAxios(context, axios) {
      context.commit('setAxios', axios);
    },
    setConfig: function setConfig(context, config) {
      context.commit('setConfig', config);
    },
    setEditItemId: function setEditItemId(context, itemId) {
      context.commit('setEditItemId', itemId);
    },
    setEditItemIdPermissions: function setEditItemIdPermissions(context, itemId) {
      context.commit('setEditItemIdPermissions', itemId);
    },
    setLoggedUserEmail: function setLoggedUserEmail(context, email) {
      context.commit('setLoggedUserEmail', email);
    },
    setCurrentUser: function setCurrentUser(context, user) {
      context.commit('setCurrentUser', user);
    },
    setCurrentUserRoles: function setCurrentUserRoles(context, roles) {
      context.commit('setCurrentUserRoles', roles);
    },
    setAppIsLoaded: function setAppIsLoaded(context, status) {
      context.commit('setAppIsLoaded', status);
    }
  },
  getters: {
    logInStatus: function logInStatus(state) {
      return state.isLogged;
    },
    axios: function axios(state) {
      return state.axios;
    },
    config: function config(state) {
      return state.dfsConfig;
    },
    editItemId: function editItemId(state) {
      return state.editItemId;
    },
    editItemIdPermissions: function editItemIdPermissions(state) {
      return state.editItemIdPermissions;
    },
    loggedUserEmail: function loggedUserEmail(state) {
      return state.loggedUserEmail;
    },
    currentUser: function currentUser(state) {
      return state.currentUser;
    },
    currentUserRoles: function currentUserRoles(state) {
      return state.currentUserRoles;
    },
    appIsLoaded: function appIsLoaded(state) {
      return state.appIsLoaded;
    }
  },
  modules: {
    cases: __WEBPACK_IMPORTED_MODULE_2__cases__["a" /* default */],
    plans: __WEBPACK_IMPORTED_MODULE_3__plans__["a" /* default */],
    products: __WEBPACK_IMPORTED_MODULE_4__products__["a" /* default */],
    users: __WEBPACK_IMPORTED_MODULE_5__users__["a" /* default */],
    services: __WEBPACK_IMPORTED_MODULE_6__services__["a" /* default */],
    roles: __WEBPACK_IMPORTED_MODULE_7__roles__["a" /* default */],
    clients: __WEBPACK_IMPORTED_MODULE_8__clients__["a" /* default */],
    utils: __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */]
  }
}));

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__ = __webpack_require__(9);



var schedulesAPI = {
  // specific schedules api
  resource: 'schedules',
  url_query: '/api/schedules',

  loadSchedule: function loadSchedule(id) {
    var _this = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var Schedule = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceShow(_this.resource, id);

      Schedule.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  loadSchedules: function loadSchedules() {
    var _this2 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var schedules = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex(_this2.resource);

      schedules.then(function (result) {
        result.forEach(function (item, i) {
          item.text = item.name;
          item.value = item.id;
        });

        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  saveSchedule: function saveSchedule(payload) {
    var _this3 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var schedules = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceStore(_this3.resource, payload);

      schedules.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  updateLeadWithDates: function updateLeadWithDates(leadUuid, startDate, endDate) {
    var _this4 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var payload = {
        schedule_start: startDate,
        schedule_end: endDate
      };

      var schedules = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceUpdate(_this4.resource + '/leads', leadUuid, payload, '/dates');

      schedules.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  updateLead: function updateLead(leadUuid, caseManagerId, palbearersIds, venueDescription) {
    var _this5 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var payload = {
        case_manager_id: caseManagerId,
        palbearers_ids: palbearersIds,
        venue_description: venueDescription
      };

      var schedules = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceUpdate(_this5.resource + '/leads', leadUuid, payload);

      schedules.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  updatePallbearers: function updatePallbearers(leadUuid, palbearersIds, closing) {
    var _this6 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var payload = {
        pallbearers_ids: palbearersIds,
        is_closing: closing
      };

      var schedules = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceUpdate(_this6.resource + '/pallbearers', leadUuid, payload);

      schedules.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  updateScheduleWithDates: function updateScheduleWithDates(id, itemId, startDate, endDate) {
    var _this7 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var payload = {
        item_id: itemId,
        schedule_start: startDate,
        schedule_end: endDate
      };

      var schedules = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceUpdate(_this7.resource, id, payload);

      schedules.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (schedulesAPI);

/***/ }),
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(58);




var plansAPI = {
  // specific plans api
  url_query: '/api/plans',

  getLinkedInventories: function getLinkedInventories(itemId) {
    var url = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_host + this.url_query + '/' + itemId + '/inventories';

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.axios.get(url).then(function (response) {
        resolve(response.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  },
  getLinkedServices: function getLinkedServices(itemId) {
    var url = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.config.api_host + this.url_query + '/' + itemId + '/services';

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.axios.get(url).then(function (response) {
        resolve(response.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  },
  loadPlans: function loadPlans() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var plans = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex('plans');

      plans.then(function (result) {
        result.forEach(function (item, i) {
          item.text = item.name;
          item.value = item.id;
        });

        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  loadPlan: function loadPlan(id) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var plans = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceShow('plans', id);

      plans.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (plansAPI);

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var INVENTORY_TYPE_ID = 1;
var SERVICE_TYPE_ID = 2;
var CASEMANAGER_TYPE_ID = 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  schedules: {
    INVENTORY_TYPE_ID: INVENTORY_TYPE_ID,
    SERVICE_TYPE_ID: SERVICE_TYPE_ID,
    CASEMANAGER_TYPE_ID: CASEMANAGER_TYPE_ID
  }
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Element; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scss_chat_scss__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scss_chat_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__scss_chat_scss__);
/* eslint-disable */






var Element = function () {
  function Element(arg) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Element);

    this.supportedTags = ['div', 'span', 'input', 'label'];
    this.supportedEvents = ['click', 'keydown', 'keyup', 'scroll', 'paste', 'change', 'focus', 'blur'];
    if (!arg || typeof arg === 'string') {
      var tag = this.supportedTags.indexOf(arg) >= 0 ? arg : 'div';
      this.$ = document.createElement(tag);
    } else if (arg instanceof HTMLElement) {
      this.$ = arg;
    }
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Element, [{
    key: 'setClass',
    value: function setClass() {
      if (this.$) {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return this.$.className = args.join(' ');
      }
    }
  }, {
    key: 'hasClass',
    value: function hasClass(className) {
      if (this.$) {
        if (this.$.classList) return this.$.classList.contains(className);else return new RegExp('(^| )' + className + '( |$)', 'gi').test(this.$.className);
      } else return false;
    }
  }, {
    key: 'addClass',
    value: function addClass(className) {
      if (this.$) {
        var classList = this.$.className.split(" ");
        if (!(className in classList)) {
          classList.push(className);
          this.$.className = classList.join(" ");
        }
      }
      return this.$;
    }
  }, {
    key: 'removeClass',
    value: function removeClass(className) {
      if (this.$) {
        if (this.$.classList) this.$.classList.remove(className);else this.$.className = this.$.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), '');
      }
      return this.$;
    }
  }, {
    key: 'findByTag',
    value: function findByTag(tag) {
      return this.$.querySelectorAll(tag);
    }
  }, {
    key: 'getTag',
    value: function getTag() {
      return this.$ ? this.$.tagName.toUpperCase() : "";
    }
  }, {
    key: 'setStyle',
    value: function setStyle(style, value) {
      var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";

      if (this.$) this.$.style[style] = value + unit;
    }
  }, {
    key: 'setWidth',
    value: function setWidth(val) {
      this.setStyle('width', val + "px");
    }
  }, {
    key: 'setHeight',
    value: function setHeight(val) {
      this.setStyle('height', val + "px");
    }
  }, {
    key: 'setPadding',
    value: function setPadding(top, right, bottom, left) {
      this.setHorizontalPadding(left, right);
      this.setVerticalPadding(top, bottom);
    }
  }, {
    key: 'setHorizontalPadding',
    value: function setHorizontalPadding(left, right) {
      this.setStyle('paddingLeft', left + "px");
      this.setStyle('paddingRight', right + "px");
    }
  }, {
    key: 'setVerticalPadding',
    value: function setVerticalPadding(top, bottom) {
      this.setStyle('paddingTop', top + "px");
      this.setStyle('paddingBottom', bottom + "px");
    }
  }, {
    key: 'show',
    value: function show(display) {
      if (this.$) this.setStyle('display', display || 'block');
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (this.$) this.setStyle('display', 'none');
    }
  }, {
    key: 'focus',
    value: function focus() {
      if (this.$) this.$.focus();
    }
  }, {
    key: 'blur',
    value: function blur() {
      if (this.$) this.$.blur();
    }
  }, {
    key: 'click',
    value: function click() {
      if (this.$) this.$.click();
    }
  }, {
    key: 'attr',
    value: function attr(key, val) {
      if (this.$) {
        if (val !== undefined) this.$.setAttribute(key, val);
        return this.$.getAttribute(key);
      }
    }
  }, {
    key: 'protectFromXSS',
    value: function protectFromXSS(text) {
      return text.replace(/\&/g, '&amp;').replace(/\#/g, '&#35;').replace(/\</g, '&lt;').replace(/\>/g, '&gt;').replace(/\"/g, '&quot;').replace(/\'/g, '&apos;').replace(/\+/g, '&#43;').replace(/\-/g, '&#45;').replace(/\(/g, '&#40;').replace(/\)/g, '&#41;').replace(/\%/g, '&#37;');
    }
  }, {
    key: 'val',
    value: function val(newVal, options) {
      if (this.$) {
        if (!options) options = {};
        if (this.getTag() == "INPUT") {
          if (newVal !== undefined) this.$.value = newVal;
          return this.$.value || "";
        } else {
          if (newVal !== undefined) {
            if (options.xssProtectionEnabled) newVal = this.protectFromXSS(newVal);
            if (options.showEndOfLine) newVal = newVal.replace(/\n/g, "<br />");
            this.$.innerHTML = newVal;
          }
          return this.$.innerHTML;
        }
      } else return "";
    }
  }, {
    key: 'appendContent',
    value: function appendContent(text, options) {
      if (this.$) {
        if (!options) options = {};
        if (options.xssProtectionEnabled) text = this.protectFromXSS(text);
        if (options.showEndOfLine) text = text.replace(/\n/g, "<br />");
        this.val(this.val() + text);
      }
      return this.val();
    }
  }, {
    key: 'enable',
    value: function enable() {
      if (this.$) this.$.disabled = false;
    }
  }, {
    key: 'disable',
    value: function disable() {
      if (this.$) this.$.disabled = true;
    }
  }, {
    key: 'first',
    value: function first() {
      return this.$.firstChild;
    }
  }, {
    key: 'last',
    value: function last() {
      return this.$.lastChild;
    }
  }, {
    key: 'children',
    value: function children() {
      return this.$.children;
    }
  }, {
    key: 'insertBefore',
    value: function insertBefore(elem, before) {
      if (this.$) {
        if (elem instanceof Element) elem = elem.$;
        if (before instanceof Element) before = before.$;
        this.$.insertBefore(elem, before);
      }
      return this.$;
    }
  }, {
    key: 'appendElement',
    value: function appendElement(elem) {
      if (this.$) {
        if (elem instanceof HTMLElement) this.$.appendChild(elem);else this.$.appendChild(elem.$);
      }
      return this.$;
    }
  }, {
    key: 'replaceElement',
    value: function replaceElement(from, to) {
      if (this.$) {
        if (from instanceof Element) from = from.$;
        if (to instanceof Element) to = to.$;
        this.$.replaceChild(to, from);
      }
    }
  }, {
    key: 'removeElement',
    value: function removeElement(elem) {
      if (this.$) {
        if (elem instanceof HTMLElement) this.$.removeChild(elem);else this.$.removeChild(elem.$);
      }
    }
  }, {
    key: 'removeFirst',
    value: function removeFirst() {
      if (this.$.children.length > 0) this.$.removeChild(this.$.firstChild);
    }
  }, {
    key: 'removeLast',
    value: function removeLast() {
      if (this.$.children.length > 0) this.$.removeChild(this.$.lastChild);
    }
  }, {
    key: 'getFullWidth',
    value: function getFullWidth() {
      var width = this.$.offsetWidth;
      var style = getComputedStyle(this.$);
      width += parseInt(style.marginLeft) + parseInt(style.marginRight);
      return width;
    }
  }, {
    key: 'getFullHeight',
    value: function getFullHeight() {
      var height = this.$.offsetHeight;
      var style = getComputedStyle(this.$);
      height += parseInt(style.marginTop) + parseInt(style.marginBottom);
      return height;
    }
  }, {
    key: 'getPadding',
    value: function getPadding() {
      try {
        return {
          top: parseFloat(window.getComputedStyle(this.$, null).getPropertyValue('padding-top')),
          bottom: parseFloat(window.getComputedStyle(this.$, null).getPropertyValue('padding-bottom')),
          left: parseFloat(window.getComputedStyle(this.$, null).getPropertyValue('padding-left')),
          right: parseFloat(window.getComputedStyle(this.$, null).getPropertyValue('padding-right'))
        };
      } catch (e) {
        return {
          top: parseFloat(this.$.currentStyle.paddingTop),
          bottom: parseFloat(this.$.currentStyle.paddingBottom),
          left: parseFloat(this.$.currentStyle.paddingLeft),
          right: parseFloat(this.$.currentStyle.paddingRight)
        };
      }
    }
  }, {
    key: 'getScrollHeight',
    value: function getScrollHeight() {
      return this.$.scrollHeight;
    }
  }, {
    key: 'getScrollX',
    value: function getScrollX() {
      return this.$.scrollLeft;
    }
  }, {
    key: 'getScrollY',
    value: function getScrollY() {
      return this.$.scrollTop;
    }
  }, {
    key: 'scroll',
    value: function scroll(x, y) {
      this.scrollX(x);
      this.scrollY(y);
    }
  }, {
    key: 'scrollX',
    value: function scrollX(x) {
      this.$.scrollLeft = x;
    }
  }, {
    key: 'scrollY',
    value: function scrollY(y) {
      this.$.scrollTop = y;
    }
  }, {
    key: 'scrollToTop',
    value: function scrollToTop() {
      this.scrollY(0);
    }
  }, {
    key: 'scrollToBottom',
    value: function scrollToBottom() {
      this.scrollY(this.$.scrollHeight - this.$.clientHeight);
    }
  }, {
    key: 'isScrollBottom',
    value: function isScrollBottom() {
      return this.getScrollY() == this.$.scrollHeight - this.$.clientHeight;
    }
  }, {
    key: 'on',
    value: function on(type, hdlr) {
      if (this.$) {
        type = this.supportedEvents.indexOf(type) >= 0 ? type : null;
        if (type) this.$.addEventListener(type, hdlr);
      }
    }
  }]);

  return Element;
}();



/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    DetectMobile: function DetectMobile() {
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\\-(n|u)|c55\/|capi|ccwa|cdm\\-|cell|chtm|cldc|cmd\\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\\-s|devi|dica|dmob|do(c|p)o|ds(12|\\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\\-|_)|g1 u|g560|gene|gf\\-5|g\\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\\-(m|p|t)|hei\\-|hi(pt|ta)|hp( i|ip)|hs\\-c|ht(c(\\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\\-(20|go|ma)|i230|iac( |\\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\\-[a-w])|libw|lynx|m1\\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\\-2|po(ck|rt|se)|prox|psio|pt\\-g|qa\\-a|qc(07|12|21|32|60|\\-[2-7]|i\\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\\-|oo|p\\-)|sdk\/|se(c(\\-|0|1)|47|mc|nd|ri)|sgh\\-|shar|sie(\\-|m)|sk\\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\\-|v\\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\\-|tdg\\-|tel(i|m)|tim\\-|t\\-mo|to(pl|sh)|ts(70|m\\-|m3|m5)|tx\\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\\-|your|zeto|zte\\-/i.test(a.substr(0, 4))) return true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return window.innerWidth <= 800 && window.innerHeight <= 600;
    }
  }
});

/***/ }),
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__ = __webpack_require__(9);



var inventoriesAPI = {
  // specific inventories api
  resource: 'inventories',

  loadInventory: function loadInventory(id) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var inventory = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceShow('inventories', id);

      inventory.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  loadInventories: function loadInventories() {
    var _this = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var inventories = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex(_this.resource);

      inventories.then(function (result) {
        result.forEach(function (item, i) {
          item.text = item.name;
          item.value = item.id;
        });

        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  loadNotAssociatedVendorsInventories: function loadNotAssociatedVendorsInventories() {
    var _this2 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var inventories = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex(_this2.resource + '/vendors/notassociated');

      inventories.then(function (result) {
        result.forEach(function (item, i) {
          item.text = item.name;
          item.value = item.id;
        });

        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  loadCheckList: function loadCheckList(itemId) {
    var _this3 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var checklist = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex(_this3.resource + '/' + itemId + '/checklist');

      checklist.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  add: function add(payload) {
    var _this4 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var result = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceStore(_this4.resource + '/withid', payload);

      result.then(function (result) {
        resolve(result.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (inventoriesAPI);

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__ = __webpack_require__(9);



var vendorsAPI = {
  // specific vendors api
  resource: 'vendors',

  getVendorItems: function getVendorItems(userId) {
    var _this = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var items = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex(_this.resource + '/' + userId + '/items');

      items.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (vendorsAPI);

/***/ }),
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(1010),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(504),
  /* template */
  __webpack_require__(943),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */,
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_resources_crud__ = __webpack_require__(9);




var invoiceAPI = {
  resource: 'invoices',

  markPaid: function markPaid(itemId) {
    var _this = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var payload = {
        status: 'paid'
      };

      var result = __WEBPACK_IMPORTED_MODULE_2__api_resources_crud__["a" /* default */].dfsResourceUpdate(_this.resource, itemId, payload);

      result.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  uploadInvoice: function uploadInvoice(formData, caseId) {
    var url = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.config.api_host + '/api/cases/' + caseId + '/upload_invoice';

    var config = {
      headers: {
        'Content-type': 'multipart/form-data'
      }
    };

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.axios.post(url, formData, config).then(function (response) {
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (invoiceAPI);

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__ = __webpack_require__(9);



var eventsAPI = {
  // specific events api
  loadEvents: function loadEvents() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var events = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex('events');

      events.then(function (result) {
        result.forEach(function (item, i) {
          item.text = item.name;
          item.value = item.id;
        });

        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (eventsAPI);

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__ = __webpack_require__(9);



var formsAPI = {
  // specific forms api
  loadForms: function loadForms() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var forms = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex('forms');

      forms.then(function (result) {
        result.forEach(function (item, i) {
          var itemJson = JSON.parse(item.form_structure);

          item.text = itemJson.form_name;
          item.value = item.id;
        });

        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  loadForm: function loadForm(id) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var forms = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceShow('forms', id);

      forms.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (formsAPI);

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__ = __webpack_require__(9);



var rolesAPI = {
  // specific roles api
  loadRoles: function loadRoles() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var roles = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex('roles');

      roles.then(function (result) {
        result.forEach(function (item, i) {
          item.text = item.name;
          item.value = item.id;
        });

        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  loadRolePermissions: function loadRolePermissions(roleId) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var permissions = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex('roles/' + roleId + '/permissions');

      permissions.then(function (result) {
        result.forEach(function (item, i) {
          item.text = item.name;
          item.value = item.id;
        });

        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (rolesAPI);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KeyCode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SendbirdAdapter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* eslint-disable */




var GLOBAL_HANDLER = 'GLOBAL_HANDLER';
var GET_MESSAGE_LIMIT = 30;

var KeyCode = {
  ENTER: 13,
  KR: 229
};

var SendbirdAdapter = function () {
  function SendbirdAdapter(appId) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SendbirdAdapter);

    this.api = new window.SendBird({ appId: appId });
    this.messageListQuery = null;
    this.channel = null;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(SendbirdAdapter, [{
    key: 'reset',
    value: function reset() {
      this.channel = null;
      this.api.removeChannelHandler(GLOBAL_HANDLER);
    }

    /*
    User
     */

  }, {
    key: 'isConnected',
    value: function isConnected() {
      return !!this.api.currentUser;
    }
  }, {
    key: 'isCurrentUser',
    value: function isCurrentUser(user) {
      return this.api.currentUser.userId == user.userId;
    }
  }, {
    key: 'connect',
    value: function connect(userId, nickname, action) {
      var _this = this;

      this.api.connect(userId.trim(), function (user, error) {
        if (error) {
          var handle = error; // eslint-disable-line;
          return;
        }
        _this.api.updateCurrentUserInfo(nickname.trim(), '', function (response, error) {
          if (error) {
            var _handle = error; // eslint-disable-line;
            return;
          }
          action();
        });
      });
    }
  }, {
    key: 'disconnect',
    value: function disconnect(action) {
      if (this.isConnected()) {
        this.api.disconnect(function () {
          action();
        });
      }
    }

    /*
    Channel
     */

  }, {
    key: 'enterChannel',
    value: function enterChannel(channelUrl, action) {
      var _this2 = this;

      this.api.OpenChannel.getChannel(channelUrl, function (channel, error) {
        if (error) {
          var handle = error; // eslint-disable-line;
          return;
        }
        channel.enter(function (response, error) {
          if (error) {
            var _handle2 = error; // eslint-disable-line;
            return;
          }
          _this2.channel = channel;
          action();
        });
      });
    }
  }, {
    key: 'exitChannel',
    value: function exitChannel(callback) {
      var _this3 = this;

      this.channel.exit(function (response, error) {
        if (error) {
          var handle = error; // eslint-disable-line;
          return;
        }
        _this3.channel = null;
        callback();
      });
    }

    /*
    Message
     */

  }, {
    key: 'getMessageList',
    value: function getMessageList(action, isInit) {
      if (!this.messageListQuery || isInit) {
        this.messageListQuery = this.channel.createPreviousMessageListQuery();
      }
      if (this.messageListQuery.hasMore && !this.messageListQuery.isLoading) {
        this.messageListQuery.load(GET_MESSAGE_LIMIT, false, function (messageList, error) {
          if (error) {
            var handle = error; // eslint-disable-line;
            return;
          }
          action(messageList);
        });
      }
    }
  }, {
    key: 'sendMessage',
    value: function sendMessage(textMessage, action) {
      this.channel.sendUserMessage(textMessage, function (message, error) {
        if (error) {
          var handle = error; // eslint-disable-line;
          return;
        }
        action(message);
      });
    }

    /*
    Handler
     */

  }, {
    key: 'createHandler',
    value: function createHandler(onMessageReceived) {
      var channelHandler = new this.api.ChannelHandler();
      channelHandler.onMessageReceived = onMessageReceived;
      channelHandler.onMessageDeleted = function (channel, messageId) {
        var deletedMessage = document.getElementById(messageId);
        if (deletedMessage) {
          deletedMessage.remove();
        }
      };
      this.api.addChannelHandler(GLOBAL_HANDLER, channelHandler);
    }
  }, {
    key: 'connectionHandler',
    value: function connectionHandler(channelUrl, liveChat) {
      var ConnectionHandler = new this.api.ConnectionHandler();
      ConnectionHandler.onReconnectStarted = function (id) {
        console.log('onReconnectStarted');
        liveChat.$spinner.attachTo(liveChat.$messageBoard.$content);
      };

      ConnectionHandler.onReconnectSucceeded = function (id) {
        console.log('onReconnectSucceeded');
        liveChat.enterChannel(channelUrl);
      };

      ConnectionHandler.onReconnectFailed = function (id) {
        console.log('onReconnectFailed');
      };
      this.api.addConnectionHandler('CONNECTION_HANDLER', ConnectionHandler);
    }
  }]);

  return SendbirdAdapter;
}();



/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_cases__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_resources_services__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_user__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_consts__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_ItemTypes__ = __webpack_require__(13);



// import inventoriesAPI from '@/api/resources/inventories'




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_ItemTypes__["a" /* default */]],
  computed: {
    itemTypeToItemIDMap: function itemTypeToItemIDMap() {
      var _ref;

      return _ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, __WEBPACK_IMPORTED_MODULE_4__config_consts__["a" /* default */].schedules.INVENTORY_TYPE_ID, this.selectedInventory), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, __WEBPACK_IMPORTED_MODULE_4__config_consts__["a" /* default */].schedules.SERVICE_TYPE_ID, this.selectedService), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, __WEBPACK_IMPORTED_MODULE_4__config_consts__["a" /* default */].schedules.CASEMANAGER_TYPE_ID, this.selectedCaseManager), _ref;
    },
    itemTypeIDInDBToEntitiesListNameMap: function itemTypeIDInDBToEntitiesListNameMap() {
      var _ref2;

      return _ref2 = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, __WEBPACK_IMPORTED_MODULE_4__config_consts__["a" /* default */].schedules.INVENTORY_TYPE_ID, 'inventoriesList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, __WEBPACK_IMPORTED_MODULE_4__config_consts__["a" /* default */].schedules.SERVICE_TYPE_ID, 'servicesList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, __WEBPACK_IMPORTED_MODULE_4__config_consts__["a" /* default */].schedules.CASEMANAGER_TYPE_ID, 'caseManagersList'), _ref2;
    },
    entitiesListNameToSelectedEntityNameMap: function entitiesListNameToSelectedEntityNameMap() {
      return {
        'inventoriesList': 'selectedInventory',
        'servicesList': 'selectedService',
        'caseManagersList': 'selectedCaseManager'
      };
    },
    listsMap: function listsMap() {
      return {
        'inventoriesList': this.inventoriesList,
        'servicesList': this.servicesList,
        'caseManagersList': this.caseManagersList
      };
    },
    entitiesSelectedMap: function entitiesSelectedMap() {
      return {
        'selectedInventory': this.selectedInventory,
        'selectedService': this.selectedService,
        'selectedCaseManager': this.selectedCaseManager
      };
    },
    itemTypeToListsMap: function itemTypeToListsMap() {
      var _ref3;

      return _ref3 = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref3, __WEBPACK_IMPORTED_MODULE_4__config_consts__["a" /* default */].schedules.INVENTORY_TYPE_ID, this.inventoriesList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref3, __WEBPACK_IMPORTED_MODULE_4__config_consts__["a" /* default */].schedules.SERVICE_TYPE_ID, this.servicesList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref3, __WEBPACK_IMPORTED_MODULE_4__config_consts__["a" /* default */].schedules.CASEMANAGER_TYPE_ID, this.caseManagersList), _ref3;
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__api_resources_cases__["a" /* default */].loadActiveCases().then(function (result) {
      _this.casesList = result;
    }, function () {});

    /*
    inventoriesAPI.loadInventories().then(result => {
      this.inventoriesList = result
    }, () => {})
    */

    __WEBPACK_IMPORTED_MODULE_2__api_resources_services__["a" /* default */].loadServices().then(function (result) {
      console.log('got services', result);
      _this.servicesList = result;
    }, function () {});

    __WEBPACK_IMPORTED_MODULE_3__api_user__["a" /* default */].loadCaseManagers().then(function (result) {
      _this.caseManagersList = result;
    }, function () {});
  }
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_resources_events__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [],
      tableHeaders: [{ text: 'Type', value: 'vendor' }, { text: 'Message', value: 'message' }, { text: 'Event', value: 'events_id' }, { text: 'Recipients', value: 'recipients_string' }, { text: 'Roles', value: '' }, { text: 'Send to client', value: 'send_to_client' }, { text: 'Is active', value: 'is_active' }, { text: 'Created at', value: 'created_at' }, { text: 'Updated at', value: 'updated_at' }, { text: 'Actions', value: 'actions' }],
      notificationTypesList: [{ value: 'whatsapp', text: 'WhatsApp' }, { value: 'twilio', text: 'SMS' }, { value: 'email', text: 'Email' }],
      dialogOpen: false,
      dialogMessage: '',
      eventsList: [],
      selectedEvent: 0,
      notificationRecipients: '',
      notificationMessage: '',
      notificationIsActive: true
    };
  },

  methods: {
    loadListingSuccess: function loadListingSuccess(result) {
      result.forEach(function (notification, i) {
        notification.recipients_string = '';

        notification.roles_string = '';

        notification.recipients.forEach(function (recipient, i) {
          if (notification.vendor === 'email') {
            notification.recipients_string = recipient.email !== null ? notification.recipients_string.concat(recipient.email) : notification.recipients_string;
          } else {
            notification.recipients_string = notification.recipients_string.concat(recipient.phone);
          }

          if (i !== notification.recipients.length - 1) {
            notification.recipients_string = notification.recipients_string.concat(', ');
          }
        });

        notification.roles.forEach(function (recipient, i) {
          notification.roles_string = notification.roles_string.concat(recipient.phone);

          if (i !== notification.roles.length - 1) {
            notification.roles_string = notification.roles_string.concat(', ');
          }
        });
      });

      this.items = result;
    }
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__api_resources_events__["a" /* default */].loadEvents().then(function (result) {
      _this.eventsList = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(result, function (p) {
        return {
          text: p.description || p.name,
          value: p.id
        };
      });
    });
  }
});

/***/ }),
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(1031),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(830)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(986),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__ = __webpack_require__(9);



var clientsAPI = {
  // specific clients api
  loadClients: function loadClients() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var clients = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex('clients');

      clients.then(function (result) {
        result.forEach(function (item, i) {
          item.text = item.name;
          item.value = item.id;
        });

        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  loadClient: function loadClient(clientId) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var client = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceShow('clients', clientId);

      client.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (clientsAPI);

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(58);



var notificationsAPI = {
  // specific notifications api
  url_query: '/api/notifications',

  getLinkedRecipients: function getLinkedRecipients(itemId) {
    var url = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.config.api_host + this.url_query + '/' + itemId + '/recipients';

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.axios.get(url).then(function (response) {
        resolve(response.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (notificationsAPI);

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__ = __webpack_require__(9);



var recipientsAPI = {
  // specific recipients api
  loadRecipients: function loadRecipients() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var recipients = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex('recipients');

      recipients.then(function (result) {
        result.forEach(function (item, i) {
          item.text = item.phone;
          item.value = item.id;
        });

        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  storeRecipient: function storeRecipient(payload) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var result = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceStore('recipients', payload);

      result.then(function (result) {
        resolve(result.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (recipientsAPI);

/***/ }),
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(1037),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(1023),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(947),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(995),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(1034),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(506),
  /* template */
  __webpack_require__(954),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(1003),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(520),
  /* template */
  __webpack_require__(983),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rules = function rules(acl) {
  acl.rule('view', 'Home', function (store) {
    return store.getters.logInStatus;
  });

  acl.rule('view', 'Login', function (store) {
    return !store.getters.logInStatus;
  });

  acl.rule('view', 'Logout', function (store) {
    return store.getters.logInStatus;
  });

  acl.rule('view', 'OnboardClient', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager'].includes(item);
    });
  });

  acl.rule('view', 'Services', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management'].includes(item);
    });
  });

  acl.rule('view', 'Products', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager'].includes(item);
    });
  });

  acl.rule('view', 'Inventories', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management'].includes(item);
    });
  });

  acl.rule('view', 'Plans', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management'].includes(item);
    });
  });

  acl.rule('view', 'EventChecklist', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager', 'vendor'].includes(item);
    });
  });

  acl.rule('view', 'SelectCrew', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager'].includes(item);
    });
  });

  acl.rule('view', 'Reminders', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'dispatcher', 'case-manager'].includes(item);
    });
  });

  acl.rule('view', 'Analytics', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager'].includes(item);
    });
  });

  acl.rule('view', 'SalesReport', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager', 'accounts'].includes(item);
    });
  });

  acl.rule('view', 'InventoryReport', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager', 'accounts'].includes(item);
    });
  });

  acl.rule('view', 'Billing', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'accounts', 'vendor'].includes(item);
    });
  });

  acl.rule('view', 'Users', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management'].includes(item);
    });
  });

  acl.rule('view', 'Clients', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager'].includes(item);
    });
  });

  acl.rule('view', 'Cases', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['vendor', 'case-manager', 'management', 'trainer', 'case-crew', 'warehouse-manager', 'warehouse-crew', 'accounts', 'customer-support', 'embalmer'].includes(item);
    });
  });

  acl.rule('view', 'Profile', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['vendor', 'case-manager', 'management', 'trainer', 'case-crew', 'warehouse-manager', 'warehouse-crew', 'accounts', 'customer-support', 'embalmer'].includes(item);
    });
  });

  // old
  acl.rule('view', 'NewCase', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'trainer', 'case-crew', 'warehouse-manager', 'warehouse-crew', 'accounts', 'customer-support', 'embalmer'].includes(item);
    });
  });

  acl.rule('view', 'NewLeads', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager', 'dispatcher'].includes(item);
    });
  });

  acl.rule('view', 'AssignCrewAndTiming', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager', 'dispatcher'].includes(item);
    });
  });

  acl.rule('view', 'SelectPlanAndVendors', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager'].includes(item);
    });
  });

  acl.rule('view', 'AppointmentSchedule', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager'].includes(item);
    }) || store.getters.currentUser.is_palbearer;
  });

  acl.rule('view', 'AddLeadForm', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'dispatcher', 'case-manager'].includes(item);
    });
  });

  acl.rule('view', 'Bookings', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager'].includes(item);
    });
  });

  acl.rule('view', 'VendorsInvoice', function (store) {
    return true;
  });

  acl.rule('view', 'Settings', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management'].includes(item);
    });
  });

  acl.rule('view', 'WhatsappNotifications', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management'].includes(item);
    });
  });

  acl.rule('view', 'SMSNotifications', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager'].includes(item);
    });
  });

  acl.rule('view', 'Notifications', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager'].includes(item);
    });
  });

  acl.rule('view', 'CasesDetail', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager', 'vendor', 'trainer', 'case-crew', 'warehouse-manager', 'warehouse-crew', 'accounts', 'customer-support', 'embalmer'].includes(item);
    });
  });

  acl.rule('view', 'PDFTemplates', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management'].includes(item);
    });
  });

  acl.rule('view', 'Roles', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management'].includes(item);
    });
  });

  acl.rule('view', 'cases-details', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager', 'vendor', 'case-crew'].includes(item);
    });
  });

  acl.rule('view', 'cases-manager-details', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager', 'vendor', 'accounts'].includes(item);
    });
  });

  acl.rule('view', 'cases-detail-case-description-tab', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager'].includes(item);
    });
  });

  acl.rule('view', 'cases-detail-client-tab', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager', 'accounts'].includes(item);
    });
  });

  acl.rule('view', 'cases-detail-plan-tab', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager'].includes(item);
    });
  });

  acl.rule('view', 'cases-detail-services-tab', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager', 'vendor'].includes(item);
    });
  });

  acl.rule('view', 'cases-detail-inventories-tab', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management'].includes(item);
    });
  });

  acl.rule('view', 'cases-detail-pdf-tab', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'vendor', 'case-manager', 'accounts'].includes(item);
    });
  });

  acl.rule('view', 'cases-detail-invoices', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'vendor', 'case-manager', 'accounts'].includes(item);
    });
  });

  acl.rule('view', 'cases-detail-forms', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager'].includes(item);
    });
  });

  acl.rule('view', 'cases-detail-chat-tab', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager', 'vendor', 'trainer', 'case-crew', 'warehouse-manager', 'warehouse-crew', 'accounts', 'customer-support', 'embalmer'].includes(item);
    });
  });

  acl.rule('create', 'cases-item', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager'].includes(item);
    });
  });

  acl.rule('edit', 'cases-item', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager'].includes(item);
    });
  });

  acl.rule('delete', 'cases-item', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management'].includes(item);
    });
  });

  acl.rule('close', 'cases-item', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager', 'accounts'].includes(item);
    });
  });

  acl.rule('send', 'cases-client-email', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager'].includes(item);
    });
  });

  acl.rule('mark-paid', 'invoices', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'accounts'].includes(item);
    });
  });

  acl.rule('view', 'cases-detail-checklist-tab', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager'].includes(item);
    });
  });

  acl.rule('view', 'cases-detail-checklist-crew-tab', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['vendor'].includes(item);
    });
  });

  acl.rule('view', 'cases-detail-embalming-tab', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager', 'embalmer'].includes(item);
    });
  });

  acl.rule('view', 'cases-detail-actions-log-tab', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management'].includes(item);
    });
  });

  acl.rule('view', 'cases-detail-agreement-feedback-tab', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager'].includes(item);
    });
  });

  acl.rule('view', 'cases-detail-deposits-tab', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager'].includes(item);
    });
  });

  acl.rule('view', 'cases-detail-readjustment-tab', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'accounts'].includes(item);
    });
  });

  acl.rule('view', 'cases-detail-commissions-tab', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager'].includes(item);
    });
  });

  acl.rule('edit', 'case-deposit', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager'].includes(item);
    });
  });

  acl.rule('edit', 'case-readjustment', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'accounts'].includes(item);
    });
  });

  acl.rule('view', 'cases-detail-actions-tab', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'dispatcher'].includes(item);
    });
  });

  acl.rule('add', 'checklist-item', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager'].includes(item);
    });
  });

  acl.rule('add', 'new-commissions-to-case-manager', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management'].includes(item);
    });
  });

  acl.rule('delete', 'checklist-item', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager'].includes(item);
    });
  });

  acl.rule('edit', 'checklist-item', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager'].includes(item);
    });
  });

  acl.rule('view', 'cases-all-list', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager'].includes(item);
    });
  });

  acl.rule('use', 'appointment-schedule-create-new-case', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager', 'dispatcher'].includes(item);
    });
  });

  acl.rule('use', 'appointment-schedule-click-event', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager', 'dispatcher'].includes(item);
    });
  });

  acl.rule('view', 'Caskets', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management', 'case-manager', 'vendor', 'trainer', 'case-crew', 'warehouse-manager', 'warehouse-crew', 'accounts', 'customer-support', 'embalmer'].includes(item);
    });
  });

  acl.rule('create', 'Caskets', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management'].includes(item);
    });
  });

  acl.rule('edit', 'Caskets', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management'].includes(item);
    });
  });

  acl.rule('delete', 'Caskets', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['management'].includes(item);
    });
  });

  acl.rule('view', 'vendor', function (store) {
    return store.getters.currentUserRoles.some(function (item) {
      return ['vendor', 'case-crew'].includes(item);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (rules);

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var config = {
  api_oauth_client_id: 5,
  api_oauth_client_secret: 'v9mGTYWLcPUFjm0sZUs9rF9VSKESvUtFWLNkOzfZ',

  api_oauth_url_authorize: '/oauth/authorize',
  api_oauth_url_token: '/oauth/token',

  api_oauth_grant_type: 'password',
  api_oauth_default_scope: 'api-main-create api-main-read api-main-update api-main-delete',

  sendbird_app_id: '7F917A67-D6FD-4E56-944D-8D58E5BCF1BE',

  default_avatar_url: 'https://statelegitimacy.files.wordpress.com/2013/01/anonymous.png',

  api_host: 'https://api.directfuneral.app'
};

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('toDate', function (value) {
  if (!value) return '';
  return __WEBPACK_IMPORTED_MODULE_1_moment___default()(value, 'YYYY-MM-DD HH:mm').locale('uk').format('ll');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('countYears', function (value) {
  if (!value) return '';
  return __WEBPACK_IMPORTED_MODULE_1_moment___default()().diff(value, 'years');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('normalizeData', function (data) {
  data.forEach(function (item, i) {
    item.text = item.name;
    item.value = item.id;
  });

  return data;
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Logout__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Logout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Logout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_resources_Services__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_resources_Services___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_resources_Services__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_resources_Products__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_resources_Products___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_resources_Products__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_resources_Inventories__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_resources_Inventories___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_resources_Inventories__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_resources_Plans__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_resources_Plans___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_resources_Plans__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_resources_Users__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_resources_Users___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_resources_Users__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_resources_Clients__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_resources_Clients___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_resources_Clients__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_resources_Cases__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_resources_Cases___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_resources_Cases__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_resources_BillingCases__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_resources_BillingCases___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_resources_BillingCases__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Profile__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Profile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_AddLeadForm__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_AddLeadForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_AddLeadForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_AddLeadFormOld__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_AddLeadFormOld___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_AddLeadFormOld__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_SelectPlanAndVendors__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_SelectPlanAndVendors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_SelectPlanAndVendors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_resources_Bookings__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_resources_Bookings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_resources_Bookings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_VendorsInvoice__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_VendorsInvoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_VendorsInvoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_resources_WhatsappNotifications__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_resources_WhatsappNotifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_resources_WhatsappNotifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_detail_CasesDetail__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_detail_CasesDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_detail_CasesDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_PDFTemplates__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_PDFTemplates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_PDFTemplates__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_resources_Roles__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_resources_Roles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_resources_Roles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_OnboardClient__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_OnboardClient___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_OnboardClient__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_resources_Notifications__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_resources_Notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_resources_Notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_resources_Analytics__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_resources_Analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_resources_Analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_resources_SalesReport__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_resources_SalesReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_resources_SalesReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_resources_InventoryReport__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_resources_InventoryReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_resources_InventoryReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_ViewCasesCalendar__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_ViewCasesCalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_ViewCasesCalendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_ViewCasesTable__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_ViewCasesTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_ViewCasesTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_NewLeadTable__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_NewLeadTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_NewLeadTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_AppointmentsTable__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_AppointmentsTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_AppointmentsTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Settings__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_TestCalendar__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_TestCalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_TestCalendar__);


















// import InventoryReport from '@/components/InventoryReport'
// import NewLeads from '@/components/NewLeads'



// import TwilioNotifications from '@/components/resources/TwilioNotifications'





// import Forms from '@/components/resources/Forms'












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a,
    secure: true,
    meta: {
      can: 'view Home',
      fail: '/login'
    }
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Login___default.a,
    secure: false,
    meta: {
      can: 'view Login'
    }
  }, {
    path: '/logout',
    name: 'Logout',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Logout___default.a,
    secure: true,
    meta: {
      can: 'view Logout',
      fail: '/'
    }
  }, {
    path: '/services',
    name: 'Services',
    component: __WEBPACK_IMPORTED_MODULE_5__components_resources_Services___default.a,
    secure: true,
    meta: {
      can: 'view Services',
      fail: '/'
    }
  }, {
    path: '/products',
    name: 'Products',
    component: __WEBPACK_IMPORTED_MODULE_6__components_resources_Products___default.a,
    secure: true,
    meta: {
      can: 'view Products',
      fail: '/'
    }
  }, {
    path: '/profile',
    name: 'Profile',
    component: __WEBPACK_IMPORTED_MODULE_13__components_Profile___default.a,
    secure: true,
    meta: {
      can: 'view Profile',
      fail: '/'
    }
  }, {
    path: '/inventories',
    name: 'Inventories',
    component: __WEBPACK_IMPORTED_MODULE_7__components_resources_Inventories___default.a,
    secure: true,
    meta: {
      can: 'view Inventories',
      fail: '/'
    }
  }, {
    path: '/plans',
    name: 'Plans',
    component: __WEBPACK_IMPORTED_MODULE_8__components_resources_Plans___default.a,
    secure: true,
    meta: {
      can: 'view Plans',
      fail: '/'
    }
  }, {
    path: '/users',
    name: 'Users',
    component: __WEBPACK_IMPORTED_MODULE_9__components_resources_Users___default.a,
    secure: true,
    meta: {
      can: 'view Users',
      fail: '/'
    }
  }, {
    path: '/clients',
    name: 'Clients',
    component: __WEBPACK_IMPORTED_MODULE_10__components_resources_Clients___default.a,
    secure: true,
    meta: {
      can: 'view Clients',
      fail: '/'
    }
  }, {
    path: '/cases',
    name: 'Cases',
    component: __WEBPACK_IMPORTED_MODULE_11__components_resources_Cases___default.a,
    props: {
      detailCaseButtonActionIsDefault: true
    },
    secure: true,
    meta: {
      can: 'view Cases',
      fail: '/'
    }
  }, {
    path: '/new-lead-calendar',
    name: 'AddLeadForm',
    component: __WEBPACK_IMPORTED_MODULE_14__components_AddLeadForm___default.a,
    secure: true,
    meta: {
      can: 'view AddLeadForm',
      fail: '/'
    }
  }, {
    path: '/new-case',
    name: 'NewLeadTable',
    component: __WEBPACK_IMPORTED_MODULE_30__components_NewLeadTable___default.a,
    secure: true,
    meta: {
      can: 'view AddLeadForm',
      fail: '/'
    }
  }, {
    path: '/assign-crew-and-timing',
    name: 'NewLeads',
    component: __WEBPACK_IMPORTED_MODULE_15__components_AddLeadFormOld___default.a,
    props: true,
    // component: NewLeads,
    secure: true,
    meta: {
      can: 'view NewLeads',
      fail: '/'
    }
  }, {
    path: '/select-plan-and-vendors',
    name: 'SelectPlanAndVendors',
    component: __WEBPACK_IMPORTED_MODULE_16__components_SelectPlanAndVendors___default.a,
    props: true,
    secure: true,
    meta: {
      can: 'view SelectPlanAndVendors',
      fail: '/'
    }
  },
  /*
  {
    path: '/appointment-schedule-calendar',
    name: 'AppointmentSchedule',
    component: AddLeadForm,
    props: {
      forCaseManager: true
    },
    secure: true,
    meta: {
      can: 'view AppointmentSchedule',
      fail: '/'
    }
  },
  */
  {
    path: '/appointment-schedule',
    name: 'AppointmentsTable',
    component: __WEBPACK_IMPORTED_MODULE_31__components_AppointmentsTable___default.a,
    props: {
      forCaseManager: true
    },
    secure: true,
    meta: {
      can: 'view AppointmentSchedule',
      fail: '/'
    }
  }, {
    path: '/bookings',
    name: 'Bookings',
    component: __WEBPACK_IMPORTED_MODULE_17__components_resources_Bookings___default.a,
    secure: true,
    meta: {
      can: 'view Bookings',
      fail: '/'
    }
  }, {
    path: '/cases/:id/upload_invoice',
    name: 'VendorsInvoice',
    component: __WEBPACK_IMPORTED_MODULE_18__components_VendorsInvoice___default.a,
    props: true,
    secure: false,
    meta: {
      can: 'view VendorsInvoice',
      fail: '/'
    }
  }, {
    path: '/notifications/whatsapp',
    name: 'WhatsappNotifications',
    component: __WEBPACK_IMPORTED_MODULE_19__components_resources_WhatsappNotifications___default.a,
    secure: true,
    meta: {
      can: 'view WhatsappNotifications',
      fail: '/'
    }
  },
  // {
  //   path: '/notifications/sms',
  //   name: 'SMSNotifications',
  //   component: TwilioNotifications,
  //   secure: true,
  //   meta: {
  //     can: 'view SMSNotifications',
  //     fail: '/'
  //   }
  // },
  {
    path: '/reminders',
    name: 'Reminders',
    component: __WEBPACK_IMPORTED_MODULE_24__components_resources_Notifications___default.a,
    secure: true,
    meta: {
      can: 'view Reminders',
      fail: '/'
    }
  }, {
    path: '/commissions-reports',
    name: 'CommissionsReports',
    component: __WEBPACK_IMPORTED_MODULE_25__components_resources_Analytics___default.a,
    secure: true,
    meta: {
      can: 'view Analytics',
      fail: '/'
    }
  }, {
    path: '/sales-report',
    name: 'SalesReport',
    component: __WEBPACK_IMPORTED_MODULE_26__components_resources_SalesReport___default.a,
    secure: true,
    meta: {
      can: 'view SalesReport',
      fail: '/'
    }
  }, {
    path: '/inventory-report',
    name: 'InventoryReport',
    component: __WEBPACK_IMPORTED_MODULE_27__components_resources_InventoryReport___default.a,
    secure: true,
    meta: {
      can: 'view InventoryReport',
      fail: '/'
    }
  }, {
    path: '/notifications',
    name: 'SMSNotifications',
    component: __WEBPACK_IMPORTED_MODULE_24__components_resources_Notifications___default.a,
    secure: true,
    meta: {
      can: 'view Notifications',
      fail: '/'
    }
  }, {
    path: '/cases/:id',
    name: 'CasesDetail',
    component: __WEBPACK_IMPORTED_MODULE_20__components_detail_CasesDetail___default.a,
    props: true,
    secure: true,
    meta: {
      can: 'view CasesDetail',
      fail: '/'
    }
  }, {
    path: '/templates',
    name: 'PDFTemplates',
    component: __WEBPACK_IMPORTED_MODULE_21__components_PDFTemplates___default.a,
    secure: true,
    meta: {
      can: 'view PDFTemplates',
      fail: '/'
    }
  }, {
    path: '/roles',
    name: 'Roles',
    component: __WEBPACK_IMPORTED_MODULE_22__components_resources_Roles___default.a,
    secure: true,
    meta: {
      can: 'view Roles',
      fail: '/'
    }
  }, {
    path: '/onboard-client',
    name: 'OnboardClient',
    component: __WEBPACK_IMPORTED_MODULE_23__components_OnboardClient___default.a,
    secure: true,
    props: true,
    meta: {
      can: 'view OnboardClient',
      fail: '/'
    }
  }, {
    path: '/event-checklist',
    name: 'EventChecklist',
    component: __WEBPACK_IMPORTED_MODULE_11__components_resources_Cases___default.a,
    props: {
      detailCaseButtonActionIsGoToCheckListsTab: true
    },
    secure: true,
    meta: {
      can: 'view EventChecklist',
      fail: '/'
    }
  }, {
    path: '/event-crew',
    name: 'SelectCrew',
    component: __WEBPACK_IMPORTED_MODULE_11__components_resources_Cases___default.a,
    props: {
      crewSelecting: true
    },
    secure: true,
    meta: {
      can: 'view SelectCrew',
      fail: '/'
    }
  }, {
    path: '/billing',
    name: 'Billing',
    component: __WEBPACK_IMPORTED_MODULE_12__components_resources_BillingCases___default.a,
    props: {
      detailCaseButtonActionIsGoToInvoicesTab: true
    },
    secure: true,
    meta: {
      can: 'view Billing',
      fail: '/'
    }
  }, {
    path: '/inventory-report',
    name: 'InventoryReport',
    component: __WEBPACK_IMPORTED_MODULE_27__components_resources_InventoryReport___default.a,
    secure: true,
    meta: {
      can: 'view InventoryReport',
      fail: '/'
    }
  }, {
    path: '/cases-calendar',
    name: 'ViewCasesCalendar',
    component: __WEBPACK_IMPORTED_MODULE_28__components_ViewCasesCalendar___default.a,
    props: true,
    secure: true,
    meta: {
      can: 'view EventChecklist',
      fail: '/'
    }
  }, {
    path: '/scheduler',
    name: 'ViewCasesTable',
    component: __WEBPACK_IMPORTED_MODULE_29__components_ViewCasesTable___default.a,
    props: {
      detailCaseButtonActionIsGoToCheckListsTab: true
    },
    secure: true,
    meta: {
      can: 'view EventChecklist',
      fail: '/'
    }
  }, {
    path: '/settings',
    name: 'Settings',
    component: __WEBPACK_IMPORTED_MODULE_32__components_Settings___default.a,
    secure: true,
    meta: {
      can: 'view Settings',
      fail: '/'
    }
  }, {
    path: '/test',
    name: 'Settings',
    component: __WEBPACK_IMPORTED_MODULE_33__components_TestCalendar___default.a,
    secure: true,
    meta: {
      can: 'view Settings',
      fail: '/'
    }
    // {
    //   path: '/forms',
    //   name: 'Forms',
    //   component: Forms,
    //   secure: true
    // }
  }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 397 */,
/* 398 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(838)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(1016),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__ = __webpack_require__(9);



var categoriesAPI = {
  // specific categories api
  resource: 'categories',

  loadCategories: function loadCategories() {
    var _this = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var categories = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex(_this.resource);

      categories.then(function (result) {
        result.forEach(function (item, i) {
          item.text = item.name;
          item.value = item.id;
        });

        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  storeCategory: function storeCategory(name) {
    var _this2 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var categories = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceStore(_this2.resource, {
        name: name
      });

      categories.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  editCategory: function editCategory(categoryId, payload) {
    var _this3 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var result = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceUpdate(_this3.resource, categoryId, payload);

      result.then(function (result) {
        resolve(result !== undefined ? result.data.additional_data : null);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (categoriesAPI);

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__ = __webpack_require__(9);



var checklistsAPI = {
  // specific checklists api
  resource: 'checklists',
  url_query: '/api/checklists',

  delete: function _delete(itemId) {
    var _this = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var result = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceDestroy(_this.resource, itemId);

      result.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  },
  add: function add(itemsIds, itemType, question) {
    var _this2 = this;

    var casesId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var payload = {
        items_ids: itemsIds,
        item_type: itemType,
        cases_id: casesId,
        question: question
      };

      var result = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceStore(_this2.resource, payload);

      result.then(function (result) {
        resolve(result.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  },
  editQuestion: function editQuestion(itemId, question) {
    var _this3 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var payload = {
        question: question
      };

      var result = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceUpdate(_this3.resource, itemId, payload);

      result.then(function (result) {
        resolve(result.data.additional_data);
      }, function (error) {
        reject(error);
      });
    });
  },
  setCheckListStatus: function setCheckListStatus(itemId, status) {
    var _this4 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var payload = {
        is_complete: status
      };

      var result = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceUpdate(_this4.resource, itemId, payload, '/completition');

      result.then(function (result) {
        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (checklistsAPI);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__ = __webpack_require__(9);



var permissionsAPI = {
  // specific permissions api
  loadPermissions: function loadPermissions() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var permissions = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex('permissions');

      permissions.then(function (result) {
        result.forEach(function (item, i) {
          item.text = item.name;
          item.value = item.id;
        });

        resolve(result);
      }, function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (permissionsAPI);

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__adapter_js__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_element_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_spinner_js__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_chat_board_js__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_login_board_js__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_message_board_js__ = __webpack_require__(430);
/* eslint-disable */











var ELEMENT_ID = 'sb_chat';
var ERROR_MESSAGE_SDK = 'Please import "SendBird SDK" on first.';
var ERROR_MESSAGE_APP_ID = 'Please pass "APP_ID" when start.';
var ERROR_MESSAGE_USER_INFO = 'Please pass "USER_ID" and "NICKNAME" when start.';
var ERROR_MESSAGE_CHANNEL_URL = 'Please pass "CHANNEL_URL" when start.';
var ERROR_MESSAGE = 'Please create "sb_chat" element on first.';

var MAX_MESSAGE_COUNT = 100;

window.WebFontConfig = {
  google: { families: ['Lato:400,700'] }
};

var LiveChat = function () {
  function LiveChat() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, LiveChat);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(LiveChat, [{
    key: 'init',
    value: function init(appId, arg) {
      if (!window.SendBird) {
        console.error(ERROR_MESSAGE_SDK);
        return;
      }
      if (!appId) {
        console.error(ERROR_MESSAGE_APP_ID);
        return;
      }
      switch (arg.type) {
        case "channel":
          if (!arg.data.channelUrl) {
            console.error(ERROR_MESSAGE_CHANNEL_URL);
            return;
          }
          break;
        case "user":
          if (!arg.data.userId || !arg.data.nickname) {
            console.error(ERROR_MESSAGE_USER_INFO);
            return;
          }
          break;
      }
      this.loadGoogleFont();

      var _this = this;
      this.$chat = new __WEBPACK_IMPORTED_MODULE_3__elements_element_js__["a" /* default */](document.getElementById(ELEMENT_ID));
      if (this.$chat) {
        this.adapter = new __WEBPACK_IMPORTED_MODULE_2__adapter_js__["a" /* default */](appId);
        this.$spinner = new __WEBPACK_IMPORTED_MODULE_4__elements_spinner_js__["a" /* default */]();
        this.$chatBoard = new __WEBPACK_IMPORTED_MODULE_5__elements_chat_board_js__["a" /* default */](this.$chat);
        this.$messageBoard = new __WEBPACK_IMPORTED_MODULE_7__elements_message_board_js__["a" /* default */]();

        this.$messageBoard.$content.on('scroll', function (e) {
          if (_this.$messageBoard.$content.getScrollY() == 0) {
            _this.adapter.getMessageList(function (messageList) {
              _this.$messageBoard.render(messageList, false, true);
            });
          }
          if (_this.$messageBoard.$content.isScrollBottom()) {
            _this.$messageBoard.removeBottomBar();
          }
        });

        _this.$messageBoard.$icon.on('click', function () {
          var textMessage = _this.$messageBoard.getMessage();
          _this.$messageBoard.clearInput();
          if (textMessage) {
            textMessage = textMessage.replace(/<[\/]?\s*br\s*[\/]?>/gi, "\n");
            _this.adapter.sendMessage(textMessage, function (message) {
              _this.$messageBoard.render([message], true, false);
              _this.clearOverflowedMessages();
            });
          }
        });
      }
    }
  }, {
    key: 'start',
    value: function start(appId, channelUrl) {
      this.init(appId, {
        'type': 'channel',
        'data': {
          'channelUrl': channelUrl
        }
      });

      if (this.$chat) {
        var _this = this;
        this.$loginBoard = new __WEBPACK_IMPORTED_MODULE_6__elements_login_board_js__["a" /* default */]();
        this.$loginBoard.onLogin(function () {
          if (!_this.$loginBoard.$login.hasClass("disabled")) {
            _this.$loginBoard.disable();
            _this.$spinner.attachTo(_this.$loginBoard.$login);

            _this.adapter.connect(_this.$loginBoard.$userId.val(), _this.$loginBoard.$nickname.val(), function () {
              _this.$spinner.remove(_this.$loginBoard.$login);
              _this.$loginBoard.reset();
              _this.$spinner.attachTo(_this.$messageBoard.$content);

              _this.$chatBoard.replaceElement(_this.$loginBoard, _this.$messageBoard);
              _this.adapter.connectionHandler(channelUrl, _this);
              _this.enterChannel(channelUrl);
            });
          }
        });
        this.$chatBoard.appendElement(this.$loginBoard);
      } else {
        console.error(ERROR_MESSAGE);
      }
    }
  }, {
    key: 'startWithConnect',
    value: function startWithConnect(appId, userId, nickname, callback) {
      var _this = this;
      _this.init(appId, {
        'type': 'user',
        'data': {
          'userId': userId,
          'nickname': nickname
        }
      });
      if (_this.$chat) {
        _this.adapter.connect(userId, nickname, function () {
          _this.$spinner.attachTo(_this.$messageBoard.$content);
          _this.$chatBoard.appendElement(_this.$messageBoard);
          callback();
        });
      } else {
        console.error(ERROR_MESSAGE);
      }
    }
  }, {
    key: 'enterChannel',
    value: function enterChannel(channelUrl, callback) {
      var _this = this;
      _this.adapter.enterChannel(channelUrl, function () {
        _this.adapter.getMessageList(function (messageList) {
          _this.$spinner.remove(_this.$messageBoard.$content);
          _this.$messageBoard.render(messageList, true, false);

          _this.adapter.createHandler(function (channel, message) {
            if (channel.url == channelUrl) {
              var isBottom = _this.$messageBoard.isScrollBottom();
              _this.$messageBoard.render([message], isBottom, false);
              if (!isBottom) {
                _this.$messageBoard.createBottomBar();
              } else _this.clearOverflowedMessages();
            }
          });
        }, true);
        if (callback) callback();
      });
    }
  }, {
    key: 'exitChannel',
    value: function exitChannel(callback) {
      this.adapter.exitChannel(callback);
    }
  }, {
    key: 'clearOverflowedMessages',
    value: function clearOverflowedMessages() {
      var $messages = this.$messageBoard.$content.children();
      var overCount = $messages.length - MAX_MESSAGE_COUNT;
      if (overCount > 0) {
        for (var i = 0; i < overCount; i++) {
          this.$messageBoard.$content.removeFirst();
        }
      }
    }
  }, {
    key: 'loadGoogleFont',
    value: function loadGoogleFont() {
      var wf = document.createElement('script');
      wf.src = ('https:' == document.location.protocol ? 'https' : 'http') + '://ajax.googleapis.com/ajax/libs/webfont/1.5.18/webfont.js';
      wf.type = 'text/javascript';
      wf.async = 'true';
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(wf, s);
    }
  }]);

  return LiveChat;
}();

/* harmony default export */ __webpack_exports__["a"] = (LiveChat);

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChatBoard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__element_js__ = __webpack_require__(91);
/* eslint-disable */








var ChatBoard = function (_Element) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ChatBoard, _Element);

  function ChatBoard(parent) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ChatBoard);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ChatBoard.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ChatBoard)).call(this));

    _this.setClass('chat-board');

    var top = new __WEBPACK_IMPORTED_MODULE_4__element_js__["a" /* default */]();
    top.setClass('top');
    top.val('Chat Live');
    parent.appendElement(_this.appendElement(top));
    return _this;
  }

  return ChatBoard;
}(__WEBPACK_IMPORTED_MODULE_4__element_js__["a" /* default */]);



/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoginBoard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__element_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__adapter_js__ = __webpack_require__(139);
/* eslint-disable */










var TEXT_INPUT_USER_ID = 'USER ID';
var TEXT_INPUT_NICKNAME = 'NICKNAME';
var TEXT_LOGIN_BTN = 'Start Chat';

var LoginBoard = function (_Element) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(LoginBoard, _Element);

  function LoginBoard(board) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LoginBoard);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LoginBoard.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(LoginBoard)).call(this, board));

    _this.setClass('login-board');

    var $userIdContainer = new __WEBPACK_IMPORTED_MODULE_5__element_js__["a" /* default */]();
    $userIdContainer.setClass('content', 'user-id');

    var $userIdText = new __WEBPACK_IMPORTED_MODULE_5__element_js__["a" /* default */]();
    $userIdText.setClass('input-text');
    $userIdText.val(TEXT_INPUT_USER_ID);
    $userIdContainer.appendElement($userIdText);

    var $userIdInput = _this.$userId = new __WEBPACK_IMPORTED_MODULE_5__element_js__["a" /* default */]('input');
    $userIdInput.setClass('input');
    $userIdContainer.appendElement($userIdInput);
    _this.appendElement($userIdContainer);

    var $nicknameContainer = new __WEBPACK_IMPORTED_MODULE_5__element_js__["a" /* default */]();
    $nicknameContainer.setClass('content', 'nickname');

    var $nicknameText = new __WEBPACK_IMPORTED_MODULE_5__element_js__["a" /* default */]();
    $nicknameText.setClass('input-text');
    $nicknameText.val(TEXT_INPUT_NICKNAME);
    $nicknameContainer.appendElement($nicknameText);

    var $nicknameInput = _this.$nickname = new __WEBPACK_IMPORTED_MODULE_5__element_js__["a" /* default */]('input');
    $nicknameInput.setClass('input');
    $nicknameContainer.appendElement($nicknameInput);
    _this.appendElement($nicknameContainer);

    var $login = _this.$login = new __WEBPACK_IMPORTED_MODULE_5__element_js__["a" /* default */]();
    $login.setClass('btn', 'disabled');
    $login.val(TEXT_LOGIN_BTN);
    _this.appendElement($login);

    var updateLoginButtonState = function updateLoginButtonState() {
      if (_this.$userId.val().trim() && _this.$nickname.val().trim()) $login.removeClass('disabled');else $login.addClass('disabled');
    };
    var userIdEventHandler = function userIdEventHandler(event) {
      if (event && event.keyCode == __WEBPACK_IMPORTED_MODULE_6__adapter_js__["a" /* default */].ENTER) _this.$nickname.focus();else updateLoginButtonState();
    };
    var nicknameEventHandler = function nicknameEventHandler(event) {
      if (event && event.keyCode == __WEBPACK_IMPORTED_MODULE_6__adapter_js__["a" /* default */].ENTER) {
        if (!_this.$login.hasClass('disabled')) {
          _this.$login.click();
        }
      } else updateLoginButtonState();
    };

    _this.$userId.on('keyup', userIdEventHandler);
    _this.$userId.on('change', userIdEventHandler);
    _this.$nickname.on('keyup', nicknameEventHandler);
    _this.$nickname.on('change', nicknameEventHandler);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(LoginBoard, [{
    key: 'disable',
    value: function disable() {
      this.$userId.disable();
      this.$nickname.disable();
      this.$login.addClass('disabled');
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.$userId.enable();
      this.$userId.val("");
      this.$nickname.enable();
      this.$nickname.val("");

      this.$login.val(TEXT_LOGIN_BTN);
      this.toggle(false);
    }
  }, {
    key: 'toggle',
    value: function toggle(isEnabled) {
      if (isEnabled || isEnabled === undefined) {
        this.$login.removeClass('disabled');
        this.$login.setStyle('cursor', '');
      } else {
        this.$login.addClass('disabled');
        this.$login.setStyle('cursor', 'defaeult');
      }
    }
  }, {
    key: 'onLogin',
    value: function onLogin(hdlr) {
      this.$login.on('click', hdlr);
    }
  }]);

  return LoginBoard;
}(__WEBPACK_IMPORTED_MODULE_5__element_js__["a" /* default */]);



/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MessageBoard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__element_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__adapter_js__ = __webpack_require__(139);
/* eslint-disable */










var MESSAGE_PREFIX = ' : ';
var LAST_MESSAGE_YESTERDAY = 'YESTERDAY';
var MORE_MESSAGE_BELOW = 'More message below.';

var MAX_HEIGHT_INPUT_OUTER = 50;
var MAX_HEIGHT_INPUT_INNER = 39;
var MIN_HEIGHT_INPUT_INNER = 14;

var MessageBoard = function (_Element) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MessageBoard, _Element);

  function MessageBoard() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MessageBoard);

    var _this2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MessageBoard.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(MessageBoard)).call(this));

    _this2.setClass('message-board');

    var $content = new __WEBPACK_IMPORTED_MODULE_5__element_js__["a" /* default */]();
    $content.setClass('content');
    _this2.appendElement($content);

    var $contentInput = new __WEBPACK_IMPORTED_MODULE_5__element_js__["a" /* default */]();
    $contentInput.setClass('content-input');

    var $input = new __WEBPACK_IMPORTED_MODULE_5__element_js__["a" /* default */]();
    $input.setClass('input');
    $input.attr('contenteditable', true);

    $input.on('focus', function () {
      if (!$contentInput.hasClass("active")) $contentInput.addClass("active");
    });
    $input.on('blur', function () {
      if ($contentInput.hasClass("active")) $contentInput.removeClass("active");
    });
    $input.on('keydown', function (event) {
      _this2.responsiveInput();
      if (event.keyCode == __WEBPACK_IMPORTED_MODULE_6__adapter_js__["a" /* default */].KR) {
        _this2.kr = _this2.$input.val();
      }
      if (event.keyCode == __WEBPACK_IMPORTED_MODULE_6__adapter_js__["a" /* default */].ENTER && !event.shiftKey) {
        event.preventDefault();
        _this2.$icon.click();
        _this2.clearInput();
      }
    });
    $input.on('keyup', function () {
      _this2.responsiveInput();
    });
    $input.on('paste', function (event) {
      event.stopPropagation();
      event.preventDefault();

      var clipboardData = event.clipboardData || window.clipboardData;
      $input.appendContent(clipboardData.getData('Text'));
    });
    $contentInput.appendElement($input);

    var $inputForm = new __WEBPACK_IMPORTED_MODULE_5__element_js__["a" /* default */]('input');
    $inputForm.setClass('input-form');
    $inputForm.attr('type', 'hidden');
    $contentInput.appendElement($inputForm);

    var $icon = new __WEBPACK_IMPORTED_MODULE_5__element_js__["a" /* default */]();
    $icon.setClass(['icon']);
    $contentInput.appendElement($icon);
    _this2.appendElement($contentInput);

    _this2.$content = $content;
    _this2.$input = $input;
    _this2.$form = $inputForm;
    _this2.$icon = $icon;
    _this2.reset();
    return _this2;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(MessageBoard, [{
    key: 'getMessage',
    value: function getMessage() {
      return this.$input.val().trim() || this.kr;
    }
  }, {
    key: 'createMessageElement',
    value: function createMessageElement(message) {
      var $item = new __WEBPACK_IMPORTED_MODULE_5__element_js__["a" /* default */]();
      $item.setClass('message-item');
      $item.attr('id', message.messageId);

      var $text = new __WEBPACK_IMPORTED_MODULE_5__element_js__["a" /* default */]();
      $text.setClass('message-text');

      var $nickname = new __WEBPACK_IMPORTED_MODULE_5__element_js__["a" /* default */]('label');
      var nicknameColor = this.senderColor[message.sender.userId];
      if (!nicknameColor) {
        nicknameColor = Math.floor(Math.random() * 12 + 1);
        nicknameColor = nicknameColor < 10 ? '0' + nicknameColor.toString() : nicknameColor.toString();
        this.senderColor[message.sender.userId] = nicknameColor;
      }
      $nickname.setClass('nickname', 'nickname-color-' + nicknameColor);
      $nickname.val(message.sender.nickname + MESSAGE_PREFIX);

      $text.appendElement($nickname);
      $text.appendContent(message.message, {
        xssProtectionEnabled: true,
        showEndOfLine: true
      });
      $item.appendElement($text);

      var $time = new __WEBPACK_IMPORTED_MODULE_5__element_js__["a" /* default */]();
      $time.setClass('time');
      $time.val(this.getTime(message));
      $item.appendElement($time);
      return $item;
    }
  }, {
    key: 'getTime',
    value: function getTime(message) {
      var months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
      var _getDay = function _getDay(val) {
        var day = parseInt(val) % 10;
        var digit = day % 10;
        switch (digit) {
          case 1:
            return day + 'st';
          case 2:
            return day + 'nd';
          case 3:
            return day + 'rd';
          default:
            return day + 'th';
        }
      };
      var _checkTime = function _checkTime(val) {
        return +val < 10 ? '0' + val : val;
      };

      if (message) {
        var _nowDate = new Date();
        var _date = new Date(message.createdAt);
        if (_nowDate.getDate() - _date.getDate() == 1) {
          return LAST_MESSAGE_YESTERDAY;
        } else if (_nowDate.getFullYear() == _date.getFullYear() && _nowDate.getMonth() == _date.getMonth() && _nowDate.getDate() == _date.getDate()) {
          return _checkTime(_date.getHours()) + ':' + _checkTime(_date.getMinutes());
        } else {
          return months[_date.getMonth()] + ' ' + _getDay(_date.getDate());
        }
      }
      return '';
    }
  }, {
    key: 'render',
    value: function render(messageList, isScrollBottom, isLoadingMore) {
      var moveScroll = 0;
      for (var i in messageList) {
        var message = messageList[i];
        if (message.isUserMessage()) {
          var $item = this.createMessageElement(message);
          if (isLoadingMore) {
            var firstChild = this.$content.first();
            this.$content.insertBefore($item, firstChild);
          } else this.$content.appendElement($item);
          moveScroll += $item.getFullHeight();
        } else {
          // put code here for other message type
        }
      }
      if (isLoadingMore) this.$content.scrollY(moveScroll);
      if (isScrollBottom) this.$content.scrollToBottom();
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.senderColor = {};
      this.kr = null;
    }
  }, {
    key: 'toggleIcon',
    value: function toggleIcon() {
      if (this.$input.val()) {
        if (!this.$icon.hasClass('active')) this.$icon.addClass('active');
      } else this.$icon.removeClass('active');
    }
  }, {
    key: 'responsiveInput',
    value: function responsiveInput() {
      var outerHeight = this.$input.getScrollHeight();
      var paddingTop = this.$input.getPadding().top;
      var innerHeight = outerHeight - paddingTop * 2;
      var expectPadding = MAX_HEIGHT_INPUT_OUTER - innerHeight;

      if (innerHeight < MIN_HEIGHT_INPUT_INNER) {
        this.$input.setVerticalPadding((MAX_HEIGHT_INPUT_OUTER - MIN_HEIGHT_INPUT_INNER) / 2);
      } else if (innerHeight > MAX_HEIGHT_INPUT_INNER) {
        this.$input.setVerticalPadding((MAX_HEIGHT_INPUT_OUTER - MAX_HEIGHT_INPUT_INNER) / 2);
      } else {
        this.$input.setVerticalPadding(expectPadding / 2);
      }
      this.toggleIcon();
    }
  }, {
    key: 'clearInput',
    value: function clearInput() {
      var items = this.$input.findByTag('div');
      for (var i = 0; i < items.length; i++) {
        items[i].remove();
      }this.$input.val("");
      this.kr = null;
      this.toggleIcon();
    }
  }, {
    key: 'createBottomBar',
    value: function createBottomBar() {
      var _this = this;
      var $btn = new __WEBPACK_IMPORTED_MODULE_5__element_js__["a" /* default */]();
      $btn.setClass('btn');
      $btn.val(MORE_MESSAGE_BELOW);
      $btn.on('click', function () {
        _this.$content.scrollToBottom();
        _this.removeBottomBar();
      });
      if (!this.$bottom) {
        this.appendElement($btn);
        this.$bottom = $btn;
      }
    }
  }, {
    key: 'removeBottomBar',
    value: function removeBottomBar() {
      if (this.$bottom) {
        this.removeElement(this.$bottom);
        this.$bottom = null;
      }
    }
  }]);

  return MessageBoard;
}(__WEBPACK_IMPORTED_MODULE_5__element_js__["a" /* default */]);



/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Spinner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__element_js__ = __webpack_require__(91);
/* eslint-disable */









var SPINNER_COUNT = 3;

var Spinner = function (_Element) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Spinner, _Element);

  function Spinner() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Spinner);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Spinner.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Spinner)).call(this));

    _this.setClass('sb-spinner');
    for (var i = 0; i < SPINNER_COUNT; i++) {
      _this.appendElement(new __WEBPACK_IMPORTED_MODULE_5__element_js__["a" /* default */]());
    }
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Spinner, [{
    key: 'attachTo',
    value: function attachTo($target) {
      $target.val("");
      $target.appendElement(this);
    }
  }, {
    key: 'remove',
    value: function remove($target) {
      if ($target.first()) {
        $target.removeElement(this);
      }
    }
  }]);

  return Spinner;
}(__WEBPACK_IMPORTED_MODULE_5__element_js__["a" /* default */]);



/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_browser_acl__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_browser_acl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_browser_acl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vee_validate__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_uuid__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_signature_pad__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__filters__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config_config__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__api_user__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__config_acl__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_time_input_polyfill_auto__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_time_input_polyfill_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_time_input_polyfill_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuetify_dist_vuetify_min_css__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_simple_calendar_dist_static_css_default_css__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_simple_calendar_dist_static_css_default_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_simple_calendar_dist_static_css_default_css__);
/* eslint-disable no-unused-vars */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.























__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_uuid__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vee_validate__["a" /* default */], { errorBagName: 'vErrors' });
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_browser_acl___default.a, __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__config_acl__["a" /* default */], { router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */] });
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_signature_pad__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$axios = __WEBPACK_IMPORTED_MODULE_6_axios___default.a;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype._ = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.moment = __WEBPACK_IMPORTED_MODULE_8_moment___default.a;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$dfsUserAPI = __WEBPACK_IMPORTED_MODULE_14__api_user__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$dfsConfig = __WEBPACK_IMPORTED_MODULE_13__config_config__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$bus = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]();

__WEBPACK_IMPORTED_MODULE_6_axios___default.a.defaults.headers.common['Content-Type'] = 'application/json';
__WEBPACK_IMPORTED_MODULE_6_axios___default.a.defaults.headers.common['Accept'] = 'application/json';

__WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */].dispatch('setAxios', __WEBPACK_IMPORTED_MODULE_6_axios___default.a);
__WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */].dispatch('setConfig', __WEBPACK_IMPORTED_MODULE_13__config_config__["a" /* default */]);

var oauthToken = localStorage.getItem('oauthToken');

if (oauthToken) {
  __WEBPACK_IMPORTED_MODULE_6_axios___default.a.defaults.headers.common['Authorization'] = 'Bearer ' + oauthToken;
}

__WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */].state.axios.interceptors.request.use(function (request) {
  __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */].dispatch('setLoading');
  return request;
});

__WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */].state.axios.interceptors.response.use(function (response) {
  __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */].dispatch('unsetLoading');
  return response;
}, function (error) {
  __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */].dispatch('unsetLoading');
  if (error.response.status === 401) {
    __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */].dispatch('logOut').then(function () {
      localStorage.clear();
      __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push({
        name: 'Login'
      });
    });
  }
});

if (__WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */].getters.currentUserRoles.length > 0 && __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */].getters.logInStatus === true || !__WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */].getters.logInStatus) {
  __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */].dispatch('setAppIsLoaded', true);
}

/* eslint-disable no-new */
var vm = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App___default.a },
  template: '<App/>'
});

window.vm = vm;

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_cases__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_resources_crud__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);






var state = {
  onBoardClientForm: {
    forms_id: 1,
    cases_id: null,
    answer: {
      form_name: 'OnBoard Client',
      form_answers: {
        main_form: {
          deceased_date: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD').toString(),
          deceased_invoice_no: null,
          deceased_name: null,
          deceased_gender: null,
          deceased_name_chinese: null,
          deceased_age: null,
          deceased_death_certificate_no: null,
          deceased_religion: null,
          deceased_dialect: null,
          deceased_days_of_wake: null,
          deceased_location_of_wake: null,
          deceased_burial_location: null,
          deceased_embalming: null
        },
        agreement_form_data: {
          no_valuable_items: false,
          ash_placement_arranged_by: null,
          no_additional_items_on_body: false,
          ashes_placement_agreement: false,
          valuable_items_declaration: '',
          valuable_additional_items_declaration: ''
        },
        client_form_data: {
          relationship_with_deceased: null,
          signature: null,
          date: null,
          email: null,
          contact_number: null,
          name: null,
          nric_fin_number: null,
          new_return: 'new'
        }
      }
    }
  },
  feedbackForm: {
    id: null,
    forms_id: 2,
    cases_id: null,
    answer: {
      dateStart: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD'),
      timeStart: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('HH:mm'),
      familyAssembleTime: null,
      funeralServiceCommencedTime: null,
      cortegeLeaveTime: null,
      selectedUser: null,
      funeralRites: null,
      churchLocation: null,
      churchMassAt: null,
      drivingPass: null,
      cremationTime: null,
      cremationLocation: null,
      postFuneralSendTo: null,
      ashCollection: null,
      ashCollectionDate: null,
      ashCollectionTime: null,
      sendAshTo: null,
      sendAshToDate: null,
      sendAshToTime: null,
      seaBurialAt: null,
      seaBurialAtDate: null,
      seaBurialAtTime: null,
      tentageAfter: null,

      addOnServices: [],

      satisfiedWithSetUp: null,
      satisfiedWithSetUpWhy: null,
      satisfiedWithCatering: null,
      satisfiedWithCateringWhy: null,
      satisfiedWithNightService: null,
      satisfiedWithNightServiceWhy: null,
      satisfiedWithInformationProvided: null,
      satisfiedWithInformationProvidedWhy: null
    }
  },
  lastOnBoardForm: null,
  lastFeedbackForm: null,
  caseForms: [],
  editable: false,
  loadingCaseForms: true
};

var getters = {
  getLoadingFormsStatus: function getLoadingFormsStatus(state) {
    return state.loadingCaseForms;
  },
  getCaseForms: function getCaseForms(state) {
    return state.caseForms;
  },
  isOnBoardClientFormAnswersEditable: function isOnBoardClientFormAnswersEditable(state) {
    return state.editable;
  },
  getOnBoardClientForm: function getOnBoardClientForm(state) {
    return state.onBoardClientForm;
  },
  getOnBoardClientFormAnswers: function getOnBoardClientFormAnswers(state) {
    return state.onBoardClientForm.answer.form_answers;
  },
  getFeedbackClientForm: function getFeedbackClientForm(state) {
    return state.feedbackForm;
  },

  getLastOnBoardForm: function getLastOnBoardForm(state) {
    return state.lastOnBoardForm;
  },
  getLastFeedbackForm: function getLastFeedbackForm(state) {
    return state.lastFeedbackForm;
  }
};

var actions = {
  loadCaseForms: function loadCaseForms(_ref, caseModel) {
    var state = _ref.state,
        commit = _ref.commit;

    state.loadingCaseForms = true;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      state.onBoardClientForm.cases_id = caseModel.id;
      state.feedbackForm.cases_id = caseModel.id;
      commit('receiveCaseForms', caseModel);
      resolve();
    });
  },
  storeOnBoardForm: function storeOnBoardForm(_ref2) {
    var state = _ref2.state,
        commit = _ref2.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_resources_crud__["a" /* default */].dfsResourceStore('answers', state.onBoardClientForm).then(function (result) {
        resolve(result);
      }, function () {});
    });
  },
  storeFeedbackForm: function storeFeedbackForm(_ref3) {
    var state = _ref3.state,
        commit = _ref3.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (state.feedbackForm.id !== undefined) {
        __WEBPACK_IMPORTED_MODULE_2__api_resources_crud__["a" /* default */].dfsResourceUpdate('answers', state.feedbackForm.id, state.feedbackForm).then(function (result) {
          resolve(result);
        }, function () {});
      } else {
        __WEBPACK_IMPORTED_MODULE_2__api_resources_crud__["a" /* default */].dfsResourceStore('answers', state.feedbackForm).then(function (result) {
          resolve(result);
        }, function () {});
      }
    });
  },
  clearCaseForms: function clearCaseForms(_ref4) {
    var commit = _ref4.commit;

    commit('clearCaseForms');
  },
  loadPdfFeedback: function loadPdfFeedback(_ref5, answersId) {
    var commit = _ref5.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api_resources_cases__["a" /* default */].loadPDFFeedback(answersId).then(function (result) {
        resolve(result);
      });
    });
  }
};

var mutations = {
  receiveCaseForms: function receiveCaseForms(state, caseForms) {
    if (caseForms && caseForms.answers && caseForms.answers.length > 0) {
      state.caseForms = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.sortBy(caseForms.answers, 'created_at').reverse();
      state.editable = true;

      state.lastOnBoardForm = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(state.caseForms, function (f) {
        return f.form.name === 'OnBoardClient';
      });
      state.lastFeedbackForm = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(state.caseForms, function (f) {
        return f.form.name === 'Feedback';
      });

      if (state.lastOnBoardForm) state.onBoardClientForm.answer.form_answers = JSON.parse(state.lastOnBoardForm.answer).form_answers;
      if (state.lastFeedbackForm) {
        state.feedbackForm = state.lastFeedbackForm;
        state.feedbackForm.answer = JSON.parse(state.lastFeedbackForm.answer);
      }
    }
    state.loadingCaseForms = false;
  },
  updateMainOnBoardForm: function updateMainOnBoardForm(state, mainForm) {
    state.onBoardClientForm.answer.form_answers.main_form = mainForm;
  },
  updateAgreementOnBoardForm: function updateAgreementOnBoardForm(state, agreementFormData) {
    state.onBoardClientForm.answer.form_answers.agreement_form_data = agreementFormData;
  },
  updateClientOnBoardForm: function updateClientOnBoardForm(state, clientFormData) {
    state.onBoardClientForm.answer.form_answers.client_form_data = clientFormData;
  },
  updateFeedbackForm: function updateFeedbackForm(state, feedbackFormAnswers) {
    state.feedbackForm.answer = feedbackFormAnswers;
  },
  clearCaseForms: function clearCaseForms(state) {
    state.caseForms = [];
    state.onBoardClientForm = {
      forms_id: 1,
      cases_id: null,
      answer: {
        form_name: 'OnBoard Client',
        form_answers: {
          main_form: {
            deceased_date: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD').toString(),
            deceased_invoice_no: null,
            deceased_name: null,
            deceased_gender: null,
            deceased_name_chinese: null,
            deceased_age: null,
            deceased_death_certificate_no: null,
            deceased_religion: null,
            deceased_dialect: null,
            deceased_days_of_wake: null,
            deceased_location_of_wake: null,
            deceased_burial_location: null,
            deceased_embalming: null
          },
          agreement_form_data: {
            no_valuable_items: false,
            ash_placement_arranged_by: null,
            no_additional_items_on_body: false,
            ashes_placement_agreement: false,
            valuable_items_declaration: '',
            valuable_additional_items_declaration: ''
          },
          client_form_data: {
            relationship_with_deceased: null,
            signature: null,
            date: null,
            email: null,
            contact_number: null,
            name: null,
            nric_fin_number: null
          }
        }
      }
    };
    state.editable = false;
    state.loadingCaseForms = false;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_resources_cases__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__caseForms__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);







var state = {
  allCases: [],
  filteredCases: [],
  caseLog: [],
  caseLogManagersFlow: [],
  caseInvoices: [],
  caseVendorInvoices: [],
  caseServices: [],
  caseManager: null,
  editCrewDialog: false,
  editCrewCaseId: null,
  crewDialogCase: null
};

var getters = {
  getEditCrewDialog: function getEditCrewDialog(state) {
    return state.editCrewDialog;
  },
  getEditCrewCaseId: function getEditCrewCaseId(state) {
    return state.editCrewCaseId;
  },
  getAllCases: function getAllCases(state) {
    return state.allCases;
  },
  getFilteredCases: function getFilteredCases(state) {
    return state.filteredCases;
  },
  getCaseById: function getCaseById(state) {
    return function (id) {
      return state.allCases.find(function (ca) {
        return ca.id === id;
      });
    };
  },
  getAllCompletedCases: function getAllCompletedCases(state) {
    return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(state.allCases, function (c) {
      return c.status === 'closed';
    });
  },
  casesWithServicesCommissions: function casesWithServicesCommissions(state, rootGetters) {
    return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(rootGetters.getAllCompletedCases, function (c) {
      var totalPrice = 0;
      c.services = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(c.services, function (s) {
        var productObj = rootGetters.getProductById(s.id);
        s.service = productObj;
        s.commission = productObj !== undefined && productObj.commission !== null ? productObj.commission * s.pivot.quantity : 0;
        totalPrice += productObj !== undefined && productObj.commission !== null ? productObj.price * s.pivot.quantity : 0;
        return s;
      });
      var casketID = rootGetters.filterCasketFromLinkedProducts(c.services);
      var casket = rootGetters.getCasketById(casketID);
      var casketCommission = casket && casket.commission ? casket.commission : 0;
      totalPrice += casket && casket.commission ? casket.price : 0;
      c.commissions = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.sumBy(c.services, 'commission') + casketCommission;
      c.casket = casket;
      c.totalPrice = totalPrice;
      return c;
    });
  },
  getAllCompletedGroupedCases: function getAllCompletedGroupedCases(state, rootGetters) {
    return function (fromDate, toDate, userId) {
      var filteredCases = rootGetters.casesWithServicesCommissions;
      if (userId !== null) {
        filteredCases = filteredCases.filter(function (c) {
          return c.manager_name === userId;
        });
      }
      if (fromDate !== null) {
        filteredCases = filteredCases.filter(function (c) {
          return __WEBPACK_IMPORTED_MODULE_5_moment___default()(c.created_at).format('YYYY-MM-DD') >= __WEBPACK_IMPORTED_MODULE_5_moment___default()(fromDate).format('YYYY-MM-DD');
        });
      }
      if (toDate !== null) {
        filteredCases = filteredCases.filter(function (c) {
          return __WEBPACK_IMPORTED_MODULE_5_moment___default()(c.created_at).format('YYYY-MM-DD') <= __WEBPACK_IMPORTED_MODULE_5_moment___default()(toDate).format('YYYY-MM-DD');
        });
      }
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.groupBy(filteredCases, 'manager_name');
    };
  },
  caseLog: function caseLog(state) {
    return state.caseLog;
  },
  caseLogManagersFlow: function caseLogManagersFlow(state) {
    return state.caseLogManagersFlow;
  },
  currentCaseInvoices: function currentCaseInvoices(state) {
    return state.caseInvoices;
  },
  currentCaseVendorInvoices: function currentCaseVendorInvoices(state) {
    return state.caseVendorInvoices;
  },
  caseManager: function caseManager(state) {
    return state.caseManager;
  },
  getCrewDialogCase: function getCrewDialogCase(state) {
    return state.crewDialogCase;
  }
};

var actions = {
  loadAllCases: function loadAllCases(_ref) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_resources_cases__["a" /* default */].loadCases().then(function (result) {
        commit('receiveCases', result);
        resolve();
      }, function () {});
    });
  },
  getCaseLog: function getCaseLog(_ref2, casesid) {
    var dispatch = _ref2.dispatch,
        commit = _ref2.commit;

    commit('clearCaseLog');
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_resources_cases__["a" /* default */].loadLogForCase(casesid).then(function (result) {
        commit('receiveCaseLog', result);
        dispatch('processManagersFlow', { id: casesid, result: result });
        resolve();
      }, function () {});
    });
  },
  getCaseManager: function getCaseManager(_ref3, casesid) {
    var commit = _ref3.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_resources_cases__["a" /* default */].loadCaseManager(casesid).then(function (result) {
        commit('receiveCaseManager', result);
        resolve();
      });
    });
  },
  processManagersFlow: function processManagersFlow(_ref4, logData) {
    var commit = _ref4.commit,
        getters = _ref4.getters,
        state = _ref4.state;

    var managersData = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(logData.result, function (c) {
      return c.action === 'Case manager changed' || c.action === 'Commissions changed case manager' || 'Commissions changed';
      // return c.action === c.action === 'Commissions changed case manager' || 'Commissions changed'
    });

    managersData = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(managersData, function (action) {
      if (action.payload && getters.getCaseManagerById(action.payload.manager_id)) {
        return {
          id: action.id,
          manager: getters.getCaseManagerById(action.payload.manager_id),
          created_at: action.created_at,
          commissions: action.payload.commissions || 0
        };
      } else {
        return false;
      }
    }).filter(function (i) {
      return i;
    });

    commit('setManagerFlow', managersData);
  },
  changeCaseManagerCommissions: function changeCaseManagerCommissions(_ref5, data) {
    var commit = _ref5.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_resources_cases__["a" /* default */].changeCaseManagerCommissions(data.case_id, { commissions: data.commissions }).then(function (result) {
        resolve(result);
      });
    });
  },
  setCaseManagerCommissions: function setCaseManagerCommissions(_ref6, data) {
    var commit = _ref6.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_resources_cases__["a" /* default */].changeCaseManagerCommissions(data.case_id).then(function (result) {
        resolve(result);
      });
    });
  },
  getCaseInvoices: function getCaseInvoices(_ref7, casesid) {
    var commit = _ref7.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_resources_cases__["a" /* default */].getLinkedInvoices(casesid).then(function (result) {
        commit('receiveCaseInvoices', result);
        resolve(true);
      }, function () {});
    });
  },
  approveCase: function approveCase(_ref8, caseId) {
    var commit = _ref8.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_resources_cases__["a" /* default */].approveCase(caseId).then(function (result) {
        resolve(true);
      }, function () {});
    });
  },
  markInvoiceAsPaid: function markInvoiceAsPaid(_ref9, caseId) {
    var commit = _ref9.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_resources_cases__["a" /* default */].markInvoiceAsPaid(caseId).then(function (result) {
        commit('markInvoiceAsPaid');
        resolve();
      }, function () {});
    });
  },
  loadCase: function loadCase(_ref10, caseId) {
    var commit = _ref10.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_resources_cases__["a" /* default */].loadCase(caseId).then(function (result) {
        var object = result[0] ? result[0] : result;
        commit('receiveCase', object);
        resolve(result);
      });
    });
  },
  updateCase: function updateCase(_ref11, data) {
    var dispatch = _ref11.dispatch,
        commit = _ref11.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_resources_cases__["a" /* default */].updateCase(data.case_id, data.payload).then(function () {
        dispatch('loadCase', data.case_id).then(function (result) {
          resolve(result);
        });
      });
    });
  },
  loadPdfInvoice: function loadPdfInvoice(_ref12, answersId) {
    var commit = _ref12.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_resources_cases__["a" /* default */].loadPDF(answersId).then(function (result) {
        resolve(result);
      });
    });
  },
  loadPdfAgreement: function loadPdfAgreement(_ref13, answersId) {
    var commit = _ref13.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_resources_cases__["a" /* default */].loadPDFAgreement(answersId).then(function (result) {
        resolve(result);
      });
    });
  },
  setCrewDialogCase: function setCrewDialogCase(_ref14, caseObject) {
    var commit = _ref14.commit;

    commit('setCrewDialogCase', caseObject);
  }
};

var mutations = {
  receiveCaseLog: function receiveCaseLog(state, caseLog) {
    state.caseLog = caseLog;
  },
  setManagerFlow: function setManagerFlow(state, flow) {
    state.caseLogManagersFlow = flow;
  },
  receiveCaseManager: function receiveCaseManager(state, manager) {
    state.caseManager = manager || null;
  },
  receiveCase: function receiveCase(state, updatedCase) {
    var item = state.allCases.find(function (item) {
      return item.id === updatedCase.id;
    });
    if (item) __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(item, updatedCase);
  },
  receiveCaseInvoices: function receiveCaseInvoices(state, caseInvoices) {
    if (caseInvoices !== undefined) {
      state.caseInvoices = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(caseInvoices.data.additional_data, function (i) {
        return i.vendors_id === 0 || i.vendors_id !== null;
      });
      state.caseVendorInvoices = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(caseInvoices.data.additional_data, function (i) {
        return i.vendors_id !== 0 || i.vendors_id === null;
      });
    }
  },
  markInvoiceAsPaid: function markInvoiceAsPaid(state) {
    if (state.caseInvoices.length) {
      state.caseInvoices[state.caseInvoices.length - 1].status = 'paid';
    }
  },
  clearCaseLog: function clearCaseLog(state) {
    state.caseLog = [];
  },
  receiveCases: function receiveCases(state, allCases) {
    state.allCases = allCases;
  },
  switchCrewDialog: function switchCrewDialog(state) {
    state.editCrewDialog = !state.editCrewDialog;
  },
  setEditCaseCrewId: function setEditCaseCrewId(state, caseId) {
    state.editCrewCaseId = caseId;
  },
  unsetEditCaseCrewId: function unsetEditCaseCrewId(state) {
    state.editCrewCaseId = null;
  },
  setCrewDialogCase: function setCrewDialogCase(state, caseObject) {
    state.crewDialogCase = caseObject;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
  modules: {
    caseForms: __WEBPACK_IMPORTED_MODULE_3__caseForms__["a" /* default */]
  }
});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_clients__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_resources_crud__ = __webpack_require__(9);




var state = {
  all: []
};

var getters = {
  allClients: function allClients(state) {
    return state.all;
  },
  getClientById: function getClientById(state) {
    return function (id) {
      return state.all.find(function (c) {
        return c.value === id;
      });
    };
  }
};

var actions = {
  getAllClients: function getAllClients(_ref) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api_resources_clients__["a" /* default */].loadClients().then(function (result) {
        commit('receiveClients', result);
        resolve();
      });
    });
  },
  createClient: function createClient(_ref2, clientName) {
    var commit = _ref2.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_resources_crud__["a" /* default */].dfsResourceStore('clients/withid', {
        name: clientName
      }).then(function (result) {
        resolve(result.data.additional_data.inserted_id);
      });
    });
  }
};

var mutations = {
  receiveClients: function receiveClients(state, clients) {
    state.all = clients;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_plans__ = __webpack_require__(89);



var state = {
  all: []
};

var getters = {
  allPlans: function allPlans(state) {
    return state.all;
  },
  getPlanById: function getPlanById(state) {
    return function (id) {
      return state.all.find(function (plan) {
        return plan.id === id;
      });
    };
  }
};

var actions = {
  getAllPlans: function getAllPlans(_ref) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api_resources_plans__["a" /* default */].loadPlans().then(function (result) {
        commit('receivePlans', result);
        resolve();
      });
    });
  }
};

var mutations = {
  receivePlans: function receivePlans(state, plans) {
    state.all = plans;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_services__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_resources_categories__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);





var state = {
  all: [],
  allServices: [],
  filteredProducts: [],
  caskets: [],
  categories: [],
  casket_category_id: null
};

var getters = {
  allCaskets: function allCaskets(state) {
    return state.caskets;
  },
  getCasketById: function getCasketById(state) {
    return function (id) {
      return state.caskets.find(function (c) {
        return c.value === id && c.categories_id === state.casket_category_id;
      });
    };
  },
  allProducts: function allProducts(state) {
    return state.all.sort(function (a, b) {
      return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
    });
  },
  filteredProducts: function filteredProducts(state) {
    return state.filteredProducts;
  },
  productsCategories: function productsCategories(state) {
    return state.categories;
  },
  getProductById: function getProductById(state, getters) {
    return function (id) {
      return state.all.find(function (product) {
        return product.id === id;
      });
    };
  },
  getProductCategoryById: function getProductCategoryById(state, getters) {
    return function (id) {
      return state.categories.find(function (c) {
        return c.id === id;
      });
    };
  },
  getProductsByCategoryId: function getProductsByCategoryId(state, getters) {
    return function (id) {
      return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(state.all, function (p) {
        return p.categories_id === id;
      });
    };
  },
  filterFromLinkedServices: function filterFromLinkedServices(state, getters) {
    return function (pivots) {
      return pivots.reduce(function (acc, s) {
        var p = getters.getProductById(s.pivot.services_id);
        if (p) {
          p.amount = s.pivot.quantity;
          acc.push(p);
        }
        return acc;
      }, []);
    };
  },
  filterCasketFromLinkedProducts: function filterCasketFromLinkedProducts(state, getters) {
    return function (services) {
      var ids = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.intersection(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(services, 'pivot.services_id'), __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(state.caskets, 'id'));
      return ids.length ? ids[0] : false;
    };
  },
  removeCasketsFromServices: function removeCasketsFromServices(state, getters) {
    return function (services) {
      return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(services, function (s) {
        return s && s.categories_id !== state.casket_category_id;
      });
    };
  }
};

var actions = {
  getAllProducts: function getAllProducts(_ref) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api_resources_services__["a" /* default */].loadProducts().then(function (result) {
        commit('receiveProducts', result);
        commit('receiveCaskets', result);
        resolve();
      });
    });
  },
  getProductsCategories: function getProductsCategories(_ref2) {
    var commit = _ref2.commit,
        getters = _ref2.getters,
        state = _ref2.state;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_resources_categories__["a" /* default */].loadCategories().then(function (result) {
        commit('receiveProductsCategories', result);
        var mapped = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(result, function (c) {
          var iteratedC = c;
          c.cascade_name = c.name;
          while (iteratedC !== undefined && iteratedC.parent_id !== null) {
            iteratedC = state.categories.find(function (c) {
              return c.id === parseInt(iteratedC.parent_id);
            });
            c.cascade_name = iteratedC.name + '->' + c.cascade_name;
          }
          return c;
        });
        commit('receiveProductsCategories', mapped);
        resolve();
      });
    });
  },
  createProductCategory: function createProductCategory(_ref3, categoryName) {
    var commit = _ref3.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_resources_categories__["a" /* default */].storeCategory(categoryName).then(function (result) {
        resolve();
      });
    });
  },
  editProductCategory: function editProductCategory(_ref4, obj) {
    var commit = _ref4.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_resources_categories__["a" /* default */].editCategory(obj.id, { parent_id: obj.parent_id }).then(function (result) {
        resolve();
      });
    });
  },
  filterProducts: function filterProducts(_ref5, category) {
    var commit = _ref5.commit,
        getters = _ref5.getters,
        state = _ref5.state;

    var ids = [];
    if (category === null) {
      commit('filterProducts', ids);
      return;
    }
    ids.push(category.id);
    var tmp = ids;
    while (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(state.categories, function (c) {
      return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(tmp, parseInt(c.parent_id));
    }).length) {
      tmp = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(state.categories, function (c) {
        return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(ids, parseInt(c.parent_id));
      }), 'id');
      ids = ids.concat(tmp);
    }
    commit('filterProducts', ids);
  }
};

var mutations = {
  receiveProducts: function receiveProducts(state, products) {
    state.filteredProducts = state.allServices = products;
    state.all = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(products, function (p) {
      return p.categories_id !== state.casket_category_id;
    });
  },
  filterProducts: function filterProducts(state, ids) {
    if (!ids.length) state.filteredProducts = state.allServices;
    if (ids.length) {
      state.filteredProducts = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(state.allServices, function (p) {
        return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(ids, p.categories_id);
      });
    }
  },
  receiveCaskets: function receiveCaskets(state, products) {
    state.caskets = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(products, function (p) {
      return p.categories_id === state.casket_category_id;
    });
  },
  receiveProductsCategories: function receiveProductsCategories(state, categories) {
    state.categories = categories;
    var casketCategory = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(categories, function (c) {
      return c.name === 'Casket' || c.name === 'caskets' || c.name === 'Caskets';
    });
    if (casketCategory !== undefined) state.casket_category_id = casketCategory.id;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_roles__ = __webpack_require__(138);



var state = {
  all: []
};

var getters = {
  allRoles: function allRoles(state) {
    return state.all;
  },
  getRoleById: function getRoleById(state, getters) {
    return function (id) {
      return state.all.find(function (role) {
        return role.id === id;
      });
    };
  },
  getRoleNamesByIds: function getRoleNamesByIds(state, getters) {
    return function (roles) {
      return roles.reduce(function (acc, r) {
        var p = getters.getRoleById(r.id);
        if (p) {
          return acc + ' ' + r.name;
        }
      }, '');
    };
  }
};

var actions = {
  getAllRoles: function getAllRoles(_ref) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api_resources_roles__["a" /* default */].loadRoles().then(function (result) {
        commit('receivedRoles', result);
        resolve();
      });
    });
  }
};

var mutations = {
  receivedRoles: function receivedRoles(state, roles) {
    state.all = roles;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_services__ = __webpack_require__(54);



var state = {
  all: []
};

var getters = {
  allServices: function allServices(state) {
    return state.all;
  },
  getServiceById: function getServiceById(state, getters) {
    return function (id) {
      return state.all.find(function (service) {
        return service.id === id;
      });
    };
  }
};

var actions = {
  getAllServices: function getAllServices(_ref) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api_resources_services__["a" /* default */].loadAllServices().then(function (result) {
        commit('receiveServices', result);
        resolve();
      });
    });
  }
};

var mutations = {
  receiveServices: function receiveServices(state, services) {
    state.all = services;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_vendors__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_user__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);





var state = {
  allUsers: [],
  caseManagers: [],
  servicesList: [],
  inventoriesList: []
};

var getters = {
  allUsers: function allUsers(state) {
    return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(state.allUsers, function (u) {
      return {
        value: u.id,
        text: u.name
      };
    });
  },
  allUsersRaw: function allUsersRaw(state) {
    return state.allUsers;
  },
  caseManagers: function caseManagers(state) {
    return state.caseManagers;
  },
  allUsersFull: function allUsersFull(state) {
    return state.allUsers.sort(function (a, b) {
      var nameA = a.name.toUpperCase();
      var nameB = b.name.toUpperCase();

      var comparison = 0;
      if (nameA > nameB) {
        comparison = 1;
      } else if (nameA < nameB) {
        comparison = -1;
      }
      return comparison;
    });
  },
  servicesList: function servicesList(state) {
    return state.servicesList;
  },
  inventoriesList: function inventoriesList(state) {
    return state.inventoriesList;
  },
  getCaseManagerById: function getCaseManagerById(state, getters) {
    return function (id) {
      return state.caseManagers.find(function (caseManager) {
        return caseManager.id === id;
      });
    };
  }
};

var actions = {
  getUserStat: function getUserStat() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_user__["a" /* default */].getStats().then(function (result) {
        resolve(result);
      });
    });
  },
  getCurrentVendorsByUser: function getCurrentVendorsByUser(_ref) {
    var commit = _ref.commit,
        rootState = _ref.rootState;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api_resources_vendors__["a" /* default */].getVendorItems(rootState.currentUser.id).then(function (result) {
        commit('receiveVendors', result);
        resolve();
      });
    });
  },
  getCaseManagers: function getCaseManagers(_ref2) {
    var commit = _ref2.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_user__["a" /* default */].loadCaseManagers().then(function (result) {
        commit('receiveCaseManagers', result);
        resolve();
      }, function () {});
    });
  },
  getAllUsers: function getAllUsers(_ref3) {
    var commit = _ref3.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_user__["a" /* default */].loadUsers().then(function (result) {
        commit('receiveUsers', result);
        resolve();
      }, function () {});
    });
  }
};

var mutations = {
  receiveVendors: function receiveVendors(state, vendors) {
    state.servicesList = vendors.services;
    state.inventoriesList = vendors.inventories;
  },
  receiveCaseManagers: function receiveCaseManagers(state, managers) {
    state.caseManagers = managers;
  },
  receiveUsers: function receiveUsers(state, users) {
    state.allUsers = users;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  loading: false
};

var getters = {
  systemLoading: function systemLoading(state) {
    return state.loading;
  }
};

var actions = {
  setLoading: function setLoading(_ref) {
    var commit = _ref.commit;

    commit('setLoading');
  },
  unsetLoading: function unsetLoading(_ref2) {
    var commit = _ref2.commit;

    commit('unsetLoading');
  }
};

var mutations = {
  setLoading: function setLoading(state) {
    state.loading = true;
  },
  unsetLoading: function unsetLoading(state) {
    state.loading = false;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppMainMenu__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppMainMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_AppMainMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Loading__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_user__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_IsMobile__ = __webpack_require__(92);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App',
  components: { AppMainMenu: __WEBPACK_IMPORTED_MODULE_3__components_AppMainMenu___default.a, Loading: __WEBPACK_IMPORTED_MODULE_4__components_Loading___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_IsMobile__["a" /* default */]],
  computed: {
    appIsLoaded: function appIsLoaded() {
      return this.$store.getters.appIsLoaded === true || this.$store.getters.logInStatus === false;
    },
    showLoading: function showLoading() {
      return this.$store.getters.systemLoading;
    }
  },
  mounted: function mounted() {
    if (this.DetectMobile()) {
      this.$refs.main_container.style.padding = 0;
    }
  },

  methods: {
    initData: function initData() {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (_this.$store.state.products.categories.length === 0) _this.$store.dispatch('getProductsCategories');
        if (!_this.$can('view', 'vendor') && _this.$store.state.users.allUsers.length === 0) _this.$store.dispatch('getAllUsers');
        if (!_this.$can('view', 'vendor') && _this.$store.state.clients.all.length === 0) _this.$store.dispatch('getAllClients');
        if (!_this.$can('view', 'vendor') && _this.$store.state.plans.all.length === 0) _this.$store.dispatch('getAllPlans');
        if (_this.$store.state.products.all.length === 0 || _this.$store.state.products.caskets.length === 0) _this.$store.dispatch('getAllProducts');
        if (_this.$store.state.services.all.length === 0) _this.$store.dispatch('getAllServices');
        resolve();
        /*
        if (this.$store.state.cases.allCases.length === 0) {
          this.$store.dispatch('loadAllCases').then(() => {
            resolve()
          })
        } else {
          resolve()
        }
        */
      });
    }
  },
  beforeCreate: function beforeCreate() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_5__api_user__["a" /* default */].getCurrentUser().then(function (result) {
      _this2.$store.dispatch('setCurrentUser', result);
    }, function () {});
    // if (this.$store.state.cases.allCases === 0) this.$store.dispatch('loadAllCases')
  },
  created: function created() {
    /*
    this.initData().then(() => {
      usersAPI.getCurrentUser().then(result => {
        this.$store.dispatch('setCurrentUser', result)
      }, () => {})
    })
    */
    // this.$store.dispatch('clearCaseForms')

    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  }
});

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_schedules__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_resources_cases__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_AddCaseNameAndDateDialog__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_AddCaseNameAndDateDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_dialogs_AddCaseNameAndDateDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_IsMobile__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_buttons_AddScheduledCaseButton__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_buttons_AddScheduledCaseButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_buttons_AddScheduledCaseButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AddScheduledCaseButton: __WEBPACK_IMPORTED_MODULE_5__components_buttons_AddScheduledCaseButton___default.a, AddCaseNameAndDateDialog: __WEBPACK_IMPORTED_MODULE_3__components_dialogs_AddCaseNameAndDateDialog___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_IsMobile__["a" /* default */]],
  data: function data() {
    return {
      todoCasesTableHeaders: [{ text: 'Case ID', value: 'id' }, { text: 'Case Name', value: 'name' }, { text: 'Wake Start Date', value: 'wake_start' }, { text: 'Wake End Date', value: 'wake_end' }],
      displayPeriodList: [{ text: 'Day', value: 'day' }, { text: '4 Day', value: '4day' }, { text: 'Week', value: 'week' }, { text: 'Month', value: 'month' }],
      displayPeriod: '4day',
      periodCount: 1,
      todoCases: [],
      dialogModel: false,
      dateForNewLead: null,
      showDate: this.moment().format('YYYY-MM-DD'),
      calendarValue: this.moment().format('YYYY-MM-DD'),
      events: [],
      eventsRaw: []
    };
  },

  computed: {
    isCaseManager: function isCaseManager() {
      return this.$store.getters.currentUserRoles.includes('case-manager');
    },
    isDispatcher: function isDispatcher() {
      return this.$store.getters.currentUserRoles.includes('dispatcher');
    },
    eventsMap: function eventsMap() {
      var map = {};
      this.events.forEach(function (e) {
        return (map[e.date] = map[e.date] || []).push(e);
      });
      return map;
    }
  },
  provide: function provide() {
    return {
      onClickDate: this.onClickDate
    };
  },
  methods: {
    isCaseManagerEqual: function isCaseManagerEqual(event) {
      return event.case_manager === this.$store.getters.currentUser.id;
    },
    loadSchedules: function loadSchedules() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__api_resources_schedules__["a" /* default */].loadSchedules().then(function (result) {
        _this.eventsRaw = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result));
        _this.events = _this.normalizeForScheduleComponent(result);
      }, function () {});
    },
    onClickEvent: function onClickEvent(event) {
      if (this.$can('use', 'appointment-schedule-click-event')) {
        if (this.forCaseManager) {
          this.$router.push({ name: 'OnboardClient', params: { caseid: event.cases_id } });
        } else {
          this.$router.push({ name: 'NewLeads', params: { caseId: event.cases_id, editable: true } });
        }
      }
    },
    onClickDate: function onClickDate(date) {
      if (this.$can('use', 'appointment-schedule-create-new-case')) {
        this.dateForNewLead = this.moment(date).subtract(1, 'month').format('YYYY-MM-DD');
        this.dialogModel = true;
      }
    },
    onMove: function onMove(data) {
      this.calendarValue = data.date;
    },
    onDrop: function onDrop(event, date) {
      var eLength = this.dayDiff(event.startDate, date);

      event.originalEvent.startDate = this.addDays(event.startDate, eLength);
      event.originalEvent.endDate = this.addDays(event.endDate, eLength);

      var dateStartObject = new Date(event.originalEvent.startDate);
      var dateEndObject = new Date(event.originalEvent.endDate);

      var dateStartFormatted = this.isoYearMonthDay(dateStartObject) + ' ' + this.formattedTime(dateStartObject, 'us-US');
      var dateEndFormatted = this.isoYearMonthDay(dateEndObject) + ' ' + this.formattedTime(dateEndObject, 'us-US');

      if (event.originalEvent.leads_id) {
        __WEBPACK_IMPORTED_MODULE_1__api_resources_schedules__["a" /* default */].updateLeadWithDates(event.originalEvent.leads_id, dateStartFormatted, dateEndFormatted).then(function () {}, function () {});
      } else {
        __WEBPACK_IMPORTED_MODULE_1__api_resources_schedules__["a" /* default */].updateScheduleWithDates(event.originalEvent.id, event.originalEvent.service.id, dateStartFormatted, dateEndFormatted).then(function () {}, function () {});
      }
    },
    selectEventColor: function selectEventColor(caseStatus) {
      switch (caseStatus) {
        case 'pending':
          return 'light-blue lighten-4';
        case 'filled':
          return 'light-green lighten-4';
        case 'closed':
          return 'purple accent-1';
        default:
          return 'light-blue lighten-4';
      }
    },

    normalizeForScheduleComponent: function normalizeForScheduleComponent(data) {
      var _this2 = this;

      var localData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));

      localData.forEach(function (item, i) {
        var caseDataLabel = item.case && '\n\nCase #: ' + item.case.id + '\nCase Name: ' + item.case.name;

        item.date = _this2.moment(item.schedule_start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
        item.time = _this2.moment(item.schedule_start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');
        item.endDate = _this2.moment(item.schedule_end, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
        item.endDateTime = _this2.moment(item.schedule_end, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');

        item.duration = _this2.moment.duration(_this2.moment(item.schedule_end, 'YYYY-MM-DD hh:mm:ss').diff(_this2.moment(item.schedule_start, 'YYYY-MM-DD hh:mm:ss'))).asMinutes() || 60;

        item.open = false;

        item.title = 'Staff: \n';

        item.classes = item.case && _this2.selectEventColor(item.case.status);

        item.case_manager = null;
        if (item.leads_id) {
          var filtered = _this2.eventsRaw.filter(function (filtering) {
            return filtering.leads_id === item.leads_id;
          });

          item.title += filtered.map(function (mapping) {
            return mapping.service !== null ? mapping.service.description + ' ' + mapping.service.name : '';
          }) + '; ' + caseDataLabel;

          var managerService = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(filtered, ['service.description', 'Case Manager']);
          if (managerService && managerService.service.users_id) {
            item.case_manager = managerService.service.users_id;
          }

          var itemsWithSameLead = localData.filter(function (filtering) {
            return filtering.leads_id === item.leads_id && filtering.item_id !== item.item_id;
          }).map(function (mapping) {
            return mapping.item_id;
          });

          if (itemsWithSameLead.length > 0) {
            itemsWithSameLead.forEach(function (sameItem) {
              var index = localData.findIndex(function (finding) {
                return finding.item_id === sameItem && finding.leads_id === item.leads_id;
              });

              localData.splice(index, 1);
            });
          }
        } else {
          item.title += item.service.description + ' ' + item.service.name + ';' + caseDataLabel;
        }
      });

      return localData;
    },
    setShowDate: function setShowDate(date) {
      this.showDate = date;
    }
  },
  created: function created() {
    var _this3 = this;

    this.loadSchedules();

    if (this.$store.getters.currentUserRoles.includes('embalmer')) {
      __WEBPACK_IMPORTED_MODULE_2__api_resources_cases__["a" /* default */].loadCasesWithEmbalming().then(function (result) {
        _this3.todoCases = result;
      }, function () {});
    }
  },
  mounted: function mounted() {
    if (this.DetectMobile()) {
      this.displayPeriod = 'day';
      this.$refs.calendar.scrollToTime('08:00');
    }
    this.isCaseManager ? this.displayPeriod = '4day' : null;
    this.isDispatcher ? this.displayPeriod = 'day' : null;
  },

  props: {
    forCaseManager: {
      type: Boolean,
      default: false,
      required: false
    }
  }
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_schedules__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_resources_cases__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_ItemTypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_AddButton__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_Bookings__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AppMainDialog__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AppMainDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_AppMainDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_IsMobile__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var currentDate = new Date().toISOString().split('T')[0];

/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppMainDialog: __WEBPACK_IMPORTED_MODULE_6__components_AppMainDialog___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_AddButton__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_ItemTypes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_Bookings__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_IsMobile__["a" /* default */]],
  data: function data() {
    return {
      isPreplan: false,
      dialogOpen: false,
      dialogMessage: '',
      casesList: [],
      inventoriesList: [],
      servicesList: [],
      caseManagersList: [],
      selectedPalbearers: [],
      selectedService: { id: 0 },
      selectedCaseManager: { id: 0 },
      selectedCase: { id: null },
      amount: { number: 0 },
      dateStart: currentDate,
      timeStart: null,
      editableLeadId: null,
      menuDateStart: false,
      menuDateEnd: false,
      menuTimeStart: { state: false },
      menuTimeEnd: { state: false },
      venueDescription: null,
      selectedItemType: { id: this.inventoryTypeID },
      loading: {
        saveNewBtn: false
      },
      snackbar: false,
      isMobile: false
    };
  },

  watch: {
    timeStart: function timeStart(newVal) {
      this.checkIfMinutesSelectedAndCloseTimePopup(newVal, this.menuTimeStart);
    },
    date: function date(newVal) {
      this.setDates(newVal);
    },
    time: function time(newVal) {
      this.setTimes(newVal);
    },
    isPreplan: function isPreplan(v) {
      if (v !== this.caseById(this.caseId).is_preplan) this.$store.dispatch('updateCase', { case_id: this.caseId, payload: { is_preplan: this.isPreplan } });
      if (v) this.selectedPalbearers = [];
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])({
    caseById: 'getCaseById',
    usersList: 'allUsersRaw'
  }), {
    itemId: function itemId() {
      return this.itemTypeToItemIDMap[this.selectedItemType.id].id;
    },
    dateStartString: function dateStartString() {
      return this.dateStart + ' ' + (this.timeStart === null ? '00:00:00' : __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.timeStart, 'hh:mm A').format('HH:mm'));
    }
  }),
  methods: {
    limiter: function limiter(e) {
      if (e.length > 999) {
        this.snackbar = true;
        e.pop();
      }
    },
    setDates: function setDates(date) {
      this.dateStart = date;
    },
    setTimes: function setTimes(time) {
      this.timeStart = time;
    },
    checkIfMinutesSelectedAndCloseTimePopup: function checkIfMinutesSelectedAndCloseTimePopup(timeStr, timePopupModel) {
      if (timeStr.indexOf(':') !== -1) {
        timePopupModel.state = false;
      }
    },
    saveNew: function saveNew() {
      var _this = this;

      var payload = {
        cases_id: this.caseId,
        is_preplan: this.isPreplan,
        is_closing: 0
      };

      this.loading.saveNewBtn = true;

      if (this.editable) {
        __WEBPACK_IMPORTED_MODULE_1__api_resources_schedules__["a" /* default */].updateLead(this.editableLeadId, this.selectedCaseManager.id, this.selectedPalbearers, this.venueDescription).then(function () {
          __WEBPACK_IMPORTED_MODULE_1__api_resources_schedules__["a" /* default */].updatePallbearers(_this.editableLeadId, _this.selectedPalbearers, 0).then(function () {
            _this.loading.saveNewBtn = false;
          });
        }, function () {
          _this.loading.saveNewBtn = false;
        });
      } else {
        payload.cases_id = this.caseId;
        // cases_id: this.selectedCase.id,
        payload.leads_id = this.$uuid.v4();
        payload.schedule_start = this.dateStartString;

        // if selectedCase == null then this is lead saving; else this is booking saving
        if (this.selectedCase.id === null) {
          // book pallbearers with casemanager
          payload.item_id = this.selectedCaseManager.id;
          payload.pallbearers_ids = this.selectedPalbearers;
          payload.item_type = this.serviceTypeID;
          payload.venue_description = this.venueDescription;
          payload.amount = 1;

          __WEBPACK_IMPORTED_MODULE_1__api_resources_schedules__["a" /* default */].saveSchedule(payload).then(function () {
            __WEBPACK_IMPORTED_MODULE_1__api_resources_schedules__["a" /* default */].updatePallbearers(payload.leads_id, payload.pallbearers_ids, 0).then(function () {
              delete payload.venue_description;
              _this.saveNewSuccess();
              _this.loading.saveNewBtn = false;
              _this.$router.push({ name: 'NewLeadTable', params: { alert: true } });
            });
          }, this.saveNewError);
        } else {
          payload.item_id = this.itemId;
          payload.item_type = this.selectedItemType.id;
          payload.amount = this.amount.number;

          __WEBPACK_IMPORTED_MODULE_1__api_resources_schedules__["a" /* default */].saveSchedule(payload).then(function () {
            __WEBPACK_IMPORTED_MODULE_1__api_resources_schedules__["a" /* default */].updatePallbearers(payload.leads_id, _this.selectedPalbearers, 0).then(function () {
              _this.loading.saveNewBtn = false;
              _this.saveNewSuccess();
              _this.$router.push({ name: 'NewLeadTable', params: { alert: true } });
            });
          }, this.saveNewError);
        }
      }
    },
    filterCaseManagers: function filterCaseManagers(value) {
      var _this2 = this;

      return value.filter(function (service) {
        return service.hasOwnProperty('description') && service.description !== null ? service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') === 'casemanager' && _this2.caseManagersList.filter(function (i) {
          return i.id === service.users_id;
        }).length > 0 : false;
      });
    },
    filterPalBearers: function filterPalBearers(value) {
      var _this3 = this;

      return value.filter(function (service) {
        return service.hasOwnProperty('description') && service.description !== null ? service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') === 'casecrew' && _this3.usersList.filter(function (i) {
          return i.id === service.users_id;
        }).length > 0 && _this3.usersList.find(function (i) {
          return i.id === service.users_id;
        }).roles.length > 0 && _this3.usersList.find(function (i) {
          return i.id === service.users_id;
        }).roles.filter(function (r) {
          return r.name === 'case-crew';
        }).length > 0 : false;
      });
    }
  },
  filters: {
    filterCaseManagers: function filterCaseManagers(value) {
      return value.filter(function (service) {
        return service.hasOwnProperty('description') && service.description !== null ? service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') === 'casemanager' : false;
      });
    },
    filterPalBearers: function filterPalBearers(value) {
      return value.filter(function (service) {
        return service.hasOwnProperty('description') && service.description !== null ? service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') === 'casecrew' : false;
      });
    }
  },
  created: function created() {
    var _this4 = this;

    //      if (!this.date && !this.editable) {
    //        this.$router.push({ name: 'AddLeadForm' })
    //      }
    if (!this.$can('view', 'vendor') && this.$store.state.users.allUsers.length === 0) this.$store.dispatch('getAllUsers');
    if (this.editable && this.caseId) {
      this.isPreplan = this.caseById(this.caseId).is_preplan;
      __WEBPACK_IMPORTED_MODULE_2__api_resources_cases__["a" /* default */].getLead(this.caseId).then(function (result) {
        // let caseCrew = result.filter(filtering => filtering.service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') === 'casecrew').map(mapping => mapping.service.id)

        var caseManagers = result.filter(function (filtering) {
          return filtering.service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') === 'casemanager';
        });
        var caseManagerId = caseManagers.map(function (mapping) {
          return mapping.service.id;
        })[0];

        _this4.dateStart = __WEBPACK_IMPORTED_MODULE_8_moment___default()(result[0].schedule_start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
        _this4.timeStart = __WEBPACK_IMPORTED_MODULE_8_moment___default()(result[0].schedule_start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');

        _this4.selectedPalbearers = result.filter(function (value, index, arr) {
          return value.item_id !== caseManagerId;
        }).map(function (item) {
          return item.item_id;
        });
        _this4.selectedCaseManager.id = caseManagerId;
        _this4.editableLeadId = caseManagers.map(function (mapping) {
          return mapping.leads_id;
        })[0];

        _this4.venueDescription = caseManagers.map(function (mapping) {
          return mapping.venue_description;
        })[0];
      }, function () {});
    } else {
      this.setDates(this.date);
      this.setTimes(this.time);
    }
  },
  mounted: function mounted() {
    if (this.DetectMobile()) {
      this.isMobile = true;
    }
  },

  props: {
    date: {
      type: String
    },
    time: {
      type: String
    },
    caseId: {
      type: Number
    },
    editable: {
      type: Boolean,
      required: false
    }
  }
});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_resources_schedules__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppMainDialog__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppMainDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_AppMainDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_ItemTypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_AddButton__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_Bookings__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_consts__ = __webpack_require__(90);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var currentDate = new Date().toISOString().split('T')[0];

/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppMainDialog: __WEBPACK_IMPORTED_MODULE_1__components_AppMainDialog___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_AddButton__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_Bookings__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_ItemTypes__["a" /* default */]],
  data: function data() {
    return {
      resources: 'schedules',
      dialog: false,
      dialogMessage: '',
      dialogOpen: false,
      casesList: [],
      inventoriesList: [],
      servicesList: [],
      caseManagersList: [],
      selectedInventory: { id: 0 },
      selectedService: { id: 0 },
      selectedCaseManager: { id: 0 },
      selectedCase: { id: null },
      amount: { number: 0 },
      dateStart: currentDate,
      dateEnd: currentDate,
      timeStart: null,
      timeEnd: null,
      menuDateStart: false,
      menuDateEnd: false,
      menuTimeStart: { state: false },
      menuTimeEnd: { state: false },
      selectedItemType: { id: __WEBPACK_IMPORTED_MODULE_5__config_consts__["a" /* default */].schedules.INVENTORY_TYPE_ID }
    };
  },

  watch: {
    timeStart: function timeStart(newVal) {
      this.checkIfMinutesSelectedAndCloseTimePopup(newVal, this.menuTimeStart);
    },
    timeEnd: function timeEnd(newVal) {
      this.checkIfMinutesSelectedAndCloseTimePopup(newVal, this.menuTimeEnd);
    }
  },
  computed: {
    itemId: function itemId() {
      return this.itemTypeToItemIDMap[this.selectedItemType.id].id;
    },
    dateStartString: function dateStartString() {
      return this.dateStart + ' ' + this.timeStart;
    },
    dateEndString: function dateEndString() {
      return this.dateEnd + ' ' + this.timeEnd;
    }
  },
  methods: {
    checkIfMinutesSelectedAndCloseTimePopup: function checkIfMinutesSelectedAndCloseTimePopup(timeStr, timePopupModel) {
      if (timeStr.indexOf(':') !== -1) {
        timePopupModel.state = false;
      }
    },
    saveNew: function saveNew() {
      var _this = this;

      var payload = {
        cases_id: this.selectedCase.id,
        schedule_start: this.dateStartString,
        schedule_end: this.dateEndString

        // if selectedCase == null then this is lead saving; else this is booking saving
      };if (this.selectedCase.id === null && this.selectedInventory.id > 0 && this.palbearersAmount > 0) {
        // book palbearers with casemanager
        payload.item_id = this.selectedCaseManager.id;
        payload.item_type = this.caseManagerTypeID;
        payload.amount = 1;

        __WEBPACK_IMPORTED_MODULE_0__api_resources_schedules__["a" /* default */].saveSchedule(payload).then(function () {
          payload.item_id = _this.selectedInventory.id;
          payload.item_type = _this.serviceTypeID;
          // payload.item_type = this.inventoryTypeID
          payload.amount = _this.palbearersAmount;

          __WEBPACK_IMPORTED_MODULE_0__api_resources_schedules__["a" /* default */].saveSchedule(payload).then(_this.saveNewSuccess, _this.saveNewError);
        }, this.saveNewError);
      } else {
        payload.item_id = this.selectedService.id;
        payload.item_type = this.serviceTypeID;
        // payload.item_type = this.selectedItemType.id
        payload.amount = 1;
        // payload.amount = this.amount.number

        __WEBPACK_IMPORTED_MODULE_0__api_resources_schedules__["a" /* default */].saveSchedule(payload).then(this.saveNewSuccess, this.saveNewError);
      }
    }
  },
  props: {
    palbearersAmount: {
      required: false
    }
  }
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppMainDialog__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppMainDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AppMainDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_AddButton__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ItemCheckList__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ItemCheckList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ItemCheckList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_ItemTypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_resources_inventories__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_resources_services__ = __webpack_require__(54);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppMainDialog: __WEBPACK_IMPORTED_MODULE_0__components_AppMainDialog___default.a, ItemCheckList: __WEBPACK_IMPORTED_MODULE_2__components_ItemCheckList___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_AddButton__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_ItemTypes__["a" /* default */]],
  computed: {
    itemsAPI: function itemsAPI() {
      switch (this.itemTypeID) {
        case this.inventoryTypeID:
          return __WEBPACK_IMPORTED_MODULE_4__api_resources_inventories__["a" /* default */];
        case this.serviceTypeID:
          return __WEBPACK_IMPORTED_MODULE_5__api_resources_services__["a" /* default */];
      }
    }
  },
  props: {
    itemTypeID: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      dialog: false,
      model: { name: '' },
      isAvailable: true,
      isVendor: false,
      amount: 0,
      dialogMessage: '',
      dialogOpen: false,
      editCheckListAfterSave: true,
      savedItemId: 0
    };
  },

  methods: {
    // TODO make object like itemData
    editCheckListAfterSaveMethod: function editCheckListAfterSaveMethod(result) {
      this.$bus.$emit('resource-added');

      this.savedItemId = result.inserted_id;
    },
    saveNew: function saveNew() {
      var payload = {
        name: this.model.name,
        is_available: this.isAvailable,
        is_vendor: this.isVendor,
        amount: this.amount
      };

      var callback = null;

      var result = this.itemsAPI.add(payload);

      if (this.editCheckListAfterSave) {
        callback = this.editCheckListAfterSaveMethod;
      } else {
        callback = this.saveNewSuccess;
      }

      result.then(callback, this.saveNewError);
    }
  }
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_resources_cases__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Resources__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_ItemTypes__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Resources__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_ItemTypes__["a" /* default */]],
  data: function data() {
    return {
      tableHeaders: [
      // { text: 'ID', value: 'id' },
      { text: 'Name', value: 'name' },
      // { text: 'Description', value: 'description' },
      // { text: 'Is external vendor', value: 'is_vendor' },
      // { text: 'Created at', value: 'created_at' },
      // { text: 'Updated at', value: 'updated_at' },
      { text: 'Actions', value: 'actions', align: 'right' }],
      items: [],
      itemForCheckList: { id: 0 }
    };
  },

  computed: {
    resources: function resources() {
      return 'cases/' + this.casesid + '/' + this.entity;
    },
    entity: function entity() {
      switch (this.itemType) {
        case this.inventoryTypeID:
          return 'inventory';
        case this.serviceTypeID:
          return 'user';
        // case this.serviceTypeID: return 'service'
      }
    }
  },
  methods: {
    deleteElementSuccess: function deleteElementSuccess() {
      this.loadListing();
      this.$store.dispatch('loadAllCases');
    },
    loadListing: function loadListing() {
      var _this = this;

      var result = null;

      switch (this.itemType) {
        case this.inventoryTypeID:
          result = __WEBPACK_IMPORTED_MODULE_0__api_resources_cases__["a" /* default */].getLinkedInventories(this.casesid);
          break;
        case this.serviceTypeID:
          result = __WEBPACK_IMPORTED_MODULE_0__api_resources_cases__["a" /* default */].getLinkedVendors(this.casesid);
          // result = casesAPI.getLinkedServices(this.casesid)
          break;
      }

      result.then(function (result) {
        _this.items = result;
      }, this.loadListingError);
    },
    editElementChecklist: function editElementChecklist(itemId) {
      this.itemForCheckList.id = itemId;
    }
  },
  props: {
    casesid: {
      type: Number,
      required: true
    },
    itemType: {
      type: Number,
      required: true
    }
  },
  created: function created() {
    this.loadListing();
  }
});

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_EditResourceDialog__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Bookings__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_consts__ = __webpack_require__(90);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_EditResourceDialog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_Bookings__["a" /* default */]],
  data: function data() {
    return {
      resource: 'schedules',
      casesList: [],
      inventoriesList: [],
      servicesList: [],
      caseManagersList: [],
      selectedInventory: { id: 0 },
      selectedService: { id: 0 },
      selectedCaseManager: { id: 0 },
      selectedItemType: { id: __WEBPACK_IMPORTED_MODULE_2__config_consts__["a" /* default */].schedules.SERVICE_TYPE_ID },
      // selectedItemType: { id: 0 },
      selectedCase: { id: 0 },
      menuDateStart: false,
      menuDateEnd: false,
      menuTimeStart: false,
      menuTimeEnd: false,
      amount: {
        number: 0
      }
    };
  },

  computed: {
    date: function date() {
      var dateStart = null;
      var dateEnd = null;
      var timeStart = null;
      var timeEnd = null;

      if (this.itemData.schedule_start) {
        dateStart = this.itemData.schedule_start.split(' ');

        timeStart = dateStart[1];
        dateStart = dateStart[0];
      }

      if (this.itemData.schedule_end) {
        dateEnd = this.itemData.schedule_end.split(' ');

        timeEnd = dateEnd[1];
        dateEnd = dateEnd[0];
      }

      var obj = {
        dateStart: dateStart,
        dateEnd: dateEnd,
        timeStart: timeStart,
        timeEnd: timeEnd
      };

      return obj;
    },
    entityListName: function entityListName() {
      return this.itemTypeIDInDBToEntitiesListNameMap[this.itemData.item_type];
    },
    entityNameSelected: function entityNameSelected() {
      return this.entitiesListNameToSelectedEntityNameMap[this.entityListName];
    },
    selectedList: function selectedList() {
      return this.listsMap[this.entityListName];
    },

    selectedEntity: {
      get: function get() {
        if (this.entitiesSelectedMap[this.entityNameSelected]) {
          return this.entitiesSelectedMap[this.entityNameSelected].id;
        }

        return 0;
      },
      set: function set(newVal) {
        this.entitiesSelectedMap[this.entityNameSelected].id = newVal;
      }
    }
  },
  watch: {
    itemId: function itemId(newVal, oldVal) {
      var _this = this;

      if (newVal > 0) {
        this.itemData = {};
        this.selectedCase.id = null;
        this.selectedInventory.id = 0;
        this.selectedService.id = 0;
        this.selectedCaseManager.id = 0;

        this.loadItemData(newVal).then(function (result) {
          _this.selectedItemType.id = _this.itemData.item_type;

          _this.amount.number = _this.itemData.amount;

          _this.selectedList.forEach(function (item, i) {
            if (item.id === _this.itemData.item_id) {
              _this.selectedEntity = _this.itemData.item_id;
            }
          });

          _this.casesList.forEach(function (item, i) {
            if (item.id === _this.itemData.cases_id) {
              _this.selectedCase.id = _this.itemData.cases_id;
            }
          });
        });

        this.dialogResult = true;
      }
    },

    selectedItemType: {
      handler: function handler(newVal) {
        this.itemData.item_type = newVal.id;
      },

      deep: true
    }
  },
  methods: {
    editItemDataDecorator: function editItemDataDecorator() {
      var scheduleStart = this.date.dateStart + ' ' + this.date.timeStart;
      var scheduleEnd = this.date.dateEnd + ' ' + this.date.timeEnd;

      this.itemData.schedule_start = scheduleStart;
      this.itemData.schedule_end = scheduleEnd;

      this.itemData.amount = this.amount.number;

      this.itemData.cases_id = this.selectedCase.id;
      this.itemData.item_id = this.itemTypeToItemIDMap[this.selectedItemType.id].id;

      this.editItemData();
    }
  }
});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  // TODO refactor with slots using =\
  data: function data() {
    return {
      internalOpen: false
    };
  },

  watch: {
    open: function open() {
      this.internalOpen = this.open;
    }
  },
  methods: {
    dialogClose: function dialogClose() {
      this.$emit('closedialog');

      this.internalOpen = false;
    }
  },
  props: {
    open: {
      type: Boolean,
      required: true,
      default: false
    },
    message: {
      type: String,
      required: true,
      default: ''
    },
    rawHtml: {
      type: Boolean,
      required: false,
      default: false
    }
  }
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppNavigation__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppNavigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AppNavigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppToolbar__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppToolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_AppToolbar__);
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppMainMenu',
  components: { AppNavigation: __WEBPACK_IMPORTED_MODULE_0__components_AppNavigation___default.a, AppToolbar: __WEBPACK_IMPORTED_MODULE_1__components_AppToolbar___default.a },
  data: function data() {
    return {
      items: [{ icon: 'contact_phone', text: 'New Case', id: 'NewLeads', url: '/new-case' }, { icon: 'accessibility_new', text: 'Select Shifting Crew', id: 'AssignCrewAndTiming', url: 'assign-crew-and-timing' },
      // { icon: 'accessibility_new', text: 'Assign Crew and Timing', id: 'NewLeads', url: '/assign-crew-and-timing' },
      { icon: 'schedule', text: 'Appointment Schedule', id: 'AppointmentSchedule', url: '/appointment-schedule' },
      // { icon: 'create', text: 'Onboard Client', id: 'OnboardClient', url: '/onboard-client' },
      // { icon: 'work', text: 'Select Plan & Vendors', id: 'Cases', url: '/cases' },
      // { icon: 'account_box', text: 'Assign Crew and Timing', id: 'Bookings', url: '/bookings' },
      { icon: 'check_circle', text: 'Event Checklist', id: 'EventChecklist', url: '/event-checklist' }, { icon: 'supervisor_account', text: 'Select Crew for Tasking', id: 'SelectCrew', url: '/event-crew' }, { icon: 'check_circle_outline', text: 'Closing Event', id: 'Cases', url: '/cases' }, { icon: 'account_balance_wallet', text: 'Billing', id: 'Billing', url: '/billing' }, { icon: 'zoom_in', text: 'Inventory Report', id: 'InventoryReport', url: '/inventory-report' }, { icon: 'calendar_today', text: 'Reminders', id: 'Reminders', url: '/reminders' }, { icon: 'insert_chart_outlined', text: 'Commissions Reports', id: 'Analytics', url: '/commissions-reports' }, { icon: 'insert_chart_outlined', text: 'Sales Report', id: 'SalesReport', url: '/sales-report' }, { icon: 'insert_chart_outlined', text: 'Inventory Report', id: 'InventoryReport', url: '/inventory-report' }, { icon: 'settings',
        text: 'Settings',
        iconalt: 'settings',
        id: 'Settings',
        children: [
        // { text: 'Inventories', id: 'Inventories', url: '/inventories' },
        // { text: 'Services', id: 'Services', url: '/services' },
        { text: 'Plans', id: 'Plans', url: '/plans' }, { text: 'Users', id: 'Users', url: '/users' }, { text: 'Clients', id: 'Clients', url: '/clients' }, { text: 'Roles', id: 'Roles', url: '/roles' }, { text: 'Notifications', id: 'Notifications', url: '/notifications' }, { text: 'Products', id: 'Products', url: '/products' }, { text: 'General', id: 'Settings', url: '/settings' }, { text: 'Test Lunar', id: 'Settings', url: '/test'
          // { text: 'Whatsapp Notifications', id: 'WhatsappNotifications', url: '/notifications/whatsapp' }
          // { text: 'SMS Notifications', id: 'SMSNotifications', url: '/notifications/sms' },
          // { text: 'PDF Templates', id: 'PDFTemplates', url: '/templates' }
        }]
        // { icon: 'chevron_right', text: 'Forms', url: '/forms' },
      }]
    };
  },

  computed: {
    loggedAndGotRoles: function loggedAndGotRoles() {
      if (this.$store.getters.logInStatus === true && this.$store.getters.currentUserRoles.length > 0) {
        return true;
      }

      return false;
    }
  }
});

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppNavigation',
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  methods: {
    isAssignCrewAndTiming: function isAssignCrewAndTiming(menuItem) {
      return menuItem.id === 'AssignCrewAndTiming';
    }
  }
});

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppToolbar',
  computed: {
    avatar: function avatar() {
      return this.$store.getters.currentUser.avatar || this.$dfsConfig.default_avatar_url;
    }
  }
});

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import resourcesMixins from '@/mixins/Resources'
// import schedulesAPI from '@/api/resources/schedules'



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Cases',
  data: function data() {
    return {
      resources: 'cases',
      items: [],
      vendorItemsPromise: null,
      tableHeaders: [{ text: '', value: 'time' }, { text: 'Time', value: 'start_time' }, { text: 'Type', value: 'type' }, { text: 'Case manager', value: 'users_id' }, { text: 'Crew', value: 'crew' }, { text: 'Description', value: 'description' }, { text: 'Case ID', value: 'case_id' }],
      caseID: 0,
      currentUserServiceId: 0,
      clientName: '',
      dialogOpen: false,
      dialogMessage: '',
      vendorInventories: [],
      disabled: {
        sendQuotationMailToClientBtn: false
      },
      vendorServices: [],
      rowsPerPageItems: [-1],
      pagination: {
        descending: true,
        rowsPerPage: -1,
        sortBy: 'created_at'
      },
      date: this.moment().format('YYYY-MM-DD'),
      menu: false,
      dateForNewLead: this.moment().format('YYYY-MM-DD'),
      dialogModel: false,
      services: [],
      loadingItemsText: 'Loading data...',
      loadingInProgress: true
    };
  },

  watch: {
    date: function date() {
      this.loadSchedules();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    servicesList: 'allServices'
  })),
  provide: function provide() {
    return {
      onClickDate: this.onClickDate
    };
  },
  methods: {
    formatTime: function formatTime(date) {
      return date ? this.moment(date, 'YYYY-MM-DD HH:mm:ss').format('HH:mm') : '-';
    },
    getCaseType: function getCaseType(item) {
      switch (item.status) {
        case 'pending':
          return 'Pickup';
        case 'approved':
          return 'Setup';
        case 'filled':
          return 'Wake';
        default:
          return 'Wake';
      }
    },
    getCaseCrew: function getCaseCrew(item) {
      return item && item.services ? item.services.filter(function (i) {
        return i && i.description === 'Case Crew';
      }).map(function (i) {
        return i.name;
      }).join(', ') : '';
    },
    checkInvolve: function checkInvolve(services) {
      var userId = this.$store.getters.currentUser.id;
      var result = '';
      if (services) {
        services.forEach(function (service) {
          if (service && service.users_id === userId) result = ' involved';
        });
      }
      return result;
    },
    getTimelinePosition: function getTimelinePosition(time) {
      var diff = this.moment().diff(time, 'minutes');
      if (diff >= 0 && diff < 60) return 'current';
      if (diff < 0) return 'future';
      if (diff > 60) return 'past';
    },
    prepareData: function prepareData(data) {
      var _this = this;

      return data.map(function (i) {
        var timeline = _this.getTimelinePosition(_this.moment(i.schedule_start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm'));
        return i.schedule_start ? {
          time: '',
          timeline: timeline,
          id: i.id,
          case_id: i.cases_id,
          date: _this.moment(i.schedule_start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
          start_time: _this.moment(i.schedule_start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm'),
          end_time: i.schedule_end ? _this.moment(i.schedule_end, 'YYYY-MM-DD HH:mm:ss').format('HH:mm') : '',
          type: 'Pickup',
          case_manager: i.service.name
        } : null;
      }).filter(function (i) {
        return i && i.date === _this.date;
      });
    },
    formTable: function formTable(data) {
      var times = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Array(24).keys()));
      var newData = [];
      for (var k = 0; k < times.length; k++) {
        var time = times[k];
        var nextTime = time < 9 ? '0' + (time + 1) + '00' : time < 23 ? time + 1 + '00' : '2400';
        var currentTime = time < 10 ? '0' + time + '00' : time + '00';
        var timeItems = [];
        for (var i = 0; i < data.length; i++) {
          var itemTime = data[i].start_time.replace(':', '');
          if (itemTime < nextTime && itemTime >= currentTime) timeItems.push(data[i]);
        }
        if (timeItems.length === 0) {
          var timeline = this.getTimelinePosition(this.date + ' ' + currentTime.slice(0, -2) + ':00');
          timeItems.push({
            time: currentTime.slice(0, -2) + ':00',
            timeline: timeline,
            id: null,
            date: null,
            start_time: null,
            end_time: null,
            type: null,
            case_manager: null
          });
        } else {
          timeItems.sort(function (a, b) {
            var timeA = parseInt(a.start_time.replace(':', ''));
            var timeB = parseInt(b.start_time.replace(':', ''));
            var comparison = 0;
            if (timeA > timeB) {
              comparison = 1;
            } else if (timeA < timeB) {
              comparison = -1;
            }
            return comparison;
          });
          timeItems[0].time = currentTime.slice(0, -2) + ':00';
        }
        newData[k] = timeItems;
      }
      return newData.flat();
    },
    groupDataByCaseId: function groupDataByCaseId(data) {
      var _this2 = this;

      var groupedData = [];
      data.forEach(function (i) {
        if (i.cases_id) {
          if (groupedData[i.cases_id]) {
            groupedData[i.cases_id].services.push(i.service);
          } else {
            var timeline = _this2.getTimelinePosition(_this2.moment(i.schedule_start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm'));
            groupedData[i.cases_id] = {
              time: '',
              timeline: timeline,
              id: i.id,
              leads_id: i.leads_id,
              item_id: i.item_id,
              case_id: i.cases_id,
              description: i.venue_description,
              date: _this2.moment(i.schedule_start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
              start_time: _this2.moment(i.schedule_start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm'),
              end_time: i.schedule_end ? _this2.moment(i.schedule_end, 'YYYY-MM-DD HH:mm:ss').format('HH:mm') : '',
              type: 'Pickup',
              services: [i.service],
              case_manager: i.case ? i.case.manager_name : '-'
            };
          }
        }
      });
      return groupedData.filter(function (value) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(value).length !== 0;
      });
    },
    loadSchedules: function loadSchedules() {
      var _this3 = this;

      this.loadingInProgress = true;
      this.items = [];
      this.$axios.get(this.$store.getters.config.api_host + '/api/schedules/bydate?date=' + this.date).then(function (response) {
        var result = response.data.additional_data;
        var data = _this3.groupDataByCaseId(result.filter(function (i) {
          return i && _this3.moment(i.schedule_start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') === _this3.date;
        }));
        _this3.items = _this3.formTable(data);
        _this3.loadingInProgress = false;
      });
    },
    onClickDate: function onClickDate(date) {
      if (this.$can('use', 'appointment-schedule-create-new-case')) {
        this.dateForNewLead = this.moment(date).subtract(1, 'month').format('YYYY-MM-DD');
        this.dialogModel = true;
      }
    },
    onEventClick: function onEventClick(caseId) {
      if (caseId) this.$router.push({ name: 'OnboardClient', params: { caseid: caseId } });
    },
    checkActive: function checkActive(caseId) {
      return caseId ? ' clickable' : '';
    }
  },
  mounted: function mounted() {
    this.loadSchedules();
  },

  props: {
    detailCaseButtonActionIsDefault: {
      type: Boolean,
      default: false,
      required: false
    },
    detailCaseButtonActionIsGoToCheckListsTab: {
      type: Boolean,
      default: false,
      required: false
    },
    detailCaseButtonActionIsGoToInvoicesTab: {
      type: Boolean,
      default: false,
      required: false
    },
    crewSelecting: {
      type: Boolean,
      default: false,
      required: false
    }
  }
});

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_datatables_ServicesDataTable__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_datatables_ServicesDataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_datatables_ServicesDataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ServicesDataTable: __WEBPACK_IMPORTED_MODULE_1__components_datatables_ServicesDataTable___default.a },
  props: {
    caseModel: {
      type: Object,
      required: true
    },
    selectedTab1: {}
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    clientById: 'getClientById',
    caseInvoices: 'currentCaseInvoices',
    allUsers: 'allUsers',
    allUsersFull: 'allUsersFull',
    storeFeedbackForm: 'getFeedbackClientForm'
  }), {
    dateStartString: function dateStartString() {
      return this.dateStart + ' ' + (this.timeStart === null ? '00:00:00' : this.timeStart);
    },
    caseManagers: function caseManagers() {
      return this.allUsersFull.filter(function (i) {
        return i.roles.map(function (i) {
          return i.name;
        }).includes('case-manager');
      });
    }
  }),
  data: function data() {
    return {
      pdfBtnDisabled: true,

      feedbackForm: {},

      menuDateStart: false,
      menuAshCollectionDate: false,
      menuSendAshToDate: false,
      menuSeaBurialAtDate: false,

      snackbar: false,

      loading: {
        pdf: false,
        feedback: false,
        signBtn: false
      }
    };
  },

  watch: {
    timeStart: function timeStart(newVal) {
      if (newVal.indexOf(':') !== -1) {
        this.menuTimeStart.state = false;
      }
    },
    selectedTab1: function selectedTab1(val) {
      var _this = this;

      if (val === 'agreement-feedback-tab') {
        setTimeout(function () {
          _this.resizeCanvas();
        }, 2000);
      }
    }
  },
  methods: {
    downloadFeedback: function downloadFeedback() {
      var _this2 = this;

      this.loading.pdf = true;
      this.$store.dispatch('loadPdfFeedback', this.storeFeedbackForm.id).then(function (result) {
        _this2.loading.pdf = false;
        window.open(window.location.origin === 'http://localhost:8080' ? window.location.origin + '/' + result.aws_s3_url : result.aws_s3_url, '_blank');
      });
    },
    clearSignature: function clearSignature() {
      this.$refs.signaturePad.undoSignature();
    },
    onServicesChanged: function onServicesChanged(services) {
      this.feedbackForm.addOnServices = services;
    },
    saveFeedback: function saveFeedback() {
      var _this3 = this;

      this.loading.signBtn = true;

      var signature = this.$refs.signaturePad.saveSignature();
      if (!signature.isEmpty) {
        this.feedbackForm.client_signature = signature.data;
      }

      this.$store.commit('updateFeedbackForm', this.feedbackForm);
      this.$store.dispatch('storeFeedbackForm').then(function (result) {
        _this3.pdfBtnDisabled = false;
        _this3.snackbar = true;
        _this3.loading.signBtn = false;
        location.reload();
      });
    },
    resizeCanvas: function resizeCanvas() {
      var ratio = Math.max(window.devicePixelRatio || 1, 1);
      var wrapper = window.document.getElementById('signature-pad');
      var canvas = wrapper.getElementsByTagName('canvas')[0];

      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      canvas.getContext('2d').scale(ratio, ratio);
      // this.$refs.signaturePad.clear()
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      var _this4 = this;

      setTimeout(function () {
        window.onresize = _this4.resizeCanvas;
        _this4.resizeCanvas();
      }, 2000);
    });
  },
  created: function created() {
    if (this.storeFeedbackForm.id !== null) this.pdfBtnDisabled = false;
    this.feedbackForm = this.storeFeedbackForm.answer;
  }
});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    caseModel: {
      type: Object,
      required: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    caseLogManagersFlow: 'caseLogManagersFlow',
    casesWithServicesCommissions: 'casesWithServicesCommissions'
  }), {
    canAddCommissions: function canAddCommissions() {
      return this.$can('add', 'new-commissions-to-case-manager');
    }
  }),
  data: function data() {
    return {
      snackbar: false,
      loading: false,
      managersTableHeaders: [{ text: 'Appointment date', value: 'created_at', sortable: true }, { text: 'Name' }, { text: 'Commissions', value: 'commissions' }]
    };
  },

  watch: {
    caseModel: function caseModel(c) {
      if (this.$store.state.cases.caseLog.length === 0) this.$store.dispatch('getCaseLog', c.id);
    }
  },
  methods: {
    updateCommissions: function updateCommissions(v) {
      var _this = this;

      this.$store.dispatch('changeCaseManagerCommissions', {
        case_id: this.caseModel.id,
        commissions: v
      }).then(function () {
        _this.$store.dispatch('getCaseLog', _this.caseModel.id);
      });
    }
  },
  created: function created() {
    if (this.$store.state.cases.caseLog.length === 0) this.$store.dispatch('getCaseLog', this.caseModel.id);
  }
});

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_epsilon__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_epsilon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_epsilon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_resources_plans__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_resources_cases__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    caseModel: {
      type: Object,
      required: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({}), {
    leftToPay: function leftToPay() {
      var gst = this.quotationTotalPrice / 100 * 8;
      var val = this.quotationTotalPrice + gst - Number(this.deposit) + Number(this.readjustment);
      return Math.round((val + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_epsilon___default.a) * 100) / 100;
    }
  }),
  data: function data() {
    return {
      snackbar: false,
      loading: false,
      deposit: this.caseModel.deposit || 0,
      readjustment: this.caseModel.readjustment || 0,
      quotationTotalPrice: 0,
      planData: {},
      depositRules: [function (value) {
        var rules = true;

        if (value.indexOf(',') >= 0) {
          rules = 'No commas allowed';
        }
        if (value.indexOf(' ') >= 0) {
          rules = 'No spaces allowed';
        }
        if (/[a-z]/i.test(value)) {
          rules = 'No letters allowed';
        }
        if (value[0] === '0') {
          rules = 'No leading 0 allowed';
        }
        if (value.indexOf('+') >= 0) {
          rules = 'No plus signs allowed';
        }

        return rules;
      }]
    };
  },

  watch: {
    timeStart: function timeStart(newVal) {
      if (newVal.indexOf(':') !== -1) {
        this.menuTimeStart.state = false;
      }
    },
    caseModel: function caseModel(c) {
      this.deposit = c.deposit || 0;
    }
  },
  methods: {
    changeDeposit: function changeDeposit() {
      var _this = this;

      this.loading = true;
      var deposit = Number(this.deposit);
      this.$store.dispatch('updateCase', { case_id: this.caseModel.id, payload: { deposit: deposit } }).then(function () {
        _this.$store.dispatch('getCaseInvoices', _this.caseModel.id);
        _this.$store.dispatch('getCaseLog', _this.caseModel.id);
        _this.loading = false;
      });
    }
  },
  created: function created() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_2__api_resources_plans__["a" /* default */].loadPlan(this.caseModel.plans_id).then(function (result) {
      _this2.planData = result;
    });

    __WEBPACK_IMPORTED_MODULE_3__api_resources_cases__["a" /* default */].getQuotationTotalPrice(this.caseModel.id).then(function (result) {
      _this2.quotationTotalPrice = result;
    }, function () {});
  }
});

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Resources__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sendbird__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sendbird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sendbird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__livechat_js_chat__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_resources_cases__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_resources_crud__ = __webpack_require__(9);
//
//
//
//
//
//
//
//


 // eslint-disable-line no-unused-vars




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CaseFormsChat',
  props: {
    casesid: {
      type: Number,
      required: true
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Resources__["a" /* default */]],
  data: function data() {
    return {
      resources: 'chats',
      createdChannelUrl: '',
      userId: this.$store.getters.loggedUserEmail,
      chat: {}
    };
  },

  computed: {
    channelName: function channelName() {
      return 'dfs_chat_' + this.casesid;
    }
  },
  watch: {
    createdChannelUrl: function createdChannelUrl() {
      this.chat.enterChannel(this.createdChannelUrl);
    }
  },
  methods: {
    loadListing: function loadListing() {}
  },
  mounted: function mounted() {
    var _this = this;

    this.chat = new __WEBPACK_IMPORTED_MODULE_2__livechat_js_chat__["a" /* default */]();

    window.liveChat = this.chat;
    window.SendBird = __WEBPACK_IMPORTED_MODULE_1_sendbird___default.a;

    var el = document.createElement('div');

    el.setAttribute('id', 'sb_chat');
    el.setAttribute('class', 'content-chat');

    var dfsChat = document.getElementById('dfs-chat');

    dfsChat.appendChild(el);

    this.chat.startWithConnect(this.$dfsConfig.sendbird_app_id, this.userId, this.userId, function () {
      __WEBPACK_IMPORTED_MODULE_3__api_resources_cases__["a" /* default */].getLinkedChat(_this.casesid).then(function (result) {
        _this.createdChannelUrl = result.url;
      }, function (error) {
        var handle = error; // eslint-disable-line

        _this.chat.adapter.api.OpenChannel.createChannel(_this.channelName, '', '', function (createdChannel, error) {
          if (error) {
            console.log('can\'t create channel');

            return;
          }

          _this.createdChannelUrl = createdChannel.url;

          var payload = {
            url: createdChannel.url
          };

          __WEBPACK_IMPORTED_MODULE_4__api_resources_crud__["a" /* default */].dfsResourceStore(_this.resources + '/withid', payload).then(function (result) {
            __WEBPACK_IMPORTED_MODULE_3__api_resources_cases__["a" /* default */].attachChatToCase(_this.casesid, result.data.additional_data.inserted_id).then(function (result) {
              // console.log(result)
            }, function () {});
          }, function (error) {
            var handle = error; // eslint-disable-line
          });
        });
      });
    });
  }
});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_ItemTypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ItemCheckList__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ItemCheckList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ItemCheckList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_resources_cases__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_resources_vendors__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_consts__ = __webpack_require__(90);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CaseFormsCheckList',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_ItemTypes__["a" /* default */]],
  components: { ItemCheckList: __WEBPACK_IMPORTED_MODULE_1__components_ItemCheckList___default.a },
  watch: {
    servicesList: function servicesList(newVal) {
      this.itemsList = newVal;
    },
    itemType: function itemType(newVal) {
      switch (newVal) {
        case this.inventoryTypeID:
          this.itemsList = this.inventoriesList;
          break;
        case this.serviceTypeID:
          this.itemsList = this.servicesList;
          break;
      }
    }
  },
  data: function data() {
    return {
      itemsList: [],
      inventoriesList: [],
      servicesList: [],
      selectedItem: 0,
      itemType: __WEBPACK_IMPORTED_MODULE_4__config_consts__["a" /* default */].schedules.SERVICE_TYPE_ID
      // itemType: 0
    };
  },
  created: function created() {
    var _this = this;

    if (this.$store.getters.currentUserRoles.includes('vendor')) {
      __WEBPACK_IMPORTED_MODULE_3__api_resources_vendors__["a" /* default */].getVendorItems(this.$store.getters.currentUser.id).then(function (result) {
        _this.servicesList = result.services;
        _this.inventoriesList = result.inventories;
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_2__api_resources_cases__["a" /* default */].getLinkedInventories(this.casesid).then(function (result) {
        _this.inventoriesList = result;
      }, function () {});

      // TODO dublicate acl logic on backend
      __WEBPACK_IMPORTED_MODULE_2__api_resources_cases__["a" /* default */].getLinkedServices(this.casesid).then(function (result) {
        if (_this.isPersonal) {
          result.forEach(function (item) {
            if (item.users_id === _this.$store.getters.currentUser.id) {
              _this.servicesList.push(item);
            }
          });
        } else {
          _this.servicesList = result;
        }
      }, function () {});
    }
  },

  props: {
    casesid: {
      type: Number,
      required: true
    },
    isPersonal: {
      type: Boolean,
      required: false
    }
  }
});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_EditResourceDialog__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_ItemTypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_resources_cases__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_resources_plans__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_resources_clients__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ItemCheckList__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ItemCheckList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ItemCheckList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_resources_services__ = __webpack_require__(54);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ItemCheckList: __WEBPACK_IMPORTED_MODULE_5__components_ItemCheckList___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_EditResourceDialog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_ItemTypes__["a" /* default */]],
  data: function data() {
    return {
      resource: 'cases',
      enableChecklist: false,
      clientsList: [],
      inventoriesList: [],
      servicesList: [],
      plansList: [],
      selectedCasket: null,
      selectedInventoryForChecklist: null,
      selectedServiceForChecklist: null
    };
  },

  computed: {
    finalItemId: function finalItemId() {
      return this.itemId > 0 ? this.itemId : this.casesId;
    },

    selectedPlan: {
      get: function get() {
        return this.itemData.plans_id;
      },
      set: function set(newVal) {
        this.itemData.plans_id = newVal;
      }
    },
    selectedInventoriesList: function selectedInventoriesList() {
      var _this = this;

      return this.inventoriesList.filter(function (item) {
        return _this.itemData.inventories.includes(item.id);
      });
    },
    selectedServicesList: function selectedServicesList() {
      var _this2 = this;

      return this.servicesList.filter(function (item) {
        return _this2.itemData.services.includes(item.id);
      });
    }
  },
  watch: {
    dialogModeCloseStatus: function dialogModeCloseStatus(newVal) {
      if (newVal) {
        this.setEditItemIdZero();
      }
    },
    selectedPlan: function selectedPlan(newVal) {
      var _this3 = this;

      if (newVal > 0) {
        // inventoriesAPI.loadInventories().then(result => {
        //   this.inventoriesList = result
        //   this.itemData.inventories = []

        //   plansAPI.getLinkedInventories(newVal).then(result => {
        //     result.forEach(item => {
        //       this.itemData.inventories.push(item.id)
        //     })
        //   }, () => {})
        // })

        __WEBPACK_IMPORTED_MODULE_6__api_resources_services__["a" /* default */].loadServices().then(function (result) {
          _this3.servicesList = result;
          _this3.itemData.services = [];

          __WEBPACK_IMPORTED_MODULE_3__api_resources_plans__["a" /* default */].getLinkedServices(newVal).then(function (result) {
            result.forEach(function (item) {
              _this3.itemData.services.push(item.id);
            });
          }, function () {});
        });
      }
    }
  },
  methods: {
    afterEditCallback: function afterEditCallback() {
      var _this4 = this;

      this.dialogResult = true;

      this.selectedServicesList.forEach(function (item) {
        __WEBPACK_IMPORTED_MODULE_2__api_resources_cases__["a" /* default */].attachDefaultChecklistToCase(_this4.itemData.id, item.id);
      });

      this.enableChecklist = true;
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    __WEBPACK_IMPORTED_MODULE_4__api_resources_clients__["a" /* default */].loadClients().then(function (result) {
      _this5.clientsList = result;
    }, function () {});
    __WEBPACK_IMPORTED_MODULE_3__api_resources_plans__["a" /* default */].loadPlans().then(function (result) {
      _this5.plansList = result;
    }, function () {});

    if (!this.isInDialog && this.casesId > 0) {
      this.changedItemIdAction(this.casesId);

      __WEBPACK_IMPORTED_MODULE_2__api_resources_cases__["a" /* default */].getLinkedAnswers(this.finalItemId).then(function (result) {
        var casketModel = JSON.parse(result[0].answer).form_answers.find(function (item) {
          return item.input_id === 'casket_model';
        });

        _this5.$set(_this5.itemData, 'casket_model', casketModel.answer);
      }, function () {});
    }
  },

  props: {
    isInDialog: {
      type: Boolean,
      default: false,
      required: false
    },
    casesId: {
      type: Number,
      default: 0,
      required: false
    }
  }
});

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_epsilon__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_epsilon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_epsilon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_resources_plans__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_resources_cases__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    caseModel: {
      type: Object,
      required: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({}), {
    leftToPay: function leftToPay() {
      var gst = this.quotationTotalPrice / 100 * 8;
      var val = this.quotationTotalPrice + gst + Number(this.readjustment);
      return Math.round((val + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_epsilon___default.a) * 100) / 100;
    }
  }),
  data: function data() {
    return {
      snackbar: false,
      loading: false,
      readjustment: this.caseModel.readjustment || 0,
      quotationTotalPrice: 0,
      planData: {},
      readjustmentRules: [function (value) {
        var rules = true;

        if (value.indexOf(',') >= 0) {
          rules = 'No commas allowed';
        }
        if (value.indexOf(' ') >= 0) {
          rules = 'No spaces allowed';
        }
        if (/[a-z]/i.test(value)) {
          rules = 'No letters allowed';
        }
        if (value.indexOf('+') >= 0) {
          rules = 'No plus signs allowed';
        }

        return rules;
      }]
    };
  },

  watch: {
    caseModel: function caseModel(c) {
      this.readjustment = c.readjustment || 0;
    }
  },
  methods: {
    changeDeposit: function changeDeposit() {
      var _this = this;

      this.loading = true;
      var readjustment = Number(this.readjustment);
      this.$store.dispatch('updateCase', { case_id: this.caseModel.id, payload: { readjustment: readjustment } }).then(function () {
        _this.$store.dispatch('getCaseInvoices', _this.caseModel.id);
        _this.$store.dispatch('getCaseLog', _this.caseModel.id);
        _this.loading = false;
      });
    }
  },
  created: function created() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_2__api_resources_plans__["a" /* default */].loadPlan(this.caseModel.plans_id).then(function (result) {
      _this2.planData = result;
    });

    __WEBPACK_IMPORTED_MODULE_3__api_resources_cases__["a" /* default */].getQuotationTotalPrice(this.caseModel.id).then(function (result) {
      _this2.quotationTotalPrice = result;
    }, function () {});
  }
});

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    return {
      loading: false,
      clientModel: null,
      clientNameRules: [function (v) {
        var rules = true;

        if (!_this.selectedClient) {
          rules = !!v || 'Required';
        }

        return rules;
      }],
      valid: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    clientById: 'getClientById'
  })),
  watch: {
    valid: function valid(newVal) {
      this.$emit('valid:changed', newVal);
    },
    clientModel: function clientModel(name) {
      this.valid = true;
      this.$emit('namechanged', name);
    },
    selectedClient: function selectedClient(id) {
      var _this2 = this;

      this.$store.dispatch('getAllClients').then(function () {
        _this2.clientModel = _this2.clientById(id).name || _this2.clientById(id).text;
      });
    }
  },
  props: {
    selectedClient: {
      required: false,
      default: false
    },
    clientName: {
      default: null
    }
  },
  created: function created() {
    this.clientModel = this.clientName;
  }
});

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    console.log(this.$vuetify.breakpoint);
  }
});

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    formData: 'getOnBoardClientFormAnswers',
    editable: 'isOnBoardClientFormAnswersEditable',
    loadingCaseForms: 'getLoadingFormsStatus'
  })),
  data: function data() {
    var _this = this;

    return {
      localAgreementFormData: [],
      valid: false,
      valuableItemsDeclarationRules: [function (v) {
        return !_this.localAgreementFormData.no_valuable_items ? !!v || 'Required' : true;
      }],
      valuableAdditionalItemsDeclarationRules: [function (v) {
        return !_this.localAgreementFormData.no_additional_items_on_body ? !!v || 'Required' : true;
      }]
      // noValuableItemsRules: [
      //   v => (!this.localAgreementFormData.valuable_items_declaration || this.localAgreementFormData.valuable_items_declaration === '') ? !!v || 'Required' : true
      // ],
      // noAdditionalItemsOnBodyRules: [
      //   v => (!this.localAgreementFormData.valuable_items_declaration || this.localAgreementFormData.valuable_additional_items_declaration === '') ? !!v || 'Required' : true
      // ],
      // ashPlacementArrangedByRules: [
      //  v => !!v || 'Required'
      // ]
    };
  },

  methods: {
    valuableItemsComplete: function valuableItemsComplete(checklist) {
      return checklist.no_valuable_items === true || typeof checklist.valuableItemsDeclaration !== 'undefined' && checklist.valuableItemsDeclaration !== null;
    },
    valuableAdditionalItemsComplete: function valuableAdditionalItemsComplete(checklist) {
      return checklist.no_additional_items_on_body === true || typeof checklist.valuableAdditionalItemsDeclaration !== 'undefined' && checklist.valuableAdditionalItemsDeclaration !== null;
    },
    ashesPlacementComplete: function ashesPlacementComplete(checklist) {
      return checklist.ashesPlacementAgreement === true && checklist.ashPlacementArrangedBy > 0;
    },
    checkListComplete: function checkListComplete(checklist) {
      return this.ashesPlacementComplete(checklist) && this.valuableItemsComplete(checklist) && this.valuableAdditionalItemsComplete(checklist);
    }
  },
  watch: {
    valid: function valid(status) {
      this.$store.commit('updateAgreementOnBoardForm', this.localAgreementFormData);
      this.$emit('valid:changed', status);
    },
    formData: function formData() {
      this.caseSelected = this.caseid;
      this.localAgreementFormData = this.formData.agreement_form_data;
    },

    localAgreementFormData: {
      handler: function handler(newObject) {
        this.$emit('agreement:status', this.checkListComplete(newObject), newObject);
      },

      deep: true
    }
  },
  created: function created() {
    this.localAgreementFormData = this.formData.agreement_form_data;
  }
});

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    formData: 'getOnBoardClientFormAnswers',
    editable: 'isOnBoardClientFormAnswersEditable',
    loadingCaseForms: 'getLoadingFormsStatus'
  })),
  data: function data() {
    return {
      localClientFormData: [],
      nameRules: [function (v) {
        return !!v || 'Required';
      }],
      nricFinNumberRules: [function (v) {
        return !!v || 'Required';
      }],
      contactNumberRules: [function (value) {
        var rules = true;

        if (value.indexOf(',') >= 0) {
          rules = 'No commas allowed';
        }
        if (value.indexOf('.') >= 0) {
          rules = 'No dots allowed';
        }
        if (value.indexOf(';') >= 0) {
          rules = 'No semicolons allowed';
        }
        if (value.indexOf(' ') >= 0) {
          rules = 'No spaces allowed';
        }
        if (/[a-z]/i.test(value)) {
          rules = 'No letters allowed';
        }
        if (value[0] !== '+') {
          rules = 'Must start with a plus ("+") sign';
        }
        if (value[1] !== '6' || value[2] !== '5') {
          rules = 'Country code (+65) is required';
        }
        if (!value) {
          rules = 'This field is required';
        }

        return rules;
      }],
      emailRules: [function (v) {
        return (/\S+@\S+\.\S+/.test(v) || 'Valid email is required'
        );
      }],
      mailingAddressRules: [function (v) {
        return !!v || 'Required';
      }],
      valid: false
    };
  },

  props: {
    clientName: String,
    newreturn: String
  },
  watch: {
    valid: function valid(status) {
      this.$store.commit('updateClientOnBoardForm', this.localClientFormData);
      this.$emit('valid:changed', status);
    },

    localClientFormData: {
      handler: function handler(newObject) {
        this.$emit('clientdata:input', newObject);
      },

      deep: true
    },
    clientName: function clientName(name) {
      this.localClientFormData.name = name;
    },
    formData: function formData() {
      this.caseSelected = this.caseid;
      this.localClientFormData = this.formData.client_form_data;
    },
    newreturn: function newreturn(value) {
      this.localClientFormData.new_return = this.value;
    }
  },
  created: function created() {
    this.localClientFormData = this.formData.client_form_data;
    this.localClientFormData.new_return = this.newreturn;
  },

  methods: {
    mailingAddressClick: function mailingAddressClick(value) {
      if (value) {
        this.localClientFormData.mailing_address = this.localClientFormData.email;
      } else {
        this.localClientFormData.mailing_address = null;
      }
    }
  }
});

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    if (this.$can('view', 'AppointmentSchedule')) {
      this.$router.push({ name: 'AppointmentsTable' });
    } else if (this.$can('view', 'AddLeadForm')) {
      this.$router.push({ name: 'AddLeadForm' });
    }
  }
});

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_resources_inventories__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_services__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_ItemTypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Resources__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_resources_checklists__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_resources_cases__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_user__ = __webpack_require__(31);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  // TODO along with SelectPlanAndVendors move part of the products datatable management to stand alone component
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_ItemTypes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_Resources__["a" /* default */]],
  data: function data() {
    return {
      productsTableHeaders: [{ text: 'Name', value: 'name' }, { text: 'Qty', value: 'amount', width: '5px' }, { text: 'Unit', value: 'price' }, { text: 'Subtotal', value: 'price' }, { text: 'Actions', value: 'actions' }],
      productsList: [],
      selectedProducts: [],
      checklists: [],
      vendorName: null,
      attachedServicesToCase: false,
      visible: {
        attachServicesToCaseBtn: true
      },
      loading: {
        items: false,
        attachServicesToCaseBtn: false
      },
      newQuestion: null
    };
  },

  computed: {
    resources: function resources() {
      return 'cases/' + this.casesId + '/service';
    },
    canAddToChecklist: function canAddToChecklist() {
      return this.$can('add', 'checklist-item') && this.productsList.length > 0;
    },
    itemTypeAPI: function itemTypeAPI() {
      switch (this.itemType) {
        case this.inventoryTypeID:
          return __WEBPACK_IMPORTED_MODULE_0__api_resources_inventories__["a" /* default */];
        case this.serviceTypeID:
          return __WEBPACK_IMPORTED_MODULE_1__api_resources_services__["a" /* default */];
      }
    },
    showRemoveButton: function showRemoveButton() {
      if (this.$can('delete', 'checklist-item')) {
        return 'close';
      }

      return '';
    },
    showEditButton: function showEditButton() {
      if (this.$can('edit', 'checklist-item')) {
        return 'edit';
      }

      return '';
    },
    selectedProductsAsObjects: function selectedProductsAsObjects() {
      var _this = this;

      return this.productsList.filter(function (filtering) {
        var inList = _this.selectedProducts.includes(filtering.id);

        if (inList) {
          var found = _this.checklists.find(function (finding) {
            return finding.item_id === filtering.id;
          });

          if (found) {
            filtering.amount = found.quantity;
          }
        }

        return inList;
      });
    }
  },
  methods: {
    deleteElementSuccess: function deleteElementSuccess() {
      this.loadProducts();
      this.loadCheckList();
    },
    deleteElementWrapper: function deleteElementWrapper(itemId) {
      this.deleteElement(itemId);
    },
    loadProducts: function loadProducts() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_6__api_user__["a" /* default */].getLinkedProducts(this.itemId).then(function (result) {
        _this2.productsList = result;
      }, function () {});
    },
    loadListingSuccess: function loadListingSuccess() {
      this.loadProducts();
    },
    attachServicesToCase: function attachServicesToCase() {
      var _this3 = this;

      var promise = __WEBPACK_IMPORTED_MODULE_5__api_resources_cases__["a" /* default */].attachVendorServicesToCase(this.casesId, this.selectedProductsAsObjects);

      promise.then(function () {
        _this3.loading.attachServicesToCaseBtn = true;

        _this3.attachedServicesToCase = true;
        _this3.loading.attachServicesToCaseBtn = false;
        _this3.visible.attachServicesToCaseBtn = false;

        _this3.$store.dispatch('loadAllCases');

        _this3.loadCheckList();
      });
    },
    toggleCheckListStatus: function toggleCheckListStatus(item) {
      __WEBPACK_IMPORTED_MODULE_4__api_resources_checklists__["a" /* default */].setCheckListStatus(item.id, item.model).then(function () {}, function () {});
    },
    deleteCheckList: function deleteCheckList(item) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_4__api_resources_checklists__["a" /* default */].delete(item.id).then(function () {
        var index = _this4.checklists.findIndex(function (checklist) {
          return checklist.id === item.id;
        });

        _this4.$store.dispatch('loadAllCases');

        _this4.checklists.splice(index, 1);
      }, function () {});
    },
    editCheckList: function editCheckList(item) {
      item.editable = true;
    },
    saveCheckList: function saveCheckList(item) {
      item.editable = false;

      __WEBPACK_IMPORTED_MODULE_4__api_resources_checklists__["a" /* default */].editQuestion(item.id, item.question).then(function () {}, function () {});
    },
    addCheckList: function addCheckList() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_4__api_resources_checklists__["a" /* default */].add(this.selectedProducts, this.itemType, this.newQuestion, this.casesId).then(function () {
        _this5.loadCheckList();
      }, function () {});

      __WEBPACK_IMPORTED_MODULE_5__api_resources_cases__["a" /* default */].attachServicesToCase(this.casesId, this.selectedProductsAsObjects).then(function () {}, function () {});
    },
    loadCheckList: function loadCheckList() {
      var _this6 = this;

      this.loading.items = true;

      var promise = null;

      this.checklists = [];

      if (this.casesId > 0) {
        promise = __WEBPACK_IMPORTED_MODULE_5__api_resources_cases__["a" /* default */].getVendorProducts(this.casesId, this.itemId);

        promise.then(function (result) {
          result.forEach(function (checklist) {
            checklist.model = checklist.is_complete;
            checklist.editable = false;
          });

          _this6.loading.items = false;

          _this6.selectedProducts = result.map(function (mapping) {
            return mapping.item_id;
          });
          _this6.checklists = result;
        }, function () {
          _this6.loading.items = false;
        });
      }
    }
  },
  watch: {
    itemId: function itemId(newVal) {
      this.loadCheckList(newVal);
    },

    selectedProductsAsObjects: {
      handler: function handler() {
        this.visible.attachServicesToCaseBtn = true;
        this.loading.attachServicesToCaseBtn = false;
        this.attachedServicesToCase = false;
      },

      deep: true
    }
  },
  created: function created() {
    var _this7 = this;

    this.loadCheckList();

    __WEBPACK_IMPORTED_MODULE_6__api_user__["a" /* default */].loadUser(this.itemId).then(function (result) {
      _this7.vendorName = result.name;
    }, function () {});

    this.loadProducts();
  },

  props: {
    casesId: {
      type: Number,
      required: false
    },
    itemId: {
      type: Number,
      required: true
    },
    itemType: {
      type: Number,
      required: true
    }
  }
});

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppMainDialog__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppMainDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_AppMainDialog__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppMainDialog: __WEBPACK_IMPORTED_MODULE_1__components_AppMainDialog___default.a },
  data: function data() {
    return {
      userLogin: '',
      userPassword: '',
      dialogMessage: '',
      dialogOpen: false
    };
  },

  methods: {
    checkLogin: function checkLogin() {
      var _this = this;

      var onFulfilled = function onFulfilled(defs) {
        if (defs.access_token) {
          _this.$store.dispatch('logIn').then(function () {
            localStorage.setItem('oauthToken', defs.access_token);
            localStorage.setItem('oauthTokenRefresh', defs.refresh_token);

            _this.$axios.defaults.headers.common['Authorization'] = 'Bearer ' + defs.access_token;

            _this.$dfsUserAPI.getCurrentUser().then(function (result) {
              localStorage.setItem('loggedUserEmail', result.email);
              localStorage.setItem('currentUser', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result));

              _this.$store.dispatch('setLoggedUserEmail', result.email);
              _this.$store.dispatch('setCurrentUser', result);

              _this.$dfsUserAPI.getCurrentUserRoles().then(function (result) {
                var arr = [];

                result.forEach(function (item) {
                  arr.push(item.name);
                });

                localStorage.setItem('currentUserRoles', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(arr));

                _this.$store.dispatch('setCurrentUserRoles', arr);
                _this.$store.dispatch('setAppIsLoaded', true);

                _this.access = arr;
              });
            }, function (error) {
              var handle = error; // eslint-disable-line
            });

            _this.$router.push({
              'name': 'Home'
            });
          });
        }
      };

      var onRejected = function onRejected(defs) {
        _this.dialogMessage = 'Invalid credentialls';
        _this.dialogOpen = true;
      };

      var credentials = {
        userLogin: this.userLogin,
        userPassword: this.userPassword
      };

      var result = this.$dfsUserAPI.auth(credentials);

      result.then(onFulfilled, onRejected);
    },
    refresh: function refresh() {
      location.reload(true);
    }
  },
  created: function created() {
    var _this2 = this;

    this.$on('dialog-close', function () {
      _this2.dialogOpen = false;
    });

    if (this.$store.getters.logInStatus === true) {
      this.$router.push({
        name: 'Home'
      });
    }
  }
});

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    var _this = this;

    this.$store.dispatch('logOut').then(function () {
      localStorage.clear();

      _this.$router.push({
        name: 'Login'
      });
    });
  }
});

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buttons_AddScheduledCaseButton__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buttons_AddScheduledCaseButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_buttons_AddScheduledCaseButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_AddCaseNameAndDateDialog__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_AddCaseNameAndDateDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_dialogs_AddCaseNameAndDateDialog__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import schedulesAPI from '@/api/resources/schedules'




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Cases',
  components: { AddScheduledCaseButton: __WEBPACK_IMPORTED_MODULE_2__components_buttons_AddScheduledCaseButton___default.a, AddCaseNameAndDateDialog: __WEBPACK_IMPORTED_MODULE_3__components_dialogs_AddCaseNameAndDateDialog___default.a },
  data: function data() {
    return {
      items: [],
      tableHeaders: [{ text: '', value: 'time' }, { text: 'Time', value: 'start_time' }, { text: 'Type', value: 'type' }, { text: 'Case manager', value: 'users_id' }, { text: 'Crew', value: 'crew' }, { text: 'Description', value: 'description' }, { text: 'Case ID', value: 'case_id' }],
      rowsPerPageItems: [-1],
      pagination: {
        descending: true,
        rowsPerPage: -1,
        sortBy: 'created_at'
      },
      date: this.moment().format('YYYY-MM-DD'),
      menu: false,
      dateForNewLead: this.moment().format('YYYY-MM-DD'),
      dialogModel: false,
      services: [],
      loadingItemsText: 'Loading data...',
      loadingInProgress: true,
      showAlert: false
    };
  },

  watch: {
    date: function date() {
      this.loadSchedules();
    }
  },
  provide: function provide() {
    return {
      onClickDate: this.onClickDate
    };
  },
  methods: {
    formatTime: function formatTime(date) {
      return date ? this.moment(date, 'YYYY-MM-DD HH:mm:ss').format('HH:mm') : '-';
    },
    getCaseType: function getCaseType(item) {
      switch (item.status) {
        case 'pending':
          return 'Pickup';
        case 'approved':
          return 'Setup';
        case 'filled':
          return 'Wake';
        default:
          return 'Wake';
      }
    },
    getCaseCrew: function getCaseCrew(item) {
      return item && item.services ? item.services.filter(function (i) {
        return i && i.description === 'Case Crew';
      }).map(function (i) {
        return i.name;
      }).join(', ') : '';
    },
    checkInvolve: function checkInvolve(services) {
      var userId = this.$store.getters.currentUser.id;
      var result = '';
      if (services) {
        services.forEach(function (service) {
          if (service && service.users_id === userId) result = ' involved';
        });
      }
      return result;
    },
    getTimelinePosition: function getTimelinePosition(time) {
      var diff = this.moment().diff(time, 'minutes');
      if (diff > 0 && diff < 60) return 'current';
      if (diff <= 0) return 'future';
      if (diff > 60) return 'past';
    },
    formTable: function formTable(data) {
      var times = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Array(24).keys()));
      var newData = [];
      for (var k = 0; k < times.length; k++) {
        var time = times[k];
        var nextTime = time < 9 ? '0' + (time + 1) + '00' : time < 23 ? time + 1 + '00' : '2400';
        var currentTime = time <= 9 ? '0' + time + '00' : time + '00';
        var timeItems = [];
        for (var i = 0; i < data.length; i++) {
          var itemTime = data[i].start_time.replace(':', '');
          if (itemTime < nextTime && itemTime >= currentTime) timeItems.push(data[i]);
        }
        if (timeItems.length === 0) {
          var timeline = this.getTimelinePosition(this.date + ' ' + currentTime.slice(0, -2) + ':00');
          timeItems.push({
            time: currentTime.slice(0, -2) + ':00',
            timeline: timeline,
            id: null,
            date: null,
            start_time: null,
            end_time: null,
            type: null,
            case_manager: null
          });
        } else {
          timeItems.sort(function (a, b) {
            var timeA = parseInt(a.start_time.replace(':', ''));
            var timeB = parseInt(b.start_time.replace(':', ''));
            var comparison = 0;
            if (timeA > timeB) {
              comparison = 1;
            } else if (timeA < timeB) {
              comparison = -1;
            }
            return comparison;
          });
          timeItems[0].time = currentTime.slice(0, -2) + ':00';
        }
        newData[k] = timeItems;
      }
      return newData.flat();
    },
    groupDataByCaseId: function groupDataByCaseId(data) {
      var _this = this;

      var groupedData = [];
      data.forEach(function (i) {
        if (i.cases_id) {
          if (groupedData[i.cases_id]) {
            groupedData[i.cases_id].services.push(i.service);
          } else {
            var timeline = _this.getTimelinePosition(_this.moment(i.schedule_start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm'));
            groupedData[i.cases_id] = {
              time: '',
              timeline: timeline,
              id: i.id,
              leads_id: i.leads_id,
              item_id: i.item_id,
              case_id: i.cases_id,
              description: i.venue_description,
              date: _this.moment(i.schedule_start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
              start_time: _this.moment(i.schedule_start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm'),
              end_time: i.schedule_end ? _this.moment(i.schedule_end, 'YYYY-MM-DD HH:mm:ss').format('HH:mm') : '',
              type: 'Pickup',
              services: [i.service],
              case_manager: i.case ? i.case.manager_name : '-'
            };
          }
        }
      });
      return groupedData.filter(function (value) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(value).length !== 0;
      });
    },
    loadSchedules: function loadSchedules() {
      var _this2 = this;

      this.loadingInProgress = true;
      this.items = [];
      this.$axios.get(this.$store.getters.config.api_host + '/api/schedules/bydate?date=' + this.date).then(function (response) {
        var result = response.data.additional_data;
        var data = _this2.groupDataByCaseId(result.filter(function (i) {
          return i && _this2.moment(i.schedule_start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') === _this2.date;
        }));
        _this2.items = _this2.formTable(data);
        _this2.loadingInProgress = false;
      });
    },
    onClickDate: function onClickDate(date) {
      if (this.$can('use', 'appointment-schedule-create-new-case')) {
        this.dateForNewLead = this.moment(date).subtract(1, 'month').format('YYYY-MM-DD');
        this.dialogModel = true;
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.loadSchedules();
    // const response = await this.$axios.get(`${this.$store.getters.config.api_host}api/schedules/bydate?date=2020-05-26`)
    this.showAlert = this.$route.params.alert;
    setTimeout(function () {
      _this3.showAlert = false;
    }, 2000);
  },

  props: {
    alert: {
      type: Boolean,
      default: false,
      required: false
    }
  }
});

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DfsServiceAgreementClientData__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DfsServiceAgreementClientData___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_DfsServiceAgreementClientData__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DfsServiceAgreement__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DfsServiceAgreement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_DfsServiceAgreement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DfsServiceAgreementCheckList__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DfsServiceAgreementCheckList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_DfsServiceAgreementCheckList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_resources_Forms__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_resources_Forms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_resources_Forms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ClientAddForm__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ClientAddForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ClientAddForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AppMainDialog__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AppMainDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_AppMainDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SelectPlanAndVendors__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SelectPlanAndVendors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_SelectPlanAndVendors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_dialogs_ConfirmationDialog__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_dialogs_ConfirmationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_dialogs_ConfirmationDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  components: { dfsForms: __WEBPACK_IMPORTED_MODULE_4__components_resources_Forms___default.a, dfsClientAddForm: __WEBPACK_IMPORTED_MODULE_5__components_ClientAddForm___default.a, AppMainDialog: __WEBPACK_IMPORTED_MODULE_6__components_AppMainDialog___default.a, DfsServiceAgreement: __WEBPACK_IMPORTED_MODULE_2__components_DfsServiceAgreement___default.a, DfsServiceAgreementCheckList: __WEBPACK_IMPORTED_MODULE_3__components_DfsServiceAgreementCheckList___default.a, DfsServiceAgreementClientData: __WEBPACK_IMPORTED_MODULE_1__components_DfsServiceAgreementClientData___default.a, SelectPlanAndVendors: __WEBPACK_IMPORTED_MODULE_7__components_SelectPlanAndVendors___default.a, ConfirmationDialog: __WEBPACK_IMPORTED_MODULE_8__components_dialogs_ConfirmationDialog___default.a },
  props: {
    caseid: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      tab: null,
      agreementFormData: null,
      clientFormData: null,
      createClient: false,
      selectedClient: null,
      clientRelation: 'new',
      notSelectedLabel: 'not selected',
      validatedForms: 0,
      clientName: '',
      agreementIsInComplete: true,
      disabled: {
        SaveCaseBtn: true
      },
      loading: {
        SaveCaseBtn: false,
        clients: false
      },
      clientDataIsInComplete: true,
      dialogOpen: false,
      formPriceTableHeaders: [{ text: 'DESCRIPTION', sortable: false }, { text: 'PRICE', sortable: false }, { text: 'REMARKS', sortable: false }],
      dialogMessage: '',
      caseData: null,
      formSubmitted: false,
      showAlert: false,
      alertMessage: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])({
    onBoardClientForm: 'getOnBoardClientForm'
  }), {
    validateClientsList: function validateClientsList() {
      return 'required|';
    },
    tab2active: function tab2active() {
      return this.formSubmitted || this.caseData && this.caseData.clients_id;
    }
  }),
  watch: {
    validatedForms: function validatedForms(count) {
      if (count === 4) {
        this.disabled.SaveCaseBtn = false;
      } else {
        this.disabled.SaveCaseBtn = true;
      }
    }
  },
  methods: {
    clientFilter: function clientFilter(item, queryText, itemText) {
      var textOne = item.name.toLowerCase();
      var searchText = queryText.toLowerCase();

      return textOne.indexOf(searchText) > -1;
    },
    clearSignature: function clearSignature() {
      this.$refs.signaturePad.undoSignature();
    },
    onFormValidate: function onFormValidate(isValid) {
      isValid ? this.validatedForms++ : this.validatedForms--;
    },
    checkIfNewClientAdded: function checkIfNewClientAdded() {},
    checkClientDataStatus: function checkClientDataStatus(object) {
      this.clientFormData = object;
    },
    checkAgreementStatus: function checkAgreementStatus(status, object) {
      this.agreementFormData = object;
      this.agreementIsInComplete = !status;
    },
    onNameChanged: function onNameChanged(newVal) {
      this.clientName = newVal;
    },
    saveCase: function saveCase() {
      var _this = this;

      this.disabled.SaveCaseBtn = this.loading.SaveCaseBtn = true;
      var dateOfDeath = this.moment(this.onBoardClientForm.answer.form_answers.main_form.deceased_date).format('YYYY-MM-DD');
      if (!this.caseData.client_signature) {
        var signature = this.$refs.signaturePad.saveSignature();

        if (!signature.isEmpty) {
          this.$store.dispatch('updateCase', {
            case_id: this.caseid,
            payload: {
              client_signature: signature.data,
              date_of_death: dateOfDeath
            }
          });
        } else {
          this.alertMessage = 'Signature is missing. Please, add a signature first';
          this.showAlert = true;
          setTimeout(function () {
            _this.showAlert = false;
            _this.disabled.SaveCaseBtn = _this.loading.SaveCaseBtn = false;
          }, 2000);
          return;
        }
      } else {
        this.$store.dispatch('updateCase', {
          case_id: this.caseid,
          payload: {
            date_of_death: dateOfDeath
          }
        });
      }

      if (this.createClient) {
        this.$store.dispatch('createClient', this.clientName).then(function (clientId) {
          _this.selectedClient = clientId;
          _this.$store.dispatch('updateCase', { case_id: _this.caseid, payload: { clients_id: clientId } });
          _this.createClient = false;
        });
      }

      this.$store.dispatch('storeOnBoardForm').then(function (result) {
        _this.dialogMessage = 'Case successfully added';
        _this.dialogOpen = true;
        _this.loading.SaveCaseBtn = _this.disabled.SaveCaseBtn = false;
        _this.formSubmitted = true;
        _this.tab = 1;
      });
    },
    checkDataSave: function checkDataSave(event) {
      if (this.formSubmitted || this.caseData && this.caseData.clients_id) return;
      event.preventDefault();
      event.returnValue = "Data wasn't saved. Leaving the page will cause data lose.";
    }
  },
  created: function created() {
    var _this2 = this;

    this.$store.dispatch('clearCaseForms');

    if (!this.caseid) {
      this.$router.push({ name: 'AppointmentSchedule' });
    }

    this.$axios.get(this.$store.getters.config.api_host + '/api/cases/' + this.caseid).then(function (response) {
      var res = response.data.additional_data[0];
      _this2.caseData = res;
      _this2.$store.dispatch('loadCaseForms', res);
      if (res.clients_id) {
        _this2.selectedClient = res.clients_id;
      } else {
        _this2.createClient = true;
      }
    });
  },
  beforeMount: function beforeMount() {
    window.addEventListener('beforeunload', this.checkDataSave);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('beforeunload', this.checkDataSave);
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.formSubmitted || this.caseData && this.caseData.clients_id) {
      next();
    } else {
      this.$refs.confirm.open('Changes you made are not saved.', 'Leave', {}).then(function (confirm) {
        next();
      });
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.formSubmitted || this.caseData && this.caseData.clients_id) {
      next();
    } else {
      this.$refs.confirm.open('Changes you made are not saved.', 'Leave', {}).then(function (confirm) {
        next();
      });
    }
  }
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_AddPDFTemplateButton__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_AddPDFTemplateButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_buttons_AddPDFTemplateButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditPDFTemplatesDialog__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditPDFTemplatesDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditPDFTemplatesDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Resources__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_resources_forms__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(78);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PDFTemplates',
  components: { AddPDFTemplateButton: __WEBPACK_IMPORTED_MODULE_0__components_buttons_AddPDFTemplateButton___default.a, AppEditPDFTemplatesDialog: __WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditPDFTemplatesDialog___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Resources__["a" /* default */]],
  data: function data() {
    return {
      resources: 'templates',
      items: [],
      tableHeaders: [{ text: 'ID', value: 'id' }, { text: 'Form', value: 'form_name' }, { text: 'Body', value: 'body' }, { text: 'Created at', value: 'created_at' }, { text: 'Updated at', value: 'updated_at' }, { text: 'Actions', value: 'actions' }]
    };
  },

  methods: {
    loadListingSuccess: function loadListingSuccess(result) {
      result.forEach(function (item, i) {
        __WEBPACK_IMPORTED_MODULE_3__api_resources_forms__["a" /* default */].loadForm(item.forms_id).then(function (result) {
          var formName = JSON.parse(result.form_structure).form_name;

          __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(item, 'form_name', formName);
        });
      });

      this.items = result;
    }
  }
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_user__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      productsTableHeaders: [{ text: 'Product Name', value: 'name' }, { text: 'Commission', value: 'commission' }, { text: 'Invoice Paid', value: 'invoice_updated' }],
      coursesTableHeaders: [{ text: 'Course Name', value: 'course_id' }, { text: 'Completed %', value: 'earned_all' }],
      userData: null,
      productsList: [],
      casesList: [],
      statData: [],
      leadsData: [],
      casesData: [],
      partiCasessData: [],
      selectedTab: 0
    };
  },

  computed: {
    courses: function courses() {
      var result = [];
      __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.each(JSON.parse(this.userData.courses_completion_percent), function (value, key) {
        return Array.prototype.push.apply(result, value);
      });
      return result;
    },
    totalCommission: function totalCommission() {
      return this.casesList.reduce(function (total, workCase) {
        return total + workCase.products.reduce(function (accum, product) {
          return accum + product.commission;
        }, 0);
      }, 0);
    }
  },
  methods: {
    calculcateCaseCommission: function calculcateCaseCommission(caseId) {
      return this.casesList.find(function (finding) {
        return finding.id === caseId;
      }).products.reduce(function (accum, product) {
        return accum + product.commission;
      }, 0);
    },
    refresh: function refresh() {
      location.reload(true);
    },
    formatLeads: function formatLeads(data) {
      var array = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(data)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          var filteredList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(value.map(function (i) {
            return i.cases_id;
          }))));
          array.push({
            name: key,
            value: filteredList.length
          });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return array;
    }
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_5__api_user__["a" /* default */].getCurrentUser().then(function (result) {
      _this.userData = result;
    }, function () {});

    if (this.$store.getters.currentUserRoles.includes('vendor')) {
      __WEBPACK_IMPORTED_MODULE_5__api_user__["a" /* default */].getLinkedProducts(this.$store.getters.currentUser.id).then(function (result) {
        _this.productsList = result;
      }, function () {});
    }

    if (this.$store.getters.currentUserRoles.includes('case-manager')) {
      __WEBPACK_IMPORTED_MODULE_5__api_user__["a" /* default */].getCaseManagersLinkedCasesAndProducts(this.$store.getters.currentUser.id).then(function (result) {
        _this.casesList = result;
      }, function () {});
    }

    this.$store.dispatch('getUserStat').then(function (res) {
      _this.leadsData = _this.formatLeads(res.leads);
      _this.casesData = _this.formatLeads(res.manager_in_cases);
      _this.partiCasessData = _this.formatLeads(res.participating_in);
      _this.statData = res;
    });
  }
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ItemCheckList__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ItemCheckList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ItemCheckList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_ConfirmationDialog__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_ConfirmationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_dialogs_ConfirmationDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_ItemTypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_resources_cases__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ItemCheckList: __WEBPACK_IMPORTED_MODULE_2__components_ItemCheckList___default.a,
    ConfirmationDialog: __WEBPACK_IMPORTED_MODULE_3__components_dialogs_ConfirmationDialog___default.a
  },
  props: {
    caseId: {
      type: Number,
      required: true
    },
    editable: {
      type: Boolean,
      default: false,
      required: false
    },
    caseData: {
      type: Object
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_ItemTypes__["a" /* default */]],
  data: function data() {
    return {
      snackbar: false,
      upgrade_id: false,
      change_product_from_category_model: null,
      menuDateStart: null,
      menuDateEnd: null,
      wakeDateStart: this.moment().format('YYYY-MM-DD'),
      wakeDateEnd: this.moment().add(2, 'days').format('YYYY-MM-DD'),
      wakeTimeStart: __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('HH:mm'),
      wakeTimeEnd: __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('HH:mm'),
      hwakeDateStart: this.moment().format('YYYY-MM-DD'),
      hwakeDateEnd: this.moment().add(2, 'days').format('YYYY-MM-DD'),
      hwakeTimeStart: __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('HH:mm'),
      hwakeTimeEnd: __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('HH:mm'),
      embalmersPhotoIsUploaded: false,
      embalmers_photo_url: false,
      uploadPercentage: 0,
      photoForEmbalmers: null,
      tagAndRemarks: null,
      discount: null,
      remarks: null,
      productsTableHeaders: [{ text: 'Name', value: 'name' }, { text: 'Qty', value: 'amount', width: '5px' }, { text: 'Unit', value: 'price' }, { text: 'Subtotal', value: 'price' }, { text: 'Actions', value: 'name', sortable: false }],
      selectedPlan: null,
      selectedService: null,
      selectedCasket: null,
      defaultCasket: null,
      casketPrice: 0,
      selectedServices: [],
      isPreplan: false,
      visible: {
        attachServicesToCaseBtn: false
      },
      loading: {
        plans: false,
        attachServicesToCaseBtn: false,
        services: false
      },
      attachedServicesToCase: false,
      disabled: {
        uploadPhotoForEmbalmersBtn: false
      },
      required: [function (v) {
        return !!v || 'Required';
      }],
      showAlert: false,
      alertMessage: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])({
    servicesList: 'allProducts',
    serviceById: 'getProductById',
    filterFromLinkedServices: 'filterFromLinkedServices',
    filterCasketFromLinkedProducts: 'filterCasketFromLinkedProducts',
    removeCasketsFromServices: 'removeCasketsFromServices',
    plansList: 'allPlans',
    planById: 'getPlanById',
    allCaskets: 'allCaskets',
    casketById: 'getCasketById',
    filteredProducts: 'filteredProducts'
  }), {
    finalPrice: function finalPrice() {
      return this.productsPrice + this.casketPrice - (this.discount ? this.discount : 0);
    },
    uploadStatus: function uploadStatus() {
      return this.embalmersPhotoIsUploaded ? 'done' : '';
    },
    productsPrice: function productsPrice() {
      return this.selectedServices.reduce(function (total, service) {
        return service ? total + service.price * service.amount : total;
      }, 0);
    },
    validated: function validated() {
      if (!this.isPreplan) {
        return this.wakeDateStart && this.wakeDateEnd;
      } else {
        return true;
      }
    },
    minStartDate: function minStartDate() {
      return this.moment().format('YYYY-MM-DD');
    },
    minEndDate: function minEndDate() {
      return this.wakeDateStart;
    },
    closed: function closed() {
      return this.caseData && this.caseData.status === 'closed';
    }
  }),
  watch: {
    photoForEmbalmers: function photoForEmbalmers(photo) {
      var _this = this;

      var formData = new FormData();

      var images = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(photo));

      images.map(function (image) {
        formData.append('images[]', image);
      });

      this.disabled.uploadPhotoForEmbalmersBtn = true;
      this.disabled.uploadPhotoForEmbalmersBtn = true;

      var url = this.$store.getters.config.api_host + '/api/cases/' + this.caseId + '/embalmers-photos';
      this.$store.getters.axios.post(url, formData, {
        headers: { 'Content-type': 'multipart/form-data' },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
        }.bind(this)
      }).then(function (response) {
        _this.embalmers_photo_url = response.data.additional_data;
        _this.disabled.uploadPhotoForEmbalmersBtn = false;
        _this.embalmersPhotoIsUploaded = true;
        _this.snackbar = true;

        setTimeout(function () {
          _this.embalmersPhotoIsUploaded = false;
        }, 5000);
      });
    },
    plansList: function plansList() {
      if (this.editable) {
        this.loading.plans = true;
        this.updateCase();
      }
    },

    selectedServices: {
      handler: function handler(newObj) {
        this.visible.attachServicesToCaseBtn = true;
        this.loading.attachServicesToCaseBtn = false;
        this.attachedServicesToCase = false;
      },

      deep: true
    },
    selectedCasket: function selectedCasket() {
      this.visible.attachServicesToCaseBtn = true;
      this.casketPrice = this.selectedCasket ? this.casketById(this.selectedCasket).price : 0;
    },
    isPreplan: function isPreplan(v) {
      if (v !== this.caseData.is_preplan) this.$store.dispatch('updateCase', { case_id: this.caseId, payload: { is_preplan: this.isPreplan } });
      if (v) {
        this.hwakeDateStart = this.wakeDateStart;
        this.hwakeTimeStart = this.wakeTimeStart;
        this.hwakeDateEnd = this.wakeDateEnd;
        this.hwwakeTimeEnd = this.wakeTimeEnd;
        this.wakeDateStart = this.wakeDateEnd = this.wakeTimeStart = this.wakeTimeEnd = null;
      } else {
        this.wakeDateStart = this.hwakeDateStart;
        this.wakeTimeStart = this.hwakeTimeStart;
        this.wakeDateEnd = this.hwakeDateEnd;
        this.wakeTimeEnd = this.hwwakeTimeEnd;
      }
    },
    selectedPlan: function selectedPlan(plan) {
      var defaultCasketId = this.filterCasketFromLinkedProducts(plan.services);
      this.defaultCasket = this.casketById(defaultCasketId).name;
    },
    caseData: function caseData() {
      if (this.$store.state.plans.all.length === 0) this.$store.dispatch('getAllPlans');
      if (this.$store.state.products.categories.length === 0) this.$store.dispatch('getProductsCategories');
      if (this.$store.state.products.all.length === 0) this.$store.dispatch('getAllProducts');
      if (this.$store.state.products.caskets.length === 0) this.$store.dispatch('getAllProducts');
      this.updateCase();
    }
  },
  methods: {
    updateCase: function updateCase() {
      if (this.caseData) {
        this.discount = this.caseData.discount || 0;
        this.remarks = this.caseData.remarks || null;
        this.selectedPlan = this.caseData.plans_id !== null ? this.planById(this.caseData.plans_id) : null;
        this.tagAndRemarks = this.caseData.embalmers_remarks;

        if (!this.caseData.is_preplan) {
          this.wakeDateStart = this.caseData.wake_start ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.caseData.wake_start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') : this.moment().format('YYYY-MM-DD');
          this.wakeDateEnd = this.caseData.wake_end ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.caseData.wake_end, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') : null;
        }

        this.wakeTimeStart = this.caseData.wake_start ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.caseData.wake_start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm') : '11:30';
        this.wakeTimeEnd = this.caseData.wake_end ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.caseData.wake_end, 'YYYY-MM-DD HH:mm:ss').format('HH:mm') : '12:30';

        var casket = this.filterCasketFromLinkedProducts(this.caseData.services);
        var planCasket = this.selectedPlan ? this.filterCasketFromLinkedProducts(this.selectedPlan.services) : false;

        this.defaultCasket = planCasket;
        this.selectedCasket = casket || planCasket;

        this.isPreplan = this.caseData.is_preplan;

        this.selectedServices = this.filterFromLinkedServices(this.caseData.services);
        this.loading.plans = false;
      } else {
        this.loading.plans = false;
      }
    },
    deleteItem: function deleteItem(item) {
      var index = this.selectedServices.indexOf(item);
      this.selectedServices.splice(index, 1);
    },
    deleteImageWithConfirmation: function deleteImageWithConfirmation(imageId, key) {
      var _this2 = this;

      this.$refs.confirm.open('Are you sure you want to delete this image?', 'Delete', {}).then(function (confirm) {
        _this2.deleteEmbImage(imageId, key);
      });
    },
    deleteEmbImage: function deleteEmbImage(imageId, key) {
      var _this3 = this;

      this.$axios.delete(this.$store.getters.config.api_host + '/api/remove-embalmer-photo/' + imageId).then(function (response) {
        _this3.caseData.embalmer_photos.splice(key, 1);
        _this3.alertMessage = 'Image successfully deleted!';
        _this3.showAlert = true;
        setTimeout(function () {
          _this3.showAlert = false;
        }, 2000);
      });
    },
    changeProductFromCategory: function changeProductFromCategory(oldItem) {
      if (oldItem.id !== this.change_product_from_category_model) {
        this.selectedServices = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.unionBy([this.serviceById(this.change_product_from_category_model.id)], this.selectedServices, 'id');
        this.deleteItem(oldItem);
      }
      this.change_product_from_category_model = null;
      this.upgrade_id = false;
    },
    upgradeCategory: function upgradeCategory(item) {
      this.upgrade_id = item.id;
      this.$store.dispatch('filterProducts', item.categories_id === undefined ? null : { id: item.categories_id });
    },
    changedPlan: function changedPlan(plan) {
      if (undefined === plan) {
        return;
      }

      if (this.filterCasketFromLinkedProducts(this.selectedPlan.services)) {
        this.selectedCasket = this.filterCasketFromLinkedProducts(this.selectedPlan.services);
      }

      if (this.selectedCasket) {
        this.casketPrice = this.casketById(this.selectedCasket).price;
      }

      this.visible.attachServicesToCaseBtn = true;
      this.selectedServices = this.removeCasketsFromServices(this.filterFromLinkedServices(this.planById(plan.id).services));
      // this.selectedServices = _.unionBy(this.removeCasketsFromServices(this.filterFromLinkedServices(this.planById(plan.id).services)), this.selectedServices, 'id')
    },
    onFileChange: function onFileChange(event) {
      this.photoForEmbalmers = event.target.files;
    },
    deleteElementSuccess: function deleteElementSuccess() {
      this.$store.dispatch('getAllProducts');
    },
    deleteElementWrapper: function deleteElementWrapper(itemId) {
      this.deleteElement(itemId);
      this.$store.dispatch('getAllProducts');
    },
    filter: function filter(item, query) {
      if (!query || query === '' || typeof query === 'undefined') {
        return true;
      }

      query = query.toLowerCase();

      return item.name.toLowerCase().includes(query) || item.user && item.user.name.toLowerCase().includes(query) || item.category && item.category.name.toLowerCase().includes(query);
    },
    goToCase: function goToCase() {
      this.$router.push({ name: 'CasesDetail', params: { id: this.caseId } });
    },
    attachServicesToCase: function attachServicesToCase() {
      var _this4 = this;

      this.loading.attachServicesToCaseBtn = true;

      var selectedServices = this.selectedServices;
      if (this.selectedCasket) selectedServices.push(this.casketById(this.selectedCasket));

      var wakeDateTimeStart = this.wakeDateStart ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.wakeDateStart, 'YYYY-MM-DD').format('YYYY-MM-DD') + ' ' + (this.wakeTimeStart ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.wakeTimeStart, 'HH:mm:ss').format('HH:mm:ss') : __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('HH:mm:ss')) : '';

      var wakeDateTimeEnd = this.wakeDateEnd ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.wakeDateEnd, 'YYYY-MM-DD').format('YYYY-MM-DD') + ' ' + (this.wakeTimeEnd ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.wakeTimeEnd, 'HH:mm:ss').format('HH:mm:ss') : __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('HH:mm:ss')) : '';

      var promise = __WEBPACK_IMPORTED_MODULE_5__api_resources_cases__["a" /* default */].attachServicesPlanCasketToCase(this.caseId, selectedServices, this.discount, this.selectedPlan, this.tagAndRemarks, wakeDateTimeStart, wakeDateTimeEnd, this.remarks);
      this.selectedServices = this.removeCasketsFromServices(this.selectedServices);
      promise.then(promise).then(function () {
        _this4.loading.attachServicesToCaseBtn = true;

        _this4.attachedServicesToCase = true;
        _this4.loading.attachServicesToCaseBtn = false;
        _this4.visible.attachServicesToCaseBtn = false;

        setTimeout(function () {
          // this.$store.dispatch('loadAllCases')
          _this4.$store.dispatch('getCaseInvoices', _this4.caseId);
        }, 2000);

        if (_this4.$router.history.current.path === '/onboard-client') {
          _this4.alertMessage = 'Order confirmed';
          _this4.showAlert = true;
          setTimeout(function () {
            _this4.goToCase();
            _this4.showAlert = false;
          }, 2000);
        } else if (_this4.caseId) {
          _this4.alertMessage = 'Order updated';
          _this4.showAlert = true;
          setTimeout(function () {
            _this4.$store.dispatch('getCaseLog', _this4.caseId);
            _this4.showAlert = false;
          }, 2000);
        }
      }, function () {});
    },
    filterProducts: function filterProducts(items) {
      // return items.filter(i => i.categories_id !== 10)
      return items.filter(function (i) {
        return i && i.category && i.category.name !== 'Add on Items' && !i.category.name.includes('Add-On');
      });
    },
    filterAddons: function filterAddons(items, categoryId) {
      return items.filter(function (i) {
        return i && i.categories_id === categoryId;
      });
    },
    filterAllAddons: function filterAllAddons(items, categoryId) {
      // return items.filter(i => i.categories_id !== 10)
      return items.filter(function (i) {
        return i && i.category && i.category.name && i.category.name.includes('Add-On') && i.categories_id !== categoryId;
      });
    },
    updateSelectedServices: function updateSelectedServices(event, op) {
      var category = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 30;

      var currentProducts = op === 'product' ? event : this.filterProducts(this.selectedServices);
      var allAddons = this.filterAllAddons(this.selectedServices, category);
      var currentAddons = op === 'add' ? event : null;
      var newServices = currentProducts.concat(allAddons).concat(currentAddons);
      this.selectedServices = newServices;
    }
  },
  mounted: function mounted() {
    if (this.$store.state.plans.all.length === 0) this.$store.dispatch('getAllPlans');
    if (this.$store.state.products.categories.length === 0) this.$store.dispatch('getProductsCategories');
    if (this.$store.state.products.all.length === 0) this.$store.dispatch('getAllProducts');
    if (this.$store.state.products.caskets.length === 0) this.$store.dispatch('getAllProducts');
    this.updateCase();
  }
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      last_quotation_no: 1,
      last_invoice_no: 1,
      snackbar: false
    };
  },

  methods: {
    save: function save() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var apiUrl, data, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                apiUrl = _this.$store.getters.config.api_host;
                data = {
                  id: 1,
                  last_quotation_no: _this.last_quotation_no,
                  last_invoice_no: _this.last_invoice_no
                };
                _context.next = 4;
                return _this.$axios.post(apiUrl + "/api/settings", data);

              case 4:
                response = _context.sent;

                if (response) {
                  _this.snackbar = true;
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  created: function created() {
    var _this2 = this;

    var apiUrl = this.$store.getters.config.api_host;
    this.$axios.get(apiUrl + "/api/settings").then(function (response) {
      _this2.last_invoice_no = response.data.additional_data[0].last_invoice_no;
      _this2.last_quotation_no = response.data.additional_data[0].last_quotation_no;
    });
  }
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      menuDateStart: false,
      date: this.moment().format('YYYY-MM-DD'),
      days: '7 days',
      lunarStartDate: null,
      lunarFinalDate: null,
      resultsLoaded: false
    };
  },

  watch: {
    date: function date(newValue) {
      this.resultsLoaded = false;
    }
  },
  methods: {
    calc: function calc() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var apiUrl, data, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                apiUrl = _this.$store.getters.config.api_host;
                data = {
                  date: _this.date,
                  days: _this.days
                };
                _context.next = 4;
                return _this.$axios.post(apiUrl + '/api/test_lunar', data);

              case 4:
                response = _context.sent;

                if (response) {
                  _this.resultsLoaded = true;
                  _this.lunarStartDate = response.data.additional_data[0].lunarYear + '-' + response.data.additional_data[0].lunarMonth + '-' + response.data.additional_data[0].lunarDay;
                  _this.lunarFinalDate = response.data.additional_data[1][0] + '-' + response.data.additional_data[1][1] + '-' + response.data.additional_data[1][2];
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_user__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_services__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ItemCheckList__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ItemCheckList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ItemCheckList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_ItemTypes__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ItemCheckList: __WEBPACK_IMPORTED_MODULE_2__components_ItemCheckList___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_ItemTypes__["a" /* default */]],
  data: function data() {
    return {
      newServiceDescription: null,
      servicesList: [],
      userData: null,
      selectedService: null
    };
  },

  watch: {
    userId: function userId() {
      this.servicesList = [];
      this.selectedService = null;
      this.newServiceDescription = null;
      this.userData = null;

      this.loadData();
    }
  },
  methods: {
    loadData: function loadData() {
      this.loadUser();
      this.loadServices();
    },
    loadUser: function loadUser() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__api_user__["a" /* default */].loadUser(this.userId).then(function (result) {
        _this.userData = result;
      }, function () {});
    },
    loadServices: function loadServices() {
      var _this2 = this;

      if (this.loadAllServices) {
        __WEBPACK_IMPORTED_MODULE_1__api_resources_services__["a" /* default */].loadServices().then(function (result) {
          _this2.servicesList = result;
        }, function () {});
      } else {
        __WEBPACK_IMPORTED_MODULE_0__api_user__["a" /* default */].getLinkedServices(this.userId).then(function (result) {
          _this2.servicesList = result;
        }, function () {});
      }
    },
    deleteService: function deleteService(serviceId) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__api_resources_services__["a" /* default */].delete(serviceId).then(function (result) {
        _this3.servicesList = _this3.servicesList.filter(function (item) {
          return item.id !== serviceId;
        });
      }, function () {});
    },
    editService: function editService(serviceId, description, price, name) {
      __WEBPACK_IMPORTED_MODULE_1__api_resources_services__["a" /* default */].edit(serviceId, description, price, name).then(function () {}, function () {});
    },
    saveService: function saveService() {
      var _this4 = this;

      var payload = {
        description: this.newServiceDescription,
        is_available: true,
        name: this.userData.name,
        is_vendor: this.isVendor,
        users_id: this.userId,
        amount: 1
      };

      __WEBPACK_IMPORTED_MODULE_1__api_resources_services__["a" /* default */].add(payload).then(function () {
        _this4.loadServices();
      }, function () {});
    }
  },
  mounted: function mounted() {
    this.loadData();
  },

  props: {
    userId: {
      type: Number,
      required: true
    },
    isVendor: {
      type: Boolean,
      required: false,
      default: false
    },
    loadAllServices: {
      type: Boolean,
      required: false,
      default: false
    }
  }
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_invoice__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_user__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppMainDialog__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppMainDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AppMainDialog__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import CrudAPI from '@/api/resources/crud'




// const DFS_INVENTORY = 1
// const DFS_SERVICE = 2

/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppMainDialog: __WEBPACK_IMPORTED_MODULE_2__components_AppMainDialog___default.a },
  data: function data() {
    return {
      vendorsList: [],
      vendorsInventories: [],
      vendorsServices: [],
      selectedVendor: null,
      invoiceFile: null,
      dialogMessage: '',
      dialogOpen: false
    };
  },

  props: {
    id: {
      required: true
    }
  },
  computed: {
    isManagement: function isManagement() {
      return this.$store.getters.currentUserRoles.some(function (item) {
        return ['case-manager', 'management'].includes(item);
      });
    }
  },
  methods: {
    uploadInvoice: function uploadInvoice() {
      var _this = this;

      // let vendorType = this.selectedVendor.split('|')

      var formData = new FormData();

      // this.selectedVendor = vendorType[0]

      formData.append('invoice_file', this.invoiceFile);
      formData.append('vendor_id', this.selectedVendor);
      formData.append('vendor_type', 2); // 1 is inventory; 2 is service
      // formData.append('vendor_type', vendorType[1]) // 1 is inventory; 2 is service

      var upload = __WEBPACK_IMPORTED_MODULE_0__api_invoice__["a" /* default */].uploadInvoice(formData, this.id);

      upload.then(function (result) {
        _this.$bus.$emit('invoice:uploaded');

        _this.dialogMessage = 'Invoice successfully uploaded';

        _this.dialogOpen = true;
      }, function (error) {
        _this.dialogMessage = 'Error happened, try again';

        _this.dialogOpen = true;

        var handle = error; // eslint-disable-line
      });
    },
    onInvoiceFileChange: function onInvoiceFileChange(event) {
      this.invoiceFile = event.target.files[0];
    }
  },
  created: function created() {
    var _this2 = this;

    if (this.isManagement) {
      __WEBPACK_IMPORTED_MODULE_1__api_user__["a" /* default */].loadVendors().then(function (result) {
        _this2.vendorsList = result;
      }, function () {});
    }

    this.selectedVendor = this.$store.getters.currentUser.id;
    // let vendorsInventories = CrudAPI.dfsResourceIndex('inventories/vendors')
    // let vendorsServices = CrudAPI.dfsResourceIndex('services/vendors')
    //
    // vendorsInventories.then(result => {
    //   result.forEach((item, i) => {
    //     item.text = item.name + '[INVENTORY]'
    //     item.value = item.id + '|' + DFS_INVENTORY
    //   })
    //
    //   this.vendorsInventories = result
    //
    //   this.vendorsList = this.vendorsList.concat(this.vendorsInventories)
    // }, error => {
    //   let handle = error // eslint-disable-line
    // })
    //
    // vendorsServices.then(result => {
    //   result.forEach((item, i) => {
    //     item.text = item.name + '[SERVICE]'
    //     item.value = item.id + '|' + DFS_SERVICE
    //   })
    //
    //   this.vendorsServices = result
    //
    //   this.vendorsList = this.vendorsList.concat(this.vendorsServices)
    // }, error => {
    //   let handle = error // eslint-disable-line
    // })
  }
});

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_schedules__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_AddCaseNameAndDateDialog__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_AddCaseNameAndDateDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_dialogs_AddCaseNameAndDateDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_IsMobile__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_buttons_AddScheduledCaseButton__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_buttons_AddScheduledCaseButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_buttons_AddScheduledCaseButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AddScheduledCaseButton: __WEBPACK_IMPORTED_MODULE_4__components_buttons_AddScheduledCaseButton___default.a, AddCaseNameAndDateDialog: __WEBPACK_IMPORTED_MODULE_2__components_dialogs_AddCaseNameAndDateDialog___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_IsMobile__["a" /* default */]],
  data: function data() {
    return {
      todoCasesTableHeaders: [{ text: 'Case ID', value: 'id' }, { text: 'Case Name', value: 'name' }, { text: 'Wake Start Date', value: 'wake_start' }, { text: 'Wake End Date', value: 'wake_end' }],
      displayPeriodList: [{ text: 'Week', value: 'week' }, { text: 'Month', value: 'month' }],
      displayPeriod: 'week',
      periodCount: 1,
      todoCases: [],
      showDate: this.moment().format('YYYY-MM-DD'),
      calendarValue: this.moment().format('YYYY-MM-DD'),
      events: [],
      eventsRaw: [],
      eventsData: []
    };
  },

  computed: {
    isCaseManager: function isCaseManager() {
      return this.$store.getters.currentUserRoles.includes('case-manager');
    },
    isDispatcher: function isDispatcher() {
      return this.$store.getters.currentUserRoles.includes('dispatcher');
    },
    eventsMap: function eventsMap() {
      var map = {};
      this.events.forEach(function (e) {
        return (map[e.date] = map[e.date] || []).push(e);
      });
      return map;
    }
  },
  provide: function provide() {
    return {
      onClickDate: this.onClickDate
    };
  },
  methods: {
    isCaseManagerEqual: function isCaseManagerEqual(event) {
      return event.case_manager === this.$store.getters.currentUser.id;
    },
    loadSchedules: function loadSchedules() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__api_resources_schedules__["a" /* default */].loadSchedules().then(function (result) {
        console.log('result', result);
        _this.eventsRaw = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result));
        _this.events = _this.normalizeForScheduleComponent(result);
      }, function () {});
    },
    onClickEvent: function onClickEvent(event) {
      if (this.$can('use', 'appointment-schedule-click-event')) {
        if (this.forCaseManager) {
          this.$router.push({ name: 'OnboardClient', params: { caseid: event.cases_id } });
        } else {
          this.$router.push({ name: 'NewLeads', params: { caseId: event.cases_id, editable: true } });
        }
      }
    },
    onClickDate: function onClickDate(date) {
      if (this.$can('use', 'appointment-schedule-create-new-case')) {
        this.dateForNewLead = this.moment(date).subtract(1, 'month').format('YYYY-MM-DD');
      }
    },
    onMove: function onMove(data) {
      this.calendarValue = data.date;
    },
    onDrop: function onDrop(event, date) {
      var eLength = this.dayDiff(event.startDate, date);

      event.originalEvent.startDate = this.addDays(event.startDate, eLength);
      event.originalEvent.endDate = this.addDays(event.endDate, eLength);

      var dateStartObject = new Date(event.originalEvent.startDate);
      var dateEndObject = new Date(event.originalEvent.endDate);

      var dateStartFormatted = this.isoYearMonthDay(dateStartObject) + ' ' + this.formattedTime(dateStartObject, 'us-US');
      var dateEndFormatted = this.isoYearMonthDay(dateEndObject) + ' ' + this.formattedTime(dateEndObject, 'us-US');

      if (event.originalEvent.leads_id) {
        __WEBPACK_IMPORTED_MODULE_1__api_resources_schedules__["a" /* default */].updateLeadWithDates(event.originalEvent.leads_id, dateStartFormatted, dateEndFormatted).then(function () {}, function () {});
      } else {
        __WEBPACK_IMPORTED_MODULE_1__api_resources_schedules__["a" /* default */].updateScheduleWithDates(event.originalEvent.id, event.originalEvent.service.id, dateStartFormatted, dateEndFormatted).then(function () {}, function () {});
      }
    },
    selectEventColor: function selectEventColor(caseStatus) {
      switch (caseStatus) {
        case 'pending':
          return 'light-blue lighten-4';
        case 'filled':
          return 'light-green lighten-4';
        case 'closed':
          return 'purple accent-1';
        default:
          return 'light-blue lighten-4';
      }
    },

    normalizeForScheduleComponent: function normalizeForScheduleComponent(data) {
      var _this2 = this;

      var localData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));

      localData.forEach(function (item, i) {
        var caseDataLabel = item.case && '\n\nCase #: ' + item.case.id + '\nCase Name: ' + item.case.name;

        item.date = _this2.moment(item.schedule_start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
        item.time = _this2.moment(item.schedule_start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');
        item.endDate = _this2.moment(item.schedule_end, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
        item.endDateTime = _this2.moment(item.schedule_end, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');

        item.duration = _this2.moment.duration(_this2.moment(item.schedule_end, 'YYYY-MM-DD hh:mm:ss').diff(_this2.moment(item.schedule_start, 'YYYY-MM-DD hh:mm:ss'))).asMinutes() || 60;

        item.open = false;

        item.title = 'Staff: \n';

        item.classes = item.case && _this2.selectEventColor(item.case.status);

        item.case_manager = null;
        if (item.leads_id) {
          var filtered = _this2.eventsRaw.filter(function (filtering) {
            return filtering.leads_id === item.leads_id;
          });

          item.title += filtered.map(function (mapping) {
            return mapping.service !== null ? mapping.service.description + ' ' + mapping.service.name : '';
          }) + '; ' + caseDataLabel;

          var managerService = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(filtered, ['service.description', 'Case Manager']);
          if (managerService && managerService.service.users_id) {
            item.case_manager = managerService.service.users_id;
          }

          var itemsWithSameLead = localData.filter(function (filtering) {
            return filtering.leads_id === item.leads_id && filtering.item_id !== item.item_id;
          }).map(function (mapping) {
            return mapping.item_id;
          });

          if (itemsWithSameLead.length > 0) {
            itemsWithSameLead.forEach(function (sameItem) {
              var index = localData.findIndex(function (finding) {
                return finding.item_id === sameItem && finding.leads_id === item.leads_id;
              });

              localData.splice(index, 1);
            });
          }
        } else {
          item.title += item.service.description + ' ' + item.service.name + ';' + caseDataLabel;
        }
      });

      return localData;
    },
    setShowDate: function setShowDate(date) {
      this.showDate = date;
    },
    loadCases: function loadCases() {
      var _this3 = this;

      // console.log('showDate', this.showDate)
      // console.log('calendarValue', this.calendarValue)
      // console.log('displayPeriod', this.displayPeriod)
      var apiUrl = this.$store.getters.config.api_host;
      this.$axios.get(apiUrl + '/api/cases/all').then(function (response) {
        _this3.events = _this3.prepareDataForCalendar(response.data.additional_data);
        _this3.eventsData = _this3.prepareDataForCalendar(response.data.additional_data);
        console.log('response', response);
        console.log('events', _this3.eventsData);
        // TODO: сделать разбивку на дни, т.е. если кейс идет с 3 по 6, то он должен забиваться в 3, 4, 5 и 6
      });
    },
    prepareDataForCalendar: function prepareDataForCalendar(data) {
      var _this4 = this;

      return data.flatMap(function (i) {
        var start = _this4.moment(i.wake_start, 'YYYY-MM-DD HH:mm:ss');
        var end = _this4.moment(i.wake_end, 'YYYY-MM-DD HH:mm:ss');
        var width = end.diff(start, 'hours') / 24 * 100;
        // If you want an inclusive end date (fully-closed interval)
        var days = [];
        if (isNaN(end.diff(start, 'days'))) {
          var dayData = {
            id: i.id,
            name: 'Case #' + i.id + '\u2013' + i.wake_start + ' till ' + i.wake_end,
            title: 'Case #' + i.id + '<br>Start: ' + i.wake_start + '<br>End: ' + i.wake_end,
            date: start.format('YYYY-MM-DD'),
            time: _this4.moment(i.wake_start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm'),
            start_date: _this4.moment(i.wake_start, 'YYYY-MM-DD HH:mm:ss'),
            end_date: _this4.moment(i.end_date, 'YYYY-MM-DD HH:mm:ss'),
            width: width,
            color: 'blue'
          };
          days.push(dayData);
        } else {
          var k = 1;
          for (var day = _this4.moment(start); day.isBefore(end); day.add(1, 'days')) {
            var _dayData = {
              id: i.id,
              name: 'Case #' + i.id + '\u2013' + i.wake_start + ' till ' + i.wake_end,
              title: k === 1 ? 'Case #' + i.id + ' <b>' + i.wake_start + '</b>&nbsp;&mdash;&nbsp;<b>' + i.wake_end + '</b>' : '',
              date: day.format('YYYY-MM-DD'),
              time: _this4.moment(i.wake_start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm'),
              start_date: _this4.moment(i.wake_start, 'YYYY-MM-DD HH:mm:ss'),
              end_date: _this4.moment(i.end_date, 'YYYY-MM-DD HH:mm:ss'),
              width: width,
              color: 'blue',
              firstEvent: k === 1,
              lastEvent: day.format('YYYY-MM-DD') === _this4.moment(i.wake_end, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
              midEvent: k !== 1 && day.format('YYYY-MM-DD') !== _this4.moment(i.wake_end, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
            };
            days.push(_dayData);
            k++;
          }
        }
        return days;
        /*
        return i.wake_start && i.wake_end ? {
          id: i.id,
          name: `Case #${i.id}–${i.wake_start} till ${i.wake_end}`,
          title: `Case #${i.id}<br>Start: ${i.wake_start}<br>End: ${i.wake_end}`,
          date: this.moment(i.wake_start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
          time: this.moment(i.wake_start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm'),
          start_date: this.moment(i.wake_start, 'YYYY-MM-DD HH:mm:ss'),
          end_date: this.moment(i.end_date, 'YYYY-MM-DD HH:mm:ss'),
          width: width,
          color: 'blue'
        } : null
        */
      }).filter(function (i) {
        return i;
      });
    }
  },
  created: function created() {
    this.loadCases();
  },
  mounted: function mounted() {
    if (this.DetectMobile()) {
      this.displayPeriod = 'day';
      this.$refs.calendar.scrollToTime('08:00');
    }
    this.isCaseManager ? this.displayPeriod = '4day' : null;
    this.isDispatcher ? this.displayPeriod = 'day' : null;
  },

  props: {
    forCaseManager: {
      type: Boolean,
      default: false,
      required: false
    }
  }
});

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_resources_schedules__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_AddScheduledCaseButton__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_AddScheduledCaseButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_buttons_AddScheduledCaseButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_dialogs_AddCaseNameAndDateDialog__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_dialogs_AddCaseNameAndDateDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_dialogs_AddCaseNameAndDateDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import resourcesMixins from '@/mixins/Resources'








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Cases',
  components: { AddScheduledCaseButton: __WEBPACK_IMPORTED_MODULE_6__components_buttons_AddScheduledCaseButton___default.a, AddCaseNameAndDateDialog: __WEBPACK_IMPORTED_MODULE_7__components_dialogs_AddCaseNameAndDateDialog___default.a },
  // mixins: [ resourcesMixins ],
  data: function data() {
    return {
      resources: 'cases',
      items: [],
      vendorItemsPromise: null,
      tableHeaders: [{ text: '', value: 'time' }, { text: 'Start Time', value: 'start_time' }, { text: 'End Time', value: 'end_time' }, { text: 'Type', value: 'type' }, { text: 'Case manager', value: 'users_id' }, { text: 'Crew', value: 'crew' }, { text: 'Case ID', value: 'id' }],
      caseID: 0,
      currentUserServiceId: 0,
      clientName: '',
      dialogOpen: false,
      dialogMessage: '',
      vendorInventories: [],
      disabled: {
        sendQuotationMailToClientBtn: false
      },
      vendorServices: [],
      rowsPerPageItems: [-1],
      pagination: {
        descending: true,
        rowsPerPage: -1,
        sortBy: 'created_at'
      },
      date: this.moment().format('YYYY-MM-DD'),
      menu: false,
      dateForNewLead: this.moment().format('YYYY-MM-DD'),
      dialogModel: false,
      services: []
    };
  },

  watch: {
    date: function date() {
      this.loadCases();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapGetters */])({
    servicesList: 'allServices'
  })),
  provide: function provide() {
    return {
      onClickDate: this.onClickDate
    };
  },
  methods: {
    formatTime: function formatTime(date) {
      return date ? this.moment(date, 'YYYY-MM-DD HH:mm:ss').format('HH:mm') : '-';
    },
    getCaseType: function getCaseType(item) {
      switch (item.status) {
        case 'pending':
          return 'Pickup';
        case 'approved':
          return 'Setup';
        case 'filled':
          return 'Wake';
        default:
          return 'Wake';
      }
    },
    getCaseCrew: function getCaseCrew(item) {
      var closing = 1;
      if (item.status === 'pending' || item.status === 'approved') closing = 0;
      return this.services.filter(function (i) {
        return i.cases_id === item.id && i.is_closing === closing;
      }).map(function (i) {
        return i.service.name;
      }).join(', ');
    },
    loadServices: function loadServices() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var services, apiUrl, i, response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                services = [];
                apiUrl = _this.$store.getters.config.api_host;
                i = 0;

              case 3:
                if (!(i < _this.items.length)) {
                  _context.next = 12;
                  break;
                }

                if (!_this.items[i].id) {
                  _context.next = 9;
                  break;
                }

                _context.next = 7;
                return _this.$axios.get(apiUrl + '/api/cases/' + _this.items[i].id + '/lead');

              case 7:
                response = _context.sent;

                if (response) {
                  response.data.additional_data.filter(function (filtering) {
                    return filtering.service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') !== 'casemanager';
                  }).map(function (i) {
                    return services.push(i);
                  });
                }

              case 9:
                i++;
                _context.next = 3;
                break;

              case 12:
                _this.services = services;

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    loadCases: function loadCases() {
      var _this2 = this;

      var apiUrl = this.$store.getters.config.api_host;
      this.$axios.get(apiUrl + '/api/cases/all?date=' + this.date).then(function (response) {
        var data = _this2.prepareData(response.data.additional_data);
        _this2.items = _this2.formTable(data);
        _this2.loadServices();
      });
    },
    getTimelinePosition: function getTimelinePosition(time) {
      var diff = this.moment().diff(time, 'minutes');
      if (diff >= 0 && diff < 60) return 'current';
      if (diff < 0) return 'future';
      if (diff > 60) return 'past';
    },
    prepareData: function prepareData(data) {
      var _this3 = this;

      return data.map(function (i) {
        var timeline = _this3.getTimelinePosition(_this3.moment(i.wake_start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm'));
        return i.wake_start && i.wake_end ? {
          time: '',
          timeline: timeline,
          id: i.id,
          date: _this3.moment(i.wake_start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
          start_time: _this3.moment(i.wake_start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm'),
          end_time: _this3.moment(i.wake_end, 'YYYY-MM-DD HH:mm:ss').format('HH:mm'),
          type: _this3.getCaseType(i),
          case_manager: i.manager_name,
          services: i.services
        } : null;
      }).filter(function (i) {
        return i && _this3.moment(i.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') === _this3.date;
      });
    },
    formTable: function formTable(data) {
      var times = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Array(24).keys()));
      var newData = [];
      for (var k = 0; k < times.length; k++) {
        var time = times[k];
        var nextTime = time < 9 ? '0' + (time + 1) + '00' : time < 23 ? time + 1 + '00' : '0';
        var currentTime = time < 10 ? '0' + time + '00' : time + '00';
        var timeItems = [];
        for (var i = 0; i < data.length; i++) {
          var itemTime = data[i].start_time.replace(':', '');
          if (itemTime < nextTime && itemTime >= currentTime) timeItems.push(data[i]);
        }
        if (timeItems.length === 0) {
          var timeline = this.getTimelinePosition(this.date + ' ' + currentTime.slice(0, -2) + ':00');
          timeItems.push({
            time: currentTime.slice(0, -2) + ':00',
            timeline: timeline,
            id: null,
            date: null,
            start_time: null,
            end_time: null,
            type: null,
            case_manager: null,
            services: null
          });
        } else {
          timeItems.sort(function (a, b) {
            var timeA = parseInt(a.start_time.replace(':', ''));
            var timeB = parseInt(b.start_time.replace(':', ''));
            var comparison = 0;
            if (timeA > timeB) {
              comparison = 1;
            } else if (timeA < timeB) {
              comparison = -1;
            }
            return comparison;
          });
          timeItems[0].time = currentTime.slice(0, -2) + ':00';
        }
        newData[k] = timeItems;
      }
      return newData.flat();
    },
    loadSchedules: function loadSchedules() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_5__api_resources_schedules__["a" /* default */].loadSchedules().then(function (result) {
        _this4.eventsRaw = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result));
        _this4.events = _this4.normalizeForScheduleComponent(result);
      }, function () {});
    },
    onClickDate: function onClickDate(date) {
      if (this.$can('use', 'appointment-schedule-create-new-case')) {
        this.dateForNewLead = this.moment(date).subtract(1, 'month').format('YYYY-MM-DD');
        this.dialogModel = true;
      }
    },

    normalizeForScheduleComponent: function normalizeForScheduleComponent(data) {
      var _this5 = this;

      var localData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      localData.forEach(function (item, i) {
        var caseDataLabel = item.case && '\n\nCase #: ' + item.case.id + '\nCase Name: ' + item.case.name;

        item.date = _this5.moment(item.schedule_start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
        item.time = _this5.moment(item.schedule_start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');
        item.endDate = _this5.moment(item.schedule_end, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
        item.endDateTime = _this5.moment(item.schedule_end, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');

        item.duration = _this5.moment.duration(_this5.moment(item.schedule_end, 'YYYY-MM-DD hh:mm:ss').diff(_this5.moment(item.schedule_start, 'YYYY-MM-DD hh:mm:ss'))).asMinutes() || 60;

        item.open = false;

        item.title = 'Staff: \n';

        item.classes = item.case && _this5.selectEventColor(item.case.status);

        item.case_manager = null;
        if (item.leads_id) {
          var filtered = _this5.eventsRaw.filter(function (filtering) {
            return filtering.leads_id === item.leads_id;
          });

          item.title += filtered.map(function (mapping) {
            return mapping.service !== null ? mapping.service.description + ' ' + mapping.service.name : '';
          }) + '; ' + caseDataLabel;

          var managerService = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.find(filtered, ['service.description', 'Case Manager']);
          if (managerService && managerService.service.users_id) {
            item.case_manager = managerService.service.users_id;
          }

          var itemsWithSameLead = localData.filter(function (filtering) {
            return filtering.leads_id === item.leads_id && filtering.item_id !== item.item_id;
          }).map(function (mapping) {
            return mapping.item_id;
          });

          if (itemsWithSameLead.length > 0) {
            itemsWithSameLead.forEach(function (sameItem) {
              var index = localData.findIndex(function (finding) {
                return finding.item_id === sameItem && finding.leads_id === item.leads_id;
              });

              localData.splice(index, 1);
            });
          }
        } else {
          item.title += item.service.description + ' ' + item.service.name + ';' + caseDataLabel;
        }
      });

      return localData;
    }
  },
  mounted: function mounted() {
    // this.loadListing()
    this.loadCases();
  },

  props: {
    detailCaseButtonActionIsDefault: {
      type: Boolean,
      default: false,
      required: false
    },
    detailCaseButtonActionIsGoToCheckListsTab: {
      type: Boolean,
      default: false,
      required: false
    },
    detailCaseButtonActionIsGoToInvoicesTab: {
      type: Boolean,
      default: false,
      required: false
    },
    crewSelecting: {
      type: Boolean,
      default: false,
      required: false
    }
  }
});

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppAddBookingButton__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppAddBookingButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AppAddBookingButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_ItemTypes__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppAddBookingButton: __WEBPACK_IMPORTED_MODULE_0__components_AppAddBookingButton___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_ItemTypes__["a" /* default */]]
});

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppMainDialog__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppMainDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AppMainDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VendorsInvoice__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VendorsInvoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_VendorsInvoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_AddButton__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ClientAddForm__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ClientAddForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ClientAddForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_resources_crud__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppMainDialog: __WEBPACK_IMPORTED_MODULE_0__components_AppMainDialog___default.a, dfsClientAddForm: __WEBPACK_IMPORTED_MODULE_3__components_ClientAddForm___default.a, VendorsInvoice: __WEBPACK_IMPORTED_MODULE_1__components_VendorsInvoice___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_AddButton__["a" /* default */]],
  props: {
    casesid: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      resources: 'clients',
      dialog: false,
      dialogMessage: '',
      dialogOpen: false,
      modelName: ''
    };
  },

  methods: {
    saveNew: function saveNew() {
      var payload = {
        name: this.modelName
      };

      var result = __WEBPACK_IMPORTED_MODULE_4__api_resources_crud__["a" /* default */].dfsResourceStore(this.resources, payload);

      result.then(this.saveNewSuccess, this.saveNewError);
    },
    onNameChanged: function onNameChanged(newVal) {
      this.modelName = newVal;
    }
  }
});

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppMainDialog__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppMainDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AppMainDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_AddButton__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ClientAddForm__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ClientAddForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ClientAddForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_resources_crud__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppMainDialog: __WEBPACK_IMPORTED_MODULE_0__components_AppMainDialog___default.a, dfsClientAddForm: __WEBPACK_IMPORTED_MODULE_2__components_ClientAddForm___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_AddButton__["a" /* default */]],
  data: function data() {
    return {
      resources: 'clients',
      dialog: false,
      dialogMessage: '',
      dialogOpen: false,
      modelName: ''
    };
  },

  methods: {
    saveNew: function saveNew() {
      var payload = {
        name: this.modelName
      };

      var result = __WEBPACK_IMPORTED_MODULE_3__api_resources_crud__["a" /* default */].dfsResourceStore(this.resources, payload);

      result.then(this.saveNewSuccess, this.saveNewError);
    },
    onNameChanged: function onNameChanged(newVal) {
      this.modelName = newVal;
    }
  }
});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppAddItemButtonBase__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppAddItemButtonBase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AppAddItemButtonBase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_ItemTypes__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppAddItemButtonBase: __WEBPACK_IMPORTED_MODULE_0__components_AppAddItemButtonBase___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_ItemTypes__["a" /* default */]],
  data: function data() {
    return {
      resources: 'inventories'
    };
  },

  computed: {
    itemType: function itemType() {
      return this.inventoryTypeID;
    }
  }
});

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppMainDialog__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppMainDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AppMainDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_AddButton__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_resources_crud__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_resources_forms__ = __webpack_require__(137);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppMainDialog: __WEBPACK_IMPORTED_MODULE_0__components_AppMainDialog___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_AddButton__["a" /* default */]],
  data: function data() {
    return {
      resources: 'templates',
      dialog: false,
      dialogMessage: '',
      dialogOpen: false,
      formsID: 0,
      templateBody: '',
      formsList: [],
      selectedForm: 0
    };
  },

  methods: {
    saveNew: function saveNew() {
      var payload = {
        forms_id: this.selectedForm,
        body: this.templateBody
      };

      var result = __WEBPACK_IMPORTED_MODULE_2__api_resources_crud__["a" /* default */].dfsResourceStore(this.resources, payload);

      result.then(this.saveNewSuccess, this.saveNewError);
    }
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__api_resources_forms__["a" /* default */].loadForms().then(function (result) {
      _this.formsList = result;
    });
  }
});

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppMainDialog__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppMainDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AppMainDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_AddButton__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppMainDialog: __WEBPACK_IMPORTED_MODULE_2__components_AppMainDialog___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_AddButton__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
    products: 'allProducts',
    serviceById: 'getProductById',
    plans: 'allPlans',
    allCaskets: 'allCaskets',
    casketById: 'getCasketById',
    filterFromLinkedServices: 'filterFromLinkedServices',
    filterCasketFromLinkedProducts: 'filterCasketFromLinkedProducts',
    removeCasketsFromServices: 'removeCasketsFromServices'
  }), {
    totalPrice: function totalPrice() {
      if (!this.planPrice && !this.selectedCasket && !this.selectedProducts) return false;
      /*
      return parseFloat(this.planPrice) +
        (this.casketById(this.selectedCasket) ? parseFloat(this.casketById(this.selectedCasket).price) : 0) +
        (this.selectedProducts ? _.reduce(this.selectedProducts, (sum, p) => {
          return sum + parseFloat(p.price) * p.amount
        }, 0) : 0)
      */
      return this.selectedProducts ? __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.reduce(this.selectedProducts, function (sum, p) {
        return sum + parseFloat(p.price) * p.amount;
      }, 0) : 0;
    }
  }),
  watch: {
    dialog: function dialog(val) {
      this.emptyForm();
    }
  },
  data: function data() {
    return {
      resources: 'plans',
      dialog: false,
      modelName: '',
      planPrice: 0,
      selectedProducts: [],
      productsTableHeaders: [{ text: 'Name', value: 'name' }, { text: 'Qty', value: 'amount', width: '5px' }, { text: 'Unit', value: 'price' }, { text: 'Subtotal', value: 'price' }],
      selectedCasket: null,
      dialogMessage: '',
      dialogOpen: false,
      showAlert: false,
      alertMessage: null
    };
  },

  methods: {
    saveNew: function saveNew() {
      var _this = this;

      if (!this.checkQuantity()) {
        this.alertMessage = 'Please set quantity';
        this.showAlert = true;
        setTimeout(function () {
          _this.showAlert = false;
        }, 2000);
        return;
      }
      this.selectedCasket ? this.selectedProducts.push(this.casketById(this.selectedCasket)) : null;
      var payload = {
        name: this.modelName,
        price: this.planPrice,
        services: this.selectedProducts
      };

      var result = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceStore(this.resources, payload);

      this.selectedProducts = this.removeCasketsFromServices(this.selectedProducts);

      result.then(this.saveNewSuccess, this.saveNewError);
      this.$store.dispatch('getAllPlans');
      // location.reload()
    },
    checkQuantity: function checkQuantity() {
      var check = true;
      this.selectedProducts.forEach(function (item) {
        if (!item.amount) check = false;
      });
      return check;
    },
    emptyForm: function emptyForm() {
      this.modelName = '';
      this.planPrice = 0;
      this.selectedProducts = [];
      this.selectedCasket = null;
    }
  },
  beforeCreate: function beforeCreate() {
    this.$store.dispatch('getAllPlans');
    this.$store.dispatch('getAllProducts');
  }
});

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppMainDialog__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppMainDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AppMainDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_AddButton__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_user__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_resources_services__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppMainDialog: __WEBPACK_IMPORTED_MODULE_2__components_AppMainDialog___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_AddButton__["a" /* default */]],
  data: function data() {
    return {
      resources: 'products',
      setParentId: false,
      loading: {
        uploadCsvBtn: null,
        categories: false
      },
      disabled: {
        uploadCsvBtn: null,
        saveBtn: false
      },
      labels: {
        uploadCsvBtn: 'Or upload CSV'
      },
      dialog: false,
      dialogMessage: '',
      usersList: [],
      name: null,
      amount: null,
      price: null,
      commission: null,
      selectedUser: null,
      selectedCategory: null,
      selectedParentCategory: null,
      dialogOpen: false,
      categorySearch: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])({
    categoriesList: 'productsCategories',
    categoryById: 'getProductCategoryById'
  }), {
    excludeSelectedCategory: function excludeSelectedCategory() {
      var _this = this;

      if (this.selectedCategory === null) return this.categoriesList;
      return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.filter(this.categoriesList, function (c) {
        return c.id !== _this.selectedCategory.id;
      });
    }
  }),
  watch: {
    selectedCategory: function selectedCategory(c) {
      if (c.parent_id === null) {
        this.setParentId = false;
        this.selectedParentCategory = null;
        return;
      }
      this.setParentId = true;
      this.selectedParentCategory = this.categoryById(parseInt(this.selectedCategory.parent_id));
    },
    selectedParentCategory: function selectedParentCategory(p) {
      if (this.selectedCategory === null || p === null) return;
      this.editCategory();
    },
    setParentId: function setParentId(v) {
      if (v === false && this.selectedCategory !== null && this.selectedParentCategory !== null) {
        this.selectedParentCategory = null;
        this.editCategory();
      }
    }
  },
  methods: {
    addCategory: function addCategory() {
      var _this2 = this;

      this.loading.categories = true;
      this.$store.dispatch('createProductCategory', this.categorySearch).then(function () {
        _this2.$store.dispatch('getProductsCategories');
        _this2.loading.categories = false;
      });
    },
    editCategory: function editCategory() {
      var _this3 = this;

      this.loading.categories = true;
      this.$store.dispatch('editProductCategory', { id: this.selectedCategory.id,
        parent_id: this.selectedParentCategory !== null ? this.selectedParentCategory.id : null
      }).then(function () {
        _this3.$store.dispatch('getProductsCategories');
        _this3.loading.categories = false;
      }, function () {
        _this3.$store.dispatch('getProductsCategories');
        _this3.loading.categories = false;
      });
    },
    uploadCsv: function uploadCsv(event) {
      var _this4 = this;

      this.loading.uploadCsvBtn = true;
      this.disabled.uploadCsvBtn = true;
      this.disabled.saveBtn = true;

      var formData = new FormData();

      formData.append('csv_file', event.target.files[0]);

      __WEBPACK_IMPORTED_MODULE_5__api_resources_services__["a" /* default */].uploadProductsWithCsv(formData).then(function () {
        _this4.loading.uploadCsvBtn = false;
        _this4.disabled.uploadCsvBtn = false;
        _this4.disabled.saveBtn = false;
        _this4.labels.uploadCsvBtn = 'Uploaded!';

        _this4.$bus.$emit('resource-added');
      }, function () {});
    },
    saveNew: function saveNew() {
      var _this5 = this;

      this.disabled.saveBtn = true;
      // TODO move to backend
      var payload = {
        name: this.name,
        is_available: true,
        is_product: true,
        price: this.price,
        commission: this.commission,
        amount: this.amount,
        users_id: this.selectedUser,
        is_vendor: false,
        categories_id: this.selectedCategory.id
      };

      var result = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceStore(this.resources, payload);

      result.then(function () {
        _this5.disabled.saveBtn = false;
      }).then(this.saveNewSuccess, this.saveNewError);
    },
    onClickUploadCsvBtn: function onClickUploadCsvBtn() {
      this.$refs.csvUploadInput.click();
    },
    emptyForm: function emptyForm() {
      this.setParentId = false;
      this.name = null;
      this.amount = null;
      this.price = null;
      this.commission = null;
      this.selectedUser = null;
      this.selectedCategory = null;
      this.selectedParentCategory = null;
      this.categorySearch = null;
    }
  },
  // TODO move to mixins along with EditProducts
  filters: {
    normalizeRoles: function normalizeRoles(items) {
      return items && items.length > 0 ? items.map(function (mapping) {
        return mapping.name;
      }).join() : '';
    }
  },
  created: function created() {
    var _this6 = this;

    if (this.$store.state.products.categories.length === 0) this.$store.dispatch('getProductsCategories');
    __WEBPACK_IMPORTED_MODULE_4__api_user__["a" /* default */].loadUsers().then(function (result) {
      _this6.usersList = result;
    }, function () {});
  },
  mounted: function mounted() {
    this.emptyForm();
  }
});

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_resources_crud__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppMainDialog__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppMainDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_AppMainDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_AddButton__ = __webpack_require__(37);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppMainDialog: __WEBPACK_IMPORTED_MODULE_1__components_AppMainDialog___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_AddButton__["a" /* default */]],
  data: function data() {
    return {
      resources: 'roles',
      dialog: false,
      modelName: '',
      guardName: 'web',
      dialogMessage: '',
      dialogOpen: false
    };
  },

  methods: {
    saveNew: function saveNew() {
      var payload = {
        name: this.modelName,
        guard_name: this.guardName
      };

      var result = __WEBPACK_IMPORTED_MODULE_0__api_resources_crud__["a" /* default */].dfsResourceStore(this.resources, payload);

      result.then(this.saveNewSuccess, this.saveNewError);
    }
  }
});

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_AddButton__ = __webpack_require__(37);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_AddButton__["a" /* default */]],
  inject: ['onClickDate'],
  methods: {
    onClickEvent: function onClickEvent() {
      this.onClickDate(this.moment().add(1, 'month').format('YYYY-MM-DD'));
    }
  }
});

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppAddItemButtonBase__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppAddItemButtonBase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AppAddItemButtonBase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_ItemTypes__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppAddItemButtonBase: __WEBPACK_IMPORTED_MODULE_0__components_AppAddItemButtonBase___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_ItemTypes__["a" /* default */]],
  data: function data() {
    return {
      resources: 'services'
    };
  },

  computed: {
    itemType: function itemType() {
      return this.serviceTypeID;
    }
  }
});

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_user__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppMainDialog__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppMainDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_AppMainDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_ItemTypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ItemCheckList__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ItemCheckList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ItemCheckList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_UserServices__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_UserServices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_UserServices__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_AddButton__ = __webpack_require__(37);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppMainDialog: __WEBPACK_IMPORTED_MODULE_1__components_AppMainDialog___default.a, ItemCheckList: __WEBPACK_IMPORTED_MODULE_3__components_ItemCheckList___default.a, UserServices: __WEBPACK_IMPORTED_MODULE_4__components_UserServices___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_AddButton__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_ItemTypes__["a" /* default */]],
  data: function data() {
    return {
      photoForUser: null,
      userPhotoIsUploaded: false,
      user_photo_url: false,
      uploadPercentage: 0,
      snackbar: false,
      disabled: {
        uploadPhotoForEmbalmersBtn: false
      },
      resources: 'users',
      dialog: false,
      modelName: '',
      userLogin: '',
      userEmail: '',
      userPassword: '',
      userAvatarEvent: null,
      sex: ['Male', 'Female'],
      userSex: null,
      userAge: null,
      userDescription: null,
      userIsBookable: false,
      userIsVendor: false,
      userServiceDescription: null,
      editCheckListAfterSave: false,
      savedItemId: null,
      userServicePrice: null,
      saveNewDisabled: false,
      savedUserId: null,
      dialogMessage: '',
      dialogOpen: false
    };
  },

  watch: {
    dialogOpen: function dialogOpen() {
      var _this = this;

      if (this.savedItemId) {
        var form = new FormData();
        form.append('avatar', this.userAvatarEvent);

        this.$store.getters.axios.post(this.$store.getters.config.api_host + '/api/users/' + this.savedItemId + '/avatar', form, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
          }.bind(this)
        }).then(function (result) {
          _this.disabled.uploadPhotoForEmbalmersBtn = false;
          _this.userPhotoIsUploaded = true;

          _this.snackbar = true;
          setTimeout(function () {
            _this.userPhotoIsUploaded = false;
          }, 5000);
        });
      }
    },
    savedItemId: function savedItemId(val) {
      this.savedUserId = val;
    },
    dialog: function dialog(val) {
      this.emptyForm();
    }
  },
  computed: {
    uploadStatus: function uploadStatus() {
      return this.userPhotoIsUploaded ? 'done' : '';
    },
    avatar: function avatar() {
      return this.user_photo_url || this.$dfsConfig.default_avatar_url;
    }
  },
  methods: {
    onChange: function onChange(event) {
      this.user_photo_url = URL.createObjectURL(event.target.files[0]);
      this.userAvatarEvent = event.target.files[0];
    },
    editCheckListAfterSaveMethod: function editCheckListAfterSaveMethod(result) {
      var _this2 = this;

      this.$bus.$emit('resource-added');

      __WEBPACK_IMPORTED_MODULE_0__api_user__["a" /* default */].getLinkedServices(result.inserted_id).then(function (result) {
        _this2.savedItemId = result[0].id;

        _this2.saveNewSuccess(result);
      }, function () {});
    },
    editServicesAfterSaveMethod: function editServicesAfterSaveMethod(result) {
      this.$bus.$emit('resource-added');

      this.saveNewDisabled = true;

      this.savedUserId = result.inserted_id;
    },
    saveNew: function saveNew() {
      var payload = {
        name: this.modelName,
        username: this.userLogin,
        email: this.userEmail,
        is_bookable: this.userIsBookable,
        is_vendor: this.userIsVendor,
        age: this.userAge,
        sex: this.userSex,
        description: this.userDescription,
        password: this.userPassword
      };

      if (this.userIsBookable || this.userIsVendor) {
        payload.service_description = this.userServiceDescription;
        payload.service_price = this.userServicePrice;
      }

      // let callback = null

      var result = __WEBPACK_IMPORTED_MODULE_0__api_user__["a" /* default */].add(payload);

      // if (this.userIsVendor) {
      //   callback = this.editServicesAfterSaveMethod
      // } else {
      //   callback = this.saveNewSuccess
      // }
      // // if (this.editCheckListAfterSave) {
      // //   callback = this.editCheckListAfterSaveMethod
      // // } else {
      // //   callback = this.saveNewSuccess
      // // }
      //
      // result.then(callback, this.saveNewError)
      result.then(this.saveNewSuccess, this.saveNewError);
      // userAPI.add(payload).then(result => {
      //   let payloadService = {
      //     name: this.modelName,
      //     description: this.userServiceDescription,
      //     amount: 1,
      //     users_id: result.inserted_id,
      //     is_available: result.inserted_id,
      //     is_vendor: false
      //   }

      //   if (this.userIsVendor) {
      //     servicesAPI.add(payloadService).then(this.saveNewSuccess, this.saveNewError)
      //   } else {
      //     this.saveNewSuccess()
      //   }
      // }, this.saveNewError)
    },
    emptyForm: function emptyForm() {
      this.userLogin = '';
      this.modelName = '';
      this.userEmail = '';
      this.userPassword = '';
      this.userDescription = '';
    }
  },
  mounted: function mounted() {
    this.emptyForm();
  }
});

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_resources_cases__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_inventories__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Resources__ = __webpack_require__(22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mixin: [__WEBPACK_IMPORTED_MODULE_2__mixins_Resources__["a" /* default */]],
  data: function data() {
    return {
      resources: 'inventories',
      dialog: false,
      inventoriesList: [],
      selectedInventories: []
    };
  },

  props: {
    casesid: {
      type: Number,
      required: true
    }
  },
  methods: {
    saveNew: function saveNew() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__api_resources_cases__["a" /* default */].attachInventoriesToCase(this.casesid, this.selectedInventories).then(function (result) {
        _this.$emit('resource-attached');

        _this.dialog = false;
      });
    },
    loadListing: function loadListing() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__api_resources_inventories__["a" /* default */].loadInventories().then(function (result) {
        _this2.inventoriesList = result;
        _this2.selectedInventories = [];

        __WEBPACK_IMPORTED_MODULE_0__api_resources_cases__["a" /* default */].getLinkedInventories(_this2.casesid).then(function (result) {
          result.forEach(function (item) {
            _this2.selectedInventories.push(item.id);
          });
        }, function () {});
      });
    }
  },
  created: function created() {
    this.loadListing();
  }
});

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_cases__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Resources__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  mixin: [__WEBPACK_IMPORTED_MODULE_2__mixins_Resources__["a" /* default */]],
  data: function data() {
    return {
      resources: 'services',
      dialog: false,
      servicesList: [],
      selectedServices: [],
      caseModel: null
    };
  },

  props: {
    casesid: {
      type: Number,
      required: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    allProducts: 'allProducts'
  })),
  methods: {
    saveNew: function saveNew() {
      var _this = this;

      var mergedServices = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.unionBy(this.caseModel.services, this.selectedServices, 'id');
      mergedServices = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.reduce(mergedServices, function (result, value, key) {
        result[key] = {
          id: value.id,
          amount: parseInt(value.pivot ? value.pivot.quantity : value.amount)
        };
        return result;
      }, []);

      __WEBPACK_IMPORTED_MODULE_1__api_resources_cases__["a" /* default */].attachServicesToCase(this.casesid, mergedServices).then(function (result) {
        _this.$store.dispatch('loadAllCases');
        _this.$emit('resource-attached');

        _this.dialog = false;
      });
    },
    loadListing: function loadListing() {
      var _this2 = this;

      this.selectedServices = [];

      this.$store.dispatch('loadCase', this.casesid).then(function (caseModel) {
        _this2.caseModel = caseModel;
        _this2.servicesList = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.differenceWith(_this2.allProducts, caseModel.services, function (prod, newProd) {
          return prod.id === newProd.id;
        });
      });
    }
  },
  created: function created() {
    this.loadListing();
  }
});

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    products: 'allProducts',
    services: 'allServices',
    serviceById: 'getServiceById',
    caseManagerById: 'getCaseManagerById',
    actionsLog: 'caseLog',
    caseManagers: 'caseManagers'
  }), {
    parsePayload: function parsePayload(item) {}
  }),
  data: function data() {
    return {
      tableHeaders: [{ text: 'Action', value: 'action' }, { text: 'Username', value: 'username' }, { text: 'Payload', value: 'payload' }, { text: 'Date', value: 'created_at' }]
    };
  },

  props: {
    casesid: {
      type: Number,
      required: true
    }
  },
  methods: {
    parsedPayload: function parsedPayload(item) {
      var _this = this;

      if (!item) return 'N/A';
      var after = undefined !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(item)[0] ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(item)[0] : false;
      var before = undefined !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(item)[1] ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(item)[1] : false;
      var log = '';
      if (item.commissions) log += 'Commission set: ' + item.commissions;
      if (item.deposit) log += 'Deposit: ' + item.deposit;
      if (item.casecrew_id) log += 'Case Crew Selected: ' + this.getCaseCrewNameById(item.casecrew_id);
      if (before) {
        if (before === 'old_services') {
          if (item[before].length > 0 && undefined !== __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(item[before], 'name').join(', ')) log += 'Before: ' + __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(item[before], 'name').join(', ');else log += 'Not set';
        }
        if (before === 'services_id') log += 'Before: ' + undefined !== this.serviceById(item[before]) ? this.serviceById(item[before]).name : item[before].length + '(N/A)';
        if (before === 'old_manager' && item[before] !== null) {
          log += 'Old manager: ' + this.caseManagerById(item[before]) && this.caseManagerById(item[before]).email !== undefined ? this.caseManagerById(item[before]).email : this.caseManagerById(item[before]).name;
        }
        log += '<br>';
      }
      if (after) {
        if (after === 'services' && item[after].length > 0) {
          var res = 'After: ' + __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(item[before], 'name').join(', ');
          if (!res) {
            res = 'After: ' + item[after].reduce(function (acc, service) {
              return _this.serviceById(service.service_id).name + ' ' + service.amount + '<br>';
            });
          }
          log += res;
        }
        if (after === 'services_id') {
          log += 'After: ';
          log += item[after].length > 0 ? item[after].length + '(N/A)' : undefined !== this.serviceById(item[after]) ? this.serviceById(item[after]).name : '1 (N/A)';
        }
        if (after === 'new_manager') log += 'New manager: ' + this.caseManagerById(item[after]) !== undefined ? this.caseManagerById(item[after]).email : '';
      }
      return log;
    },
    getCaseCrewNameById: function getCaseCrewNameById(id) {
      return this.services.find(function (i) {
        return i.id === id;
      }).name;
    }
  },
  beforeCreate: function beforeCreate() {
    // this.$store.dispatch('getAllPlans')
    // this.$store.dispatch('getAllProducts')
    // this.$store.dispatch('getCaseManagers')
  },
  created: function created() {
    this.$store.dispatch('getCaseLog', this.casesid);
  }
});

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppMainDialog__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppMainDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_AppMainDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_invoice__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(4);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import _ from 'lodash'

/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppMainDialog: __WEBPACK_IMPORTED_MODULE_3__components_AppMainDialog___default.a },
  data: function data() {
    return {
      tableHeaders: [{ text: 'ID', value: 'id' }, { text: 'Invoice path', value: 'invoice_path' }, { text: 'Status', value: 'status' }, { text: 'Created Date', value: 'created_at' }, { text: 'Actions', value: 'actions' }],
      clientData: {},
      dialogOpen: false,
      dialogMessage: '',
      loadingInvoice: false,
      loadingReceiptEmail: false,
      loadingReceiptDownload: false,
      loadingAgreement: false,
      loading: {
        paidInvoiceBtn: false
      },
      disabled: {
        agreement: true,
        invoice: true,
        receipt: true
      },
      markPaidDisabled: false,
      showAlert: false,
      alertMessage: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])({
    clientById: 'getClientById',
    caseInvoices: 'currentCaseInvoices',
    getLastOnBoardForm: 'getLastOnBoardForm',
    items: 'currentCaseInvoices'
  })),
  props: {
    caseModel: {
      type: Object,
      required: true
    }
  },
  watch: {
    caseModel: function caseModel(m) {
      this.$store.dispatch('getCaseInvoices', m.id);
    },
    caseInvoices: function caseInvoices(c) {
      if (c && c.length) this.disabled.invoice = false;
      if (c && c[c.length - 1].status !== 'pending') this.disabled.receipt = false;
    }
  },
  methods: {
    sendReceipt: function sendReceipt() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var apiUrl, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loadingReceiptEmail = true;
                apiUrl = _this.$store.getters.config.api_host;
                _context.next = 4;
                return _this.$axios.post(apiUrl + '/api/cases/' + _this.caseModel.id + '/client/receipt/email');

              case 4:
                response = _context.sent;

                if (response) {
                  _this.loadingReceiptEmail = false;
                  _this.alertMessage = 'Receipt successfully sent!';
                  _this.showAlert = true;
                  setTimeout(function () {
                    _this.showAlert = false;
                  }, 2000);
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    markPaidInvoice: function markPaidInvoice(itemId) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_4__api_invoice__["a" /* default */].markPaid(itemId).then(function () {
        _this2.$store.dispatch('getCaseInvoices', _this2.caseModel.id);
      }, function () {});
    },
    loadLinkedInvoices: function loadLinkedInvoices() {
      if (this.$store.state.cases.caseInvoices.length === 0) this.$store.dispatch('getCaseInvoices', this.caseModel.id);
    },
    downloadReceipt: function downloadReceipt() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var apiUrl, formId, response, win;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.loadingReceiptDownload = true;
                apiUrl = _this3.$store.getters.config.api_host;
                formId = _this3.caseModel.answers[_this3.caseModel.answers.length - 1].id;
                _context2.next = 5;
                return _this3.$axios.get(apiUrl + '/api/pdf/receipt/' + formId);

              case 5:
                response = _context2.sent;

                if (response) {
                  _this3.loadingReceiptDownload = false;
                  win = window.open(response.data.additional_data.aws_s3_url, '_blank');

                  win.focus();
                }

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    downloadAgreement: function downloadAgreement() {
      var _this4 = this;

      this.loadingAgreement = true;
      var formId = this.caseModel.answers[this.caseModel.answers.length - 1].id;
      this.$store.dispatch('loadPdfAgreement', formId).then(function (result) {
        _this4.loadingAgreement = false;

        var win = window.open(result.aws_s3_url, '_blank');
        win.focus();

        /*
        this.dialogMessage = '<a href="' + result.aws_s3_url + '" target="_blank">' + result.aws_s3_url + '</a>'
        this.dialogOpen = true
        */
      });
    },
    downloadInvoice: function downloadInvoice() {
      this.loadingInvoice = true;

      if (this.caseInvoices.length) {
        var path = this.caseInvoices[this.caseInvoices.length - 1].invoice_path;
        this.loadingInvoice = false;

        var win = window.open(path, '_blank');
        win.focus();

        /*
        this.dialogMessage = '<a href="' + path + '" target="_blank">' + path + '</a>'
        this.dialogOpen = true
        */
      }
      // window.open(window.location.origin + '/', '_blank')
    },
    markPaid: function markPaid() {
      var _this5 = this;

      this.loading.paidInvoiceBtn = true;
      this.$store.dispatch('markInvoiceAsPaid', this.caseModel.id).then(function () {
        _this5.loading.paidInvoiceBtn = false;
        _this5.markPaidDisabled = true;
      });
    }
  },
  created: function created() {
    this.$store.dispatch('getCaseInvoices', this.caseModel.id);
  }
});

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_cases__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_resources_schedules__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      selectedShiftingCrew: [],
      selectedSendingCrew: [],
      selectedFuneralCrew: [],
      disabled: {
        caseCrewSelect: false
      },
      leadsUuid: null
    };
  },

  props: {
    caseid: {
      type: Number,
      required: true
    },
    case: {
      type: Object
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    servicesList: 'allServices',
    usersList: 'allUsersRaw'
  }), {
    closed: function closed() {
      return this.case.status === 'closed';
    }
  }),
  filters: {
    filterPallBearers: function filterPallBearers(value, closing) {
      return value.filter(function (service) {
        return service.hasOwnProperty('description') && service.description !== null ? service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') === 'casecrew' : false;
      });
    }
  },
  watch: {
    users: function users() {
      if (!this.$store.state.cases.caseManager) this.$store.dispatch('getCaseManager', this.caseid);
    }
  },
  created: function created() {
    var _this = this;

    if (!this.$can('view', 'vendor') && this.$store.state.users.allUsers.length === 0) this.$store.dispatch('getAllUsers');
    if (this.$store.state.services.all.length === 0) this.$store.dispatch('getAllServices');
    if (!this.$store.state.cases.caseManager) this.$store.dispatch('getCaseManager', this.caseid);
    __WEBPACK_IMPORTED_MODULE_1__api_resources_cases__["a" /* default */].getLead(this.caseid).then(function (result) {
      _this.leadsUuid = result[0].leads_id;
      _this.selectedShiftingCrew = result.filter(function (filtering) {
        return filtering.service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') !== 'casemanager' && filtering.is_closing === 0;
      }).map(function (item) {
        return item.item_id;
      });
      _this.selectedSendingCrew = result.filter(function (filtering) {
        return filtering.service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') !== 'casemanager' && filtering.is_closing === 1;
      }).map(function (item) {
        return item.item_id;
      });
      _this.selectedFuneralCrew = result.filter(function (filtering) {
        return filtering.service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') !== 'casemanager' && filtering.is_closing === 2;
      }).map(function (item) {
        return item.item_id;
      });
    }, function () {});
  },

  methods: {
    updatePallbearers: function updatePallbearers(closing) {
      var _this2 = this;

      this.disabled.caseCrewSelect = true;

      var pallbearers = void 0;
      if (closing === 0) {
        pallbearers = this.selectedShiftingCrew;
      }
      if (closing === 1) {
        pallbearers = this.selectedSendingCrew;
      }
      if (closing === 2) {
        pallbearers = this.selectedFuneralCrew;
      }

      __WEBPACK_IMPORTED_MODULE_2__api_resources_schedules__["a" /* default */].updatePallbearers(this.leadsUuid, pallbearers, closing).then(function () {
        _this2.$store.dispatch('getCaseLog', _this2.caseid);
        setTimeout(function () {
          _this2.disabled.caseCrewSelect = false;
        }, 1000);
      }, function () {});
    },
    filterPallBearers: function filterPallBearers(value, closing) {
      var _this3 = this;

      return value.filter(function (service) {
        return service.hasOwnProperty('description') && service.description !== null ? service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') === 'casecrew' && _this3.usersList.filter(function (i) {
          return i.id === service.users_id;
        }).length > 0 && _this3.usersList.find(function (i) {
          return i.id === service.users_id;
        }).roles.length > 0 && _this3.usersList.find(function (i) {
          return i.id === service.users_id;
        }).roles.filter(function (r) {
          return r.name === 'case-crew';
        }).length > 0 : false;
      });
    }
  }
});

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_resources_cases__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppMainDialog__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppMainDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_AppMainDialog__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import resourcesMixins from '@/mixins/Resources'

/* harmony default export */ __webpack_exports__["default"] = ({
  // mixins: [ resourcesMixins ],
  components: { AppMainDialog: __WEBPACK_IMPORTED_MODULE_1__components_AppMainDialog___default.a },
  data: function data() {
    return {
      tableHeaders: [{ text: 'Answer ID', value: 'id' }, { text: 'Form Name', value: 'form_name' }, { text: 'Created at', value: 'created_at' }, { text: 'Updated at', value: 'updated_at' }, { text: 'Actions', value: 'actions', sortable: false }],
      items: [],
      formName: '',
      loading: false,
      dialogOpen: false,
      dialogMessage: ''
    };
  },

  methods: {
    downloadPDF: function downloadPDF(answersId) {
      var _this = this;

      var pdf = __WEBPACK_IMPORTED_MODULE_0__api_resources_cases__["a" /* default */].loadPDF(answersId);

      this.loading = true;

      pdf.then(function (result) {
        _this.loading = false;

        _this.dialogMessage = '<a href="' + result.aws_s3_url + '" target="_blank">' + result.aws_s3_url + '</a>';

        _this.dialogOpen = true;
      });
    },
    loadListing: function loadListing() {}
  },
  props: {
    casesid: {
      type: Number,
      required: true
    }
  },
  created: function created() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0__api_resources_cases__["a" /* default */].getLinkedAnswers(this.casesid).then(function (result) {
      var data = result[0].answer;
      var dataJson = JSON.parse(data);

      _this2.formName = dataJson.form_name;

      _this2.items = result;
    }, this.loadListingError);
  }
});

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_AttachInventoriesToCaseButton__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_AttachInventoriesToCaseButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_buttons_AttachInventoriesToCaseButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditItemCheckListDialog_vue__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditItemCheckListDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditItemCheckListDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppCaseItemsDataTableBase__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppCaseItemsDataTableBase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AppCaseItemsDataTableBase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_ItemTypes__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AttachInventoriesToCaseButton: __WEBPACK_IMPORTED_MODULE_0__components_buttons_AttachInventoriesToCaseButton___default.a, AppEditItemCheckListDialog: __WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditItemCheckListDialog_vue___default.a, AppCaseItemsDataTableBase: __WEBPACK_IMPORTED_MODULE_2__components_AppCaseItemsDataTableBase___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_ItemTypes__["a" /* default */]],
  props: {
    casesid: {
      type: Number,
      required: true
    }
  }
});

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_invoice__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buttons_AddCaseInvoiceButton__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buttons_AddCaseInvoiceButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_buttons_AddCaseInvoiceButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AddCaseInvoiceButton: __WEBPACK_IMPORTED_MODULE_2__components_buttons_AddCaseInvoiceButton___default.a },
  data: function data() {
    return {
      tableHeaders: [{ text: 'ID', value: 'id' }, { text: 'Invoice path', value: 'invoice_path' }, { text: 'Vendor', value: 'vendors_id' }, { text: 'Status', value: 'status' }, { text: 'Created Date', value: 'created_at' }, { text: 'Actions', value: 'actions' }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    // caseById: 'getCaseById',
    // getAllCases: 'getAllCases',
    items: 'currentCaseVendorInvoices'
  })),
  props: {
    casesid: {
      type: Number,
      required: true
    }
  },
  methods: {
    markPaid: function markPaid(itemId) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__api_invoice__["a" /* default */].markPaid(itemId).then(function () {
        _this.loadLinkedInvoices();
      }, function () {});
    },
    loadLinkedInvoices: function loadLinkedInvoices() {
      this.$store.dispatch('getCaseInvoices', this.casesid);
    }
  },
  created: function created() {
    var _this2 = this;

    this.$bus.$on('invoice:uploaded', function () {
      _this2.$store.dispatch('getCaseInvoices', _this2.casesid);
    });
    this.$store.dispatch('getCaseInvoices', this.casesid);
  }
});

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_resources_plans__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_resources_cases__ = __webpack_require__(14);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import { mapGetters } from 'vuex'

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      planData: {},
      quotationTotalPrice: 0,
      loading: {
        updatePaymentInfo: false
      },
      caseModel: null,
      payment_method: null,
      payment_method_cc_datetime: null,
      payment_method_cc_remarks: null,
      payment_method_cash_collected_by: null,
      payment_method_cash_remarks: null,
      payment_method_cheque_collected_by: null,
      payment_method_cheque_remarks: null,
      payment_method_ibanking_datetime: null,
      payment_method_ibanking_remarks: null
    };
  },

  props: {
    plansid: {
      type: Number,
      required: true
    },
    casesid: {
      required: true
    },
    caseData: {
      type: Object
    }
  },
  computed: {
    /*
    ...mapGetters({
      getAllCases: 'getAllCases',
      caseById: 'getCaseById'
    }),
    */
    closed: function closed() {
      return this.caseData && this.caseData.status === 'closed';
    }
  },
  watch: {
    /*
    getAllCases (cases) {
      this.caseData = cases.find(cas => cas.id === parseInt(this.casesid))
    }
    */
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__api_resources_plans__["a" /* default */].loadPlan(this.plansid).then(function (result) {
      _this.planData = result;
    });

    __WEBPACK_IMPORTED_MODULE_3__api_resources_cases__["a" /* default */].getQuotationTotalPrice(this.casesid).then(function (result) {
      _this.quotationTotalPrice = result;
    }, function () {});

    this.payment_method = this.caseData.payment_method;
    this.payment_method_cc_datetime = this.caseData.payment_method_cc_datetime;
    this.payment_method_cc_remarks = this.caseData.payment_method_cc_remarks;
    this.payment_method_cash_collected_by = this.caseData.payment_method_cash_collected_by;
    this.payment_method_cash_remarks = this.caseData.payment_method_cash_remarks;
    this.payment_method_cheque_collected_by = this.caseData.payment_method_cheque_collected_by;
    this.payment_method_cheque_remarks = this.caseData.payment_method_cheque_remarks;
    this.payment_method_ibanking_datetime = this.caseData.payment_method_ibanking_datetime;
    this.payment_method_ibanking_remarks = this.caseData.payment_method_ibanking_remarks;

    /*
    casesAPI.loadCase(this.casesid).then(result => {
      this.caseData = result[0]
      const defaultPaymentData = {
        payment_method: null,
        payment_method_cc_datetime: null,
        payment_method_cc_remarks: null,
        payment_method_cash_collected_by: null,
        payment_method_cash_remarks: null,
        payment_method_cheque_collected_by: null,
        payment_method_cheque_remarks: null,
        payment_method_ibanking_datetime: null,
        payment_method_ibanking_remarks: null
      }
      this.caseData = Object.assign(this.caseData, defaultPaymentData)
      const paymentData = JSON.parse(result[0].payment_info) || { payment_method: null }
      this.caseData = Object.assign(this.caseData, paymentData)
      console.log('case data', this.caseData)
    }, () => {})
    */
  },

  methods: {
    currencyFormat: function currencyFormat(number) {
      return 'SGD $' + number.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    },
    updatePaymentData: function updatePaymentData(value) {
      this.$emit('updatePaymentMethod', value);
    },
    updatePaymentInfo: function updatePaymentInfo() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.loading.updatePaymentInfo = true;
                data = {
                  payment_info: {
                    payment_method: _this2.payment_method,
                    payment_method_cc_datetime: _this2.payment_method_cc_datetime,
                    payment_method_cc_remarks: _this2.payment_method_cc_remarks,
                    payment_method_cash_collected_by: _this2.payment_method_cash_collected_by,
                    payment_method_cash_remarks: _this2.payment_method_cash_remarks,
                    payment_method_cheque_collected_by: _this2.payment_method_cheque_collected_by,
                    payment_method_cheque_remarks: _this2.payment_method_cheque_remarks,
                    payment_method_ibanking_datetime: _this2.payment_method_ibanking_datetime,
                    payment_method_ibanking_remarks: _this2.payment_method_ibanking_remarks
                  }
                };
                _context.next = 4;
                return _this2.$axios.post(_this2.$store.getters.config.api_host + '/api/cases/' + _this2.casesid + '/payment-info', data);

              case 4:
                response = _context.sent;

                _this2.$emit('updatePaymentInfo', data);
                if (response) {
                  _this2.loading.updatePaymentInfo = false;
                }
                return _context.abrupt('return', true);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  }
});

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_AttachServicesToCaseButton__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_AttachServicesToCaseButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_buttons_AttachServicesToCaseButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditItemCheckListDialog_vue__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditItemCheckListDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditItemCheckListDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppCaseItemsDataTableBase__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppCaseItemsDataTableBase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AppCaseItemsDataTableBase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_ItemTypes__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AttachServicesToCaseButton: __WEBPACK_IMPORTED_MODULE_0__components_buttons_AttachServicesToCaseButton___default.a, AppEditItemCheckListDialog: __WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditItemCheckListDialog_vue___default.a, AppCaseItemsDataTableBase: __WEBPACK_IMPORTED_MODULE_2__components_AppCaseItemsDataTableBase___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_ItemTypes__["a" /* default */]],
  props: {
    casesid: {
      type: Number,
      required: true
    }
  }
});

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_cases__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      selectedCaseManager: null,
      changed: false,
      toggleChangeCaseManager: false,
      disabled: {
        caseManagerSelect: false
      }
    };
  },

  props: {
    caseid: {
      type: Number,
      required: true
    },
    caseModel: {
      type: Object
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    managerData: 'caseManager',
    users: 'caseManagers'
  }), {
    icon: function icon() {
      // return this.changed ? 'done' : 'edit'
      return 'edit';
    },
    closed: function closed() {
      return this.caseModel.status === 'closed';
    }
  }),
  watch: {
    users: function users() {
      if (!this.$store.state.cases.caseManager) this.$store.dispatch('getCaseManager', this.caseid);
    },
    selectedCaseManager: function selectedCaseManager(manager) {
      var _this = this;

      this.changed = false;
      this.disabled.caseManagerSelect = true;

      __WEBPACK_IMPORTED_MODULE_1__api_resources_cases__["a" /* default */].updateCaseManager(this.caseid, manager).then(function () {
        if (!_this.$store.state.cases.caseManager) _this.$store.dispatch('getCaseManager', _this.caseid);
        _this.$store.dispatch('getCaseLog', _this.caseid);
        setTimeout(function () {
          _this.toggleChangeCaseManager = false;
          _this.changed = true;
          _this.disabled.caseManagerSelect = false;
        }, 1000);
      }, function () {});
    }
  },
  methods: {},
  created: function created() {
    if (this.$store.state.users.caseManagers.length === 0) this.$store.dispatch('getCaseManagers');
    this.$store.dispatch('getCaseManager', this.caseid);
  }
});

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ServicesDataTable',
  props: {
    selectedServices: {
      type: Array
    },
    discount: {
      type: Boolean,
      default: false
    },
    price: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    servicesList: 'allProducts',
    serviceById: 'getProductById',
    getProductsByCategoryId: 'getProductsByCategoryId'
  }), {
    finalPrice: function finalPrice() {
      return this.mutableSelectedServices.reduce(function (total, service) {
        return total + service.price * service.amount;
      }, 0) + (this.discount ? this.discountValue : 0);
    }
  }),
  data: function data() {
    return {
      discountValue: 0,

      upgrade_id: false,
      change_product_from_category_model: null,

      mutableSelectedServices: this.selectedServices,

      productsTableHeaders: [{ text: 'Name', value: 'name' }, { text: 'Qty', value: 'amount', width: '5px' }, { text: 'Unit', value: 'price' }, { text: 'Subtotal', value: 'price' }, { text: 'Actions', value: 'name', sortable: false }]
    };
  },

  watch: {
    mutableSelectedServices: function mutableSelectedServices(services) {
      if (!services.length) return;
      this.$emit('services:changed', __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(services, function (s) {
        return {
          name: s.name || s.description,
          id: s.id,
          amount: s.amount,
          price: s.price
        };
      }));
    }
  },
  methods: {
    deleteItem: function deleteItem(item) {
      var index = this.mutableSelectedServices.indexOf(item);
      this.mutableSelectedServices.splice(index, 1);
    },
    changeProductFromCategory: function changeProductFromCategory(oldItem) {
      if (oldItem.id !== this.change_product_from_category_model) {
        this.mutableSelectedServices = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.unionBy([this.serviceById(this.change_product_from_category_model)], this.mutableSelectedServices, 'id');
        this.deleteItem(oldItem);
      }
      this.change_product_from_category_model = null;
      this.upgrade_id = false;
    }
  }
});

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_datatables_CaseUserCreatedDataTable__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_datatables_CaseUserCreatedDataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_datatables_CaseUserCreatedDataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_datatables_CaseCrewDataTable__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_datatables_CaseCrewDataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_datatables_CaseCrewDataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_datatables_CaseClientDataTable__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_datatables_CaseClientDataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_datatables_CaseClientDataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_datatables_CasePlanDataTable__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_datatables_CasePlanDataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_datatables_CasePlanDataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_datatables_CaseServicesDataTable__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_datatables_CaseServicesDataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_datatables_CaseServicesDataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_datatables_CaseActionsLogDataTable__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_datatables_CaseActionsLogDataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_datatables_CaseActionsLogDataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_datatables_CaseInventoriesDataTable__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_datatables_CaseInventoriesDataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_datatables_CaseInventoriesDataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_datatables_CaseInvoicesDataTable__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_datatables_CaseInvoicesDataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_datatables_CaseInvoicesDataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_datatables_CaseFormsAnswersDataTable__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_datatables_CaseFormsAnswersDataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_datatables_CaseFormsAnswersDataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_CaseFormsChat__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_CaseFormsChat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_CaseFormsChat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_CaseFormsCheckList__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_CaseFormsCheckList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_CaseFormsCheckList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_SelectPlanAndVendors__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_SelectPlanAndVendors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_SelectPlanAndVendors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_CaseAgreementFeedback__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_CaseAgreementFeedback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_CaseAgreementFeedback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_CaseDeposit__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_CaseDeposit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_CaseDeposit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_CaseReadjustment__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_CaseReadjustment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_CaseReadjustment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_CaseCommissions__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_CaseCommissions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_CaseCommissions__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















// import CasePlanAndServicesEdition from '@/components/CasePlanAndServicesEdition'
// import { mapGetters } from 'vuex'
// import _ from 'lodash'

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    CaseUserCreatedDataTable: __WEBPACK_IMPORTED_MODULE_3__components_datatables_CaseUserCreatedDataTable___default.a,
    CaseCrewDataTable: __WEBPACK_IMPORTED_MODULE_4__components_datatables_CaseCrewDataTable___default.a,
    CaseClientDataTable: __WEBPACK_IMPORTED_MODULE_5__components_datatables_CaseClientDataTable___default.a,
    CasePlanDataTable: __WEBPACK_IMPORTED_MODULE_6__components_datatables_CasePlanDataTable___default.a,
    CaseServicesDataTable: __WEBPACK_IMPORTED_MODULE_7__components_datatables_CaseServicesDataTable___default.a,
    CaseActionsLogDataTable: __WEBPACK_IMPORTED_MODULE_8__components_datatables_CaseActionsLogDataTable___default.a,
    CaseInventoriesDataTable: __WEBPACK_IMPORTED_MODULE_9__components_datatables_CaseInventoriesDataTable___default.a,
    CaseFormsChat: __WEBPACK_IMPORTED_MODULE_12__components_CaseFormsChat___default.a,
    CaseInvoicesDataTable: __WEBPACK_IMPORTED_MODULE_10__components_datatables_CaseInvoicesDataTable___default.a,
    CaseFormsAnswersDataTable: __WEBPACK_IMPORTED_MODULE_11__components_datatables_CaseFormsAnswersDataTable___default.a,
    SelectPlanAndVendors: __WEBPACK_IMPORTED_MODULE_14__components_SelectPlanAndVendors___default.a,
    CaseFormsCheckList: __WEBPACK_IMPORTED_MODULE_13__components_CaseFormsCheckList___default.a,
    CaseAgreementFeedback: __WEBPACK_IMPORTED_MODULE_15__components_CaseAgreementFeedback___default.a,
    CaseDeposit: __WEBPACK_IMPORTED_MODULE_16__components_CaseDeposit___default.a,
    CaseReadjustment: __WEBPACK_IMPORTED_MODULE_17__components_CaseReadjustment___default.a,
    CaseCommissions: __WEBPACK_IMPORTED_MODULE_18__components_CaseCommissions___default.a
  },
  props: {
    id: {
      // type: String,
      required: true
    },
    goToCheckListsTab: {
      type: Boolean,
      default: false,
      required: false
    },
    goToInvoicesTab: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: function data() {
    return {
      caseData: null,
      selectedTab: 0,
      selectedTab1: 1,
      selectedTab2: 0,
      formAnswer: null
    };
  },

  computed: {
    // ...mapGetters(['getCaseById', 'getAllCases']),
    caseDataLoaded: function caseDataLoaded() {
      return !!(this.caseData && this.caseData.id > 0);
    }
  },
  /*
  watch: {
    getAllCases (cases) {
      // this.caseData = cases.find(cas => cas.id === parseInt(this.id))
      this.$store.dispatch('loadCaseForms', this.caseData)
    },
    id () {
      this.$store.dispatch('getCaseInvoices', this.id)
      this.$store.dispatch('loadCaseForms', this.caseData)
    }
  },
  */
  methods: {
    approveCase: function approveCase() {
      var _this = this;

      this.loading.approveCaseBtn = true;
      this.$store.dispatch('approveCase', this.caseData.id).then(function () {
        _this.$store.dispatch('getCaseInvoices', _this.caseData.id);
        _this.loading.approveCaseBtn = false;
        _this.caseData.status = 'approved';
      });
    },
    loadData: function loadData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response, defaultPaymentData, paymentData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$axios.get(_this2.$store.getters.config.api_host + '/api/cases/' + _this2.id);

              case 2:
                response = _context.sent;

                if (response) {
                  _this2.caseData = response.data.additional_data[0];
                  defaultPaymentData = {
                    payment_method: null,
                    payment_method_cc_datetime: null,
                    payment_method_cc_remarks: null,
                    payment_method_cash_collected_by: null,
                    payment_method_cash_remarks: null,
                    payment_method_cheque_collected_by: null,
                    payment_method_cheque_remarks: null,
                    payment_method_ibanking_datetime: null,
                    payment_method_ibanking_remarks: null
                  };

                  _this2.caseData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(_this2.caseData, defaultPaymentData);
                  paymentData = JSON.parse(response.data.additional_data[0].payment_info) || { payment_method: null };

                  _this2.caseData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(_this2.caseData, paymentData);
                  _this2.formAnswer = _this2.caseData && _this2.caseData.answers && _this2.caseData.answers[0] && _this2.caseData.answers[0].answer ? JSON.parse(_this2.caseData.answers[0].answer) : null;
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    updatePaymentMethod: function updatePaymentMethod(value) {
      this.caseData.payment_method = value;
    },
    updatePaymentInfo: function updatePaymentInfo(value) {
      this.caseData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.caseData, value.payment_info);
    }
  },
  created: function created() {
    if (this.$store.state.products.categories.length === 0) this.$store.dispatch('getProductsCategories');
    if (!this.$can('view', 'vendor') && this.$store.state.users.allUsers.length === 0) this.$store.dispatch('getAllUsers');
    if (!this.$can('view', 'vendor') && this.$store.state.clients.all.length === 0) this.$store.dispatch('getAllClients');
    if (!this.$can('view', 'vendor') && this.$store.state.plans.all.length === 0) this.$store.dispatch('getAllPlans');
    if (this.$store.state.products.all.length === 0 || this.$store.state.products.caskets.length === 0) this.$store.dispatch('getAllProducts');
    if (this.$store.state.services.all.length === 0) this.$store.dispatch('getAllServices');
    if (this.$store.state.users.caseManagers.length === 0) this.$store.dispatch('getCaseManagers');
    if (!this.caseData) this.loadData();
    // this.caseData = this.getAllCases.find(cas => cas.id === parseInt(this.id))
    // console.log('case data', this.caseData)
    if (this.goToCheckListsTab) {
      if (this.$can('view', 'cases-detail-checklist-tab')) {
        this.selectedTab1 = 'checklist-tab';
      } else if (this.$can('view', 'cases-detail-checklist-crew-tab')) {
        this.selectedTab1 = 'checklist-crew-tab';
      }
    } else if (this.goToInvoicesTab) {
      this.selectedTab2 = 'pdf-tab';
    }
  }
});

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_resources_cases__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_IsMobile__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_IsMobile__["a" /* default */]],
  data: function data() {
    return {
      menuDateModel: false,
      menuTimeModel: false,
      caseName: null,
      timeModel: null,
      dateModel: null,
      minDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),
      isMobile: false,
      addLoading: false,
      rules: {
        date: function date(d) {
          return __WEBPACK_IMPORTED_MODULE_2_moment___default()(d).utc().isAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(1, 'day')) || 'Wrong Date.';
        }
        // time: t => ((moment().format('YYYY-MM-DD') !== this.dateModel) && (moment().diff(moment(t, 'HH:mm'), 'minutes') > 1)) || 'Wrong Time' todo
      }
    };
  },

  computed: {
    dialogModel: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    saveNewCase: function saveNewCase() {
      var _this = this;

      this.addLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__api_resources_cases__["a" /* default */].saveCase({ name: this.caseName }).then(function (result) {
        _this.dialogModel = false;
        _this.addLoading = false;
        _this.$store.dispatch('loadAllCases');
        _this.$router.push({ name: 'NewLeads', params: { date: _this.dateModel, time: _this.timeModel, caseId: result.inserted_id } });
      }, function () {
        _this.dialogModel = false;
        _this.addLoading = false;
      });
    },
    setDate: function setDate(newDate) {
      this.dateModel = newDate;
    },
    dateValidation: function dateValidation(date) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).utc().isAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(1, 'day'));
    }
  },
  watch: {
    date: function date(val) {
      this.setDate(val);
    },
    timeModel: function timeModel() {
      this.timeModel.match(/^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/);
    }
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    date: {
      type: String,
      required: true,
      default: false
    }
  },
  created: function created() {
    this.setDate(this.date);
  },
  mounted: function mounted() {
    if (this.DetectMobile()) {
      this.isMobile = true;
    }
  }
});

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppEditBookingsBaseDialog__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppEditBookingsBaseDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AppEditBookingsBaseDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_ItemTypes__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppEditBookingsBaseDialog: __WEBPACK_IMPORTED_MODULE_0__components_AppEditBookingsBaseDialog___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_ItemTypes__["a" /* default */]]
});

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CasePlanAndServicesEdition__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CasePlanAndServicesEdition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_CasePlanAndServicesEdition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_EditResourceDialog__ = __webpack_require__(26);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { CasePlanAndServicesEdition: __WEBPACK_IMPORTED_MODULE_0__components_CasePlanAndServicesEdition___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_EditResourceDialog__["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    // TODO remove this dirty hack :'(
    this.$bus.$on('dialog-close', function () {
      _this.dialogClose();
    });
  }
});

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_EditResourceDialog__ = __webpack_require__(26);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      resource: 'clients'
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_EditResourceDialog__["a" /* default */]]
});

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_EditResourceDialog__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ItemCheckList__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ItemCheckList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ItemCheckList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_ItemTypes__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ItemCheckList: __WEBPACK_IMPORTED_MODULE_1__components_ItemCheckList___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_EditResourceDialog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_ItemTypes__["a" /* default */]],
  data: function data() {
    return {
      resource: 'inventories'
    };
  },

  computed: {
    itemType: function itemType() {
      return this.inventoryTypeID;
    }
  }
});

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_ItemTypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ItemCheckList__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ItemCheckList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ItemCheckList__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ItemCheckList: __WEBPACK_IMPORTED_MODULE_1__components_ItemCheckList___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_ItemTypes__["a" /* default */]],
  methods: {
    closeDialog: function closeDialog(event) {
      this.dialog = false;

      this.$emit('update:itemId', 0);
    }
  },
  data: function data() {
    return {
      dialog: false
    };
  },

  watch: {
    itemId: function itemId() {
      if (this.itemId > 0) {
        this.dialog = true;
      }
    }
  },
  props: {
    itemId: {
      type: Number,
      required: true
    },
    casesId: {
      default: 0,
      required: false
    },
    itemType: {
      type: Number,
      required: true
    }
  }
});

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_EditResourceDialog__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_resources_events__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_resources_recipients__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_resources_notifications__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_Notifications__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);



var _this3 = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_EditResourceDialog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_Notifications__["a" /* default */]],
  data: function data() {
    return {
      resource: 'notifications',
      notificationRecipients: [],
      eventsList: [],
      selectedRecipients: [],
      selectedRoles: [],
      isEmailType: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])({
    roles: 'allRoles'
  }), {
    isLeadAddedEvent: function isLeadAddedEvent() {
      var _this = this;

      var ev = this.eventsList.find(function (e) {
        return e.value === _this.selectedEvent;
      });
      return ev !== undefined && ev.text === 'New Lead Added';
    }
  }),
  methods: {
    clearDialogForm: function clearDialogForm() {
      this.selectedRecipients = [];
      this.selectedRoles = [];
      this.isEmailType = false;
      this.itemData.events_id = null;
      this.itemData.vendor = null;
      this.itemData.message = null;
      this.itemData.subject = null;
    },
    editItemDataDecorator: function editItemDataDecorator() {
      var _this2 = this;

      this.selectedRecipients.forEach(function (item, i) {
        if ((typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(item)) !== 'object') {
          _this2.selectedRecipients[i] = {
            id: null,
            phone: !_this2.isEmailType ? item : null,
            email: _this2.isEmailType ? item : null
          };
        }
      });

      this.itemData.recipients = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.map(this.selectedRecipients, this.isEmailType ? 'email' : 'phone');
      this.itemData.roles = this.selectedRoles;

      this.editItemData();
    },
    pasteVar: function pasteVar(v) {
      this.itemData.message = this.itemData.message + v;
    }
  },
  watch: {
    'itemData.vendor': function itemDataVendor(v) {
      _this3.isEmailType = v === 'email';
    },
    itemId: function itemId(newVal, oldVal) {
      var _this4 = this;

      if (newVal > 0) {
        __WEBPACK_IMPORTED_MODULE_3__api_resources_events__["a" /* default */].loadEvents().then(function (result) {
          _this4.eventsList = result;
        });

        __WEBPACK_IMPORTED_MODULE_4__api_resources_recipients__["a" /* default */].loadRecipients().then(function (result) {
          __WEBPACK_IMPORTED_MODULE_5__api_resources_notifications__["a" /* default */].getLinkedRecipients(newVal).then(function (result) {
            _this4.selectedRecipients = result.recipients;

            result.roles.forEach(function (item, i) {
              if (_this4.selectedRoles.indexOf(item.id) === -1) {
                _this4.selectedRoles.push(item.id);
              }
            });
          });

          _this4.notificationRecipients = result;
        });
      }
    }
  }
});

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_EditResourceDialog__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_forms__ = __webpack_require__(137);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      resource: 'templates',
      formsList: []
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_EditResourceDialog__["a" /* default */]],
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__api_resources_forms__["a" /* default */].loadForms().then(function (result) {
      _this.formsList = result;
    });
  }
});

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_EditResourceDialog__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_EditResourceDialog__["a" /* default */]],
  data: function data() {
    return {
      resource: 'plans',
      selectedServices: [],
      productsTableHeaders: [{ text: 'Name', value: 'name' }, { text: 'Qty', value: 'amount', width: '5px' }, { text: 'Unit', value: 'price' }, { text: 'Subtotal', value: 'price' }],
      selectedCasket: null,
      loading: {
        plan: false
      },
      showAlert: false,
      alertMessage: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    products: 'allProducts',
    serviceById: 'getProductById',
    plans: 'allPlans',
    planById: 'getPlanById',
    allCaskets: 'allCaskets',
    casketById: 'getCasketById',
    filterFromLinkedServices: 'filterFromLinkedServices',
    filterCasketFromLinkedProducts: 'filterCasketFromLinkedProducts',
    removeCasketsFromServices: 'removeCasketsFromServices'
  }), {
    totalPrice: function totalPrice() {
      if (!this.planById(this.itemId) && !this.selectedCasket && !this.selectedServices) return false;
      /*
      return (this.planById(this.itemId) ? parseFloat(this.itemData.price) : 0) +
        (this.casketById(this.selectedCasket) ? parseFloat(this.casketById(this.selectedCasket).price) : 0) +
        (this.selectedServices ? _.reduce(this.selectedServices, (sum, p) => {
          return sum + parseFloat(p.price) * p.amount
        }, 0) : 0)
      */
      return this.selectedServices ? __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.reduce(this.selectedServices, function (sum, p) {
        return sum + parseFloat(p.price) * p.amount;
      }, 0) : 0;
    }
  }),
  methods: {
    editItemDataDecorator: function editItemDataDecorator() {
      var _this = this;

      if (!this.checkQuantity()) {
        this.alertMessage = 'Please set quantity';
        this.showAlert = true;
        setTimeout(function () {
          _this.showAlert = false;
        }, 2000);
        return;
      }
      var selectedServices = this.selectedServices;
      if (this.selectedCasket) selectedServices.push(this.casketById(this.selectedCasket));
      this.itemData.services = selectedServices;

      this.editItemData();
      this.$bus.$emit('resource-updated');
      this.$store.dispatch('getAllPlans');
      this.selectedServices = this.removeCasketsFromServices(this.itemData.services);
    },
    checkQuantity: function checkQuantity() {
      var check = true;
      this.selectedServices.forEach(function (item) {
        if (!item.amount) check = false;
      });
      return check;
    }
  },
  watch: {
    itemId: function itemId() {
      if (this.itemId > 0) {
        this.selectedCasket = this.filterCasketFromLinkedProducts(this.planById(this.itemId).services);
        this.selectedServices = this.filterFromLinkedServices(this.planById(this.itemId).services);
      }
    }
  },
  beforeCreate: function beforeCreate() {
    this.$store.dispatch('getAllPlans');
    this.$store.dispatch('getAllProducts');
  },
  created: function created() {}
});

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_EditResourceDialog__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_ItemTypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ItemCheckList__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ItemCheckList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ItemCheckList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_user__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ItemCheckList: __WEBPACK_IMPORTED_MODULE_3__components_ItemCheckList___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_EditResourceDialog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_ItemTypes__["a" /* default */]],
  data: function data() {
    return {
      resource: 'services',
      usersList: [],
      categorySearch: null,
      selectedCategory: null,
      selectedParentCategory: null,
      setParentId: false,
      loading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])({
    products: 'allProducts',
    categoriesList: 'productsCategories',
    categoryById: 'getProductCategoryById'
  }), {
    itemType: function itemType() {
      return this.serviceTypeID;
    },
    excludeSelectedCategory: function excludeSelectedCategory() {
      var _this = this;

      if (this.selectedCategory === null) return this.categoriesList;
      return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.filter(this.categoriesList, function (c) {
        return c.id !== _this.selectedCategory.id;
      });
    }
  }),
  // TODO move to mixins along with EditProducts
  filters: {
    normalizeRoles: function normalizeRoles(items) {
      return items && items.length > 0 ? items.map(function (mapping) {
        return mapping.name;
      }).join() : '';
    }
  },
  watch: {
    itemData: {
      handler: function handler(service) {
        this.selectedUser = service.users_id;
        this.selectedCategory = this.categoryById(service.categories_id);
      },

      deep: true
    },
    selectedCategory: function selectedCategory(c) {
      if (c.parent_id === null) {
        this.setParentId = false;
        this.selectedParentCategory = null;
        return;
      }
      this.setParentId = true;
      this.selectedParentCategory = this.categoryById(parseInt(this.selectedCategory.parent_id));
    },
    selectedParentCategory: function selectedParentCategory(p) {
      if (this.selectedCategory === null || p === null) return;
      this.editCategory();
    },
    setParentId: function setParentId(v) {
      if (v === false && this.selectedCategory !== null && this.selectedParentCategory !== null) {
        this.selectedParentCategory = null;
        this.editCategory();
      }
    }
  },
  methods: {
    addCategory: function addCategory() {
      var _this2 = this;

      this.loading = true;
      this.$store.dispatch('createProductCategory', this.categorySearch).then(function () {
        _this2.loading = false;
        _this2.$store.dispatch('getProductsCategories');
      });
    },
    editCategory: function editCategory() {
      var _this3 = this;

      this.loading = true;
      this.$store.dispatch('editProductCategory', { id: this.selectedCategory.id,
        parent_id: this.selectedParentCategory !== null ? this.selectedParentCategory.id : null
      }).then(function () {
        _this3.$store.dispatch('getProductsCategories');
        _this3.loading = false;
      }, function () {
        _this3.$store.dispatch('getProductsCategories');
        _this3.loading = false;
      });
    },
    editItemDataDecorator: function editItemDataDecorator() {
      if (this.selectedCategory) {
        this.itemData.categories_id = this.selectedCategory.id;
      }

      this.editItemData();
    }
  },
  created: function created() {
    var _this4 = this;

    __WEBPACK_IMPORTED_MODULE_4__api_user__["a" /* default */].loadUsers().then(function (result) {
      _this4.usersList = result;
    }, function () {});
  }
});

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_EditResourceDialog__ = __webpack_require__(26);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      resource: 'roles'
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_EditResourceDialog__["a" /* default */]]
});

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_EditResourceDialog__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_permissions__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_resources_roles__ = __webpack_require__(138);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import _ from 'lodash'

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    roleId: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      resource: 'roles',
      permissionsList: [],
      selectedPermissions: [],
      dialogPermissions: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_EditResourceDialog__["a" /* default */]],
  watch: {
    dialogResult: function dialogResult(val) {
      if (this.roleId > 0 && val) {
        this.dialogPermissions = true;
      }

      if (!val) {
        this.dialogPermissions = false;
      }
    },
    roleId: function roleId(newVal) {
      var _this = this;

      this.changedItemIdAction(newVal);

      this.selectedPermissions = [];

      if (newVal > 0) {
        __WEBPACK_IMPORTED_MODULE_2__api_resources_roles__["a" /* default */].loadRolePermissions(newVal).then(function (result) {
          result.forEach(function (item, i) {
            _this.permissionsList.forEach(function (permission, index) {
              if (permission.id === item.id) {
                _this.selectedPermissions.push(permission.id);
              }
            });
          });

          _this.permissionsList.sort(function (current, next) {
            return current.text > next.text;
          });
        }, function () {});
      }
    },
    selectedPermissions: function selectedPermissions() {
      this.itemData.permissions = this.selectedPermissions;
    }
  },
  methods: {
    setEditItemIdPermissionsZero: function setEditItemIdPermissionsZero() {
      this.$store.dispatch('setEditItemIdPermissions', 0);
    }
  },
  created: function created() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_1__api_resources_permissions__["a" /* default */].loadPermissions().then(function (result) {
      _this2.permissionsList = result;
      /*
      this.permissionsList = _.filter(result, (p) => {
        p.text = p.description || p.text
        return p.description != null
      })
      */
    });
  }
});

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_EditResourceDialog__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_ItemTypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ItemCheckList__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ItemCheckList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ItemCheckList__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ItemCheckList: __WEBPACK_IMPORTED_MODULE_2__components_ItemCheckList___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_EditResourceDialog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_ItemTypes__["a" /* default */]],
  data: function data() {
    return {
      resource: 'services'
    };
  },

  computed: {
    itemType: function itemType() {
      return this.serviceTypeID;
    }
  }
});

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_EditResourceDialog__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_resources_roles__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_user__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_resources_inventories__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_resources_services__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_ItemTypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ItemCheckList__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ItemCheckList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_ItemCheckList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_UserServices__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_UserServices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_UserServices__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ItemCheckList: __WEBPACK_IMPORTED_MODULE_7__components_ItemCheckList___default.a,
    UserServices: __WEBPACK_IMPORTED_MODULE_8__components_UserServices___default.a
  },
  data: function data() {
    return {
      coursesTableHeaders: [{ text: 'Course ID', value: 'id' }, { text: 'Percent', value: 'percent' }],
      contactNumberRules: [function (value) {
        var rules = true;

        if (value && value.indexOf(',') >= 0) {
          rules = 'No commas allowed';
        }
        if (value && value.indexOf('.') >= 0) {
          rules = 'No dots allowed';
        }
        if (value && value.indexOf(';') >= 0) {
          rules = 'No semicolons allowed';
        }
        if (value && value.indexOf(' ') >= 0) {
          rules = 'No spaces allowed';
        }
        if (value && /[a-z]/i.test(value)) {
          rules = 'No letters allowed';
        }
        if (value && value[0] !== '+') {
          rules = 'Must start with a plus ("+") sign + country code (e.g. +65 or +60)';
        }

        return rules;
      }],
      emailRules: [function (value) {
        var rules = true;
        if (value && !/\S+@\S+\.\S+/.test(value)) rules = 'Must be a valid email address';
        return rules;
      }],
      photoForUser: null,
      userPhotoIsUploaded: false,
      user_photo_url: false,
      uploadPercentage: 0,
      snackbar: false,
      disabled: {
        uploadPhotoForEmbalmersBtn: false
      },
      vendorIsSelected: false,
      resource: 'users',
      rolesList: [],
      selectedRoles: [],
      servicesVendorsList: [],
      serviceDescription: null,
      servicePrice: null,
      servicesList: [],
      sex: ['Male', 'Female'],
      selectedServices: [],
      inventoriesList: [],
      selectedInventories: [],
      courses: [],
      inventoriesVendorsList: []
    };
  },

  computed: {
    uploadStatus: function uploadStatus() {
      return this.userPhotoIsUploaded ? 'done' : '';
    },
    avatar: function avatar() {
      return this.user_photo_url || this.itemData.avatar || this.$dfsConfig.default_avatar_url;
    },
    coursesCompletitionPercent: function coursesCompletitionPercent(coursesData) {
      var coursesObject = JSON.parse(coursesData);
      var result = 0;

      if (coursesObject) {
        var courses = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(coursesObject);

        var coursesCommonPercents = courses.reduce(function (accumulator, course) {
          var commonEarnedForCourse = coursesObject[course].reduce(function (accumulateEarnedForCourse, courseBlock) {
            accumulateEarnedForCourse += courseBlock.earned_all;

            return accumulateEarnedForCourse;
          }, 0);

          var commonPossibleForCourse = coursesObject[course].reduce(function (accumulatePossibleForCourse, courseBlock) {
            accumulatePossibleForCourse += courseBlock.possible_all;

            return accumulatePossibleForCourse;
          }, 0);

          accumulator += parseInt(commonEarnedForCourse / commonPossibleForCourse * 100);

          return accumulator;
        }, 0);

        result = parseInt(coursesCommonPercents / courses.length);
      }

      return result;
      // return this.itemData.courses_completion_percent ? this.itemData.courses_completion_percent : 0
    }
  },
  watch: {
    itemData: function itemData(newVal) {
      var _this = this;

      this.selectedRoles = [];
      this.inventoriesList = [];
      this.servicesList = [];
      this.selectedInventories = [];
      this.selectedServices = [];

      this.user_photo_url = newVal.avatar || null;

      if (this.itemId > 0) {
        this.courses = this.normalizeCourses(this.itemData.courses_completion_percent);

        if (this._.has(this.itemData, 'service.description')) {
          this.serviceDescription = this._.get(this.itemData, 'service.description');
          this.servicePrice = this._.get(this.itemData, 'service.price');
        }

        __WEBPACK_IMPORTED_MODULE_4__api_resources_inventories__["a" /* default */].loadNotAssociatedVendorsInventories().then(function (result) {
          _this.inventoriesVendorsList = result;
        }, function () {});

        __WEBPACK_IMPORTED_MODULE_5__api_resources_services__["a" /* default */].loadNotAssociatedVendorsServices().then(function (result) {
          _this.servicesVendorsList = result;
        }, function () {});

        __WEBPACK_IMPORTED_MODULE_3__api_user__["a" /* default */].getLinkedRoles(this.itemId).then(function (result) {
          result.forEach(function (item, i) {
            _this.rolesList.forEach(function (role, index) {
              if (role.id === item.id) {
                _this.selectedRoles.push(role.id);
              }
            });
          });
        }, function () {});

        __WEBPACK_IMPORTED_MODULE_3__api_user__["a" /* default */].getLinkedInventories(this.itemId).then(function (result) {
          result.forEach(function (item) {
            item.text = item.name;
            item.value = item.id;
          });

          _this.inventoriesList = result.concat(_this.inventoriesVendorsList);

          _this.selectedInventories = result.map(function (item) {
            return item.id;
          });
        }, function () {
          _this.inventoriesList = _this.inventoriesVendorsList;
        });

        __WEBPACK_IMPORTED_MODULE_3__api_user__["a" /* default */].getLinkedServices(this.itemId).then(function (result) {
          result.forEach(function (item) {
            item.text = item.name;
            item.value = item.id;
          });

          _this.servicesList = result.concat(_this.servicesVendorsList);

          _this.selectedServices = result.map(function (item) {
            return item.id;
          });
        }, function () {
          _this.servicesList = _this.servicesVendorsList;
        });
      }
    },
    selectedRoles: function selectedRoles(newVal) {
      var _this2 = this;

      this.itemData.roles = newVal;

      this.rolesList.forEach(function (item) {
        if (item.name === 'vendor') {
          if (_this2.selectedRoles.includes(item.id)) {
            _this2.vendorIsSelected = true;
          } else {
            _this2.vendorIsSelected = false;
          }
        }
      });
    },
    photoForUser: function photoForUser(photo) {
      var _this3 = this;

      var form = new FormData();
      form.append('avatar', photo);
      this.$store.getters.axios.post(this.$store.getters.config.api_host + '/api/users/' + this.itemData.id + '/avatar', form, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
        }.bind(this)
      }).then(function (result) {
        _this3.user_photo_url = result.data.additional_data;
        _this3.disabled.uploadPhotoForEmbalmersBtn = false;
        _this3.userPhotoIsUploaded = true;
        _this3.snackbar = true;
        setTimeout(function () {
          _this3.userPhotoIsUploaded = false;
        }, 5000);
      });
    }
  },
  methods: {
    normalizeCourses: function normalizeCourses(coursesData) {
      var normalizedCourses = [];
      var coursesObject = JSON.parse(coursesData);

      if (coursesObject) {
        var courses = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(coursesObject);

        normalizedCourses = courses.map(function (course) {
          var commonEarnedForCourse = coursesObject[course].reduce(function (accumulateEarnedForCourse, courseBlock) {
            accumulateEarnedForCourse += courseBlock.earned_all;

            return accumulateEarnedForCourse;
          }, 0);

          var commonPossibleForCourse = coursesObject[course].reduce(function (accumulatePossibleForCourse, courseBlock) {
            accumulatePossibleForCourse += courseBlock.possible_all;

            return accumulatePossibleForCourse;
          }, 0);

          return {
            course_id: course,
            course_completion_percent: parseInt(commonEarnedForCourse / commonPossibleForCourse * 100)
          };
        });
      }

      return normalizedCourses;
    },
    onChange: function onChange(event) {
      this.photoForUser = event.target.files[0];
    },
    editItemDataDecorator: function editItemDataDecorator() {
      if (this.itemData.phone === '') this.itemData.phone = null;
      if (this.itemData.email === '') this.itemData.email = null;

      if (this.serviceDescription) {
        if (this._.has(this.itemData, 'service.id')) {
          this.itemData.service.description = this.serviceDescription;
        } else {
          this.itemData.service = { description: this.serviceDescription };
        }

        if (this.vendorIsSelected) {
          this.itemData.inventories = this.selectedInventories;
          this.itemData.services = this.selectedServices;
          this.itemData.service.price = this.servicePrice;
        }

        this.itemData.service.is_vendor = this.vendorIsSelected;
      }

      this.editItemData();
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_EditResourceDialog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_ItemTypes__["a" /* default */]],
  created: function created() {
    var _this4 = this;

    __WEBPACK_IMPORTED_MODULE_2__api_resources_roles__["a" /* default */].loadRoles().then(function (result) {
      _this4.rolesList = result;
    });
  }
});

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_EditResourceDialog__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_events__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_resources_recipients__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_resources_notifications__ = __webpack_require__(200);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_EditResourceDialog__["a" /* default */]],
  data: function data() {
    return {
      resource: 'notifications/whatsapp',
      notificationRecipients: [],
      eventsList: [],
      selectedRecipients: []
    };
  },

  methods: {
    editItemDataDecorator: function editItemDataDecorator() {
      this.itemData.recipients = this.selectedRecipients;

      this.editItemData();
    }
  },
  watch: {
    itemId: function itemId(newVal, oldVal) {
      var _this = this;

      if (newVal > 0) {
        __WEBPACK_IMPORTED_MODULE_1__api_resources_events__["a" /* default */].loadEvents().then(function (result) {
          _this.eventsList = result;
        });

        __WEBPACK_IMPORTED_MODULE_2__api_resources_recipients__["a" /* default */].loadRecipients().then(function (result) {
          __WEBPACK_IMPORTED_MODULE_3__api_resources_notifications__["a" /* default */].getLinkedRecipients(newVal).then(function (result) {
            result.forEach(function (item, i) {
              _this.selectedRecipients.push(item.id);
            });
          });

          _this.notificationRecipients = result;
        });
      }
    }
  }
});

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);


//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      title: null,
      sbmtText: 'Submit',
      options: {
        color: 'primary'
      }
    };
  },
  methods: {
    open: function open(title, sbmtText, options) {
      var _this = this;

      this.dialog = true;
      this.title = title;
      this.sbmtText = sbmtText;
      this.options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.options, options);
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.resolve = resolve;
        _this.reject = reject;
      });
    },
    agree: function agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel: function cancel() {
      this.reject();
      this.dialog = false;
    }
  }
});

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_resources_cases__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_resources_schedules__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AddLeadFormOld__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AddLeadFormOld___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_AddLeadFormOld__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(4);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AddLeadFormOld: __WEBPACK_IMPORTED_MODULE_5__components_AddLeadFormOld___default.a },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])({
    getEditCrewDialog: 'getEditCrewDialog',
    getEditCrewCaseId: 'getEditCrewCaseId',
    servicesList: 'allServices',
    case: 'getCrewDialogCase',
    usersList: 'allUsersRaw'
  }), {
    approved: function approved() {
      return this.getEditCrewCaseId && this.case && this.case.status === 'approved';
    },
    approvedBtnLabel: function approvedBtnLabel() {
      if (!this.approved) return 'Approve Case, ';
      return '';
    },
    isPreplan: function isPreplan() {
      return this.case && this.case.is_preplan;
    },
    timesSelected: function timesSelected() {
      return this.wakeSendingTime && this.leaveOfficeTime && this.leaveWakeTime && this.leaveFuneralTime;
    }
  }),
  data: function data() {
    return {
      selectedShiftingCrew: [],
      selectedSendingCrew: [],
      selectedFuneralCrew: [],
      snackbar: false,
      leadsUuid: null,
      caseData: null,
      wakeSendingTime: null,
      leaveOfficeTime: null,
      leaveWakeTime: null,
      leaveFuneralTime: null
    };
  },

  filters: {
    filterPalBearers: function filterPalBearers(value, closing) {
      var _this = this;

      return value.filter(function (service) {
        return service.hasOwnProperty('description') && service.description !== null ? service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') === 'casecrew' && _this.usersList.filter(function (i) {
          return i.id === service.users_id;
        }).length > 0 : false;
      });
    }
  },
  watch: {
    getEditCrewCaseId: function getEditCrewCaseId(v) {
      var _this2 = this;

      if (this.getEditCrewCaseId) {
        __WEBPACK_IMPORTED_MODULE_3__api_resources_cases__["a" /* default */].getLead(this.getEditCrewCaseId).then(function (result) {
          _this2.leadsUuid = result[0].leads_id;
          _this2.selectedShiftingCrew = result.filter(function (filtering) {
            return filtering.service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') !== 'casemanager' && filtering.is_closing === 0;
          }).map(function (item) {
            return item.item_id;
          });
          _this2.selectedSendingCrew = result.filter(function (filtering) {
            return filtering.service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') !== 'casemanager' && filtering.is_closing === 1;
          }).map(function (item) {
            return item.item_id;
          });
          _this2.selectedFuneralCrew = result.filter(function (filtering) {
            return filtering.service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') !== 'casemanager' && filtering.is_closing === 2;
          }).map(function (item) {
            return item.item_id;
          });
        }, function () {});
      }
    },
    caseData: function caseData() {
      if (this.caseData.is_preplan) {
        this.isPreplan = true;
        this.selectedShiftingCrew = [];
        this.selectedSendingCrew = [];
        this.selectedFuneralCrew = [];
      }
    }
  },
  methods: {
    limiter: function limiter(e) {
      if (e.length > 999) {
        this.snackbar = true;
        e.pop();
      }
    },
    close: function close() {
      this.$store.commit('switchCrewDialog');
    },
    selectShiftingCrew: function selectShiftingCrew() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api_resources_schedules__["a" /* default */].updatePallbearers(_this3.leadsUuid, _this3.selectedShiftingCrew, 0);

              case 3:
                response = _context.sent;
                return _context.abrupt('return', response);

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);
                return _context.abrupt('return', _context.t0);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 7]]);
      }))();
    },
    selectSendingCrew: function selectSendingCrew() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api_resources_schedules__["a" /* default */].updatePallbearers(_this4.leadsUuid, _this4.selectedSendingCrew, 1);

              case 3:
                response = _context2.sent;
                return _context2.abrupt('return', response);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);
                return _context2.abrupt('return', _context2.t0);

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[0, 7]]);
      }))();
    },
    selectFuneralCrew: function selectFuneralCrew() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api_resources_schedules__["a" /* default */].updatePallbearers(_this5.leadsUuid, _this5.selectedFuneralCrew, 2);

              case 3:
                response = _context3.sent;
                return _context3.abrupt('return', response);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);
                return _context3.abrupt('return', _context3.t0);

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[0, 7]]);
      }))();
    },
    approveCase: function approveCase() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return _this6.$store.dispatch('approveCase', _this6.getEditCrewCaseId);

              case 3:
                response = _context4.sent;
                return _context4.abrupt('return', response);

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4['catch'](0);
                return _context4.abrupt('return', _context4.t0);

              case 10:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[0, 7]]);
      }))();
    },
    getCaseInvoices: function getCaseInvoices() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return _this7.$store.dispatch('getCaseInvoices', _this7.getEditCrewCaseId);

              case 3:
                response = _context5.sent;
                return _context5.abrupt('return', response);

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5['catch'](0);
                return _context5.abrupt('return', _context5.t0);

              case 10:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7, [[0, 7]]);
      }))();
    },
    setTimes: function setTimes() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var data, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                data = {
                  wake_sending_time: _this8.wakeSendingTime,
                  leave_office_time: _this8.leaveOfficeTime,
                  leave_wake_time: _this8.leaveWakeTime,
                  leave_funeral_time: _this8.leaveFuneralTime
                };
                _context6.next = 4;
                return _this8.$axios.post(_this8.$store.getters.config.api_host + '/api/cases/' + _this8.getEditCrewCaseId + '/times', data);

              case 4:
                response = _context6.sent;
                return _context6.abrupt('return', response);

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6['catch'](0);
                return _context6.abrupt('return', _context6.t0);

              case 11:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this8, [[0, 8]]);
      }))();
    },
    selectCrew: function selectCrew() {
      var _this9 = this;

      var approve = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var updateShiftingCrew, updateSendingCrew, updateFuneralCrew, setTimes, approveCase, getInvoices;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _this9.selectShiftingCrew();

              case 2:
                updateShiftingCrew = _context7.sent;
                _context7.next = 5;
                return _this9.selectSendingCrew();

              case 5:
                updateSendingCrew = _context7.sent;
                _context7.next = 8;
                return _this9.selectFuneralCrew();

              case 8:
                updateFuneralCrew = _context7.sent;
                _context7.next = 11;
                return _this9.setTimes();

              case 11:
                setTimes = _context7.sent;
                approveCase = false;
                getInvoices = false;

                if (!approve) {
                  _context7.next = 23;
                  break;
                }

                _context7.next = 17;
                return _this9.approveCase();

              case 17:
                approveCase = _context7.sent;
                _context7.next = 20;
                return _this9.getCaseInvoices();

              case 20:
                getInvoices = _context7.sent;
                _context7.next = 25;
                break;

              case 23:
                approveCase = true;
                getInvoices = true;

              case 25:

                if (updateShiftingCrew && updateSendingCrew && updateFuneralCrew && approveCase && getInvoices && setTimes) {
                  setTimeout(function () {
                    // this.$store.dispatch('loadAllCases')
                    location.reload();
                  }, 5000);
                  _this9.$store.commit('switchCrewDialog');
                }

              case 26:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this9);
      }))();
    },
    submit: function submit() {
      this.selectCrew(!this.approved);
    },
    filterPalBearers: function filterPalBearers(value, closing) {
      var _this10 = this;

      return value.filter(function (service) {
        return service.hasOwnProperty('description') && service.description !== null ? service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') === 'casecrew' && _this10.usersList.filter(function (i) {
          return i.id === service.users_id;
        }).length > 0 && _this10.usersList.find(function (i) {
          return i.id === service.users_id;
        }).roles.length > 0 && _this10.usersList.find(function (i) {
          return i.id === service.users_id;
        }).roles.filter(function (r) {
          return r.name === 'case-crew';
        }).length > 0 : false;
      });
    }
  },
  created: function created() {
    if (!this.$can('view', 'vendor') && this.$store.state.users.allUsers.length === 0) this.$store.dispatch('getAllUsers');
    if (this.$store.state.services.all.length === 0) this.$store.dispatch('getAllServices');
  }
});

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    users: 'caseManagers',
    allCompletedCases: 'getAllCompletedGroupedCases'
  }), {
    managerName: function managerName() {
      var _this = this;

      return this.selectedUser && this.users.find(function (i) {
        return i.id === _this.selectedUser;
      }) ? this.users.find(function (i) {
        return i.id === _this.selectedUser;
      }).name : null;
    }
  }),
  data: function data() {
    return {
      menu: false,
      menu1: false,
      fromDate: null,
      toDate: null,
      expand: false,
      selectedUser: null,
      completedCases: [],
      analyticHeaders: [{ text: 'User', value: 'user.name' }, { text: 'Completed Cases', value: 'cases.length' }, { text: 'Commission', value: 'commission' }],
      loading: true
    };
  },

  watch: {
    selectedUser: function selectedUser(user) {
      this.filterCases();
    },
    fromDate: function fromDate() {
      this.filterCases();
    },
    toDate: function toDate() {
      this.filterCases();
    }
  },
  methods: {
    mapCases: function mapCases(cases) {
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(cases, function (u) {
        return {
          id: u[0].user.id,
          manager_name: u[0].manager_name,
          user: u[0].user,
          cases: u,
          commission: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sumBy(u, 'commissions')
        };
      });
    },
    filterCases: function filterCases() {
      this.completedCases = this.mapCases(this.allCompletedCases(this.fromDate, this.toDate, this.managerName));
    },
    getWakeLocation: function getWakeLocation(answers) {
      var parsed = JSON.parse(answers[0].answer);
      return parsed.form_answers.main_form.deceased_location_of_wake;
    },
    exportToCSV: function exportToCSV(cases) {
      var _this2 = this;

      var rows = [];
      rows.push(['Case ID', 'Case Wake Date', 'Services', 'Location of Wake', 'Commission']);
      cases.forEach(function (item) {
        rows.push([item.id, item.wake_end, _this2.getServices(item.services), _this2.getWakeLocation(item.answers), item.commissions]);
      });

      var userName = cases[0].user.name.toLowerCase().replace(/ /g, '_');
      var periodStart = this.fromDate ? this.fromDate.toLowerCase().replace(/ /g, '_') : null;
      var periodEnd = this.toDate ? this.toDate.toLowerCase().replace(/ /g, '_') : null;
      var period = '';
      if (periodStart) period += '_from_' + periodStart;
      if (periodEnd) period += '_to_' + periodEnd;

      var csvContent = 'data:text/csv;charset=utf-8,' + rows.map(function (e) {
        return e.join(',');
      }).join('\n');
      var encodedUri = encodeURI(csvContent);
      // window.open(encodedUri)

      var link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      link.setAttribute('download', userName + '_commissions' + period + '.csv');
      document.body.appendChild(link);

      link.click();
    },
    getServices: function getServices(services) {
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(services, 'service.name').join('+');
    }
  },
  created: function created() {
    var _this3 = this;

    this.$store.dispatch('loadAllCases').then(function () {
      _this3.loading = false;
      _this3.completedCases = _this3.mapCases(_this3.allCompletedCases(null, null, null));
    });
    if (this.users.length === 0) this.$store.dispatch('getCaseManagers');
    if (this.$store.state.plans.all.length === 0) this.$store.dispatch('getAllPlans');
    if (this.$store.state.products.categories.length === 0) this.$store.dispatch('getProductsCategories');
    if (this.$store.state.products.all.length === 0) this.$store.dispatch('getAllProducts');
    if (this.$store.state.products.caskets.length === 0) this.$store.dispatch('getAllProducts');
  }
});

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_resources_vendors__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_AppEditCasesDialog__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_AppEditCasesDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_dialogs_AppEditCasesDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_ConfirmationDialog__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_ConfirmationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_dialogs_ConfirmationDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dialogs_CrewDialog__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dialogs_CrewDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_dialogs_CrewDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(4);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import resourcesMixins from '@/mixins/Resources'

// import casesAPI from '@/api/resources/cases'






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Cases',
  components: { AppEditCasesDialog: __WEBPACK_IMPORTED_MODULE_4__components_dialogs_AppEditCasesDialog___default.a, ConfirmationDialog: __WEBPACK_IMPORTED_MODULE_5__components_dialogs_ConfirmationDialog___default.a, CrewDialog: __WEBPACK_IMPORTED_MODULE_6__components_dialogs_CrewDialog___default.a },
  // mixins: [ resourcesMixins ],
  data: function data() {
    return {
      resources: 'cases',
      items: [],
      vendorItemsPromise: null,
      tableHeaders: [{ text: 'ID', value: 'id' }, { text: 'Invoice Number', value: 'invoice_number' }, { text: 'Location of Wake', value: 'deceased_location_of_wake' }, { text: 'Plan', value: 'plans_id' }, { text: 'Case manager', value: 'users_id' }, { text: 'Funeral Date', value: 'wake_end' }, { text: 'Status', value: 'status' }, { text: 'Actions', value: 'actions' }],
      caseID: 0,
      currentUserServiceId: 0,
      clientName: '',
      dialogOpen: false,
      dialogMessage: '',
      vendorInventories: [],
      disabled: {
        sendReceiptToClient: false
      },
      vendorServices: [],
      rowsPerPageItems: [10, 20, 30, 40, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }],
      pagination: {
        descending: true,
        rowsPerPage: 10,
        sortBy: 'created_at',
        current: 1,
        total: 1
      },
      loadingInProgress: true,
      loadingItemsText: 'Loading data',
      showAlert: false,
      alertMessage: null
    };
  },

  watch: {
    getEditCrewDialog: function getEditCrewDialog(v) {
      // if (!v) this.loadListing()
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapGetters */])({
    getEditCrewDialog: 'getEditCrewDialog'
  }), {
    isVendor: function isVendor() {
      return this.$store.getters.currentUserRoles.includes('vendor');
    },
    vendorInventoriesIDs: function vendorInventoriesIDs() {
      return this.vendorInventories.map(function (item) {
        return item.id;
      });
    },
    vendorServicesIDs: function vendorServicesIDs() {
      return this.vendorServices.map(function (item) {
        return item.id;
      });
    }
  }),
  methods: {
    sendReceiptToClient: function sendReceiptToClient(caseId) {
      var _this = this;

      this.$refs.confirm.open('Are you sure?', 'Send', {}).then(function (confirm) {
        _this.sendRequest(caseId);
      });
    },
    sendRequest: function sendRequest(caseId) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var apiUrl, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                apiUrl = _this2.$store.getters.config.api_host;
                _context.next = 3;
                return _this2.$axios.post(apiUrl + '/api/cases/' + caseId + '/client/receipt/email');

              case 3:
                response = _context.sent;

                if (response) {
                  _this2.alertMessage = 'Receipt successfully sent!';
                  _this2.showAlert = true;
                  setTimeout(function () {
                    _this2.showAlert = false;
                  }, 2000);
                }

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    handleLoadListingResult: function handleLoadListingResult(result) {
      var _this3 = this;

      this.items = [];
      result.forEach(function (item, i) {
        if (_this3.isVendor && _this3.checkVendorAccessForItem(item) || !_this3.isVendor) {
          item = _this3.parseOnBoardForm(item);
          _this3.items.push(item);
        }
        if (i === result.length - 1 && _this3.items.length === 0) {
          _this3.setNoItemsLoaded();
        }
      });
    },
    parseOnBoardForm: function parseOnBoardForm(item) {
      item.deceased_location_of_wake = '-';
      item.deceased_date = '-';

      if (item.answers !== undefined && item.answers.length > 0) {
        var answers = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.sortBy(item.answers, 'created_at').reverse();
        var lastOnBoardForm = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.find(answers, function (f) {
          return f.form.name === 'OnBoardClient';
        });
        if (lastOnBoardForm) {
          var onBoardForm = JSON.parse(lastOnBoardForm.answer).form_answers;
          item.deceased_location_of_wake = onBoardForm.main_form.deceased_location_of_wake;
          item.deceased_date = onBoardForm.main_form.deceased_date;
        }
      }

      return item;
    },
    checkVendorAccessForItem: function checkVendorAccessForItem(caseRecord) {
      var _this4 = this;

      // let inventoriesIDs = caseRecord.inventories.map(item => item.id)
      var servicesIDs = caseRecord.services.map(function (item) {
        return item.id;
      });
      //
      // if (inventoriesIDs.some(item => this.vendorInventoriesIDs.includes(item))) {
      //   return true
      // }

      return servicesIDs.some(function (item) {
        return _this4.vendorServicesIDs.includes(item);
      });
    },
    goCasesDetail: function goCasesDetail(itemId) {
      this.$router.push({
        name: 'CasesDetail',
        params: { id: itemId }
      });
    },
    goCasesDetailCheckListsTab: function goCasesDetailCheckListsTab(itemId) {
      this.$router.push({
        name: 'CasesDetail',
        params: { id: itemId, goToCheckListsTab: true }
      });
    },
    goCasesDetailInvoicesTab: function goCasesDetailInvoicesTab(itemId) {
      this.$router.push({
        name: 'CasesDetail',
        params: { id: itemId, goToInvoicesTab: true }
      });
    },
    loadListingSuccess: function loadListingSuccess(result) {
      var _this5 = this;

      if (this.isVendor) {
        this.vendorItemsPromise.then(function (vendorResult) {
          _this5.vendorInventories = vendorResult.inventories;
          _this5.vendorServices = vendorResult.services;

          _this5.handleLoadListingResult(result);
        }, function () {});
      } else {
        this.handleLoadListingResult(result);
      }
    },
    onPageChange: function onPageChange() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this6.loadingInProgress = true;
                _context2.next = 3;
                return _this6.$axios.get(_this6.$store.getters.config.api_host + '/api/cases/paginated?page=' + _this6.pagination.current);

              case 3:
                response = _context2.sent;

                if (response) {
                  _this6.handleLoadListingResult(response.data.additional_data.data);
                  // this.items = response.data.additional_data.data
                  _this6.pagination.total = response.data.additional_data.last_page;
                  _this6.loadingInProgress = false;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },
    loadCases: function loadCases() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this7.$axios.get(_this7.$store.getters.config.api_host + '/api/cases/paginated?page=' + _this7.pagination.current);

              case 2:
                response = _context3.sent;

                if (response) {
                  _this7.handleLoadListingResult(response.data.additional_data.data);
                  // this.items = response.data.additional_data.data
                  _this7.pagination.total = response.data.additional_data.last_page;
                  _this7.loadingInProgress = false;
                }

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this7);
      }))();
    }
  },
  created: function created() {
    if (this.isVendor) {
      this.vendorItemsPromise = __WEBPACK_IMPORTED_MODULE_3__api_resources_vendors__["a" /* default */].getVendorItems(this.$store.getters.currentUser.id);
    }
  },
  mounted: function mounted() {
    this.loadCases();
  },

  props: {
    detailCaseButtonActionIsDefault: {
      type: Boolean,
      default: false,
      required: false
    },
    detailCaseButtonActionIsGoToCheckListsTab: {
      type: Boolean,
      default: false,
      required: false
    },
    detailCaseButtonActionIsGoToInvoicesTab: {
      type: Boolean,
      default: false,
      required: false
    },
    crewSelecting: {
      type: Boolean,
      default: false,
      required: false
    }
  }
});

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_AddBookingButton__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_AddBookingButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_buttons_AddBookingButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditBookingsDialog__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditBookingsDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditBookingsDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Resources__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_resources_crud__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_ItemTypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_ConfirmationDialog__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_ConfirmationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_dialogs_ConfirmationDialog__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Bookings',
  components: { AddBookingButton: __WEBPACK_IMPORTED_MODULE_0__components_buttons_AddBookingButton___default.a, AppEditBookingsDialog: __WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditBookingsDialog___default.a, ConfirmationDialog: __WEBPACK_IMPORTED_MODULE_5__components_dialogs_ConfirmationDialog___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Resources__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_ItemTypes__["a" /* default */]],
  data: function data() {
    return {
      resources: 'schedules',
      items: [],
      tableHeaders: [{ text: 'ID', value: 'id' }, { text: 'Case ID', value: 'cases_id' }, { text: 'Name', value: 'item_id' }, { text: 'Role', value: 'service.description' }, { text: 'From', value: 'schedule_start' }, { text: 'To', value: 'schedule_end' }, { text: 'Created at', value: 'created_at' }, { text: 'Updated at', value: 'updated_at' }, { text: 'Actions', value: 'actions' }]
    };
  },

  methods: {
    deleteDialog: function deleteDialog(id) {
      var _this = this;

      this.$refs.confirm.open('Are you sure?', 'Delete', {}).then(function (confirm) {
        _this.deleteElement(id);
      });
    },
    loadListingSuccess: function loadListingSuccess(result) {
      var _this2 = this;

      this.items = [];

      result.forEach(function (item, i) {
        var res = _this2.itemTypeStringify(parseInt(item.item_type));

        __WEBPACK_IMPORTED_MODULE_3__api_resources_crud__["a" /* default */].dfsResourceShow(res, item.item_id).then(function (result) {
          item.item_type_name = result.name;

          _this2.items.push(item);
        }, function () {});
      });
    },
    itemTypeStringify: function itemTypeStringify(itemTypeId) {
      var res = '';

      switch (itemTypeId) {
        case this.inventoryTypeID:
          res = 'inventories';
          break;

        case this.serviceTypeID:
          res = 'services';
          break;

        case this.caseManagerTypeID:
          res = 'users';
          break;
      }

      return res;
    }
  }
});

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_resources_vendors__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_resources_cases__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_AppEditCasesDialog__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_AppEditCasesDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_dialogs_AppEditCasesDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dialogs_ConfirmationDialog__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dialogs_ConfirmationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_dialogs_ConfirmationDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_dialogs_CrewDialog__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_dialogs_CrewDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_dialogs_CrewDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(4);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import resourcesMixins from '@/mixins/Resources'








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Cases',
  components: { AppEditCasesDialog: __WEBPACK_IMPORTED_MODULE_5__components_dialogs_AppEditCasesDialog___default.a, ConfirmationDialog: __WEBPACK_IMPORTED_MODULE_6__components_dialogs_ConfirmationDialog___default.a, CrewDialog: __WEBPACK_IMPORTED_MODULE_7__components_dialogs_CrewDialog___default.a },
  // mixins: [ resourcesMixins ],
  data: function data() {
    return {
      resources: 'cases',
      items: [],
      vendorItemsPromise: null,
      tableHeaders: [{ text: 'ID', value: 'id' }, { text: 'Invoice Number', value: 'invoice_number' }, { text: 'Address', value: 'deceased_location_of_wake' }, { text: 'Plan', value: 'plans_id' }, { text: 'Case manager', value: 'users_id' }, { text: 'Funeral date', value: 'deceased_date' }, { text: 'Status', value: 'status' }, { text: 'Actions', value: 'actions' }],
      caseID: 0,
      currentUserServiceId: 0,
      clientName: '',
      dialogOpen: false,
      dialogMessage: '',
      vendorInventories: [],
      disabled: {
        sendQuotationMailToClientBtn: false
      },
      vendorServices: [],
      rowsPerPageItems: [10, 20, 30, 40, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }],
      pagination: {
        descending: true,
        rowsPerPage: 10,
        sortBy: 'created_at',
        current: 1,
        total: 1
      },
      loadingInProgress: true,
      loadingItemsText: 'Loading data',
      showAlert: false,
      alertMessage: null
    };
  },

  watch: {
    getEditCrewDialog: function getEditCrewDialog(v) {
      // if (!v) this.loadListing()
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])({
    getEditCrewDialog: 'getEditCrewDialog'
  }), {
    isVendor: function isVendor() {
      return this.$store.getters.currentUserRoles.includes('vendor');
    },
    vendorInventoriesIDs: function vendorInventoriesIDs() {
      return this.vendorInventories.map(function (item) {
        return item.id;
      });
    },
    vendorServicesIDs: function vendorServicesIDs() {
      return this.vendorServices.map(function (item) {
        return item.id;
      });
    }
  }),
  methods: {
    sendQuotationMailToClient: function sendQuotationMailToClient(caseId) {
      var _this = this;

      this.$refs.confirm.open('Are you sure?', 'Send', {}).then(function (confirm) {
        __WEBPACK_IMPORTED_MODULE_4__api_resources_cases__["a" /* default */].sendQuotationMailToClient(caseId).then(function () {
          // this.disabled.sendQuotationMailToClientBtn = true
          _this.alertMessage = 'Email successfully sent!';
          _this.showAlert = true;
          setTimeout(function () {
            _this.showAlert = false;
          }, 2000);
        }, function () {});
      });
    },
    checkCasePayment: function checkCasePayment(caseId) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var apiUrl, response, paymentData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                apiUrl = _this2.$store.getters.config.api_host;
                _context.next = 3;
                return _this2.$axios.get(apiUrl + '/api/cases/' + caseId);

              case 3:
                response = _context.sent;

                if (!response) {
                  _context.next = 11;
                  break;
                }

                paymentData = response.data && response.data.additional_data && response.data.additional_data[0] && JSON.parse(response.data.additional_data[0].payment_info);

                if (!paymentData) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt('return', paymentData);

              case 10:
                return _context.abrupt('return', { payment_method: null });

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    closeCase: function closeCase(itemId) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var paymentData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.checkCasePayment(itemId);

              case 2:
                paymentData = _context2.sent;

                if (paymentData) {
                  if (paymentData.payment_method) {
                    _this3.$refs.confirm.open('Are you sure?', 'Close case', {}).then(function (confirm) {
                      __WEBPACK_IMPORTED_MODULE_4__api_resources_cases__["a" /* default */].closeCase(itemId).then(function () {
                        _this3.loadCases();
                        /*
                        casesAPI.changeCaseManagerCommissions(itemId).then(() => {
                          this.loadListing()
                        })
                        */
                      }, function () {});
                    });
                  } else {
                    _this3.$refs.confirm.open('Payment method is missing for this case', 'Open Case Details', {}).then(function (confirm) {
                      _this3.goCasesDetail(itemId);
                    });
                  }
                }

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    handleLoadListingResult: function handleLoadListingResult(result) {
      var _this4 = this;

      result.forEach(function (item, i) {
        if (_this4.isVendor && _this4.checkVendorAccessForItem(item) || !_this4.isVendor) {
          item = _this4.parseOnBoardForm(item);
          _this4.items.push(item);
        }

        if (i === result.length - 1 && _this4.items.length === 0) {
          _this4.setNoItemsLoaded();
        }
      });
    },
    parseOnBoardForm: function parseOnBoardForm(item) {
      item.deceased_location_of_wake = '-';
      item.deceased_date = '-';

      if (item.answers !== undefined && item.answers.length > 0) {
        var answers = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.sortBy(item.answers, 'created_at').reverse();
        var lastOnBoardForm = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.find(answers, function (f) {
          return f.form.name === 'OnBoardClient';
        });
        if (lastOnBoardForm) {
          var onBoardForm = JSON.parse(lastOnBoardForm.answer).form_answers;
          item.deceased_location_of_wake = onBoardForm.main_form.deceased_location_of_wake;
          item.deceased_date = onBoardForm.main_form.deceased_date;
        }
      }

      return item;
    },
    checkVendorAccessForItem: function checkVendorAccessForItem(caseRecord) {
      var _this5 = this;

      // let inventoriesIDs = caseRecord.inventories.map(item => item.id)
      var servicesIDs = caseRecord.services.map(function (item) {
        return item.id;
      });
      //
      // if (inventoriesIDs.some(item => this.vendorInventoriesIDs.includes(item))) {
      //   return true
      // }

      return servicesIDs.some(function (item) {
        return _this5.vendorServicesIDs.includes(item);
      });
    },
    goCasesDetail: function goCasesDetail(itemId) {
      this.$router.push({
        name: 'CasesDetail',
        params: { id: itemId }
      });
    },
    goCasesDetailCheckListsTab: function goCasesDetailCheckListsTab(itemId) {
      this.$router.push({
        name: 'CasesDetail',
        params: { id: itemId, goToCheckListsTab: true }
      });
    },
    goCasesDetailInvoicesTab: function goCasesDetailInvoicesTab(itemId) {
      this.$router.push({
        name: 'CasesDetail',
        params: { id: itemId, goToInvoicesTab: true }
      });
    },
    loadListingSuccess: function loadListingSuccess(result) {
      var _this6 = this;

      if (this.isVendor) {
        this.vendorItemsPromise.then(function (vendorResult) {
          _this6.vendorInventories = vendorResult.inventories;
          _this6.vendorServices = vendorResult.services;

          _this6.handleLoadListingResult(result);
        }, function () {});
      } else {
        this.handleLoadListingResult(result);
      }
    },
    deleteCaseElement: function deleteCaseElement(id) {
      var _this7 = this;

      this.$refs.confirm.open('Are you sure?', 'Delete', {}).then(function (confirm) {
        _this7.deleteCase(id);
      });
    },
    deleteCase: function deleteCase(id) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this8.$axios.delete(_this8.$store.getters.config.api_host + '/api/cases/' + id);

              case 2:
                response = _context3.sent;

                if (response) {
                  _this8.loadCases();
                }

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this8);
      }))();
    },
    selectCrew: function selectCrew(id) {
      var _this9 = this;

      var selectedCase = this.items.find(function (i) {
        return i.id === id;
      });
      this.$store.commit('unsetEditCaseCrewId');
      this.$store.commit('setCrewDialogCase', selectedCase);
      setTimeout(function () {
        _this9.$store.commit('setEditCaseCrewId', id);
        _this9.$store.commit('switchCrewDialog');
      }, 500);
    },
    onPageChange: function onPageChange() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this10.loadingInProgress = true;
                _context4.next = 3;
                return _this10.$axios.get(_this10.$store.getters.config.api_host + '/api/cases/paginated?page=' + _this10.pagination.current);

              case 3:
                response = _context4.sent;

                if (response) {
                  _this10.items = response.data.additional_data.data;
                  _this10.pagination.total = response.data.additional_data.last_page;
                  _this10.loadingInProgress = false;
                }

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this10);
      }))();
    },
    loadCases: function loadCases() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this11.$axios.get(_this11.$store.getters.config.api_host + '/api/cases/paginated?page=' + _this11.pagination.current);

              case 2:
                response = _context5.sent;

                if (response) {
                  _this11.items = response.data.additional_data.data;
                  _this11.pagination.total = response.data.additional_data.last_page;
                  _this11.loadingInProgress = false;
                }

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this11);
      }))();
    },
    getAnswerItem: function getAnswerItem(answers, form, field) {
      var parsed = answers[0] ? JSON.parse(answers[0].answer) : null;
      return parsed && parsed.form_answers[form][field] ? parsed.form_answers[form][field].replace(',', ';') : '-';
    }
  },
  created: function created() {
    if (this.isVendor) {
      this.vendorItemsPromise = __WEBPACK_IMPORTED_MODULE_3__api_resources_vendors__["a" /* default */].getVendorItems(this.$store.getters.currentUser.id);
    }
  },
  mounted: function mounted() {
    this.loadCases();
  },

  props: {
    detailCaseButtonActionIsDefault: {
      type: Boolean,
      default: false,
      required: false
    },
    detailCaseButtonActionIsGoToCheckListsTab: {
      type: Boolean,
      default: false,
      required: false
    },
    detailCaseButtonActionIsGoToInvoicesTab: {
      type: Boolean,
      default: false,
      required: false
    },
    crewSelecting: {
      type: Boolean,
      default: false,
      required: false
    }
  }
});

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_AddClientButton__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_AddClientButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_buttons_AddClientButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditClientsDialog__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditClientsDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditClientsDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Resources__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_ConfirmationDialog__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_ConfirmationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_dialogs_ConfirmationDialog__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Clients',
  components: { AddClientButton: __WEBPACK_IMPORTED_MODULE_0__components_buttons_AddClientButton___default.a, AppEditClientsDialog: __WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditClientsDialog___default.a, ConfirmationDialog: __WEBPACK_IMPORTED_MODULE_3__components_dialogs_ConfirmationDialog___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Resources__["a" /* default */]],
  data: function data() {
    return {
      resources: 'clients',
      items: [],
      tableHeaders: [{ text: 'ID', value: 'id' }, { text: 'Name', value: 'name' }, { text: 'Created at', value: 'created_at' }, { text: 'Updated at', value: 'updated_at' }, { text: 'Actions', value: 'actions' }],
      rowsPerPageItems: [10, 20, 30, 40, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }],
      pagination: {
        descending: true,
        rowsPerPage: 10,
        sortBy: 'id'
      }
    };
  },

  methods: {
    deleteDialog: function deleteDialog(id) {
      var _this = this;

      this.$refs.confirm.open('Are you sure?', 'Delete', {}).then(function (confirm) {
        _this.deleteElement(id);
      });
    }
  }
});

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms_TermsInEnglish__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms_TermsInEnglish___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_forms_TermsInEnglish__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_TermsInMandarin__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_TermsInMandarin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_forms_TermsInMandarin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { TermsInEnglish: __WEBPACK_IMPORTED_MODULE_1__components_forms_TermsInEnglish___default.a, TermsInMandarin: __WEBPACK_IMPORTED_MODULE_2__components_forms_TermsInMandarin___default.a },
  props: {
    caseid: {
      type: Number,
      required: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    formData: 'getOnBoardClientFormAnswers',
    editable: 'isOnBoardClientFormAnswersEditable',
    loadingCaseForms: 'getLoadingFormsStatus'
  }), {
    dialogTitle: function dialogTitle() {
      return this.dialogLang === 'en' ? 'Terms & Conditions' : '';
    }
  }),
  watch: {
    valid: function valid(newVal) {
      this.$store.commit('updateMainOnBoardForm', this.localMainForm);
      this.$emit('valid:changed', newVal);
    },
    formData: function formData() {
      this.caseSelected = this.caseid;
      this.localMainForm = this.formData.main_form;
    }
  },
  data: function data() {
    return {
      localMainForm: {},
      valid: false,
      caseSelected: null,
      items: [],
      dateRules: [function (v) {
        return !!v || 'Required';
      }],
      genderRules: [function (v) {
        return !!v || 'Required';
      }],
      deceasedNameRules: [function (v) {
        return !!v || 'Required';
      }],
      ageRules: [function (v) {
        return v >= 0 && v <= 120 || 'Age can be from 1 to 120';
      }, function (v) {
        return !!v || 'Required';
      }],
      deathCertificateNoRules: [function (v) {
        return !!v || 'Required';
      }],
      religionRules: [function (v) {
        return !!v || 'Required';
      }],
      dialectRules: [function (v) {
        return !!v || 'Required';
      }],
      locationOfWakeRules: [function (v) {
        return !!v || 'Required';
      }],
      burialLocations: ['Mandai Crematorium', 'Kong Meng San Phor Kark See Monastery', 'Tse Tho Aum Temple', 'Choa Chu Kang Cemetery Complex'],
      relationshipWithDeceasedRules: [function (v) {
        return !!v || 'Required';
      }],
      termsAndConditionsRules: [function (v) {
        return !!v || 'Required';
      }],
      dialog: false,
      dialogLang: 'en'
    };
  },

  methods: {
    openDialog: function openDialog(lang) {
      this.dialogLang = lang;
      this.dialog = true;
    }
  },
  created: function created() {
    // this[_.camelCase(item.input_id)] = item.answer
    // s.split(/(?=[A-Z])/).join('_').toLowerCase()
    this.localMainForm = this.formData.main_form;
  }
});

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_AddInventoryButton__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_AddInventoryButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_buttons_AddInventoryButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditInventoriesDialog__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditInventoriesDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditInventoriesDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Resources__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_ConfirmationDialog__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_ConfirmationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_dialogs_ConfirmationDialog__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Inventories',
  components: { AddInventoryButton: __WEBPACK_IMPORTED_MODULE_0__components_buttons_AddInventoryButton___default.a, AppEditInventoriesDialog: __WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditInventoriesDialog___default.a, ConfirmationDialog: __WEBPACK_IMPORTED_MODULE_3__components_dialogs_ConfirmationDialog___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Resources__["a" /* default */]],
  data: function data() {
    return {
      resources: 'inventories',
      items: [],
      tableHeaders: [{ text: 'ID', value: 'id' }, { text: 'Name', value: 'name' }, { text: 'Is available', value: 'is_available' }, { text: 'Is external vendor', value: 'is_vendor' }, { text: 'Amount', value: 'amount' }, { text: 'Created at', value: 'created_at' }, { text: 'Updated at', value: 'updated_at' }, { text: 'Actions', value: 'actions' }]
    };
  },

  methods: {
    deleteDialog: function deleteDialog(id) {
      var _this = this;

      this.$refs.confirm.open('Are you sure?', 'Delete', {}).then(function (confirm) {
        _this.deleteElement(id);
      });
    }
  }
});

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    allCases: 'casesWithServicesCommissions',
    categories: 'productsCategories'
  })),
  data: function data() {
    return {
      menu: false,
      menu1: false,
      fromDate: null,
      toDate: null,
      category: null,
      items: [],
      header: [{ text: 'Product', value: 'name' }, { text: 'Quantity', value: 'quantity' }],
      loading: true
    };
  },

  watch: {
    fromDate: function fromDate() {
      this.filterCases();
    },
    toDate: function toDate() {
      this.filterCases();
    },
    category: function category() {
      this.filterCases();
    }
  },
  methods: {
    filterCases: function filterCases() {
      var _this = this;

      var filteredCases = this.allCases;

      if (this.fromDate !== null) {
        filteredCases = filteredCases.filter(function (c) {
          return __WEBPACK_IMPORTED_MODULE_3_moment___default()(c.created_at).format('YYYY-MM-DD') >= __WEBPACK_IMPORTED_MODULE_3_moment___default()(_this.fromDate).format('YYYY-MM-DD');
        });
      }
      if (this.toDate !== null) {
        filteredCases = filteredCases.filter(function (c) {
          return __WEBPACK_IMPORTED_MODULE_3_moment___default()(c.created_at).format('YYYY-MM-DD') <= __WEBPACK_IMPORTED_MODULE_3_moment___default()(_this.toDate).format('YYYY-MM-DD');
        });
      }

      filteredCases = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(filteredCases, ['id']).reverse();

      var allServices = [];
      filteredCases.map(function (item) {
        item.services.map(function (service) {
          return allServices.push(service);
        });
      });

      if (this.category !== null) {
        allServices = allServices.filter(function (service) {
          return service.service && service.service.categories_id === _this.category;
        });
      }

      var services = [];
      allServices.map(function (service) {
        if (service && service.service && service.pivot && service.pivot.quantity > 0) {
          if (services.length > 0 && services.find(function (serviceInServices) {
            return serviceInServices.name === service.service.name;
          })) {
            services.find(function (serviceInServices) {
              return serviceInServices.name === service.service.name;
            }).quantity += service.pivot.quantity;
          } else {
            services.push({ name: service.service.name, quantity: service.pivot.quantity });
          }
        }
      });

      this.items = services;
    },
    exportToCSV: function exportToCSV(cases) {
      var rows = [];
      rows.push(['Product', 'Quantity']);
      cases.forEach(function (item) {
        rows.push([item.name, item.quantity]);
      });

      var periodStart = this.fromDate ? this.fromDate.toLowerCase().replace(/ /g, '_') : null;
      var periodEnd = this.toDate ? this.toDate.toLowerCase().replace(/ /g, '_') : null;
      var period = '';
      if (periodStart) period += '_from_' + periodStart;
      if (periodEnd) period += '_to_' + periodEnd;

      var category = this.category ? this.getCategoryById(this.category) : '';

      var csvContent = 'data:text/csv;charset=utf-8,' + rows.map(function (e) {
        return e.join(',');
      }).join('\n');
      var encodedUri = encodeURI(csvContent);
      // window.open(encodedUri)

      var link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      link.setAttribute('download', category + 'inventory_report' + period + '.csv');
      document.body.appendChild(link);

      link.click();
    },
    getCategoryById: function getCategoryById(id) {
      return (this.categories.find(function (category) {
        return category.id === id;
      }).name + '_').toLowerCase();
    }
  },
  created: function created() {
    var _this2 = this;

    this.$store.dispatch('loadAllCases').then(function () {
      _this2.filterCases();
      _this2.loading = false;
    });
    if (this.$store.state.plans.all.length === 0) this.$store.dispatch('getAllPlans');
    if (this.$store.state.products.categories.length === 0) this.$store.dispatch('getProductsCategories');
    if (this.$store.state.products.all.length === 0) this.$store.dispatch('getAllProducts');
    if (this.$store.state.products.caskets.length === 0) this.$store.dispatch('getAllProducts');
  }
});

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_AppEditNotificationsDialog__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_AppEditNotificationsDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_dialogs_AppEditNotificationsDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Resources__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_Notifications__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AppMainDialog__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AppMainDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_AppMainDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dialogs_ConfirmationDialog__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dialogs_ConfirmationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_dialogs_ConfirmationDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TwilioNotifications',
  components: { AppMainDialog: __WEBPACK_IMPORTED_MODULE_5__components_AppMainDialog___default.a, AppEditTwilioNotificationsDialog: __WEBPACK_IMPORTED_MODULE_2__components_dialogs_AppEditNotificationsDialog___default.a, ConfirmationDialog: __WEBPACK_IMPORTED_MODULE_6__components_dialogs_ConfirmationDialog___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_Resources__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_Notifications__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])({
    roles: 'allRoles',
    getRoleNamesByIds: 'getRoleNamesByIds'
  }), {
    isLeadAddedEvent: function isLeadAddedEvent() {
      var _this = this;

      var ev = this.eventsList.find(function (e) {
        return e.value === _this.selectedEvent;
      });
      return ev !== undefined && ev.text === 'New Lead Added';
    }
  }),
  data: function data() {
    return {
      resources: 'notifications',
      selectedNotificationTypes: null,
      sendToClient: false,
      selectedRoles: [],
      isEmailType: false
    };
  },

  watch: {
    selectedNotificationTypes: function selectedNotificationTypes(v) {
      this.isEmailType = v === 'email';
    }
  },
  methods: {
    deleteDialog: function deleteDialog(id) {
      var _this2 = this;

      this.$refs.confirm.open('Are you sure?', 'Delete', {}).then(function (confirm) {
        _this2.deleteElement(id);
      });
    },
    loadListing: function loadListing() {
      var result = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceIndex(this.resources);

      result.then(this.loadListingSuccess, this.loadListingError);
    },
    pasteVar: function pasteVar(v) {
      this.notificationMessage = this.notificationMessage + v;
    },
    saveNotification: function saveNotification() {
      var _this3 = this;

      var payload = {
        events_id: this.selectedEvent,
        recipients: this.notificationRecipients,
        subject: this.notificationSubject,
        message: this.notificationMessage,
        vendor: this.selectedNotificationTypes,
        is_active: this.notificationIsActive,
        send_to_client: this.sendToClient,
        roles: this.selectedRoles
      };

      var save = __WEBPACK_IMPORTED_MODULE_1__api_resources_crud__["a" /* default */].dfsResourceStore(this.resources, payload);

      save.then(function (result) {
        _this3.$bus.$emit('resource-added');

        _this3.dialogMessage = 'Successfully added';

        _this3.dialogOpen = true;
      }, function (error) {
        var handle = error; // eslint-disable-line
      });
    }
  },
  beforeCreate: function beforeCreate() {
    this.$store.dispatch('getAllRoles');
  }
});

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_AddPlanButton__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_AddPlanButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_buttons_AddPlanButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_AppEditPlansDialog__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_AppEditPlansDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_dialogs_AppEditPlansDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Resources__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_ConfirmationDialog__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_ConfirmationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_dialogs_ConfirmationDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Plans',
  components: { AddPlanButton: __WEBPACK_IMPORTED_MODULE_1__components_buttons_AddPlanButton___default.a, AppEditPlansDialog: __WEBPACK_IMPORTED_MODULE_2__components_dialogs_AppEditPlansDialog___default.a, ConfirmationDialog: __WEBPACK_IMPORTED_MODULE_4__components_dialogs_ConfirmationDialog___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_Resources__["a" /* default */]],
  data: function data() {
    return {
      resources: 'plans',
      items: [],
      tableHeaders: [{ text: 'ID', value: 'id' }, { text: 'Name', value: 'name' }, { text: 'Price', value: 'price' }, { text: 'Created at', value: 'created_at' }, { text: 'Updated at', value: 'updated_at' }, { text: 'Actions', value: 'actions' }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])({
    casketById: 'getCasketById',
    planById: 'getPlanById'
  })),
  methods: {
    totalPrice: function totalPrice(plan) {
      return plan && plan.price ? parseFloat(plan.price) : plan ? __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.reduce(plan.services, function (sum, s) {
        return sum + parseFloat(s.price) * s.pivot.quantity;
      }, 0) : 0;
    },
    deleteDialog: function deleteDialog(id) {
      var _this = this;

      this.$refs.confirm.open('Are you sure?', 'Delete', {}).then(function (confirm) {
        _this.deleteElement(id);
      });
    }
  },
  mounted: function mounted() {
    if (this.$store.state.products.categories.length === 0) this.$store.dispatch('getProductsCategories');
    if (this.$store.state.products.all.length === 0 || this.$store.state.products.caskets.length === 0) this.$store.dispatch('getAllProducts');
  }
});

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_AddProductButton__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_AddProductButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_buttons_AddProductButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_AppEditProductsDialog__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_AppEditProductsDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_dialogs_AppEditProductsDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Resources__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_ConfirmationDialog__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_ConfirmationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_dialogs_ConfirmationDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Products',
  components: { AddProductButton: __WEBPACK_IMPORTED_MODULE_1__components_buttons_AddProductButton___default.a, AppEditProductsDialog: __WEBPACK_IMPORTED_MODULE_2__components_dialogs_AppEditProductsDialog___default.a, ConfirmationDialog: __WEBPACK_IMPORTED_MODULE_4__components_dialogs_ConfirmationDialog___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_Resources__["a" /* default */]],
  data: function data() {
    return {
      resources: 'products',
      categorySearch: null,
      tableHeaders: [{ text: 'ID', value: 'id' }, { text: 'Name', value: 'name' }, { text: 'Unit Price ($)', value: 'price' }, { text: 'Commission', value: 'commission' }, { text: 'Default amount', value: 'amount' }, { text: 'Category', value: 'category' }, { text: 'Vendor', value: 'vendor' }, { text: 'Actions', value: 'actions' }],
      rowsPerPageItems: [10, 20, 30, 40, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }],
      pagination: {
        descending: true,
        rowsPerPage: 10,
        sortBy: 'id'
      },
      loadingOrNoItemsText: 'Loading items...'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])({
    products: 'filteredProducts',
    removeCasketsFromServices: 'removeCasketsFromServices',
    categoriesList: 'productsCategories',
    categoryById: 'getProductCategoryById'
  })),
  watch: {
    products: function products(newItems) {
      this.loadingInProgress = false;
      if (newItems.length === 0) {
        this.loadingOrNoItemsText = 'No items';
      }
    }
  },
  methods: {
    filterByCategory: function filterByCategory(category) {
      this.$store.dispatch('filterProducts', category === undefined ? null : category);
    },
    deleteDialog: function deleteDialog(id) {
      var _this = this;

      this.$refs.confirm.open('Are you sure?', 'Delete', {}).then(function (confirm) {
        _this.deleteElement(id);
      });
    },
    loadListing: function loadListing() {
      var _this2 = this;

      this.$store.dispatch('getAllProducts').then(function () {
        _this2.loadingInProgress = false;
      });
    }
  },
  created: function created() {
    if (this.$store.state.products.categories.length === 0) this.$store.dispatch('getProductsCategories');
    this.loadListing();
  }
});

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_AddRoleButton__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_AddRoleButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_buttons_AddRoleButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditRolesDialog__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditRolesDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditRolesDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_AppEditRolesPermissionsDialog__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_AppEditRolesPermissionsDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_dialogs_AppEditRolesPermissionsDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Resources__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_ConfirmationDialog__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_ConfirmationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_dialogs_ConfirmationDialog__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Roles',
  components: { AddRoleButton: __WEBPACK_IMPORTED_MODULE_0__components_buttons_AddRoleButton___default.a, AppEditRolesDialog: __WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditRolesDialog___default.a, AppEditRolesPermissionsDialog: __WEBPACK_IMPORTED_MODULE_2__components_dialogs_AppEditRolesPermissionsDialog___default.a, ConfirmationDialog: __WEBPACK_IMPORTED_MODULE_4__components_dialogs_ConfirmationDialog___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_Resources__["a" /* default */]],
  data: function data() {
    return {
      resources: 'roles',
      items: [],
      tableHeaders: [{ text: 'ID', value: 'id' }, { text: 'Name', value: 'name' }, { text: 'Guard', value: 'guard_name' }, { text: 'Created at', value: 'created_at' }, { text: 'Updated at', value: 'updated_at' }, { text: 'Actions', value: 'actions' }]
    };
  },

  methods: {
    editElementPermissions: function editElementPermissions(itemId) {
      this.$store.dispatch('setEditItemIdPermissions', itemId);
    },
    deleteDialog: function deleteDialog(id) {
      var _this = this;

      this.$refs.confirm.open('Are you sure?', 'Delete', {}).then(function (confirm) {
        _this.deleteElement(id);
      });
    }
  }
});

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_epsilon__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_epsilon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_epsilon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])({
    filterCasketFromLinkedProducts: 'filterCasketFromLinkedProducts',
    getCasketById: 'getCasketById',
    getProductById: 'getProductById'
  })),
  data: function data() {
    return {
      menu: false,
      menu1: false,
      fromDate: __WEBPACK_IMPORTED_MODULE_7_moment___default()().startOf('month').format('YYYY-MM-DD'),
      toDate: __WEBPACK_IMPORTED_MODULE_7_moment___default()().endOf('month').format('YYYY-MM-DD'),
      completedCases: [],
      items: [],
      analyticHeaders: [{ text: 'Invoice ID', value: 'id' }, { text: 'Invoice Number', value: 'workcase.invoice_number' }, { text: 'Invoice Date', value: 'created_at' }, { text: 'Invoice Status', value: 'status' }, { text: 'Deceased Name', value: 'workcase.answers.deceased_name' }, { text: 'Coffin Model', value: 'workcase.coffin_name' }, { text: 'Plan Name', value: 'workcase.plan.name' }, { text: 'Death Cert', value: 'workcase.answers.deceased_death_certificate_no' }, { text: 'Location of Wake', value: 'workcase.answers.deceased_location_of_wake' }, { text: 'Ashes Collection', value: 'workcase.answers.ashes_collection' }, { text: 'Ashes Vendor', value: 'workcase.answers.ashes_vendor' },
      // { text: 'New/Return Customer', value: 'new_return_customer' },
      { text: 'Client Name', value: 'workcase.answers.client_name' }, { text: 'Client Mailing Address', value: 'workcase.answers.client_mailing_address' }, { text: 'Client Contact Number', value: 'workcase.answers.client_contact_number' }, { text: 'Client Email Address', value: 'workcase.answers.client_email_address' }, { text: 'Invoice Total', value: 'workcase.answers.Invoice Total' }, { text: 'Payment Mode', value: 'workcase.payment_info.payment_method' }, { text: 'Case Manager', value: 'workcase.manager_name' }, { text: 'Cremation Date/Time', value: 'workcase.manager_name' }, { text: 'Cremation/Burial Location', value: 'workcase.answers.deceased_burial_location' }],
      loading: true
    };
  },

  watch: {
    fromDate: function fromDate() {
      this.requestData();
    },
    toDate: function toDate() {
      this.requestData();
    }
  },
  methods: {
    filterCases: function filterCases() {
      var _this = this;

      var filteredCases = this.allCases;

      if (this.fromDate !== null) {
        filteredCases = filteredCases.filter(function (c) {
          return __WEBPACK_IMPORTED_MODULE_7_moment___default()(c.created_at).format('YYYY-MM-DD') >= __WEBPACK_IMPORTED_MODULE_7_moment___default()(_this.fromDate).format('YYYY-MM-DD');
        });
      }
      if (this.toDate !== null) {
        filteredCases = filteredCases.filter(function (c) {
          return __WEBPACK_IMPORTED_MODULE_7_moment___default()(c.created_at).format('YYYY-MM-DD') <= __WEBPACK_IMPORTED_MODULE_7_moment___default()(_this.toDate).format('YYYY-MM-DD');
        });
      }

      this.completedCases = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.sortBy(filteredCases, ['id']).reverse();
    },
    getClientCreated: function getClientCreated(item) {
      var clientCreated = item.client && item.client.created_at ? __WEBPACK_IMPORTED_MODULE_7_moment___default()(item.client.created_at).format('YYYY-MM-DD') : null;
      var leadCreated = __WEBPACK_IMPORTED_MODULE_7_moment___default()(item.created_at).format('YYYY-MM-DD');
      return clientCreated === leadCreated ? 'New' : 'Return';
    },
    getAnswerItem: function getAnswerItem(answers, form, field) {
      var parsed = answers[0] ? JSON.parse(answers[0].answer) : null;
      return parsed && parsed.form_answers[form][field] ? parsed.form_answers[form][field].replace(',', ';') : '-';
    },
    exportToCSV: function exportToCSV(cases) {
      var _this2 = this;

      var rows = [];
      rows.push(['Invoice ID', 'Invoice Number', 'Invoice Date', 'Invoice Status', 'Deceased Name', 'Coffin Name', 'Plan Name', 'Death Cert', 'Location of Wake', 'Ashes Collection', 'Ashes Vendor', 'Client Name', 'Client Mailing Address', 'Client Contact Number', 'Client Email Address', 'Invoice Total', 'Payment Mode', 'Case Manager', 'Cremation Date/Time', 'Cremation/Burial Location']);

      cases.forEach(function (item) {
        rows.push([item.id, item.workcase.invoice_number, item.created_at, item.status, item.workcase.answers ? _this2.getAnswerItem(item.workcase.answers, 'main_form', 'deceased_name') : '-', item.workcase.casket ? item.workcase.casket.name : '-', item.workcase.plan && item.workcase.plan.name ? item.workcase.plan.name : '-', item.workcase.answers ? _this2.getAnswerItem(item.workcase.answers, 'main_form', 'deceased_death_certificate_no') : '-', item.workcase.answers ? _this2.getAnswerItem(item.workcase.answers, 'main_form', 'deceased_location_of_wake') : '-', item.workcase.answers ? _this2.getAnswerItem(item.workcase.answers, 'agreement_form_data', 'ash_collection_location') : '-', item.workcase.answers ? _this2.getAnswerItem(item.workcase.answers, 'agreement_form_data', 'ash_collection_vendor') : '-', item.workcase.answers ? _this2.getAnswerItem(item.workcase.answers, 'client_form_data', 'name') : '-', item.workcase.answers ? _this2.getAnswerItem(item.workcase.answers, 'client_form_data', 'mailing_address') : '-', item.workcase.answers ? _this2.getAnswerItem(item.workcase.answers, 'client_form_data', 'contact_number') : '-', item.workcase.answers ? _this2.getAnswerItem(item.workcase.answers, 'client_form_data', 'email') : '-', _this2.calculatePriceWithGST(item.workcase.totalPrice), item.workcase.payment_info ? _this2.getPaymentMode(item.workcase.payment_info) : '-', item.workcase.manager_name, _this2.getCremationTime(item), item.workcase.answers ? _this2.getAnswerItem(item.workcase.answers, 'main_form', 'deceased_burial_location') : '-']);
      });

      var periodStart = this.fromDate ? this.fromDate.toLowerCase().replace(/ /g, '_') : null;
      var periodEnd = this.toDate ? this.toDate.toLowerCase().replace(/ /g, '_') : null;
      var period = '';
      if (periodStart) period += '_from_' + periodStart;
      if (periodEnd) period += '_to_' + periodEnd;

      var csv = rows.map(function (e) {
        return e.join(',');
      }).join('\n');
      var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      var csvUrl = URL.createObjectURL(blob);

      var link = document.createElement('a');
      link.setAttribute('href', csvUrl);
      link.setAttribute('download', 'sales_report' + period + '.csv');
      document.body.appendChild(link);

      link.click();
    },
    getPaymentMode: function getPaymentMode(paymentInfo) {
      var parsed = JSON.parse(paymentInfo);
      return parsed.payment_method;
    },
    getCremationTime: function getCremationTime(item) {
      var date = item.wake_end ? __WEBPACK_IMPORTED_MODULE_7_moment___default()(item.wake_end).format('YYYY-MM-DD') : '-';
      var time = item.leave_funeral_time ? item.leave_funeral_time : '-:-';
      return date + ' ' + time;
    },
    prepareCases: function prepareCases(data) {
      var _this3 = this;

      this.items = data.map(function (item) {
        var totalPrice = 0;
        item.workcase.services = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(item.workcase.services, function (service) {
          var productObj = _this3.getProductById(service.id);
          service.service = productObj;
          service.commission = productObj !== undefined && productObj.commission !== null ? productObj.commission * service.pivot.quantity : 0;
          totalPrice += productObj !== undefined && productObj.commission !== null ? productObj.price * service.pivot.quantity : 0;
          return service;
        });
        var casketID = _this3.filterCasketFromLinkedProducts(item.workcase.services);
        var casket = _this3.getCasketById(casketID);
        var casketCommission = casket && casket.commission ? casket.commission : 0;
        totalPrice += casket && casket.commission ? casket.price : 0;
        item.workcase.commissions = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.sumBy(item.workcase.services, 'commission') + casketCommission;
        item.workcase.casket = casket;
        item.workcase.totalPrice = totalPrice;
        return item;
      });
    },
    requestData: function requestData() {
      var _this4 = this;

      this.loading = true;
      this.$axios.get(this.$store.getters.config.api_host + '/api/invoices/withcases?start=' + this.fromDate + '&end=' + this.toDate).then(function (response) {
        _this4.prepareCases(response.data.additional_data);
        _this4.loading = false;
      });
    },
    calculatePriceWithGST: function calculatePriceWithGST(value) {
      var gst = value / 100 * 8;
      var result = Math.round((value + gst + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_epsilon___default.a) * 100) / 100;
      return result;
    }
  },
  created: function created() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var promises;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              promises = [];

              if (_this5.$store.state.plans.all.length === 0) promises.push(_this5.$store.dispatch('getAllPlans'));
              if (_this5.$store.state.products.categories.length === 0) promises.push(_this5.$store.dispatch('getProductsCategories'));
              if (_this5.$store.state.products.all.length === 0) promises.push(_this5.$store.dispatch('getAllProducts'));
              if (_this5.$store.state.products.caskets.length === 0) promises.push(_this5.$store.dispatch('getAllProducts'));

              __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
                _this5.requestData();
              });

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this5);
    }))();
  }
});

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_AddServiceButton__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_AddServiceButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_buttons_AddServiceButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditServicesDialog__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditServicesDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditServicesDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Resources__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_ConfirmationDialog__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_ConfirmationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_dialogs_ConfirmationDialog__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Services',
  components: { AddServiceButton: __WEBPACK_IMPORTED_MODULE_0__components_buttons_AddServiceButton___default.a, AppEditServicesDialog: __WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditServicesDialog___default.a, ConfirmationDialog: __WEBPACK_IMPORTED_MODULE_3__components_dialogs_ConfirmationDialog___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Resources__["a" /* default */]],
  data: function data() {
    return {
      resources: 'services',
      items: [],
      tableHeaders: [{ text: 'ID', value: 'id' }, { text: 'Name', value: 'name' }, { text: 'Is available', value: 'is_available' }, { text: 'Is external vendor', value: 'is_vendor' }, { text: 'Amount', value: 'amount' }, { text: 'Created at', value: 'created_at' }, { text: 'Updated at', value: 'updated_at' }, { text: 'Actions', value: 'actions' }]
    };
  },

  methods: {
    deleteDialog: function deleteDialog(id) {
      var _this = this;

      this.$refs.confirm.open('Are you sure?', 'Delete', {}).then(function (confirm) {
        _this.deleteElement(id);
      });
    }
  }
});

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_AddUserButton__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_AddUserButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_buttons_AddUserButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_AppEditUsersDialog__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_AppEditUsersDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_dialogs_AppEditUsersDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Resources__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_ConfirmationDialog__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_ConfirmationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_dialogs_ConfirmationDialog__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Users',
  components: { AddUserButton: __WEBPACK_IMPORTED_MODULE_1__components_buttons_AddUserButton___default.a, AppEditUsersDialog: __WEBPACK_IMPORTED_MODULE_2__components_dialogs_AppEditUsersDialog___default.a, ConfirmationDialog: __WEBPACK_IMPORTED_MODULE_4__components_dialogs_ConfirmationDialog___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_Resources__["a" /* default */]],
  data: function data() {
    return {
      resources: 'users',
      items: [],
      tableHeaders: [{ text: 'ID', value: 'id', width: '5%' }, { text: 'Name', value: 'name', width: '22.5%' }, { text: 'Email', value: 'email', width: '22.5%' }, { text: 'Roles', value: 'email', width: '22.5%' }, { text: 'Courses Complete', value: 'email', width: '5%' }, { text: 'Actions', value: 'actions', width: '22.5%' }],
      rowsPerPageItems: [10, 20, 30, 40, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }],
      pagination: {
        descending: true,
        rowsPerPage: 10,
        sortBy: 'id'
      }
    };
  },

  methods: {
    deleteDialog: function deleteDialog(id) {
      var _this = this;

      this.$refs.confirm.open('Are you sure?', 'Delete', {}).then(function (confirm) {
        _this.deleteElement(id);
      });
    },
    calculateCommonCoursesCompletionPercent: function calculateCommonCoursesCompletionPercent(coursesData) {
      var coursesObject = JSON.parse(coursesData);
      var result = 0;

      if (coursesObject) {
        var courses = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(coursesObject);

        var coursesCommonPercents = courses.reduce(function (accumulator, course) {
          var commonEarnedForCourse = coursesObject[course].reduce(function (accumulateEarnedForCourse, courseBlock) {
            accumulateEarnedForCourse += courseBlock.earned_all;

            return accumulateEarnedForCourse;
          }, 0);

          var commonPossibleForCourse = coursesObject[course].reduce(function (accumulatePossibleForCourse, courseBlock) {
            accumulatePossibleForCourse += courseBlock.possible_all;

            return accumulatePossibleForCourse;
          }, 0);

          accumulator += parseInt(commonEarnedForCourse / commonPossibleForCourse * 100);

          return accumulator;
        }, 0);

        result = parseInt(coursesCommonPercents / courses.length);
      }

      return result;
    }
  },
  filters: {
    filterRoleNames: function filterRoleNames(val) {
      return val.map(function (mapping) {
        return mapping.name;
      }).join();
    }
  }
});

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_resources_crud__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditWhatsappNotificationsDialog__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditWhatsappNotificationsDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditWhatsappNotificationsDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Resources__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Notifications__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AppMainDialog__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AppMainDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_AppMainDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_ConfirmationDialog__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_ConfirmationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_dialogs_ConfirmationDialog__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'WhatsappNotifications',
  components: { AppMainDialog: __WEBPACK_IMPORTED_MODULE_4__components_AppMainDialog___default.a, AppEditWhatsappNotificationsDialog: __WEBPACK_IMPORTED_MODULE_1__components_dialogs_AppEditWhatsappNotificationsDialog___default.a, ConfirmationDialog: __WEBPACK_IMPORTED_MODULE_5__components_dialogs_ConfirmationDialog___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Resources__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_Notifications__["a" /* default */]],
  data: function data() {
    return {
      resources: 'notifications/whatsapp'
    };
  },

  methods: {
    deleteDialog: function deleteDialog(id) {
      var _this = this;

      this.$refs.confirm.open('Are you sure?', 'Delete', {}).then(function (confirm) {
        _this.deleteElement(id);
      });
    },
    loadListing: function loadListing() {
      var result = __WEBPACK_IMPORTED_MODULE_0__api_resources_crud__["a" /* default */].dfsResourceIndex(this.resources);

      result.then(this.loadListingSuccess, this.loadListingError);
    },
    saveNotification: function saveNotification() {
      var _this2 = this;

      var payload = {
        events_id: this.selectedEvent,
        recipients: this.notificationRecipients,
        message: this.notificationMessage,
        vendor: 'whatsapp',
        is_active: this.notificationIsActive
      };

      var save = __WEBPACK_IMPORTED_MODULE_0__api_resources_crud__["a" /* default */].dfsResourceStore(this.resources, payload);

      save.then(function (result) {
        _this2.$bus.$emit('resource-added');

        _this2.dialogMessage = 'Successfully added';

        _this2.dialogOpen = true;
      }, function (error) {
        var handle = error; // eslint-disable-line
      });
    }
  }
});

/***/ }),
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 813 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 814 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 815 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 816 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 817 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 818 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 819 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 820 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 821 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 822 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 823 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 824 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 825 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 826 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 827 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 828 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 829 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 830 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 831 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 832 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 833 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 834 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 835 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 836 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 837 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 838 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 839 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 840 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 841 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 842 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 843 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 844 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 845 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 846 */,
/* 847 */,
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 257,
	"./af.js": 257,
	"./ar": 264,
	"./ar-dz": 258,
	"./ar-dz.js": 258,
	"./ar-kw": 259,
	"./ar-kw.js": 259,
	"./ar-ly": 260,
	"./ar-ly.js": 260,
	"./ar-ma": 261,
	"./ar-ma.js": 261,
	"./ar-sa": 262,
	"./ar-sa.js": 262,
	"./ar-tn": 263,
	"./ar-tn.js": 263,
	"./ar.js": 264,
	"./az": 265,
	"./az.js": 265,
	"./be": 266,
	"./be.js": 266,
	"./bg": 267,
	"./bg.js": 267,
	"./bm": 268,
	"./bm.js": 268,
	"./bn": 269,
	"./bn.js": 269,
	"./bo": 270,
	"./bo.js": 270,
	"./br": 271,
	"./br.js": 271,
	"./bs": 272,
	"./bs.js": 272,
	"./ca": 273,
	"./ca.js": 273,
	"./cs": 274,
	"./cs.js": 274,
	"./cv": 275,
	"./cv.js": 275,
	"./cy": 276,
	"./cy.js": 276,
	"./da": 277,
	"./da.js": 277,
	"./de": 280,
	"./de-at": 278,
	"./de-at.js": 278,
	"./de-ch": 279,
	"./de-ch.js": 279,
	"./de.js": 280,
	"./dv": 281,
	"./dv.js": 281,
	"./el": 282,
	"./el.js": 282,
	"./en-SG": 283,
	"./en-SG.js": 283,
	"./en-au": 284,
	"./en-au.js": 284,
	"./en-ca": 285,
	"./en-ca.js": 285,
	"./en-gb": 286,
	"./en-gb.js": 286,
	"./en-ie": 287,
	"./en-ie.js": 287,
	"./en-il": 288,
	"./en-il.js": 288,
	"./en-nz": 289,
	"./en-nz.js": 289,
	"./eo": 290,
	"./eo.js": 290,
	"./es": 293,
	"./es-do": 291,
	"./es-do.js": 291,
	"./es-us": 292,
	"./es-us.js": 292,
	"./es.js": 293,
	"./et": 294,
	"./et.js": 294,
	"./eu": 295,
	"./eu.js": 295,
	"./fa": 296,
	"./fa.js": 296,
	"./fi": 297,
	"./fi.js": 297,
	"./fo": 298,
	"./fo.js": 298,
	"./fr": 301,
	"./fr-ca": 299,
	"./fr-ca.js": 299,
	"./fr-ch": 300,
	"./fr-ch.js": 300,
	"./fr.js": 301,
	"./fy": 302,
	"./fy.js": 302,
	"./ga": 303,
	"./ga.js": 303,
	"./gd": 304,
	"./gd.js": 304,
	"./gl": 305,
	"./gl.js": 305,
	"./gom-latn": 306,
	"./gom-latn.js": 306,
	"./gu": 307,
	"./gu.js": 307,
	"./he": 308,
	"./he.js": 308,
	"./hi": 309,
	"./hi.js": 309,
	"./hr": 310,
	"./hr.js": 310,
	"./hu": 311,
	"./hu.js": 311,
	"./hy-am": 312,
	"./hy-am.js": 312,
	"./id": 313,
	"./id.js": 313,
	"./is": 314,
	"./is.js": 314,
	"./it": 316,
	"./it-ch": 315,
	"./it-ch.js": 315,
	"./it.js": 316,
	"./ja": 317,
	"./ja.js": 317,
	"./jv": 318,
	"./jv.js": 318,
	"./ka": 319,
	"./ka.js": 319,
	"./kk": 320,
	"./kk.js": 320,
	"./km": 321,
	"./km.js": 321,
	"./kn": 322,
	"./kn.js": 322,
	"./ko": 323,
	"./ko.js": 323,
	"./ku": 324,
	"./ku.js": 324,
	"./ky": 325,
	"./ky.js": 325,
	"./lb": 326,
	"./lb.js": 326,
	"./lo": 327,
	"./lo.js": 327,
	"./lt": 328,
	"./lt.js": 328,
	"./lv": 329,
	"./lv.js": 329,
	"./me": 330,
	"./me.js": 330,
	"./mi": 331,
	"./mi.js": 331,
	"./mk": 332,
	"./mk.js": 332,
	"./ml": 333,
	"./ml.js": 333,
	"./mn": 334,
	"./mn.js": 334,
	"./mr": 335,
	"./mr.js": 335,
	"./ms": 337,
	"./ms-my": 336,
	"./ms-my.js": 336,
	"./ms.js": 337,
	"./mt": 338,
	"./mt.js": 338,
	"./my": 339,
	"./my.js": 339,
	"./nb": 340,
	"./nb.js": 340,
	"./ne": 341,
	"./ne.js": 341,
	"./nl": 343,
	"./nl-be": 342,
	"./nl-be.js": 342,
	"./nl.js": 343,
	"./nn": 344,
	"./nn.js": 344,
	"./pa-in": 345,
	"./pa-in.js": 345,
	"./pl": 346,
	"./pl.js": 346,
	"./pt": 348,
	"./pt-br": 347,
	"./pt-br.js": 347,
	"./pt.js": 348,
	"./ro": 349,
	"./ro.js": 349,
	"./ru": 350,
	"./ru.js": 350,
	"./sd": 351,
	"./sd.js": 351,
	"./se": 352,
	"./se.js": 352,
	"./si": 353,
	"./si.js": 353,
	"./sk": 354,
	"./sk.js": 354,
	"./sl": 355,
	"./sl.js": 355,
	"./sq": 356,
	"./sq.js": 356,
	"./sr": 358,
	"./sr-cyrl": 357,
	"./sr-cyrl.js": 357,
	"./sr.js": 358,
	"./ss": 359,
	"./ss.js": 359,
	"./sv": 360,
	"./sv.js": 360,
	"./sw": 361,
	"./sw.js": 361,
	"./ta": 362,
	"./ta.js": 362,
	"./te": 363,
	"./te.js": 363,
	"./tet": 364,
	"./tet.js": 364,
	"./tg": 365,
	"./tg.js": 365,
	"./th": 366,
	"./th.js": 366,
	"./tl-ph": 367,
	"./tl-ph.js": 367,
	"./tlh": 368,
	"./tlh.js": 368,
	"./tr": 369,
	"./tr.js": 369,
	"./tzl": 370,
	"./tzl.js": 370,
	"./tzm": 372,
	"./tzm-latn": 371,
	"./tzm-latn.js": 371,
	"./tzm.js": 372,
	"./ug-cn": 373,
	"./ug-cn.js": 373,
	"./uk": 374,
	"./uk.js": 374,
	"./ur": 375,
	"./ur.js": 375,
	"./uz": 377,
	"./uz-latn": 376,
	"./uz-latn.js": 376,
	"./uz.js": 377,
	"./vi": 378,
	"./vi.js": 378,
	"./x-pseudo": 379,
	"./x-pseudo.js": 379,
	"./yo": 380,
	"./yo.js": 380,
	"./zh-cn": 381,
	"./zh-cn.js": 381,
	"./zh-hk": 382,
	"./zh-hk.js": 382,
	"./zh-tw": 383,
	"./zh-tw.js": 383
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 848;

/***/ }),
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * Signature Pad v2.3.2
 * https://github.com/szimek/signature_pad
 *
 * Copyright 2017 Szymon Nowak
 * Released under the MIT license
 *
 * The main idea and some parts of the code (e.g. drawing variable width Bézier curve) are taken from:
 * http://corner.squareup.com/2012/07/smoother-signatures.html
 *
 * Implementation of interpolation using cubic Bézier curves is taken from:
 * http://benknowscode.wordpress.com/2012/09/14/path-interpolation-using-cubic-bezier-and-control-point-estimation-in-javascript
 *
 * Algorithm for approximated length of a Bézier curve is taken from:
 * http://www.lemoda.net/maths/bezier-length/index.html
 *
 */

function Point(x, y, time) {
  this.x = x;
  this.y = y;
  this.time = time || new Date().getTime();
}

Point.prototype.velocityFrom = function (start) {
  return this.time !== start.time ? this.distanceTo(start) / (this.time - start.time) : 1;
};

Point.prototype.distanceTo = function (start) {
  return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
};

Point.prototype.equals = function (other) {
  return this.x === other.x && this.y === other.y && this.time === other.time;
};

function Bezier(startPoint, control1, control2, endPoint) {
  this.startPoint = startPoint;
  this.control1 = control1;
  this.control2 = control2;
  this.endPoint = endPoint;
}

// Returns approximated length.
Bezier.prototype.length = function () {
  var steps = 10;
  var length = 0;
  var px = void 0;
  var py = void 0;

  for (var i = 0; i <= steps; i += 1) {
    var t = i / steps;
    var cx = this._point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
    var cy = this._point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
    if (i > 0) {
      var xdiff = cx - px;
      var ydiff = cy - py;
      length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
    }
    px = cx;
    py = cy;
  }

  return length;
};

/* eslint-disable no-multi-spaces, space-in-parens */
Bezier.prototype._point = function (t, start, c1, c2, end) {
  return start * (1.0 - t) * (1.0 - t) * (1.0 - t) + 3.0 * c1 * (1.0 - t) * (1.0 - t) * t + 3.0 * c2 * (1.0 - t) * t * t + end * t * t * t;
};

/* eslint-disable */

// http://stackoverflow.com/a/27078401/815507
function throttle(func, wait, options) {
  var context, args, result;
  var timeout = null;
  var previous = 0;
  if (!options) options = {};
  var later = function later() {
    previous = options.leading === false ? 0 : Date.now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  return function () {
    var now = Date.now();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
}

function SignaturePad(canvas, options) {
  var self = this;
  var opts = options || {};

  this.velocityFilterWeight = opts.velocityFilterWeight || 0.7;
  this.minWidth = opts.minWidth || 0.5;
  this.maxWidth = opts.maxWidth || 2.5;
  this.throttle = 'throttle' in opts ? opts.throttle : 16; // in miliseconds
  this.minDistance = 'minDistance' in opts ? opts.minDistance : 5;

  if (this.throttle) {
    this._strokeMoveUpdate = throttle(SignaturePad.prototype._strokeUpdate, this.throttle);
  } else {
    this._strokeMoveUpdate = SignaturePad.prototype._strokeUpdate;
  }

  this.dotSize = opts.dotSize || function () {
    return (this.minWidth + this.maxWidth) / 2;
  };
  this.penColor = opts.penColor || 'black';
  this.backgroundColor = opts.backgroundColor || 'rgba(0,0,0,0)';
  this.onBegin = opts.onBegin;
  this.onEnd = opts.onEnd;

  this._canvas = canvas;
  this._ctx = canvas.getContext('2d');
  this.clear();

  // We need add these inline so they are available to unbind while still having
  // access to 'self' we could use _.bind but it's not worth adding a dependency.
  this._handleMouseDown = function (event) {
    if (event.which === 1) {
      self._mouseButtonDown = true;
      self._strokeBegin(event);
    }
  };

  this._handleMouseMove = function (event) {
    if (self._mouseButtonDown) {
      self._strokeMoveUpdate(event);
    }
  };

  this._handleMouseUp = function (event) {
    if (event.which === 1 && self._mouseButtonDown) {
      self._mouseButtonDown = false;
      self._strokeEnd(event);
    }
  };

  this._handleTouchStart = function (event) {
    if (event.targetTouches.length === 1) {
      var touch = event.changedTouches[0];
      self._strokeBegin(touch);
    }
  };

  this._handleTouchMove = function (event) {
    // Prevent scrolling.
    event.preventDefault();

    var touch = event.targetTouches[0];
    self._strokeMoveUpdate(touch);
  };

  this._handleTouchEnd = function (event) {
    var wasCanvasTouched = event.target === self._canvas;
    if (wasCanvasTouched) {
      event.preventDefault();
      self._strokeEnd(event);
    }
  };

  // Enable mouse and touch event handlers
  this.on();
}

// Public methods
SignaturePad.prototype.clear = function () {
  var ctx = this._ctx;
  var canvas = this._canvas;

  ctx.fillStyle = this.backgroundColor;
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  this._data = [];
  this._reset();
  this._isEmpty = true;
};

SignaturePad.prototype.fromDataURL = function (dataUrl) {
  var _this = this;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var image = new Image();
  var ratio = options.ratio || window.devicePixelRatio || 1;
  var width = options.width || this._canvas.width / ratio;
  var height = options.height || this._canvas.height / ratio;

  this._reset();
  image.src = dataUrl;
  image.onload = function () {
    _this._ctx.drawImage(image, 0, 0, width, height);
  };
  this._isEmpty = false;
};

SignaturePad.prototype.toDataURL = function (type) {
  var _canvas;

  switch (type) {
    case 'image/svg+xml':
      return this._toSVG();
    default:
      for (var _len = arguments.length, options = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        options[_key - 1] = arguments[_key];
      }

      return (_canvas = this._canvas).toDataURL.apply(_canvas, [type].concat(options));
  }
};

SignaturePad.prototype.on = function () {
  this._handleMouseEvents();
  this._handleTouchEvents();
};

SignaturePad.prototype.off = function () {
  this._canvas.removeEventListener('mousedown', this._handleMouseDown);
  this._canvas.removeEventListener('mousemove', this._handleMouseMove);
  document.removeEventListener('mouseup', this._handleMouseUp);

  this._canvas.removeEventListener('touchstart', this._handleTouchStart);
  this._canvas.removeEventListener('touchmove', this._handleTouchMove);
  this._canvas.removeEventListener('touchend', this._handleTouchEnd);
};

SignaturePad.prototype.isEmpty = function () {
  return this._isEmpty;
};

// Private methods
SignaturePad.prototype._strokeBegin = function (event) {
  this._data.push([]);
  this._reset();
  this._strokeUpdate(event);

  if (typeof this.onBegin === 'function') {
    this.onBegin(event);
  }
};

SignaturePad.prototype._strokeUpdate = function (event) {
  var x = event.clientX;
  var y = event.clientY;

  var point = this._createPoint(x, y);
  var lastPointGroup = this._data[this._data.length - 1];
  var lastPoint = lastPointGroup && lastPointGroup[lastPointGroup.length - 1];
  var isLastPointTooClose = lastPoint && point.distanceTo(lastPoint) < this.minDistance;

  // Skip this point if it's too close to the previous one
  if (!(lastPoint && isLastPointTooClose)) {
    var _addPoint = this._addPoint(point),
        curve = _addPoint.curve,
        widths = _addPoint.widths;

    if (curve && widths) {
      this._drawCurve(curve, widths.start, widths.end);
    }

    this._data[this._data.length - 1].push({
      x: point.x,
      y: point.y,
      time: point.time,
      color: this.penColor
    });
  }
};

SignaturePad.prototype._strokeEnd = function (event) {
  var canDrawCurve = this.points.length > 2;
  var point = this.points[0]; // Point instance

  if (!canDrawCurve && point) {
    this._drawDot(point);
  }

  if (point) {
    var lastPointGroup = this._data[this._data.length - 1];
    var lastPoint = lastPointGroup[lastPointGroup.length - 1]; // plain object

    // When drawing a dot, there's only one point in a group, so without this check
    // such group would end up with exactly the same 2 points.
    if (!point.equals(lastPoint)) {
      lastPointGroup.push({
        x: point.x,
        y: point.y,
        time: point.time,
        color: this.penColor
      });
    }
  }

  if (typeof this.onEnd === 'function') {
    this.onEnd(event);
  }
};

SignaturePad.prototype._handleMouseEvents = function () {
  this._mouseButtonDown = false;

  this._canvas.addEventListener('mousedown', this._handleMouseDown);
  this._canvas.addEventListener('mousemove', this._handleMouseMove);
  document.addEventListener('mouseup', this._handleMouseUp);
};

SignaturePad.prototype._handleTouchEvents = function () {
  // Pass touch events to canvas element on mobile IE11 and Edge.
  this._canvas.style.msTouchAction = 'none';
  this._canvas.style.touchAction = 'none';

  this._canvas.addEventListener('touchstart', this._handleTouchStart);
  this._canvas.addEventListener('touchmove', this._handleTouchMove);
  this._canvas.addEventListener('touchend', this._handleTouchEnd);
};

SignaturePad.prototype._reset = function () {
  this.points = [];
  this._lastVelocity = 0;
  this._lastWidth = (this.minWidth + this.maxWidth) / 2;
  this._ctx.fillStyle = this.penColor;
};

SignaturePad.prototype._createPoint = function (x, y, time) {
  var rect = this._canvas.getBoundingClientRect();

  return new Point(x - rect.left, y - rect.top, time || new Date().getTime());
};

SignaturePad.prototype._addPoint = function (point) {
  var points = this.points;
  var tmp = void 0;

  points.push(point);

  if (points.length > 2) {
    // To reduce the initial lag make it work with 3 points
    // by copying the first point to the beginning.
    if (points.length === 3) points.unshift(points[0]);

    tmp = this._calculateCurveControlPoints(points[0], points[1], points[2]);
    var c2 = tmp.c2;
    tmp = this._calculateCurveControlPoints(points[1], points[2], points[3]);
    var c3 = tmp.c1;
    var curve = new Bezier(points[1], c2, c3, points[2]);
    var widths = this._calculateCurveWidths(curve);

    // Remove the first element from the list,
    // so that we always have no more than 4 points in points array.
    points.shift();

    return { curve: curve, widths: widths };
  }

  return {};
};

SignaturePad.prototype._calculateCurveControlPoints = function (s1, s2, s3) {
  var dx1 = s1.x - s2.x;
  var dy1 = s1.y - s2.y;
  var dx2 = s2.x - s3.x;
  var dy2 = s2.y - s3.y;

  var m1 = { x: (s1.x + s2.x) / 2.0, y: (s1.y + s2.y) / 2.0 };
  var m2 = { x: (s2.x + s3.x) / 2.0, y: (s2.y + s3.y) / 2.0 };

  var l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
  var l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);

  var dxm = m1.x - m2.x;
  var dym = m1.y - m2.y;

  var k = l2 / (l1 + l2);
  var cm = { x: m2.x + dxm * k, y: m2.y + dym * k };

  var tx = s2.x - cm.x;
  var ty = s2.y - cm.y;

  return {
    c1: new Point(m1.x + tx, m1.y + ty),
    c2: new Point(m2.x + tx, m2.y + ty)
  };
};

SignaturePad.prototype._calculateCurveWidths = function (curve) {
  var startPoint = curve.startPoint;
  var endPoint = curve.endPoint;
  var widths = { start: null, end: null };

  var velocity = this.velocityFilterWeight * endPoint.velocityFrom(startPoint) + (1 - this.velocityFilterWeight) * this._lastVelocity;

  var newWidth = this._strokeWidth(velocity);

  widths.start = this._lastWidth;
  widths.end = newWidth;

  this._lastVelocity = velocity;
  this._lastWidth = newWidth;

  return widths;
};

SignaturePad.prototype._strokeWidth = function (velocity) {
  return Math.max(this.maxWidth / (velocity + 1), this.minWidth);
};

SignaturePad.prototype._drawPoint = function (x, y, size) {
  var ctx = this._ctx;

  ctx.moveTo(x, y);
  ctx.arc(x, y, size, 0, 2 * Math.PI, false);
  this._isEmpty = false;
};

SignaturePad.prototype._drawCurve = function (curve, startWidth, endWidth) {
  var ctx = this._ctx;
  var widthDelta = endWidth - startWidth;
  var drawSteps = Math.floor(curve.length());

  ctx.beginPath();

  for (var i = 0; i < drawSteps; i += 1) {
    // Calculate the Bezier (x, y) coordinate for this step.
    var t = i / drawSteps;
    var tt = t * t;
    var ttt = tt * t;
    var u = 1 - t;
    var uu = u * u;
    var uuu = uu * u;

    var x = uuu * curve.startPoint.x;
    x += 3 * uu * t * curve.control1.x;
    x += 3 * u * tt * curve.control2.x;
    x += ttt * curve.endPoint.x;

    var y = uuu * curve.startPoint.y;
    y += 3 * uu * t * curve.control1.y;
    y += 3 * u * tt * curve.control2.y;
    y += ttt * curve.endPoint.y;

    var width = startWidth + ttt * widthDelta;
    this._drawPoint(x, y, width);
  }

  ctx.closePath();
  ctx.fill();
};

SignaturePad.prototype._drawDot = function (point) {
  var ctx = this._ctx;
  var width = typeof this.dotSize === 'function' ? this.dotSize() : this.dotSize;

  ctx.beginPath();
  this._drawPoint(point.x, point.y, width);
  ctx.closePath();
  ctx.fill();
};

SignaturePad.prototype._fromData = function (pointGroups, drawCurve, drawDot) {
  for (var i = 0; i < pointGroups.length; i += 1) {
    var group = pointGroups[i];

    if (group.length > 1) {
      for (var j = 0; j < group.length; j += 1) {
        var rawPoint = group[j];
        var point = new Point(rawPoint.x, rawPoint.y, rawPoint.time);
        var color = rawPoint.color;

        if (j === 0) {
          // First point in a group. Nothing to draw yet.

          // All points in the group have the same color, so it's enough to set
          // penColor just at the beginning.
          this.penColor = color;
          this._reset();

          this._addPoint(point);
        } else if (j !== group.length - 1) {
          // Middle point in a group.
          var _addPoint2 = this._addPoint(point),
              curve = _addPoint2.curve,
              widths = _addPoint2.widths;

          if (curve && widths) {
            drawCurve(curve, widths, color);
          }
        } else {
          // Last point in a group. Do nothing.
        }
      }
    } else {
      this._reset();
      var _rawPoint = group[0];
      drawDot(_rawPoint);
    }
  }
};

SignaturePad.prototype._toSVG = function () {
  var _this2 = this;

  var pointGroups = this._data;
  var canvas = this._canvas;
  var ratio = Math.max(window.devicePixelRatio || 1, 1);
  var minX = 0;
  var minY = 0;
  var maxX = canvas.width / ratio;
  var maxY = canvas.height / ratio;
  var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

  svg.setAttributeNS(null, 'width', canvas.width);
  svg.setAttributeNS(null, 'height', canvas.height);

  this._fromData(pointGroups, function (curve, widths, color) {
    var path = document.createElement('path');

    // Need to check curve for NaN values, these pop up when drawing
    // lines on the canvas that are not continuous. E.g. Sharp corners
    // or stopping mid-stroke and than continuing without lifting mouse.
    if (!isNaN(curve.control1.x) && !isNaN(curve.control1.y) && !isNaN(curve.control2.x) && !isNaN(curve.control2.y)) {
      var attr = 'M ' + curve.startPoint.x.toFixed(3) + ',' + curve.startPoint.y.toFixed(3) + ' ' + ('C ' + curve.control1.x.toFixed(3) + ',' + curve.control1.y.toFixed(3) + ' ') + (curve.control2.x.toFixed(3) + ',' + curve.control2.y.toFixed(3) + ' ') + (curve.endPoint.x.toFixed(3) + ',' + curve.endPoint.y.toFixed(3));

      path.setAttribute('d', attr);
      path.setAttribute('stroke-width', (widths.end * 2.25).toFixed(3));
      path.setAttribute('stroke', color);
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke-linecap', 'round');

      svg.appendChild(path);
    }
  }, function (rawPoint) {
    var circle = document.createElement('circle');
    var dotSize = typeof _this2.dotSize === 'function' ? _this2.dotSize() : _this2.dotSize;
    circle.setAttribute('r', dotSize);
    circle.setAttribute('cx', rawPoint.x);
    circle.setAttribute('cy', rawPoint.y);
    circle.setAttribute('fill', rawPoint.color);

    svg.appendChild(circle);
  });

  var prefix = 'data:image/svg+xml;base64,';
  var header = '<svg' + ' xmlns="http://www.w3.org/2000/svg"' + ' xmlns:xlink="http://www.w3.org/1999/xlink"' + (' viewBox="' + minX + ' ' + minY + ' ' + maxX + ' ' + maxY + '"') + (' width="' + maxX + '"') + (' height="' + maxY + '"') + '>';
  var body = svg.innerHTML;

  // IE hack for missing innerHTML property on SVGElement
  if (body === undefined) {
    var dummy = document.createElement('dummy');
    var nodes = svg.childNodes;
    dummy.innerHTML = '';

    for (var i = 0; i < nodes.length; i += 1) {
      dummy.appendChild(nodes[i].cloneNode(true));
    }

    body = dummy.innerHTML;
  }

  var footer = '</svg>';
  var data = header + body + footer;

  return prefix + btoa(data);
};

SignaturePad.prototype.fromData = function (pointGroups) {
  var _this3 = this;

  this.clear();

  this._fromData(pointGroups, function (curve, widths) {
    return _this3._drawCurve(curve, widths.start, widths.end);
  }, function (rawPoint) {
    return _this3._drawDot(rawPoint);
  });

  this._data = pointGroups;
};

SignaturePad.prototype.toData = function () {
  return this._data;
};

/* harmony default export */ __webpack_exports__["a"] = (SignaturePad);


/***/ }),
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(823)
  __webpack_require__(822)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(961),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-13989e06",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(980),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(962),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(1026),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(996),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(975),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(835)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(453),
  /* template */
  __webpack_require__(1013),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-87f65214",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(832)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(454),
  /* template */
  __webpack_require__(993),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-567a495b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(997),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(836)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(456),
  /* template */
  __webpack_require__(1014),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(817)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(457),
  /* template */
  __webpack_require__(952),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(981),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(459),
  /* template */
  __webpack_require__(965),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(837)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(460),
  /* template */
  __webpack_require__(1015),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(462),
  /* template */
  __webpack_require__(1039),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(831)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(463),
  /* template */
  __webpack_require__(991),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(990),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(465),
  /* template */
  __webpack_require__(973),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(819)
}
var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(957),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(840)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(467),
  /* template */
  __webpack_require__(1021),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-af3d2d36",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(839)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(468),
  /* template */
  __webpack_require__(1017),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9e466884",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(845)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(469),
  /* template */
  __webpack_require__(1040),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fb910574",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(826)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(971),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(471),
  /* template */
  __webpack_require__(976),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(820)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(472),
  /* template */
  __webpack_require__(958),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-10d97aa5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(828)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(982),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-38467252",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(842)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(1025),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c7ddbfb8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(834)
  __webpack_require__(833)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(998),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-63094378",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(827)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(979),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-310a0604",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(1009),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(967),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(951),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(483),
  /* template */
  __webpack_require__(945),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(1033),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(1000),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(818)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(486),
  /* template */
  __webpack_require__(953),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(487),
  /* template */
  __webpack_require__(955),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(1032),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(1007),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(1027),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(964),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(493),
  /* template */
  __webpack_require__(974),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(1002),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(844)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(495),
  /* template */
  __webpack_require__(1038),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(496),
  /* template */
  __webpack_require__(1004),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(956),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(498),
  /* template */
  __webpack_require__(1006),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(816)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(499),
  /* template */
  __webpack_require__(949),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(966),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(824)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(501),
  /* template */
  __webpack_require__(968),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(502),
  /* template */
  __webpack_require__(1001),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(841)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(1024),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c3d612ac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(989),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(984),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(508),
  /* template */
  __webpack_require__(1035),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(510),
  /* template */
  __webpack_require__(1008),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(511),
  /* template */
  __webpack_require__(988),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(512),
  /* template */
  __webpack_require__(994),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(829)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(513),
  /* template */
  __webpack_require__(985),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-41c6c68f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(514),
  /* template */
  __webpack_require__(970),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(1005),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(516),
  /* template */
  __webpack_require__(999),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(517),
  /* template */
  __webpack_require__(1028),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(1030),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(843)
}
var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(1036),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e8e97c50",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(978),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(825)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(969),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-25af1598",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(522),
  /* template */
  __webpack_require__(1029),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(523),
  /* template */
  __webpack_require__(950),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(1012),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(977),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(814)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(526),
  /* template */
  __webpack_require__(946),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0103d6c1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(527),
  /* template */
  __webpack_require__(963),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(821)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(528),
  /* template */
  __webpack_require__(959),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-120ff742",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(529),
  /* template */
  __webpack_require__(1011),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(530),
  /* template */
  __webpack_require__(960),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(531),
  /* template */
  __webpack_require__(992),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(532),
  /* template */
  __webpack_require__(1020),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(813)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(944),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-00b6501c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(534),
  /* template */
  __webpack_require__(1018),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(535),
  /* template */
  __webpack_require__(1019),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(536),
  /* template */
  __webpack_require__(987),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 943 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "400px",
      "persistent": "",
      "fullscreen": _vm.isMobile
    },
    model: {
      value: (_vm.dialogModel),
      callback: function($$v) {
        _vm.dialogModel = $$v
      },
      expression: "dialogModel"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "full-width": "",
      "max-width": "290"
    },
    model: {
      value: (_vm.menuDateModel),
      callback: function($$v) {
        _vm.menuDateModel = $$v
      },
      expression: "menuDateModel"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Date",
      "append-icon": "event",
      "rules": [_vm.rules.date],
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateModel),
      callback: function($$v) {
        _vm.dateModel = $$v
      },
      expression: "dateModel"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "min": _vm.minDate,
      "scrollable": ""
    },
    model: {
      value: (_vm.dateModel),
      callback: function($$v) {
        _vm.dateModel = $$v
      },
      expression: "dateModel"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Time",
      "value": "12:30",
      "type": "time"
    },
    model: {
      value: (_vm.timeModel),
      callback: function($$v) {
        _vm.timeModel = $$v
      },
      expression: "timeModel"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "error",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogModel = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.dateValidation(_vm.dateModel)) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "",
      "block": "",
      "loading": _vm.addLoading
    },
    on: {
      "click": _vm.saveNewCase
    }
  }, [_vm._v("Add case")]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 944 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_c('h3', [_vm._v("Sales Report")])]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "md3": "",
      "px-1": "",
      "mt-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "date__picker"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Start Date",
            "prepend-icon": "event",
            "readonly": "",
            "clearable": ""
          },
          model: {
            value: (_vm.fromDate),
            callback: function($$v) {
              _vm.fromDate = $$v
            },
            expression: "fromDate"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "input": function($event) {
        _vm.menu = false
      }
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "md3": "",
      "px-1": "",
      "mt-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "date__picker"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "End Date",
            "prepend-icon": "event",
            "readonly": "",
            "clearable": ""
          },
          model: {
            value: (_vm.toDate),
            callback: function($$v) {
              _vm.toDate = $$v
            },
            expression: "toDate"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu1),
      callback: function($$v) {
        _vm.menu1 = $$v
      },
      expression: "menu1"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "input": function($event) {
        _vm.menu1 = false
      }
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "items": _vm.items,
      "headers": _vm.analyticHeaders,
      "loading": _vm.loading,
      "item-key": "id",
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.workcase.invoice_number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.workcase.answers ? _vm.getAnswerItem(props.item.workcase.answers, 'main_form', 'deceased_name') : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.workcase.casket ? props.item.workcase.casket.name : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item && props.item.workcase && props.item.workcase.plan && props.item.workcase.plan.name ? props.item.workcase.plan.name : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.workcase.answers ? _vm.getAnswerItem(props.item.workcase.answers, 'main_form', 'deceased_death_certificate_no') : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.workcase.answers ? _vm.getAnswerItem(props.item.workcase.answers, 'main_form', 'deceased_location_of_wake') : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.workcase.answers ? _vm.getAnswerItem(props.item.workcase.answers, 'agreement_form_data', 'ash_collection_location') : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.workcase.answers ? _vm.getAnswerItem(props.item.workcase.answers, 'agreement_form_data', 'ash_collection_vendor') : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.workcase.answers ? _vm.getAnswerItem(props.item.workcase.answers, 'client_form_data', 'name') : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.workcase.answers ? _vm.getAnswerItem(props.item.workcase.answers, 'client_form_data', 'mailing_address') : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.workcase.answers ? _vm.getAnswerItem(props.item.workcase.answers, 'client_form_data', 'contact_number') : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.workcase.answers ? _vm.getAnswerItem(props.item.workcase.answers, 'client_form_data', 'email') : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.calculatePriceWithGST(props.item.workcase.totalPrice)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.workcase.payment_info ? _vm.getPaymentMode(props.item.workcase.payment_info) : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.workcase.manager_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getCremationTime(props.item)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.workcase.answers ? _vm.getAnswerItem(props.item.workcase.answers, 'main_form', 'deceased_burial_location') : '-'))])])]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "align-right"
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.exportToCSV(_vm.items)
      }
    }
  }, [_vm._v("Export to CSV")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 945 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('AppAddItemButtonBase', {
    attrs: {
      "itemTypeID": _vm.itemType
    },
    scopedSlots: _vm._u([{
      key: "itemInputField",
      fn: function(props) {
        return [_c('v-text-field', {
          attrs: {
            "placeholder": "Inventory name"
          },
          model: {
            value: (props.model.name),
            callback: function($$v) {
              _vm.$set(props.model, "name", $$v)
            },
            expression: "props.model.name"
          }
        })]
      }
    }])
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("\n    Add Inventory\n  ")])], 2)
},staticRenderFns: []}

/***/ }),
/* 946 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loadingCaseForms) ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": _vm.loadingCaseForms
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loadingCaseForms) ? _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "required"
  }, [_vm._v("Client salutation:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Salutation",
      "items": [
        'Mr',
        'Miss',
        'Mrs',
        'Mdm',
        'Dr'
      ]
    },
    model: {
      value: (_vm.localMainForm.salutation),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "salutation", $$v)
      },
      expression: "localMainForm.salutation"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "required"
  }, [_vm._v("Relationship with deceased:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Relationship with deceased",
      "rules": _vm.relationshipWithDeceasedRules,
      "items": [
        'Husband',
        'Wife',
        'Son',
        'Daughter',
        'Father',
        'Mother',
        'Father in law',
        'Mother in law',
        'Son in law',
        'Daughter in law',
        'Brother',
        'Sister',
        'Brother in law',
        'Sister in law',
        'Uncle',
        'Auntie',
        'Nephew',
        'Niece',
        'Cousin',
        'Friend',
        'Social worker',
        'Others'
      ]
    },
    model: {
      value: (_vm.localMainForm.relationship_with_deceased),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "relationship_with_deceased", $$v)
      },
      expression: "localMainForm.relationship_with_deceased"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "20px",
      "margin-top": "20px"
    }
  }, [_vm._v("Deceased's Details")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "required"
  }, [_vm._v("Date of Death:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-menu', [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "readonly": "",
      "rules": _vm.dateRules
    },
    slot: "activator",
    model: {
      value: (_vm.localMainForm.deceased_date),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_date", $$v)
      },
      expression: "localMainForm.deceased_date"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": ""
    },
    model: {
      value: (_vm.localMainForm.deceased_date),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_date", $$v)
      },
      expression: "localMainForm.deceased_date"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "required"
  }, [_vm._v("Deceased Gender:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": ['M', 'F'],
      "rules": _vm.genderRules
    },
    model: {
      value: (_vm.localMainForm.deceased_gender),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_gender", $$v)
      },
      expression: "localMainForm.deceased_gender"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "required"
  }, [_vm._v("Deceased Name:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "rules": _vm.deceasedNameRules
    },
    model: {
      value: (_vm.localMainForm.deceased_name),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_name", $$v)
      },
      expression: "localMainForm.deceased_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', [_vm._v("Deceased Chinese Name:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    model: {
      value: (_vm.localMainForm.deceased_name_chinese),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_name_chinese", $$v)
      },
      expression: "localMainForm.deceased_name_chinese"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "required"
  }, [_vm._v("Deceased Age:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "rules": _vm.ageRules
    },
    model: {
      value: (_vm.localMainForm.deceased_age),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_age", $$v)
      },
      expression: "localMainForm.deceased_age"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', [_vm._v("Death Certificate No:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    model: {
      value: (_vm.localMainForm.deceased_death_certificate_no),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_death_certificate_no", $$v)
      },
      expression: "localMainForm.deceased_death_certificate_no"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "required"
  }, [_vm._v("Religion:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": [
        'Buddhist',
        'Taoist',
        'Catholic',
        'Christian',
        'Free thinker',
        'Hindu',
        'Soka',
        'Others'
      ],
      "rules": _vm.religionRules
    },
    model: {
      value: (_vm.localMainForm.deceased_religion),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_religion", $$v)
      },
      expression: "localMainForm.deceased_religion"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "required"
  }, [_vm._v("Dialect:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": [
        'Cantonese',
        'Hainanese',
        'Hakka',
        'Hokchew',
        'Hokkien',
        'Kerk',
        'Shanghainese',
        'Tamil',
        'Teochew',
        'Others'
      ],
      "rules": _vm.dialectRules
    },
    model: {
      value: (_vm.localMainForm.deceased_dialect),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_dialect", $$v)
      },
      expression: "localMainForm.deceased_dialect"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "required"
  }, [_vm._v("Location of Wake:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "rules": _vm.locationOfWakeRules
    },
    model: {
      value: (_vm.localMainForm.deceased_location_of_wake),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_location_of_wake", $$v)
      },
      expression: "localMainForm.deceased_location_of_wake"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', [_vm._v("Crematorium / Burial Location:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.burialLocations,
      "clearable": ""
    },
    model: {
      value: (_vm.localMainForm.deceased_burial_location),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_burial_location", $$v)
      },
      expression: "localMainForm.deceased_burial_location"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', [_vm._v("Embalming:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-checkbox', {
    model: {
      value: (_vm.localMainForm.deceased_embalming),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_embalming", $$v)
      },
      expression: "localMainForm.deceased_embalming"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-subheader', [_vm._v("TERMS & CONDITIONS ("), _c('a', {
    staticClass: "link",
    on: {
      "click": function($event) {
        return _vm.openDialog('en')
      }
    }
  }, [_vm._v("Click to Open and Read")]), _vm._v(")")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "ph16",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "rules": _vm.termsAndConditionsRules,
      "label": "I acknowledge that our funeral director has shown and clearly explained the terms and conditions of products and services. In addition, I confirm that I have fully understood and agree to the terms and conditions stated above."
    },
    on: {
      "change": function($event) {
        return _vm.openDialog('en')
      }
    },
    model: {
      value: (_vm.localMainForm.terms),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "terms", $$v)
      },
      expression: "localMainForm.terms"
    }
  }), _vm._v(" "), _c('br')], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "hide-overlay": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.dialogTitle))]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), (_vm.dialogLang === 'en') ? _c('TermsInEnglish') : _c('TermsInMandarin')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 947 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.items,
      "hide-actions": "",
      "loading": _vm.loadingInProgress,
      "no-data-text": _vm.loadingItemsText
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.editElementChecklist(props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "light-blue lighten-2"
          }
        }, [_vm._v("format_list_numbered")])], 1), _vm._v("\n          Edit products & checklist\n        ")], 1), _vm._v(" "), (!_vm.$can('view', 'vendor')) ? _c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteElement(props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("delete")])], 1), _vm._v("\n          Remove user products\n        ")], 1) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), _vm._t("bottom", null, {
    "casesid": _vm.casesid,
    "loadListing": _vm.loadListing,
    "itemForCheckList": _vm.itemForCheckList
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 948 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "pl-2": "",
      "ml-2": ""
    }
  }, [(_vm.checklists.length > 0) ? _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-flex', [_c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mt-2": "",
      "pt-2": ""
    }
  }, [(_vm.casesId > 0 && this.vendorName) ? _c('h3', [_vm._v("Vendor \"" + _vm._s(_vm.vendorName) + "\" Products")]) : _c('h3', [_vm._v("Default checklist for the item")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mt-2": "",
      "pt-2": ""
    }
  }, _vm._l((_vm.checklists), function(checklist, i) {
    return _c('v-flex', {
      key: i
    }, [(checklist.editable) ? _c('v-flex', [_c('v-text-field', {
      attrs: {
        "append-icon": "save",
        "append-icon-cb": function () {
          _vm.saveCheckList(checklist)
        }
      },
      model: {
        value: (checklist.name),
        callback: function($$v) {
          _vm.$set(checklist, "name", $$v)
        },
        expression: "checklist.name"
      }
    })], 1) : _c('v-checkbox', {
      key: i,
      attrs: {
        "id": i.toString(),
        "label": checklist.service.name + ' - ' + '$' + checklist.service.price + ' - ' + checklist.service.category.name,
        "prepend-icon": _vm.showRemoveButton,
        "prepend-icon-cb": function () {
          _vm.deleteCheckList(checklist)
        }
      },
      on: {
        "change": function($event) {
          return _vm.toggleCheckListStatus(checklist)
        }
      },
      model: {
        value: (checklist.model),
        callback: function($$v) {
          _vm.$set(checklist, "model", $$v)
        },
        expression: "checklist.model"
      }
    })], 1)
  }), 1)], 1) : _c('v-flex', [(!_vm.loading.items) ? _c('span', [_vm._v("No items yet")]) : _vm._e(), _vm._v(" "), (_vm.loading.items) ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.canAddToChecklist) ? _c('v-flex', [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.productsList,
      "label": "Manage products in checklist",
      "item-text": "name",
      "item-value": "id",
      "multiple": ""
    },
    model: {
      value: (_vm.selectedProducts),
      callback: function($$v) {
        _vm.selectedProducts = $$v
      },
      expression: "selectedProducts"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "mt-5": ""
    }
  }, [(_vm.selectedProductsAsObjects.length > 0) ? _c('v-data-table', {
    attrs: {
      "items": _vm.selectedProductsAsObjects,
      "headers": _vm.productsTableHeaders,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', {
          staticClass: "quantity_bgcolor"
        }, [_c('v-edit-dialog', {
          attrs: {
            "return-value": props.item.amount,
            "large": "",
            "lazy": "",
            "persistent": ""
          },
          on: {
            "update:returnValue": function($event) {
              return _vm.$set(props.item, "amount", $event)
            },
            "update:return-value": function($event) {
              return _vm.$set(props.item, "amount", $event)
            }
          },
          scopedSlots: _vm._u([{
            key: "input",
            fn: function() {
              return [_c('v-text-field', {
                attrs: {
                  "label": "Quantity",
                  "single-line": "",
                  "autofocus": ""
                },
                model: {
                  value: (props.item.amount),
                  callback: function($$v) {
                    _vm.$set(props.item, "amount", $$v)
                  },
                  expression: "props.item.amount"
                }
              })]
            },
            proxy: true
          }], null, true)
        }, [_c('div', [_vm._v(_vm._s(props.item.amount))])])], 1), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(props.item.price))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(props.item.amount * props.item.price))]), _vm._v(" "), _c('td', [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteElementWrapper(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("delete")])], 1)], 1)]
      }
    }], null, false, 674801953)
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mt-5": ""
    }
  }, [(_vm.selectedProductsAsObjects.length > 0 && _vm.visible.attachServicesToCaseBtn) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "block": "",
      "loading": _vm.loading.attachServicesToCaseBtn
    },
    on: {
      "click": _vm.attachServicesToCase
    }
  }, [_vm._v("Attach products to case")]) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 949 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card-title', [_c('h3', [_vm._v("Package Details")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Name")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.planData.name) + "\n      ")])], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Price")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.currencyFormat(_vm.quotationTotalPrice)) + "\n      ")])], 1), _vm._v(" "), (_vm.formAnswer) ? _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Location of Wake")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [_c('span', [_vm._v("\n          " + _vm._s(_vm.formAnswer.form_answers.main_form.deceased_location_of_wake) + "\n        ")])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Wake Start Date")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [(_vm.caseData.is_preplan) ? _c('span', [_vm._v("\n          N/A (preplan)\n        ")]) : _c('span', [_vm._v("\n          " + _vm._s(_vm.moment(_vm.caseData.wake_start).format('YYYY-MM-DD')) + "\n        ")])])], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Wake End Date")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [(_vm.caseData.is_preplan) ? _c('span', [_vm._v("\n          N/A (preplan)\n        ")]) : _c('span', [_vm._v("\n          " + _vm._s(_vm.moment(_vm.caseData.wake_end).format('YYYY-MM-DD')) + "\n        ")])])], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Sending Time")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [(_vm.caseData.is_preplan) ? _c('span', [_vm._v("\n          N/A (preplan)\n        ")]) : _c('span', [_vm._v("\n          " + _vm._s(_vm.caseData.wake_sending_time ? _vm.caseData.wake_sending_time : '-') + "\n        ")])])], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Leave Office Time")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [(_vm.caseData.is_preplan) ? _c('span', [_vm._v("\n          N/A (preplan)\n        ")]) : _c('span', [_vm._v("\n          " + _vm._s(_vm.caseData.leave_office_time ? _vm.caseData.leave_office_time : '-') + "\n        ")])])], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Leave Wake Time")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [(_vm.caseData.is_preplan) ? _c('span', [_vm._v("\n          N/A (preplan)\n        ")]) : _c('span', [_vm._v("\n          " + _vm._s(_vm.caseData.leave_wake_time ? _vm.caseData.leave_wake_time : '-') + "\n        ")])])], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Cremation / Burial Time")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [(_vm.caseData.is_preplan) ? _c('span', [_vm._v("\n          N/A (preplan)\n        ")]) : _c('span', [_vm._v("\n          " + _vm._s(_vm.caseData.leave_funeral_time ? _vm.caseData.leave_funeral_time : '-') + "\n        ")])])], 1)], 1), _vm._v(" "), _c('v-card-title', [_c('h3', [_vm._v("Payment Methods")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    staticClass: "padded-row",
    attrs: {
      "row": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "large-radio full-width",
    attrs: {
      "large": ""
    },
    on: {
      "change": _vm.updatePaymentData
    },
    model: {
      value: (_vm.payment_method),
      callback: function($$v) {
        _vm.payment_method = $$v
      },
      expression: "payment_method"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "first-row",
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [_c('v-radio', {
    attrs: {
      "label": 'Credit Card',
      "value": 'credit_card'
    }
  })], 1), _vm._v(" "), (_vm.payment_method === 'credit_card') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md10": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Date and Time Client will head down to office",
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.payment_method_cc_datetime),
      callback: function($$v) {
        _vm.payment_method_cc_datetime = $$v
      },
      expression: "payment_method_cc_datetime"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Other remarks",
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.payment_method_cc_remarks),
      callback: function($$v) {
        _vm.payment_method_cc_remarks = $$v
      },
      expression: "payment_method_cc_remarks"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "first-row",
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [_c('v-radio', {
    attrs: {
      "label": 'Cash',
      "value": 'cash'
    }
  })], 1), _vm._v(" "), (_vm.payment_method === 'cash') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md10": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Cash collected by and amount",
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.payment_method_cash_collected_by),
      callback: function($$v) {
        _vm.payment_method_cash_collected_by = $$v
      },
      expression: "payment_method_cash_collected_by"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Other remarks",
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.payment_method_cash_remarks),
      callback: function($$v) {
        _vm.payment_method_cash_remarks = $$v
      },
      expression: "payment_method_cash_remarks"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "first-row",
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [_c('v-radio', {
    attrs: {
      "label": 'Cheque',
      "value": 'cheque'
    }
  })], 1), _vm._v(" "), (_vm.payment_method === 'cheque') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md10": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Cheque collected by",
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.payment_method_cheque_collected_by),
      callback: function($$v) {
        _vm.payment_method_cheque_collected_by = $$v
      },
      expression: "payment_method_cheque_collected_by"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Other remarks",
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.payment_method_cheque_remarks),
      callback: function($$v) {
        _vm.payment_method_cheque_remarks = $$v
      },
      expression: "payment_method_cheque_remarks"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "first-row",
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [_c('v-radio', {
    attrs: {
      "label": 'Internet banking',
      "value": 'internet_banking'
    }
  })], 1), _vm._v(" "), (_vm.payment_method === 'internet_banking') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md10": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Date and Time of Transfer",
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.payment_method_ibanking_datetime),
      callback: function($$v) {
        _vm.payment_method_ibanking_datetime = $$v
      },
      expression: "payment_method_ibanking_datetime"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Other remarks",
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.payment_method_ibanking_remarks),
      callback: function($$v) {
        _vm.payment_method_ibanking_remarks = $$v
      },
      expression: "payment_method_ibanking_remarks"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "first-row",
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [(_vm.payment_method && !_vm.closed) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "block": "",
      "loading": _vm.loading.updatePaymentInfo,
      "disabled": _vm.loading.updatePaymentInfo
    },
    on: {
      "click": _vm.updatePaymentInfo
    }
  }, [_vm._v("\n            Update Payment Info\n          ")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 950 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.items,
      "hide-actions": "",
      "loading": _vm.loadingInProgress,
      "no-data-text": _vm.loadingItemsText
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.cases_id ? props.item.cases_id : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.item_type_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.service.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.schedule_start))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.schedule_end))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.updated_at))]), _vm._v(" "), _c('td', {
          staticClass: "justify-left layout px-0"
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.editElement(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteDialog(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("delete")])], 1), _vm._v(" "), _c('confirmation-dialog', {
          ref: "confirm"
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('AppEditBookingsDialog'), _vm._v(" "), _c('AddBookingButton')], 1)
},staticRenderFns: []}

/***/ }),
/* 951 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    attrs: {
      "fab": "",
      "bottom": "",
      "right": "",
      "color": "pink",
      "dark": "",
      "fixed": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialog = !_vm.dialog
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "800px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-4 py-4 title"
  }, [_vm._v("\n          Add Client\n        ")]), _vm._v(" "), _c('v-card-text', [_c('dfs-client-add-form', {
    on: {
      "namechanged": _vm.onNameChanged
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.saveNew
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('AppMainDialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "message": _vm.dialogMessage
    },
    on: {
      "closedialog": function($event) {
        _vm.dialogOpen = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 952 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "md8": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "dfs-chat"
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 953 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    attrs: {
      "fab": "",
      "bottom": "",
      "right": "",
      "color": "pink",
      "dark": "",
      "fixed": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialog = !_vm.dialog
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "800px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-4 py-4 title"
  }, [_vm._v("\n        Add Product\n      ")]), _vm._v(" "), _c('v-container', {
    staticClass: "pa-4",
    attrs: {
      "grid-list-sm": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Name"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "Price"
    },
    model: {
      value: (_vm.price),
      callback: function($$v) {
        _vm.price = $$v
      },
      expression: "price"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "Commission"
    },
    model: {
      value: (_vm.commission),
      callback: function($$v) {
        _vm.commission = $$v
      },
      expression: "commission"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "Default amount"
    },
    model: {
      value: (_vm.amount),
      callback: function($$v) {
        _vm.amount = $$v
      },
      expression: "amount"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.usersList,
      "label": "Select user"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n                " + _vm._s(props.item.name) + " - " + _vm._s(_vm._f("normalizeRoles")(props.item.roles)) + "\n              ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_vm._v("\n                " + _vm._s(props.item.name) + " - " + _vm._s(_vm._f("normalizeRoles")(props.item.roles)) + "\n              ")]
      }
    }]),
    model: {
      value: (_vm.selectedUser),
      callback: function($$v) {
        _vm.selectedUser = $$v
      },
      expression: "selectedUser"
    }
  }), _vm._v(" "), (_vm.categoriesList) ? _c('v-combobox', {
    attrs: {
      "loading": _vm.loading.categories,
      "items": _vm.categoriesList,
      "search-input": _vm.categorySearch,
      "hide-selected": "",
      "label": "Select category"
    },
    on: {
      "update:searchInput": function($event) {
        _vm.categorySearch = $event
      },
      "update:search-input": function($event) {
        _vm.categorySearch = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n                " + _vm._s(props.item.text) + "\n              ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_vm._v("\n                " + _vm._s(props.item.text) + "\n              ")]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_c('v-list-tile', {
          staticClass: "pointer"
        }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
          on: {
            "click": _vm.addCategory
          }
        }, [_vm._v("\n                      No results matching \""), _c('strong', [_vm._v(_vm._s(_vm.categorySearch))]), _vm._v("\". "), _c('kbd', [_vm._v("Click")]), _vm._v(" to create a new category\n                    ")])], 1)], 1)]
      },
      proxy: true
    }, {
      key: "append-outer",
      fn: function() {
        return [_c('v-checkbox', {
          staticClass: "checkboxParentCategory",
          attrs: {
            "label": "Set parent category"
          },
          model: {
            value: (_vm.setParentId),
            callback: function($$v) {
              _vm.setParentId = $$v
            },
            expression: "setParentId"
          }
        })]
      },
      proxy: true
    }], null, false, 2561039045),
    model: {
      value: (_vm.selectedCategory),
      callback: function($$v) {
        _vm.selectedCategory = $$v
      },
      expression: "selectedCategory"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.categoriesList && _vm.setParentId) ? _c('v-combobox', {
    attrs: {
      "loading": _vm.loading.categories,
      "items": _vm.excludeSelectedCategory,
      "hide-selected": "",
      "label": "Select parent category"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n                " + _vm._s(props.item.text) + "\n              ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_vm._v("\n                " + _vm._s(props.item.text) + "\n              ")]
      }
    }], null, false, 81737084),
    model: {
      value: (_vm.selectedParentCategory),
      callback: function($$v) {
        _vm.selectedParentCategory = $$v
      },
      expression: "selectedParentCategory"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('input', {
    ref: "csvUploadInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.uploadCsv
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.loading.uploadCsvBtn,
      "disabled": _vm.disabled.uploadCsvBtn
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onClickUploadCsvBtn($event)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.labels.uploadCsvBtn) + "\n              "), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("cloud_upload")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [(!_vm.disabled.saveBtn) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.saveNew
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('AppMainDialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "message": _vm.dialogMessage
    },
    on: {
      "closedialog": function($event) {
        _vm.dialogOpen = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 954 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "500px"
    },
    on: {
      "update:returnValue": _vm.setEditItemIdZero
    },
    model: {
      value: (_vm.dialogResult),
      callback: function($$v) {
        _vm.dialogResult = $$v
      },
      expression: "dialogResult"
    }
  }, [_c('CasePlanAndServicesEdition', {
    attrs: {
      "is-in-dialog": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 955 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    attrs: {
      "fab": "",
      "bottom": "",
      "right": "",
      "color": "pink",
      "dark": "",
      "fixed": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialog = !_vm.dialog
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "800px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-4 py-4 title"
  }, [_vm._v("\n        Add Role\n      ")]), _vm._v(" "), _c('v-container', {
    staticClass: "pa-4",
    attrs: {
      "grid-list-sm": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Role name"
    },
    model: {
      value: (_vm.modelName),
      callback: function($$v) {
        _vm.modelName = $$v
      },
      expression: "modelName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Role guard",
      "disabled": ""
    },
    model: {
      value: (_vm.guardName),
      callback: function($$v) {
        _vm.guardName = $$v
      },
      expression: "guardName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.saveNew
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('AppMainDialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "message": _vm.dialogMessage
    },
    on: {
      "closedialog": function($event) {
        _vm.dialogOpen = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 956 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('AppCaseItemsDataTableBase', {
    attrs: {
      "casesid": _vm.casesid,
      "item-type": _vm.inventoryTypeID
    },
    scopedSlots: _vm._u([{
      key: "bottom",
      fn: function(props) {
        return [_c('AttachInventoriesToCaseButton', {
          attrs: {
            "casesid": props.casesid
          },
          on: {
            "resource-attached": props.loadListing
          }
        }), _vm._v(" "), _c('AppEditItemCheckListDialog', {
          attrs: {
            "item-id": props.itemForCheckList.id,
            "item-type": _vm.inventoryTypeID
          },
          on: {
            "update:itemId": function($event) {
              return _vm.$set(props.itemForCheckList, "id", $event)
            },
            "update:item-id": function($event) {
              return _vm.$set(props.itemForCheckList, "id", $event)
            }
          }
        })]
      }
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 957 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-overlay"
  }, [_c('v-progress-circular', {
    staticClass: "loader",
    attrs: {
      "size": 50,
      "indeterminate": "",
      "color": "primary"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 958 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('h2', [_vm._v("Profile")]), _vm._v(" "), _c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "show-arrows": ""
    },
    model: {
      value: (_vm.selectedTab),
      callback: function($$v) {
        _vm.selectedTab = $$v
      },
      expression: "selectedTab"
    }
  }, [_c('v-tab', {
    attrs: {
      "href": "#profile-tab"
    }
  }, [_vm._v("\n            Profile\n          ")]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "href": "#courses-tab"
    }
  }, [_vm._v("\n            Courses\n          ")]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "href": "#stats-tab"
    }
  }, [_vm._v("\n            Stats\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tabs-items', [_c('v-tab-item', {
    attrs: {
      "id": "profile-tab"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.userData) ? _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-list', [_c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Name")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.userData.name) + "\n                      ")])], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Email")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.userData.email) + "\n                      ")])], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Phone")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.userData.phone) + "\n                      ")])], 1)], 1), _vm._v(" "), (_vm.$store.getters.currentUserRoles.includes('vendor')) ? _c('v-flex', {
    attrs: {
      "mt-2": "",
      "ml-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "tag": "h4",
      "mb-5": ""
    }
  }, [_vm._v("\n                        Products\n                      ")]), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "items": _vm.productsList,
      "hide-actions": "",
      "hide-headers": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(props.item.price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.category.name))])]
      }
    }], null, false, 808808980)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.currentUserRoles.includes('case-manager')) ? _c('v-flex', {
    attrs: {
      "mt-2": "",
      "ml-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "tag": "h4",
      "mb-5": ""
    }
  }, [_vm._v("\n                        Commissions (total for now $" + _vm._s(_vm.totalCommission) + ")\n                      ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.casesList), function(workCase, i) {
    return _c('v-flex', {
      key: i,
      attrs: {
        "mb-5": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "tag": "b"
      }
    }, [_vm._v("\n                        Case ID # " + _vm._s(workCase.id) + "\n                      ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": "",
        "mt-3": ""
      }
    }, [_c('v-data-table', {
      attrs: {
        "items": workCase.products,
        "headers": _vm.productsTableHeaders,
        "hide-actions": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(props.item.commission))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.invoice_updated))])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('template', {
      slot: "footer"
    }, [_c('v-flex', {
      attrs: {
        "mt-5": "",
        "ml-3": ""
      }
    }, [_c('b', [_vm._v("Total commission for case:")]), _vm._v(" $" + _vm._s(_vm.calculcateCaseCommission(workCase.id)) + "\n                            ")])], 1)], 2)], 1)], 1)
  })], 2) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  }, [_vm._v("\n                    Hard Refresh\n                  ")])], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "id": "courses-tab"
    }
  }, [(_vm.userData) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('v-list', [_c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Edx Completion Percent")])])])], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "items": _vm.courses,
      "headers": _vm.coursesTableHeaders,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.course_id.replace(/\+/g, " ")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((Number(props.item.earned_all / props.item.possible_all).toFixed(2) * 100).toFixed(0)))])]
      }
    }], null, false, 3122296579)
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "id": "stats-tab"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.statData) ? _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [(_vm.$store.getters.currentUserRoles.includes('dispatcher') || _vm.$store.getters.currentUserRoles.includes('management')) ? _c('div', {
    staticClass: "stat-lead-row",
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', [_c('h5', [_c('b', [_vm._v("Total leads by month:")])])]), _vm._v(" "), _c('v-flex', [_c('div', {
    staticClass: "leadsTable"
  }, _vm._l((_vm.leadsData), function(leadItem, index) {
    return _c('div', {
      staticClass: "leadsTable__item"
    }, [_c('div', {
      staticClass: "leadsTable__item__month"
    }, [_vm._v(_vm._s(leadItem.name))]), _vm._v(" "), _c('div', {
      staticClass: "leadsTable__item__count"
    }, [_vm._v(_vm._s(leadItem.value))])])
  }), 0)])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.currentUserRoles.includes('case-manager')) ? _c('div', {
    staticClass: "stat-lead-row",
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', [_c('h5', [_c('b', [_vm._v("Your cases:")])])]), _vm._v(" "), _c('v-flex', [_c('div', {
    staticClass: "leadsTable"
  }, _vm._l((_vm.casesData), function(caseItem, index) {
    return _c('div', {
      staticClass: "leadsTable__item"
    }, [_c('div', {
      staticClass: "leadsTable__item__month"
    }, [_vm._v(_vm._s(caseItem.name))]), _vm._v(" "), _c('div', {
      staticClass: "leadsTable__item__count"
    }, [_vm._v(_vm._s(caseItem.value))])])
  }), 0)])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.currentUserRoles.includes('case-crew')) ? _c('div', {
    staticClass: "stat-lead-row",
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', [_c('h5', [_c('b', [_vm._v("Participating in cases:")])])]), _vm._v(" "), _c('v-flex', [_c('div', {
    staticClass: "leadsTable"
  }, _vm._l((_vm.partiCasessData), function(leadItem, index) {
    return _c('div', {
      staticClass: "leadsTable__item"
    }, [_c('div', {
      staticClass: "leadsTable__item__month"
    }, [_vm._v(_vm._s(leadItem.name))]), _vm._v(" "), _c('div', {
      staticClass: "leadsTable__item__count"
    }, [_vm._v(_vm._s(leadItem.value))])])
  }), 0)])], 1) : _vm._e()]) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 959 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_c('h3', [_vm._v("Inventory Report")])]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "md4": "",
      "px-1": "",
      "mt-2": ""
    }
  }, [_c('v-flex', [_c('v-select', {
    attrs: {
      "items": _vm.categories,
      "label": "Select Category"
    },
    model: {
      value: (_vm.category),
      callback: function($$v) {
        _vm.category = $$v
      },
      expression: "category"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "md3": "",
      "px-1": "",
      "mt-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "date__picker"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Start Date",
            "prepend-icon": "event",
            "readonly": "",
            "clearable": ""
          },
          model: {
            value: (_vm.fromDate),
            callback: function($$v) {
              _vm.fromDate = $$v
            },
            expression: "fromDate"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "input": function($event) {
        _vm.menu = false
      }
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "md3": "",
      "px-1": "",
      "mt-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "date__picker"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "End Date",
            "prepend-icon": "event",
            "readonly": "",
            "clearable": ""
          },
          model: {
            value: (_vm.toDate),
            callback: function($$v) {
              _vm.toDate = $$v
            },
            expression: "toDate"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu1),
      callback: function($$v) {
        _vm.menu1 = $$v
      },
      expression: "menu1"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "input": function($event) {
        _vm.menu1 = false
      }
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "items": _vm.items,
      "headers": _vm.header,
      "loading": _vm.loading,
      "item-key": "id",
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.quantity))])])]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "align-right"
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.exportToCSV(_vm.items)
      }
    }
  }, [_vm._v("Export to CSV")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 960 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pb9"
  }, [_c('AppEditPlansDialog'), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.items,
      "hide-actions": "",
      "loading": _vm.loadingInProgress,
      "no-data-text": _vm.loadingItemsText
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.totalPrice(props.item)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.updated_at))]), _vm._v(" "), _c('td', {
          staticClass: "justify-left layout px-0"
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.editElement(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteDialog(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("delete")])], 1), _vm._v(" "), _c('ConfirmationDialog', {
          ref: "confirm"
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('AddPlanButton')], 1)
},staticRenderFns: []}

/***/ }),
/* 961 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pb9"
  }, [_c('v-card', [_c('v-card-text', [_c('v-flex', [_c('v-flex', [(_vm.$store.getters.currentUserRoles.includes('embalmer')) ? _c('v-flex', {
    attrs: {
      "mb-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "mb-3": ""
    }
  }, [_c('h1', [_vm._v("TODO")])]), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "items": _vm.todoCases,
      "headers": _vm.todoCasesTableHeaders,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.name ? props.item.name : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.wake_start))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.wake_end))])]
      }
    }], null, false, 3443140808)
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('v-select', {
    attrs: {
      "items": _vm.displayPeriodList,
      "label": "Select period"
    },
    model: {
      value: (_vm.displayPeriod),
      callback: function($$v) {
        _vm.displayPeriod = $$v
      },
      expression: "displayPeriod"
    }
  })], 1)], 1), _vm._v(" "), _c('v-calendar', {
    ref: "calendar",
    staticClass: "theme-default",
    attrs: {
      "now": _vm.showDate,
      "value": _vm.calendarValue,
      "type": _vm.displayPeriod,
      "color": "primary"
    },
    on: {
      "click:date": _vm.onClickDate,
      "moved": _vm.onMove
    },
    scopedSlots: _vm._u([{
      key: "day",
      fn: function(ref) {
        var date = ref.date;

        return [_vm._l((_vm.eventsMap[date]), function(event) {
          return [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({
                  directives: [{
                    name: "ripple",
                    rawName: "v-ripple"
                  }],
                  staticClass: "my-event",
                  class: {
                    'manager-class': _vm.isCaseManagerEqual(event),
                      'not-manager': !_vm.isCaseManagerEqual(event)
                  },
                  domProps: {
                    "innerHTML": _vm._s(event.time + ' ' + event.title)
                  },
                  on: {
                    "click": function($event) {
                      return _vm.onClickEvent(event)
                    }
                  }
                }, on))]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', {
            domProps: {
              "innerHTML": _vm._s(event.title)
            }
          })])]
        })]
      }
    }, {
      key: "dayBody",
      fn: function(ref) {
        var date = ref.date;
        var timeToY = ref.timeToY;
        var minutesToPixels = ref.minutesToPixels;

        return [_vm._l((_vm.eventsMap[date]), function(event) {
          return [(event.time) ? _c('div', {
            key: event.id,
            staticClass: "my-event with-time",
            class: {
              'manager-class': _vm.isCaseManagerEqual(event),
                'not-manager': !_vm.isCaseManagerEqual(event)
            },
            style: ({
              top: timeToY(event.time) + 'px',
              height: minutesToPixels(event.duration) + 'px'
            }),
            domProps: {
              "innerHTML": _vm._s(event.title)
            },
            on: {
              "click": function($event) {
                return _vm.onClickEvent(event)
              }
            }
          }) : _vm._e()]
        })]
      }
    }])
  }), _vm._v(" "), _c('AddScheduledCaseButton'), _vm._v(" "), (_vm.dateForNewLead) ? _c('AddCaseNameAndDateDialog', {
    attrs: {
      "date": _vm.dateForNewLead
    },
    on: {
      "input": _vm.loadSchedules
    },
    model: {
      value: (_vm.dialogModel),
      callback: function($$v) {
        _vm.dialogModel = $$v
      },
      expression: "dialogModel"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "text-sm-left text-xs-center",
    attrs: {
      "md6": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.$refs.calendar.prev()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": ""
    }
  }, [_vm._v("keyboard_arrow_left")]), _vm._v("\n            Prev\n          ")], 1), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.$refs.calendar.next()
      }
    }
  }, [_vm._v("\n            Next\n            "), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("keyboard_arrow_right")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "legend-box case-manager"
  }), _vm._v(" – you are a case manager\n    "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "legend-box not-case-manager"
  }), _vm._v(" – you aren't a case manager\n    "), _c('br'), _c('br')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 962 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "update:returnValue": _vm.setEditItemIdZero
    },
    model: {
      value: (_vm.dialogResult),
      callback: function($$v) {
        _vm.dialogResult = $$v
      },
      expression: "dialogResult"
    }
  }, [_c('v-card', [_c('v-card-text', [_vm._t("CaseAndAmount", null, {
    "casesList": _vm.casesList,
    "selectedCase": _vm.selectedCase,
    "amount": _vm.amount
  }), _vm._v(" "), _vm._t("ItemsSelection", null, {
    "selectedItemType": _vm.selectedItemType,
    "inventoriesList": _vm.inventoriesList,
    "servicesList": _vm.servicesList,
    "caseManagersList": _vm.caseManagersList,
    "selectedInventory": _vm.selectedInventory,
    "selectedService": _vm.selectedService,
    "selectedCaseManager": _vm.selectedCaseManager
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.selectedList,
      "label": "Select items"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n          ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n          ")]
      }
    }]),
    model: {
      value: (_vm.selectedEntity),
      callback: function($$v) {
        _vm.selectedEntity = $$v
      },
      expression: "selectedEntity"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-menu', {
    model: {
      value: (_vm.menuDateStart),
      callback: function($$v) {
        _vm.menuDateStart = $$v
      },
      expression: "menuDateStart"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Select start date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.date.dateStart),
      callback: function($$v) {
        _vm.$set(_vm.date, "dateStart", $$v)
      },
      expression: "date.dateStart"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": ""
    },
    model: {
      value: (_vm.date.dateStart),
      callback: function($$v) {
        _vm.$set(_vm.date, "dateStart", $$v)
      },
      expression: "date.dateStart"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false
    },
    model: {
      value: (_vm.menuTimeStart),
      callback: function($$v) {
        _vm.menuTimeStart = $$v
      },
      expression: "menuTimeStart"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Select start time",
      "prepend-icon": "alarm",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.date.timeStart),
      callback: function($$v) {
        _vm.$set(_vm.date, "timeStart", $$v)
      },
      expression: "date.timeStart"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    model: {
      value: (_vm.date.timeStart),
      callback: function($$v) {
        _vm.$set(_vm.date, "timeStart", $$v)
      },
      expression: "date.timeStart"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-menu', {
    model: {
      value: (_vm.menuDateEnd),
      callback: function($$v) {
        _vm.menuDateEnd = $$v
      },
      expression: "menuDateEnd"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Select end date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.date.dateEnd),
      callback: function($$v) {
        _vm.$set(_vm.date, "dateEnd", $$v)
      },
      expression: "date.dateEnd"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": ""
    },
    model: {
      value: (_vm.date.dateEnd),
      callback: function($$v) {
        _vm.$set(_vm.date, "dateEnd", $$v)
      },
      expression: "date.dateEnd"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false
    },
    model: {
      value: (_vm.menuTimeEnd),
      callback: function($$v) {
        _vm.menuTimeEnd = $$v
      },
      expression: "menuTimeEnd"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Select end time",
      "prepend-icon": "alarm",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.date.timeEnd),
      callback: function($$v) {
        _vm.$set(_vm.date, "timeEnd", $$v)
      },
      expression: "date.timeEnd"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    model: {
      value: (_vm.date.timeEnd),
      callback: function($$v) {
        _vm.$set(_vm.date, "timeEnd", $$v)
      },
      expression: "date.timeEnd"
    }
  })], 1)], 1)], 2), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editItemDataDecorator($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.dialogClose($event)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 963 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('AppEditInventoriesDialog'), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.items,
      "hide-actions": "",
      "loading": _vm.loadingInProgress,
      "no-data-text": _vm.loadingItemsText
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.is_available))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.is_vendor))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.amount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.updated_at))]), _vm._v(" "), _c('td', {
          staticClass: "justify-left layout px-0"
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.editElement(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteDialog(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("delete")])], 1), _vm._v(" "), _c('confirmation-dialog', {
          ref: "confirm"
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('AddInventoryButton')], 1)
},staticRenderFns: []}

/***/ }),
/* 964 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    attrs: {
      "fab": "",
      "bottom": "",
      "right": "",
      "color": "pink",
      "dark": "",
      "fixed": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialog = !_vm.dialog
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "800px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-container', {
    staticClass: "pa-4",
    attrs: {
      "grid-list-sm": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.servicesList,
      "label": "Select products",
      "item-text": "name",
      "item-value": "id",
      "multiple": "",
      "return-object": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n                " + _vm._s(props.item.name) + " - " + _vm._s(props.item.category.name) + "\n              ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_vm._v("\n                " + _vm._s(props.item.name) + " - " + _vm._s(props.item.category.name) + "\n              ")]
      }
    }]),
    model: {
      value: (_vm.selectedServices),
      callback: function($$v) {
        _vm.selectedServices = $$v
      },
      expression: "selectedServices"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.selectedServices), function(service, i) {
    return _c('v-flex', {
      key: i,
      attrs: {
        "xs12": "",
        "align-center": "",
        "justify-space-between": ""
      }
    }, [_c('v-layout', [_c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_vm._v("\n                " + _vm._s(service.name) + " in quantity\n              ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "type": "number"
      },
      model: {
        value: (service.amount),
        callback: function($$v) {
          _vm.$set(service, "amount", $$v)
        },
        expression: "service.amount"
      }
    })], 1)], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.saveNew
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 965 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', {
    staticClass: "text-md-center"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.plansList,
      "label": "Select an existing plan"
    },
    model: {
      value: (_vm.itemData.plans_id),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "plans_id", $$v)
      },
      expression: "itemData.plans_id"
    }
  }), _vm._v(" "), (_vm.selectedPlan > 0) ? _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.servicesList,
      "multiple": "",
      "label": "Select services (replaces already added)"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n                " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n              ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_vm._v("\n                " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n              ")]
      }
    }], null, false, 2095008220),
    model: {
      value: (_vm.itemData.services),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "services", $$v)
      },
      expression: "itemData.services"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isInDialog && _vm.casesId > 0) ? _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": ['Comfort S30', 'Comfort S803', 'Deluxe Lotus S809', 'S220', 'Teak'],
      "label": "Select Casket Model"
    },
    model: {
      value: (_vm.itemData.casket_model),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "casket_model", $$v)
      },
      expression: "itemData.casket_model"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.itemData.services && _vm.itemData.services.length > 0 && this.enableChecklist) ? _c('v-flex', {
    staticClass: "text-md-left"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.selectedServicesList,
      "label": "Select service to edit checklist"
    },
    model: {
      value: (_vm.selectedServiceForChecklist),
      callback: function($$v) {
        _vm.selectedServiceForChecklist = $$v
      },
      expression: "selectedServiceForChecklist"
    }
  }), _vm._v(" "), (_vm.selectedServiceForChecklist > 0) ? _c('ItemCheckList', {
    attrs: {
      "cases-id": _vm.itemData.id,
      "item-id": _vm.selectedServiceForChecklist,
      "item-type": _vm.serviceTypeID
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editItemData(_vm.finalItemId)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), (_vm.isInDialog) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$bus.$emit('dialog-close')
      }
    }
  }, [_vm._v("Close")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 966 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('AppCaseItemsDataTableBase', {
    attrs: {
      "casesid": _vm.casesid,
      "item-type": _vm.serviceTypeID
    },
    scopedSlots: _vm._u([{
      key: "bottom",
      fn: function(props) {
        return [_c('AttachServicesToCaseButton', {
          attrs: {
            "casesid": props.casesid
          },
          on: {
            "resource-attached": props.loadListing
          }
        }), _vm._v(" "), _c('AppEditItemCheckListDialog', {
          attrs: {
            "item-id": props.itemForCheckList.id,
            "item-type": _vm.serviceTypeID,
            "cases-id": _vm.casesid
          },
          on: {
            "update:itemId": function($event) {
              return _vm.$set(props.itemForCheckList, "id", $event)
            },
            "update:item-id": function($event) {
              return _vm.$set(props.itemForCheckList, "id", $event)
            }
          }
        })]
      }
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 967 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    attrs: {
      "fab": "",
      "bottom": "",
      "right": "",
      "color": "pink",
      "dark": "",
      "fixed": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialog = !_vm.dialog
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "value": "false",
      "width": "800px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('VendorsInvoice', {
    attrs: {
      "id": _vm.casesid
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('AppMainDialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "message": _vm.dialogMessage
    },
    on: {
      "closedialog": function($event) {
        _vm.dialogOpen = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 968 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-height"
  }, [_c('v-card-title', [_c('v-flex', {
    attrs: {
      "tag": "h3"
    }
  }, [_vm._v("\n      Case Manager\n    ")])], 1), _vm._v(" "), _c('v-list', [_c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Name")])])]), _vm._v(" "), (_vm.managerData) ? _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [(_vm.toggleChangeCaseManager) ? _c('v-select', {
    attrs: {
      "items": _vm.users,
      "label": "Select new manager",
      "disabled": _vm.disabled.caseManagerSelect || _vm.closed
    },
    model: {
      value: (_vm.selectedCaseManager),
      callback: function($$v) {
        _vm.selectedCaseManager = $$v
      },
      expression: "selectedCaseManager"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.toggleChangeCaseManager) ? _c('span', [_vm._v("\n          " + _vm._s(_vm.managerData.name) + "\n          "), (!_vm.closed) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "flat": "",
      "color": "teal"
    },
    on: {
      "click": function($event) {
        _vm.toggleChangeCaseManager = true
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.icon))])], 1) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Email")])])]), _vm._v(" "), (_vm.managerData) ? _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.managerData.email || 'N/A') + "\n      ")]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 969 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_c('h3', [_vm._v("Commissions Reports")])]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "md4": "",
      "px-1": "",
      "mt-2": ""
    }
  }, [_c('v-flex', [_c('v-select', {
    attrs: {
      "items": _vm.users,
      "label": "Select Case Manager"
    },
    model: {
      value: (_vm.selectedUser),
      callback: function($$v) {
        _vm.selectedUser = $$v
      },
      expression: "selectedUser"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "md3": "",
      "px-1": "",
      "mt-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "date__picker"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Start Date",
            "prepend-icon": "event",
            "readonly": "",
            "clearable": ""
          },
          model: {
            value: (_vm.fromDate),
            callback: function($$v) {
              _vm.fromDate = $$v
            },
            expression: "fromDate"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "input": function($event) {
        _vm.menu = false
      }
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "md3": "",
      "px-1": "",
      "mt-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "date__picker"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "End Date",
            "prepend-icon": "event",
            "readonly": "",
            "clearable": ""
          },
          model: {
            value: (_vm.toDate),
            callback: function($$v) {
              _vm.toDate = $$v
            },
            expression: "toDate"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu1),
      callback: function($$v) {
        _vm.menu1 = $$v
      },
      expression: "menu1"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "input": function($event) {
        _vm.menu1 = false
      }
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "items": _vm.completedCases,
      "headers": _vm.analyticHeaders,
      "loading": _vm.loading,
      "expand": _vm.expand,
      "item-key": "id",
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "grey lighten-2",
          on: {
            "click": function($event) {
              props.expanded = !props.expanded
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.manager_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.cases.length))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.round(Number(props.item.commission))))])])]
      }
    }, {
      key: "expand",
      fn: function(props) {
        return [_c('v-data-table', {
          attrs: {
            "items": props.item.cases,
            "hide-actions": "",
            "hide-headers": ""
          },
          scopedSlots: _vm._u([{
            key: "items",
            fn: function(props) {
              return [_c('td', [_vm._v("Case ID: " + _vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v("Case Wake Date: " + _vm._s(props.item.wake_end))]), _vm._v(" "), _c('td', [(props.item.services.length) ? _c('span', [_vm._v("Services: ")]) : _vm._e(), _vm._v(_vm._s(_vm._.map(props.item.services, 'service.name').join(',')))]), _vm._v(" "), _c('td', [_vm._v("Location of wake: " + _vm._s(_vm.getWakeLocation(props.item.answers)))]), _vm._v(" "), _c('td', [_vm._v("Commissions: " + _vm._s(Math.round(Number(props.item.commissions))))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('div', {
          staticClass: "align-right"
        }, [_c('v-btn', {
          on: {
            "click": function($event) {
              return _vm.exportToCSV(props.item.cases)
            }
          }
        }, [_vm._v("Export to CSV")])], 1)]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 970 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "update:returnValue": _vm.setEditItemIdZero
    },
    model: {
      value: (_vm.dialogResult),
      callback: function($$v) {
        _vm.dialogResult = $$v
      },
      expression: "dialogResult"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "text-md-center"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Name"
    },
    model: {
      value: (_vm.itemData.name),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "name", $$v)
      },
      expression: "itemData.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Guard",
      "disabled": ""
    },
    model: {
      value: (_vm.itemData.guard_name),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "guard_name", $$v)
      },
      expression: "itemData.guard_name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editItemData($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.dialogClose($event)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 971 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.caseData) ? _c('div', [
    [_c('v-tabs', {
      attrs: {
        "color": "#e1e1e1"
      },
      model: {
        value: (_vm.tab),
        callback: function($$v) {
          _vm.tab = $$v
        },
        expression: "tab"
      }
    }, [_c('v-tabs-slider'), _vm._v(" "), _c('v-tab', {
      key: 1,
      staticClass: "primary--text",
      attrs: {
        "ripple": ""
      }
    }, [_vm._v("\n          Client Details\n        ")]), _vm._v(" "), _c('v-tab', {
      key: 2,
      staticClass: "primary--text",
      attrs: {
        "ripple": "",
        "disabled": !_vm.tab2active
      }
    }, [_vm._v("\n          Packages and Vendors\n        ")])], 1), _vm._v(" "), _c('v-tabs-items', {
      attrs: {
        "touchless": ""
      },
      model: {
        value: (_vm.tab),
        callback: function($$v) {
          _vm.tab = $$v
        },
        expression: "tab"
      }
    }, [_c('v-tab-item', {
      key: 1
    }, [_c('v-card', [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('h3', [_vm._v("Next-of-Kin's Details")])])], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": ""
      }
    }, [_c('v-radio-group', {
      staticClass: "large-radio",
      attrs: {
        "large": "",
        "column": false
      },
      model: {
        value: (_vm.clientRelation),
        callback: function($$v) {
          _vm.clientRelation = $$v
        },
        expression: "clientRelation"
      }
    }, [_c('v-radio', {
      attrs: {
        "label": 'Returning Customer',
        "value": 'returning'
      }
    }), _vm._v(" "), _c('v-radio', {
      attrs: {
        "label": 'New Customer',
        "value": 'new'
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('v-subheader', {
      staticClass: "required"
    }, [_vm._v("Client (Next of Kin):")])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": ""
      }
    }, [_c('dfs-client-add-form', {
      attrs: {
        "selected-client": _vm.selectedClient,
        "client-name": _vm.caseData && _vm.caseData.client && _vm.caseData.client.name
      },
      on: {
        "namechanged": _vm.onNameChanged,
        "valid:changed": _vm.onFormValidate
      }
    })], 1)], 1), _vm._v(" "), _c('dfs-forms', {
      attrs: {
        "caseid": _vm.caseid
      },
      on: {
        "valid:changed": _vm.onFormValidate
      }
    })], 1)], 1), _vm._v(" "), _c('DfsServiceAgreementCheckList', {
      on: {
        "agreement:status": _vm.checkAgreementStatus,
        "valid:changed": _vm.onFormValidate
      }
    }), _vm._v(" "), _c('DfsServiceAgreementClientData', {
      attrs: {
        "clientName": _vm.clientName,
        "newreturn": _vm.clientRelation
      },
      on: {
        "clientdata:input": _vm.checkClientDataStatus,
        "valid:changed": _vm.onFormValidate
      }
    }), _vm._v(" "), (!_vm.caseData.client_signature) ? _c('div', [_c('h3', {
      staticClass: "required"
    }, [_vm._v("Draw Client Signature")]), _vm._v(" "), _c('v-tooltip', {
      attrs: {
        "top": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "flat": "",
        "icon": ""
      },
      on: {
        "click": _vm.clearSignature
      },
      slot: "activator"
    }, [_c('v-icon', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v("undo")])], 1), _vm._v("\n                  Clear signature\n                ")], 1), _vm._v(" "), _c('div', {
      staticClass: "sign-pad"
    }, [_c('VueSignaturePad', {
      ref: "signaturePad",
      attrs: {
        "height": "250px",
        "width": "500px"
      }
    })], 1)], 1) : _c('div', [_c('h3', {
      staticClass: "required"
    }, [_vm._v("Client Signature")]), _vm._v(" "), _c('v-img', {
      attrs: {
        "src": _vm.caseData.client_signature
      }
    })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      attrs: {
        "color": "primary",
        "block": "",
        "loading": _vm.loading.SaveCaseBtn,
        "disabled": _vm.disabled.SaveCaseBtn
      },
      nativeOn: {
        "click": function($event) {
          return _vm.saveCase($event)
        }
      }
    }, [_vm._v("\n                Save case\n              ")])], 1)], 1), _vm._v(" "), _c('AppMainDialog', {
      attrs: {
        "open": _vm.dialogOpen,
        "message": _vm.dialogMessage
      },
      on: {
        "closedialog": function($event) {
          _vm.dialogOpen = false
        }
      }
    })], 1), _vm._v(" "), _c('v-tab-item', {
      key: 2
    }, [_c('SelectPlanAndVendors', {
      attrs: {
        "caseData": _vm.caseData,
        "case-id": _vm.caseid,
        "editable": ""
      }
    })], 1)], 1)], _vm._v(" "), _c('ConfirmationDialog', {
      ref: "confirm"
    }), _vm._v(" "), _c('v-dialog', {
      attrs: {
        "hide-overlay": "",
        "persistent": "",
        "width": "300"
      },
      model: {
        value: (_vm.showAlert),
        callback: function($$v) {
          _vm.showAlert = $$v
        },
        expression: "showAlert"
      }
    }, [_c('v-card', {
      attrs: {
        "color": "primary",
        "dark": ""
      }
    }, [_c('v-card-text', {
      staticClass: "flex-alert-center"
    }, [_c('v-icon', {
      staticClass: "flex-alert-notification-check",
      attrs: {
        "dark": "",
        "right": ""
      }
    }, [_vm._v("error")]), _vm._v(" " + _vm._s(_vm.alertMessage) + "\n        ")], 1)], 1)], 1)
  ], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 972 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "persistent": ""
    },
    model: {
      value: (_vm.internalOpen),
      callback: function($$v) {
        _vm.internalOpen = $$v
      },
      expression: "internalOpen"
    }
  }, [_c('v-card', [(_vm.rawHtml) ? _c('v-card-text', {
    staticClass: "text-md-center",
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }) : _c('v-card-text', {
    staticClass: "text-md-center"
  }, [_vm._v("\n      " + _vm._s(_vm.message) + "\n    ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.dialogClose($event)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 973 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('img', {
    staticClass: "text-md-center",
    attrs: {
      "alt": "logo",
      "src": "/static/img/dfs-logo.png",
      "srcset": "/static/img/dfs-logo@2x.png 2x"
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 974 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.caseManagers) ? _c('v-data-table', {
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.actionsLog,
      "no-data-text": "No actions",
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.action))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.username))]), _vm._v(" "), _c('td', [(props.item.payload && props.item.payload === 'null') ? _c('v-flex') : _c('v-expansion-panel', [_c('v-expansion-panel-content', [_c('v-flex', {
          attrs: {
            "slot": "header"
          },
          slot: "header"
        }, [_vm._v("show")]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
          staticClass: "grey lighten-3",
          domProps: {
            "innerHTML": _vm._s(_vm.parsedPayload(props.item.payload))
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.created_at))])]
      }
    }], null, false, 3573952361)
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 975 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    attrs: {
      "color": "blue darken-3",
      "dark": "",
      "app": "",
      "clipped-left": _vm.$vuetify.breakpoint.mdAndUp,
      "fixed": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "ml-0 pl-3",
    staticStyle: {
      "width": "300px"
    }
  }, [_c('v-toolbar-side-icon', {
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$store.dispatch('toggleMainMenuDrawer')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-sm-and-down"
  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "to": "/logout"
    }
  }, [_c('v-icon', [_vm._v("exit_to_app")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "large": "",
      "round": ""
    }
  }, [_c('v-avatar', {
    attrs: {
      "size": "32px",
      "tile": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Profile'
        })
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.avatar
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 976 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('AppEditPDFTemplatesDialog'), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.items,
      "hide-actions": "",
      "loading": _vm.loadingInProgress,
      "no-data-text": _vm.loadingItemsText
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.form_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.body))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.updated_at))]), _vm._v(" "), _c('td', {
          staticClass: "justify-left layout px-0"
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.editElement(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteElement(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("delete")])], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('AddPDFTemplateButton')], 1)
},staticRenderFns: []}

/***/ }),
/* 977 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pb9"
  }, [_c('AppEditClientsDialog'), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.items,
      "loading": _vm.loadingInProgress,
      "no-data-text": _vm.loadingItemsText,
      "rows-per-page-items": _vm.rowsPerPageItems,
      "pagination": _vm.pagination
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.updated_at))]), _vm._v(" "), _c('td', {
          staticClass: "justify-left layout px-0"
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.editElement(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteDialog(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("delete")])], 1), _vm._v(" "), _c('ConfirmationDialog', {
          ref: "confirm"
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('AddClientButton')], 1)
},staticRenderFns: []}

/***/ }),
/* 978 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card-text', [_vm._v("\n  Terms and Conditions in Chinese\n")])
},staticRenderFns: []}

/***/ }),
/* 979 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "md3": "",
      "px-1": "",
      "mt-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "date__picker"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Date",
            "prepend-icon": "event",
            "readonly": ""
          },
          model: {
            value: (_vm.date),
            callback: function($$v) {
              _vm.date = $$v
            },
            expression: "date"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "input": function($event) {
        _vm.menu = false
      }
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.items,
      "loading": _vm.loadingInProgress,
      "no-data-text": _vm.loadingItemsText,
      "rows-per-page-items": _vm.rowsPerPageItems,
      "pagination": _vm.pagination,
      "hide-actions": true
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "slotTime",
          class: props.item.timeline
        }, [_vm._v(_vm._s(props.item.time))]), _vm._v(" "), _c('td', {
          class: props.item.timeline
        }, [_vm._v(_vm._s(props.item.start_time))]), _vm._v(" "), _c('td', {
          class: props.item.timeline
        }, [_vm._v(_vm._s(props.item.end_time))]), _vm._v(" "), _c('td', {
          class: props.item.timeline
        }, [_vm._v(_vm._s(props.item.type))]), _vm._v(" "), _c('td', {
          class: props.item.timeline
        }, [_vm._v(_vm._s(props.item.case_manager))]), _vm._v(" "), _c('td', {
          class: props.item.timeline
        }, [_vm._v(_vm._s(_vm.getCaseCrew(props.item)))]), _vm._v(" "), _c('td', {
          class: props.item.timeline
        }, [_vm._v(_vm._s(props.item.id))])]
      }
    }])
  }), _vm._v(" "), _c('AddScheduledCaseButton'), _vm._v(" "), (_vm.dateForNewLead) ? _c('AddCaseNameAndDateDialog', {
    attrs: {
      "date": _vm.dateForNewLead
    },
    on: {
      "input": _vm.loadSchedules
    },
    model: {
      value: (_vm.dialogModel),
      callback: function($$v) {
        _vm.dialogModel = $$v
      },
      expression: "dialogModel"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 980 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    attrs: {
      "fab": "",
      "bottom": "",
      "right": "",
      "color": "pink",
      "dark": "",
      "fixed": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialog = !_vm.dialog
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "800px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-4 py-4 title"
  }, [_vm._v("\n        Add Booking\n      ")]), _vm._v(" "), _c('v-container', {
    staticClass: "pa-4",
    attrs: {
      "grid-list-sm": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "row": "",
      "wrap": ""
    }
  }, [_vm._t("CaseAndAmount", null, {
    "casesList": _vm.casesList,
    "selectedCase": _vm.selectedCase,
    "amount": _vm.amount
  }), _vm._v(" "), _vm._t("ItemsSelection", null, {
    "selectedItemType": _vm.selectedItemType,
    "inventoriesList": _vm.inventoriesList,
    "servicesList": _vm.servicesList,
    "caseManagersList": _vm.caseManagersList,
    "selectedInventory": _vm.selectedInventory,
    "selectedService": _vm.selectedService,
    "selectedCaseManager": _vm.selectedCaseManager,
    "amount": _vm.amount
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-menu', {
    model: {
      value: (_vm.menuDateStart),
      callback: function($$v) {
        _vm.menuDateStart = $$v
      },
      expression: "menuDateStart"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Select start date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateStart),
      callback: function($$v) {
        _vm.dateStart = $$v
      },
      expression: "dateStart"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": ""
    },
    model: {
      value: (_vm.dateStart),
      callback: function($$v) {
        _vm.dateStart = $$v
      },
      expression: "dateStart"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false
    },
    model: {
      value: (_vm.menuTimeStart.state),
      callback: function($$v) {
        _vm.$set(_vm.menuTimeStart, "state", $$v)
      },
      expression: "menuTimeStart.state"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Select start time",
      "prepend-icon": "alarm",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.timeStart),
      callback: function($$v) {
        _vm.timeStart = $$v
      },
      expression: "timeStart"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    model: {
      value: (_vm.timeStart),
      callback: function($$v) {
        _vm.timeStart = $$v
      },
      expression: "timeStart"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-menu', {
    model: {
      value: (_vm.menuDateEnd),
      callback: function($$v) {
        _vm.menuDateEnd = $$v
      },
      expression: "menuDateEnd"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Select end date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateEnd),
      callback: function($$v) {
        _vm.dateEnd = $$v
      },
      expression: "dateEnd"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": ""
    },
    model: {
      value: (_vm.dateEnd),
      callback: function($$v) {
        _vm.dateEnd = $$v
      },
      expression: "dateEnd"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false
    },
    model: {
      value: (_vm.menuTimeEnd.state),
      callback: function($$v) {
        _vm.$set(_vm.menuTimeEnd, "state", $$v)
      },
      expression: "menuTimeEnd.state"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Select end time",
      "prepend-icon": "alarm",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.timeEnd),
      callback: function($$v) {
        _vm.timeEnd = $$v
      },
      expression: "timeEnd"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    model: {
      value: (_vm.timeEnd),
      callback: function($$v) {
        _vm.timeEnd = $$v
      },
      expression: "timeEnd"
    }
  })], 1)], 1)], 2)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.saveNew
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('AppMainDialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "message": _vm.dialogMessage
    },
    on: {
      "closedialog": function($event) {
        _vm.dialogOpen = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 981 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "md8": ""
    }
  }, [_c('ItemCheckList', {
    attrs: {
      "item-id": _vm.$store.getters.currentUser.id,
      "item-type": _vm.itemType,
      "casesId": _vm.casesid
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 982 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('h2', [_vm._v("Settings")]), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Last Quotation No"
    },
    model: {
      value: (_vm.last_quotation_no),
      callback: function($$v) {
        _vm.last_quotation_no = $$v
      },
      expression: "last_quotation_no"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Last Invoice No"
    },
    model: {
      value: (_vm.last_invoice_no),
      callback: function($$v) {
        _vm.last_invoice_no = $$v
      },
      expression: "last_invoice_no"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.save($event)
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "bottom": "",
      "color": "success",
      "multi-line": "",
      "timeout": 2000
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    Saved!\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 983 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [(_vm.servicesList.length) ? _c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.close($event)
      }
    },
    model: {
      value: (_vm.getEditCrewDialog),
      callback: function($$v) {
        _vm.getEditCrewDialog = $$v
      },
      expression: "getEditCrewDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('h2', [_vm._v("Select Crew for Tasking")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v("Select shifting crew")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "disabled": _vm.isPreplan,
      "items": _vm.filterPalBearers(_vm.servicesList),
      "item-text": "description",
      "attach": "",
      "chips": "",
      "clearable": "",
      "multiple": "",
      "label": "Select shifting crew"
    },
    on: {
      "input": _vm.limiter
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n          ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_c('span', {
          staticClass: "v-chip v-chip--select-multi theme--light"
        }, [_c('span', {
          staticClass: "v-chip__content"
        }, [_vm._v("\n                " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n              ")])])]
      }
    }], null, false, 2443514655),
    model: {
      value: (_vm.selectedShiftingCrew),
      callback: function($$v) {
        _vm.selectedShiftingCrew = $$v
      },
      expression: "selectedShiftingCrew"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Select sending crew")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "disabled": _vm.isPreplan,
      "items": _vm.filterPalBearers(_vm.servicesList, 1),
      "item-text": "description",
      "attach": "",
      "chips": "",
      "clearable": "",
      "multiple": "",
      "label": "Select sending crew"
    },
    on: {
      "input": _vm.limiter
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n          ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_c('span', {
          staticClass: "v-chip v-chip--select-multi theme--light"
        }, [_c('span', {
          staticClass: "v-chip__content"
        }, [_vm._v("\n                " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n              ")])])]
      }
    }], null, false, 2443514655),
    model: {
      value: (_vm.selectedSendingCrew),
      callback: function($$v) {
        _vm.selectedSendingCrew = $$v
      },
      expression: "selectedSendingCrew"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Select funeral crew")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "disabled": _vm.isPreplan,
      "items": _vm.filterPalBearers(_vm.servicesList, 2),
      "item-text": "description",
      "attach": "",
      "chips": "",
      "clearable": "",
      "multiple": "",
      "label": "Select funeral crew"
    },
    on: {
      "input": _vm.limiter
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n          ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_c('span', {
          staticClass: "v-chip v-chip--select-multi theme--light"
        }, [_c('span', {
          staticClass: "v-chip__content"
        }, [_vm._v("\n                " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n              ")])])]
      }
    }], null, false, 2443514655),
    model: {
      value: (_vm.selectedFuneralCrew),
      callback: function($$v) {
        _vm.selectedFuneralCrew = $$v
      },
      expression: "selectedFuneralCrew"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Select times")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Sending Time",
      "prepend-icon": "alarm",
      "value": "12:30:00",
      "type": "time",
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.wakeSendingTime),
      callback: function($$v) {
        _vm.wakeSendingTime = $$v
      },
      expression: "wakeSendingTime"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Leave Office Time",
      "prepend-icon": "alarm",
      "value": "12:30:00",
      "type": "time",
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.leaveOfficeTime),
      callback: function($$v) {
        _vm.leaveOfficeTime = $$v
      },
      expression: "leaveOfficeTime"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Leave Wake Time",
      "prepend-icon": "alarm",
      "value": "12:30:00",
      "type": "time",
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.leaveWakeTime),
      callback: function($$v) {
        _vm.leaveWakeTime = $$v
      },
      expression: "leaveWakeTime"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Cremation / Burial Time",
      "prepend-icon": "alarm",
      "value": "12:30:00",
      "type": "time",
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.leaveFuneralTime),
      callback: function($$v) {
        _vm.leaveFuneralTime = $$v
      },
      expression: "leaveFuneralTime"
    }
  })], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": "#ff5353",
      "multi-line": "",
      "top": "",
      "right": "",
      "timeout": 6000
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n          You can select no more than three\n          "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("\n            Close\n          ")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "gray darken-1",
      "flat": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submit($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.approvedBtnLabel) + "Select & Notify")])], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 984 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "update:returnValue": _vm.setEditItemIdZero
    },
    model: {
      value: (_vm.dialogResult),
      callback: function($$v) {
        _vm.dialogResult = $$v
      },
      expression: "dialogResult"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "text-md-center"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Name"
    },
    model: {
      value: (_vm.itemData.name),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "name", $$v)
      },
      expression: "itemData.name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editItemData($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.dialogClose($event)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 985 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "update:returnValue": _vm.setEditItemIdZero
    },
    model: {
      value: (_vm.dialogResult),
      callback: function($$v) {
        _vm.dialogResult = $$v
      },
      expression: "dialogResult"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "text-md-center"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Name"
    },
    model: {
      value: (_vm.itemData.name),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "name", $$v)
      },
      expression: "itemData.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "Price"
    },
    model: {
      value: (_vm.itemData.price),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "price", $$v)
      },
      expression: "itemData.price"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "Commission"
    },
    model: {
      value: (_vm.itemData.commission),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "commission", $$v)
      },
      expression: "itemData.commission"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "Default amount"
    },
    model: {
      value: (_vm.itemData.amount),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "amount", $$v)
      },
      expression: "itemData.amount"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.usersList,
      "label": "Select user"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(props.item.name) + " - " + _vm._s(_vm._f("normalizeRoles")(props.item.roles)) + "\n          ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(props.item.name) + " - " + _vm._s(_vm._f("normalizeRoles")(props.item.roles)) + "\n          ")]
      }
    }]),
    model: {
      value: (_vm.itemData.users_id),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "users_id", $$v)
      },
      expression: "itemData.users_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [(_vm.categoriesList) ? _c('v-combobox', {
    attrs: {
      "loading": _vm.loading,
      "items": _vm.categoriesList,
      "search-input": _vm.categorySearch,
      "hide-selected": "",
      "label": "Select category"
    },
    on: {
      "update:searchInput": function($event) {
        _vm.categorySearch = $event
      },
      "update:search-input": function($event) {
        _vm.categorySearch = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(props.item.text) + "\n          ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(props.item.text) + "\n          ")]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_c('v-list-tile', {
          staticClass: "pointer"
        }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
          on: {
            "click": _vm.addCategory
          }
        }, [_vm._v("\n                  No results matching \""), _c('strong', [_vm._v(_vm._s(_vm.categorySearch))]), _vm._v("\". "), _c('kbd', [_vm._v("Click")]), _vm._v(" to create a new category\n                ")])], 1)], 1)]
      },
      proxy: true
    }, {
      key: "append-outer",
      fn: function() {
        return [_c('v-checkbox', {
          staticClass: "checkboxParentCategory",
          attrs: {
            "label": "Set parent category"
          },
          model: {
            value: (_vm.setParentId),
            callback: function($$v) {
              _vm.setParentId = $$v
            },
            expression: "setParentId"
          }
        })]
      },
      proxy: true
    }], null, false, 437995461),
    model: {
      value: (_vm.selectedCategory),
      callback: function($$v) {
        _vm.selectedCategory = $$v
      },
      expression: "selectedCategory"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.categoriesList && _vm.setParentId) ? _c('v-combobox', {
    attrs: {
      "loading": _vm.loading.categories,
      "items": _vm.excludeSelectedCategory,
      "hide-selected": "",
      "label": "Select parent category"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(props.item.text) + "\n          ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(props.item.text) + "\n          ")]
      }
    }], null, false, 4114375804),
    model: {
      value: (_vm.selectedParentCategory),
      callback: function($$v) {
        _vm.selectedParentCategory = $$v
      },
      expression: "selectedParentCategory"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editItemDataDecorator($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.dialogClose($event)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 986 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('v-select', {
    attrs: {
      "items": _vm.plansList,
      "loading": _vm.loading.plans,
      "disabled": _vm.closed,
      "label": "Select plan",
      "return-object": "",
      "rules": _vm.required
    },
    on: {
      "change": _vm.changedPlan
    },
    model: {
      value: (_vm.selectedPlan),
      callback: function($$v) {
        _vm.selectedPlan = $$v
      },
      expression: "selectedPlan"
    }
  }), _vm._v(" "), (_vm.selectedPlan) ? _c('v-layout', {
    attrs: {
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('div', {
    staticClass: "selected"
  }, [_vm._v("Default casket: "), _c('span', {
    staticClass: "default-casket"
  }, [_vm._v(_vm._s(_vm.defaultCasket))])]), _vm._v(" "), _c('span', {
    staticClass: "arrow-right"
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [(_vm.selectedPlan) ? _c('v-select', {
    attrs: {
      "items": _vm.allCaskets,
      "disabled": _vm.closed,
      "label": "Select Casket Model",
      "clearable": "",
      "id": "selectCasket"
    },
    model: {
      value: (_vm.selectedCasket),
      callback: function($$v) {
        _vm.selectedCasket = $$v
      },
      expression: "selectedCasket"
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectedPlan && _vm.servicesList && _vm.servicesList.length > 0) ? _c('v-flex', [(_vm.selectedPlan && _vm.servicesList && _vm.servicesList.length > 0) ? _c('v-combobox', {
    attrs: {
      "items": _vm.filterProducts(_vm.servicesList),
      "loading": _vm.loading.services,
      "value": _vm.filterProducts(_vm.selectedServices),
      "disabled": _vm.closed,
      "label": "Select products",
      "item-value": "id",
      "item-text": "name",
      "filter": _vm.filter,
      "return-object": "",
      "multiple": "",
      "attach": "",
      "clearable": "",
      "hide-selected": "",
      "id": "selectProducts"
    },
    on: {
      "change": function($event) {
        return _vm.updateSelectedServices($event, 'product')
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n          Product: " + _vm._s(props.item.name) + " | Category: " + _vm._s(props.item.category.name) + "\n        ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_c('span', {
          staticClass: "v-chip v-chip--select-multi theme--light"
        }, [_c('span', {
          staticClass: "v-chip__content"
        }, [_vm._v("\n              " + _vm._s(props.item.name) + "\n            ")])])]
      }
    }], null, false, 4123951351)
  }) : _vm._e(), _vm._v(" "), (_vm.selectedPlan && _vm.servicesList && _vm.servicesList.length > 0) ? _c('v-combobox', {
    attrs: {
      "items": _vm.filterAddons(_vm.servicesList, 30),
      "loading": _vm.loading.services,
      "value": _vm.filterAddons(_vm.selectedServices, 30),
      "disabled": _vm.closed,
      "label": "Select Floral Add-Ons",
      "item-value": "id",
      "item-text": "name",
      "filter": _vm.filter,
      "return-object": "",
      "autofocus": "",
      "deletable-chips": "",
      "multiple": "",
      "clearable": "",
      "hide-selected": ""
    },
    on: {
      "change": function($event) {
        return _vm.updateSelectedServices($event, 'add', 30)
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n          " + _vm._s(props.item.name) + "\n        ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_c('span', {
          staticClass: "v-chip v-chip--select-multi theme--light"
        }, [_c('span', {
          staticClass: "v-chip__content"
        }, [_vm._v("\n              " + _vm._s(props.item.name) + "\n            ")])])]
      }
    }], null, false, 1524128383)
  }) : _vm._e(), _vm._v(" "), (_vm.selectedPlan && _vm.servicesList && _vm.servicesList.length > 0) ? _c('v-combobox', {
    attrs: {
      "items": _vm.filterAddons(_vm.servicesList, 31),
      "loading": _vm.loading.services,
      "value": _vm.filterAddons(_vm.selectedServices, 31),
      "disabled": _vm.closed,
      "label": "Select Services Add-Ons",
      "item-value": "id",
      "item-text": "name",
      "filter": _vm.filter,
      "return-object": "",
      "autofocus": "",
      "deletable-chips": "",
      "multiple": "",
      "clearable": "",
      "hide-selected": ""
    },
    on: {
      "change": function($event) {
        return _vm.updateSelectedServices($event, 'add', 31)
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n          " + _vm._s(props.item.name) + "\n        ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_c('span', {
          staticClass: "v-chip v-chip--select-multi theme--light"
        }, [_c('span', {
          staticClass: "v-chip__content"
        }, [_vm._v("\n              " + _vm._s(props.item.name) + "\n            ")])])]
      }
    }], null, false, 1524128383)
  }) : _vm._e(), _vm._v(" "), (_vm.selectedPlan && _vm.servicesList && _vm.servicesList.length > 0) ? _c('v-combobox', {
    attrs: {
      "items": _vm.filterAddons(_vm.servicesList, 32),
      "loading": _vm.loading.services,
      "value": _vm.filterAddons(_vm.selectedServices, 32),
      "disabled": _vm.closed,
      "label": "Select Add-On Items",
      "item-value": "id",
      "item-text": "name",
      "filter": _vm.filter,
      "return-object": "",
      "autofocus": "",
      "deletable-chips": "",
      "multiple": "",
      "clearable": "",
      "hide-selected": ""
    },
    on: {
      "change": function($event) {
        return _vm.updateSelectedServices($event, 'add', 32)
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n          " + _vm._s(props.item.name) + "\n        ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_c('span', {
          staticClass: "v-chip v-chip--select-multi theme--light"
        }, [_c('span', {
          staticClass: "v-chip__content"
        }, [_vm._v("\n              " + _vm._s(props.item.name) + "\n            ")])])]
      }
    }], null, false, 1524128383)
  }) : _vm._e(), _vm._v(" "), (_vm.selectedPlan && _vm.servicesList && _vm.servicesList.length > 0) ? _c('v-combobox', {
    attrs: {
      "items": _vm.filterAddons(_vm.servicesList, 33),
      "loading": _vm.loading.services,
      "value": _vm.filterAddons(_vm.selectedServices, 33),
      "disabled": _vm.closed,
      "label": "Select Food and Gift Add-Ons",
      "item-value": "id",
      "item-text": "name",
      "filter": _vm.filter,
      "return-object": "",
      "autofocus": "",
      "deletable-chips": "",
      "multiple": "",
      "clearable": "",
      "hide-selected": ""
    },
    on: {
      "change": function($event) {
        return _vm.updateSelectedServices($event, 'add', 33)
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n          " + _vm._s(props.item.name) + "\n        ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_c('span', {
          staticClass: "v-chip v-chip--select-multi theme--light"
        }, [_c('span', {
          staticClass: "v-chip__content"
        }, [_vm._v("\n              " + _vm._s(props.item.name) + "\n            ")])])]
      }
    }], null, false, 1524128383)
  }) : _vm._e(), _vm._v(" "), (_vm.selectedPlan && _vm.servicesList && _vm.servicesList.length > 0) ? _c('v-combobox', {
    attrs: {
      "items": _vm.filterAddons(_vm.servicesList, 34),
      "loading": _vm.loading.services,
      "value": _vm.filterAddons(_vm.selectedServices, 34),
      "disabled": _vm.closed,
      "label": "Select Logistics Add-Ons",
      "item-value": "id",
      "item-text": "name",
      "filter": _vm.filter,
      "return-object": "",
      "autofocus": "",
      "deletable-chips": "",
      "multiple": "",
      "clearable": "",
      "hide-selected": ""
    },
    on: {
      "change": function($event) {
        return _vm.updateSelectedServices($event, 'add', 34)
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n          " + _vm._s(props.item.name) + "\n        ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_c('span', {
          staticClass: "v-chip v-chip--select-multi theme--light"
        }, [_c('span', {
          staticClass: "v-chip__content"
        }, [_vm._v("\n              " + _vm._s(props.item.name) + "\n            ")])])]
      }
    }], null, false, 1524128383)
  }) : _vm._e(), _vm._v(" "), (_vm.selectedServices && _vm.selectedServices.length) ? _c('v-data-table', {
    attrs: {
      "items": _vm.selectedServices,
      "headers": _vm.productsTableHeaders,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_c('v-layout', {
          attrs: {
            "justify-space-between": "",
            "align-center": ""
          }
        }, [(_vm.upgrade_id === props.item.id) ? _c('v-combobox', {
          attrs: {
            "items": _vm.filteredProducts,
            "label": "Select Another Product from same category"
          },
          on: {
            "change": function($event) {
              return _vm.changeProductFromCategory(props.item)
            }
          },
          model: {
            value: (_vm.change_product_from_category_model),
            callback: function($$v) {
              _vm.change_product_from_category_model = $$v
            },
            expression: "change_product_from_category_model"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.upgrade_id !== props.item.id) ? _c('span', [_vm._v("\n                " + _vm._s(props.item.name) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.upgrade_id !== props.item.id && !_vm.closed) ? _c('v-btn', {
          attrs: {
            "small": "",
            "align-rigth": ""
          },
          on: {
            "click": function($event) {
              return _vm.upgradeCategory(props.item)
            }
          }
        }, [_vm._v("Upgrade")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('td', {
          staticClass: "quantity_bgcolor"
        }, [_c('v-edit-dialog', {
          attrs: {
            "return-value": props.item.amount,
            "large": "",
            "lazy": "",
            "persistent": ""
          },
          on: {
            "update:returnValue": function($event) {
              return _vm.$set(props.item, "amount", $event)
            },
            "update:return-value": function($event) {
              return _vm.$set(props.item, "amount", $event)
            }
          },
          scopedSlots: _vm._u([{
            key: "input",
            fn: function() {
              return [_c('v-text-field', {
                attrs: {
                  "label": "Quantity",
                  "disabled": _vm.closed,
                  "single-line": "",
                  "autofocus": ""
                },
                model: {
                  value: (props.item.amount),
                  callback: function($$v) {
                    _vm.$set(props.item, "amount", $$v)
                  },
                  expression: "props.item.amount"
                }
              })]
            },
            proxy: true
          }], null, true)
        }, [_c('div', [_vm._v(_vm._s(props.item.amount))])])], 1), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(props.item.price))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(props.item.amount * props.item.price))]), _vm._v(" "), _c('td', {
          staticClass: "justify-center layout px-0"
        }, [(!_vm.closed) ? _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteItem(props.item)
            }
          }
        }, [_vm._v("\n              delete\n            ")]) : _vm._e()], 1)]
      }
    }], null, false, 3565082664)
  }, [_vm._v(" "), _c('template', {
    slot: "footer"
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Remarks in $",
      "type": "number",
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.discount),
      callback: function($$v) {
        _vm.discount = $$v
      },
      expression: "discount"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-textarea', {
    attrs: {
      "label": "Remarks in text",
      "outline": "",
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.remarks),
      callback: function($$v) {
        _vm.remarks = $$v
      },
      expression: "remarks"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "tag": "h3"
    }
  }, [_vm._v("\n            Final price: $" + _vm._s(_vm.finalPrice) + "\n          ")])], 1)], 2) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mt-5": ""
    }
  }, [_c('h3', [_vm._v("Embalming Notes")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Tag number & other remarks",
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.tagAndRemarks),
      callback: function($$v) {
        _vm.tagAndRemarks = $$v
      },
      expression: "tagAndRemarks"
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [(_vm.caseData && _vm.caseData.embalmer_photos) ? _c('div', {
    staticClass: "emb_images_container"
  }, _vm._l((_vm.caseData.embalmer_photos), function(embImage, key) {
    return _c('div', {
      key: key,
      staticClass: "emb_image_wrap"
    }, [_c('div', {
      staticClass: "removeImage",
      on: {
        "click": function($event) {
          return _vm.deleteImageWithConfirmation(embImage.id, key)
        }
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "emb_image",
      attrs: {
        "src": embImage.embalmer_photo_uri,
        "alt": embImage.embalmer_photo_caption
      }
    })])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.uploadPercentage !== 0 && _vm.uploadPercentage !== 100) ? _c('v-progress-linear', {
    attrs: {
      "value": _vm.uploadPercentage,
      "color": "light-blue"
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.closed) ? _c('v-btn', {
    staticClass: "mt-3 ml-0",
    attrs: {
      "color": "primary",
      "disabled": _vm.disabled.uploadPhotoForEmbalmersBtn,
      "loading": _vm.disabled.uploadPhotoForEmbalmersBtn,
      "prepend-icon": _vm.uploadStatus,
      "type": "file"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.inputUpload.click()
      }
    }
  }, [_vm._v("Upload Optional Photo\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.closed) ? _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "inputUpload",
    attrs: {
      "accept": "image/*, .jpg, .jpeg, .png",
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.onFileChange
    }
  }) : _vm._e(), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "bottom": "",
      "color": "success",
      "multi-line": "",
      "timeout": 2000
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("Photo uploaded!")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mt-5": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Preplan",
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.isPreplan),
      callback: function($$v) {
        _vm.isPreplan = $$v
      },
      expression: "isPreplan"
    }
  }), _vm._v(" "), (!_vm.isPreplan) ? _c('h3', [_vm._v("Wake Dates")]) : _vm._e(), _vm._v(" "), (!_vm.isPreplan) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "id": "selectStartDate"
    },
    model: {
      value: (_vm.menuDateStart),
      callback: function($$v) {
        _vm.menuDateStart = $$v
      },
      expression: "menuDateStart"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Select start date",
      "prepend-icon": "event",
      "readonly": "",
      "disabled": _vm.closed
    },
    slot: "activator",
    model: {
      value: (_vm.wakeDateStart),
      callback: function($$v) {
        _vm.wakeDateStart = $$v
      },
      expression: "wakeDateStart"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": "",
      "min": _vm.minStartDate,
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.wakeDateStart),
      callback: function($$v) {
        _vm.wakeDateStart = $$v
      },
      expression: "wakeDateStart"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isPreplan) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "id": "selectEndDate"
    },
    model: {
      value: (_vm.menuDateEnd),
      callback: function($$v) {
        _vm.menuDateEnd = $$v
      },
      expression: "menuDateEnd"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Select end date",
      "prepend-icon": "event",
      "readonly": "",
      "disabled": _vm.closed
    },
    slot: "activator",
    model: {
      value: (_vm.wakeDateEnd),
      callback: function($$v) {
        _vm.wakeDateEnd = $$v
      },
      expression: "wakeDateEnd"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": "",
      "min": _vm.minEndDate,
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.wakeDateEnd),
      callback: function($$v) {
        _vm.wakeDateEnd = $$v
      },
      expression: "wakeDateEnd"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.selectedServices && _vm.selectedServices.length &&
    _vm.visible.attachServicesToCaseBtn && !_vm.closed) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "block": "",
      "loading": _vm.loading.attachServicesToCaseBtn,
      "disabled": _vm.loading.attachServicesToCaseBtn || !_vm.validated
    },
    on: {
      "click": _vm.attachServicesToCase
    }
  }, [_vm._v("\n        Confirm Order\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.validated) ? _c('v-flex', {
    staticClass: "validation",
    attrs: {
      "xs12": ""
    }
  }, [_c('h4', [_vm._v("Left to fill in:")]), _vm._v(" "), _c('ul', [(!_vm.selectedCasket) ? _c('li', [_c('a', {
    attrs: {
      "href": "#selectCasket"
    }
  }, [_vm._v("Select Casket Model")])]) : _vm._e(), _vm._v(" "), (!_vm.selectedServices) ? _c('li', [_c('a', {
    attrs: {
      "href": "#selectProducts"
    }
  }, [_vm._v("Select Products")])]) : _vm._e(), _vm._v(" "), (!_vm.wakeDateStart) ? _c('li', [_c('a', {
    attrs: {
      "href": "#selectStartDate"
    }
  }, [_vm._v("Select Wake Start Date")])]) : _vm._e(), _vm._v(" "), (!_vm.wakeDateEnd) ? _c('li', [_c('a', {
    attrs: {
      "href": "#selectEndDate"
    }
  }, [_vm._v("Select Wake End Date")])]) : _vm._e()])]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('ConfirmationDialog', {
    ref: "confirm"
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.showAlert),
      callback: function($$v) {
        _vm.showAlert = $$v
      },
      expression: "showAlert"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', {
    staticClass: "flex-alert-center"
  }, [_c('v-icon', {
    staticClass: "flex-alert-notification-check",
    attrs: {
      "dark": "",
      "right": ""
    }
  }, [_vm._v("check_circle")]), _vm._v(" " + _vm._s(_vm.alertMessage) + "\n      ")], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 987 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "px-5": "",
      "py-3": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.eventsList,
      "label": "Select an event"
    },
    model: {
      value: (_vm.selectedEvent),
      callback: function($$v) {
        _vm.selectedEvent = $$v
      },
      expression: "selectedEvent"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "textarea": "",
      "label": "Message",
      "rows": "5"
    },
    model: {
      value: (_vm.notificationMessage),
      callback: function($$v) {
        _vm.notificationMessage = $$v
      },
      expression: "notificationMessage"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "textarea": "",
      "label": "Recipients (comma-separated values)",
      "rows": "2"
    },
    model: {
      value: (_vm.notificationRecipients),
      callback: function($$v) {
        _vm.notificationRecipients = $$v
      },
      expression: "notificationRecipients"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Is active?"
    },
    model: {
      value: (_vm.notificationIsActive),
      callback: function($$v) {
        _vm.notificationIsActive = $$v
      },
      expression: "notificationIsActive"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.saveNotification
    }
  }, [_vm._v("Save settings")])], 1)], 1), _vm._v(" "), _c('AppEditWhatsappNotificationsDialog'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mt-5": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.items,
      "hide-actions": "",
      "loading": _vm.loadingInProgress,
      "no-data-text": _vm.loadingItemsText
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.message))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.event.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.recipients_string))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.is_active))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.updated_at))]), _vm._v(" "), _c('td', {
          staticClass: "justify-left layout px-0"
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.editElement(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteDialog(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("delete")])], 1), _vm._v(" "), _c('confirmation-dialog', {
          ref: "confirm"
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('AppMainDialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "message": _vm.dialogMessage
    },
    on: {
      "closedialog": function($event) {
        _vm.dialogOpen = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 988 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "update:returnValue": _vm.setEditItemIdZero
    },
    model: {
      value: (_vm.dialogResult),
      callback: function($$v) {
        _vm.dialogResult = $$v
      },
      expression: "dialogResult"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "text-md-center"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.formsList,
      "label": "Form ID"
    },
    model: {
      value: (_vm.itemData.forms_id),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "forms_id", $$v)
      },
      expression: "itemData.forms_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Body",
      "textarea": ""
    },
    model: {
      value: (_vm.itemData.body),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "body", $$v)
      },
      expression: "itemData.body"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editItemData($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.dialogClose($event)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 989 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('AppEditBookingsBaseDialog', {
    scopedSlots: _vm._u([{
      key: "CaseAndAmount",
      fn: function(props) {
        return [_c('v-flex', {
          attrs: {
            "xs12": "",
            "align-center": "",
            "justify-space-between": ""
          }
        }, [_c('v-select', {
          attrs: {
            "items": props.casesList,
            "label": "Select case"
          },
          model: {
            value: (props.selectedCase.id),
            callback: function($$v) {
              _vm.$set(props.selectedCase, "id", $$v)
            },
            expression: "props.selectedCase.id"
          }
        })], 1)]
      }
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 990 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [(!_vm.loadingCaseForms) ? _c('v-flex', {
    staticClass: "ph16",
    attrs: {
      "md12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md2": "",
      "d-inline-flex": ""
    }
  }, [_vm._v("\n      I,\n    ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md5": "",
      "d-inline-flex": ""
    }
  }, [_c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": "Name",
      "rules": _vm.nameRules
    },
    model: {
      value: (_vm.localClientFormData.name),
      callback: function($$v) {
        _vm.$set(_vm.localClientFormData, "name", $$v)
      },
      expression: "localClientFormData.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md5": "",
      "xs12": "",
      "d-inline-flex": ""
    }
  }, [_c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": "NRIC/FIN Number",
      "rules": _vm.nricFinNumberRules
    },
    model: {
      value: (_vm.localClientFormData.nric_fin_number),
      callback: function($$v) {
        _vm.$set(_vm.localClientFormData, "nric_fin_number", $$v)
      },
      expression: "localClientFormData.nric_fin_number"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-inline-flex": ""
    }
  }, [_vm._v("\n      have acknowledged receipt of and accepted the above mentioned Service Agreement that outlines the terms and\n      conditions of the services provided, and hereby authorise “Direct Funeral Services Pte Ltd” to bill myself based\n      on the above information provided.\n    ")]), _c('br'), _c('br'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-inline-flex": ""
    }
  }, [_vm._v("\n      I acknowledge that our funeral director has shown and clearly explained the terms and conditions of products and services. In addition, I confirm that I have fully understood and agree to the terms and conditions stated above.\n    ")]), _c('br'), _c('br'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": "Contact Number",
      "rules": _vm.contactNumberRules
    },
    model: {
      value: (_vm.localClientFormData.contact_number),
      callback: function($$v) {
        _vm.$set(_vm.localClientFormData, "contact_number", $$v)
      },
      expression: "localClientFormData.contact_number"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": "Email",
      "rules": _vm.emailRules
    },
    model: {
      value: (_vm.localClientFormData.email),
      callback: function($$v) {
        _vm.$set(_vm.localClientFormData, "email", $$v)
      },
      expression: "localClientFormData.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": "Mailing address",
      "rules": _vm.mailingAddressRules
    },
    model: {
      value: (_vm.localClientFormData.mailing_address),
      callback: function($$v) {
        _vm.$set(_vm.localClientFormData, "mailing_address", $$v)
      },
      expression: "localClientFormData.mailing_address"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Mailing Address same as per Deceased's Address"
    },
    model: {
      value: (_vm.localClientFormData.mailing_address_same),
      callback: function($$v) {
        _vm.$set(_vm.localClientFormData, "mailing_address_same", $$v)
      },
      expression: "localClientFormData.mailing_address_same"
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 991 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loadingCaseForms) ? _c('v-form', {
    staticClass: "ph16",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "pb-3": ""
    }
  }, [_vm._v("\n      Please check and sign in the space provided to acknowledge that our funeral director has explained our funeral packages adequately, provided you with a quotation and gone through the preparation list. In addition, you confirmed that you fully understand and agree with the terms and conditions stated above. By signing below, you have confirmed that you have given consent to Direct Funeral Services Pte Ltd on the collection, use and disclosure of my personal data for administrative and marketing purposes.\n    ")]), _vm._v(" "), _c('v-flex', [_c('v-radio-group', {
    staticClass: "required large-radio",
    attrs: {
      "large": "",
      "label": "I confirm that I have checked and verified that there are no valuable items on the deceased body at the point of collection."
    },
    model: {
      value: (_vm.localAgreementFormData.no_valuable_items),
      callback: function($$v) {
        _vm.$set(_vm.localAgreementFormData, "no_valuable_items", $$v)
      },
      expression: "localAgreementFormData.no_valuable_items"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": 'Yes',
      "value": 1
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": 'No',
      "value": 0
    }
  })], 1), _vm._v(" "), (_vm.localAgreementFormData.no_valuable_items === 0) ? _c('v-text-field', {
    attrs: {
      "label": "If there are, please declare"
    },
    model: {
      value: (_vm.localAgreementFormData.valuable_items_declaration),
      callback: function($$v) {
        _vm.$set(_vm.localAgreementFormData, "valuable_items_declaration", $$v)
      },
      expression: "localAgreementFormData.valuable_items_declaration"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', [_c('v-radio-group', {
    staticClass: "required large-radio",
    attrs: {
      "label": "I confirm that I have checked and verified that there are none of any medical implants (pace maker and others) or any prosthetics (dentures, prosthetic limbs, gold teeth) are in the deceased body at the point of collection."
    },
    model: {
      value: (_vm.localAgreementFormData.no_additional_items_on_body),
      callback: function($$v) {
        _vm.$set(_vm.localAgreementFormData, "no_additional_items_on_body", $$v)
      },
      expression: "localAgreementFormData.no_additional_items_on_body"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": 'Yes',
      "value": 1
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": 'No',
      "value": 0
    }
  })], 1), _vm._v(" "), (_vm.localAgreementFormData.no_additional_items_on_body === 0) ? _c('v-text-field', {
    attrs: {
      "label": "If there are, please declare"
    },
    model: {
      value: (_vm.localAgreementFormData.valuable_additional_items_declaration),
      callback: function($$v) {
        _vm.$set(_vm.localAgreementFormData, "valuable_additional_items_declaration", $$v)
      },
      expression: "localAgreementFormData.valuable_additional_items_declaration"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', [_vm._v("Ash placement will be arranged by:")]), _vm._v(" "), _c('v-flex', [_c('v-radio-group', {
    staticClass: "large-radio",
    model: {
      value: (_vm.localAgreementFormData.ash_placement_arranged_by),
      callback: function($$v) {
        _vm.$set(_vm.localAgreementFormData, "ash_placement_arranged_by", $$v)
      },
      expression: "localAgreementFormData.ash_placement_arranged_by"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "N/A",
      "value": "0"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Family",
      "value": "1"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Direct Funeral Services Pte Ltd",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', [_vm._v("Ash Collection Location:")]), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    model: {
      value: (_vm.localAgreementFormData.ash_collection_location),
      callback: function($$v) {
        _vm.$set(_vm.localAgreementFormData, "ash_collection_location", $$v)
      },
      expression: "localAgreementFormData.ash_collection_location"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_vm._v("Ash Collection Vendor:")]), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    model: {
      value: (_vm.localAgreementFormData.ash_collection_vendor),
      callback: function($$v) {
        _vm.$set(_vm.localAgreementFormData, "ash_collection_vendor", $$v)
      },
      expression: "localAgreementFormData.ash_collection_vendor"
    }
  })], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 992 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pb9"
  }, [_c('AppEditProductsDialog'), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('v-spacer'), _vm._v(" "), (_vm.categoriesList) ? _c('v-combobox', {
    attrs: {
      "items": _vm.categoriesList,
      "search-input": _vm.categorySearch,
      "hide-selected": "",
      "clearable": "",
      "label": "Filter by category"
    },
    on: {
      "change": _vm.filterByCategory,
      "update:searchInput": function($event) {
        _vm.categorySearch = $event
      },
      "update:search-input": function($event) {
        _vm.categorySearch = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n          " + _vm._s(props.item.cascade_name) + "\n        ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_vm._v("\n          " + _vm._s(props.item.cascade_name) + "\n        ")]
      }
    }], null, false, 127982300)
  }) : _vm._e()], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.products,
      "loading": _vm.loadingInProgress,
      "no-data-text": _vm.loadingOrNoItemsText,
      "rows-per-page-items": _vm.rowsPerPageItems,
      "pagination": _vm.pagination
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.commission))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.amount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.category ? props.item.category.name : 'N/A'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.user ? props.item.user.name : 'N/A'))]), _vm._v(" "), _c('td', {
          staticClass: "justify-left layout px-0"
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.editElement(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteDialog(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("delete")])], 1), _vm._v(" "), _c('confirmation-dialog', {
          ref: "confirm"
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('AddProductButton')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 993 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('v-card-title', [_c('h3', [_vm._v("Feedback")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.loading.pdf,
      "disabled": _vm.pdfBtnDisabled || _vm.loading.pdf,
      "outline": "",
      "color": "blue"
    },
    on: {
      "click": _vm.downloadFeedback
    }
  }, [_vm._v("PDF\n        "), _c('v-icon', [_vm._v("list")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md2": ""
    }
  }, [_c('v-menu', {
    model: {
      value: (_vm.menuDateStart),
      callback: function($$v) {
        _vm.menuDateStart = $$v
      },
      expression: "menuDateStart"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Visitation date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.feedbackForm.dateStart),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "dateStart", $$v)
      },
      expression: "feedbackForm.dateStart"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": ""
    },
    model: {
      value: (_vm.feedbackForm.dateStart),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "dateStart", $$v)
      },
      expression: "feedbackForm.dateStart"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md2": "",
      "offset-sm1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Visitation time",
      "prepend-icon": "alarm",
      "value": "12:30:00",
      "type": "time"
    },
    model: {
      value: (_vm.feedbackForm.timeStart),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "timeStart", $$v)
      },
      expression: "feedbackForm.timeStart"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.caseManagers,
      "label": "Briefing by"
    },
    model: {
      value: (_vm.feedbackForm.selectedUser),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "selectedUser", $$v)
      },
      expression: "feedbackForm.selectedUser"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Family assemble time",
      "prepend-icon": "alarm",
      "value": "12:30:00",
      "type": "time"
    },
    model: {
      value: (_vm.feedbackForm.familyAssembleTime),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "familyAssembleTime", $$v)
      },
      expression: "feedbackForm.familyAssembleTime"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md2": "",
      "offset-sm1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Funeral Time",
      "prepend-icon": "alarm",
      "value": "12:30:00",
      "type": "time"
    },
    model: {
      value: (_vm.feedbackForm.funeralServiceCommencedTime),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "funeralServiceCommencedTime", $$v)
      },
      expression: "feedbackForm.funeralServiceCommencedTime"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": ['lifting of coffin', 'fong ting', 'sa jing'],
      "multiple": "",
      "small-chips": "",
      "label": "Funeral rites"
    },
    model: {
      value: (_vm.feedbackForm.funeralRites),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "funeralRites", $$v)
      },
      expression: "feedbackForm.funeralRites"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Cortege leave time",
      "prepend-icon": "alarm",
      "value": "12:30:00",
      "type": "time"
    },
    model: {
      value: (_vm.feedbackForm.cortegeLeaveTime),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "cortegeLeaveTime", $$v)
      },
      expression: "feedbackForm.cortegeLeaveTime"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm8": "",
      "md10": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Church location"
    },
    model: {
      value: (_vm.feedbackForm.churchLocation),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "churchLocation", $$v)
      },
      expression: "feedbackForm.churchLocation"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": "",
      "offset-sm1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Church mass at",
      "prepend-icon": "alarm",
      "value": "12:30:00",
      "type": "time"
    },
    model: {
      value: (_vm.feedbackForm.churchMassAt),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "churchMassAt", $$v)
      },
      expression: "feedbackForm.churchMassAt"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Driving pass"
    },
    model: {
      value: (_vm.feedbackForm.drivingPass),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "drivingPass", $$v)
      },
      expression: "feedbackForm.drivingPass"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": ['Mandai Crematorium', 'Kong Meng San Phor Kark See Monastery', 'Tse Tho Aum Temple', 'Choa Chu Kang Cemetery Complex'],
      "label": "Cremation location"
    },
    model: {
      value: (_vm.feedbackForm.cremationLocation),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "cremationLocation", $$v)
      },
      expression: "feedbackForm.cremationLocation"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": "",
      "offset-sm1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Cremation time",
      "prepend-icon": "alarm",
      "value": "12:30:00",
      "type": "time"
    },
    model: {
      value: (_vm.feedbackForm.cremationTime),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "cremationTime", $$v)
      },
      expression: "feedbackForm.cremationTime"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Post funeral send to"
    },
    model: {
      value: (_vm.feedbackForm.postFuneralSendTo),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "postFuneralSendTo", $$v)
      },
      expression: "feedbackForm.postFuneralSendTo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Ash collection"
    },
    model: {
      value: (_vm.feedbackForm.ashCollection),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "ashCollection", $$v)
      },
      expression: "feedbackForm.ashCollection"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": "",
      "offset-sm0": "",
      "offset-md1": ""
    }
  }, [_c('v-menu', {
    model: {
      value: (_vm.menuAshCollectionDate),
      callback: function($$v) {
        _vm.menuAshCollectionDate = $$v
      },
      expression: "menuAshCollectionDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Ash collection date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.feedbackForm.ashCollectionDate),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "ashCollectionDate", $$v)
      },
      expression: "feedbackForm.ashCollectionDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": ""
    },
    model: {
      value: (_vm.feedbackForm.ashCollectionDate),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "ashCollectionDate", $$v)
      },
      expression: "feedbackForm.ashCollectionDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": "",
      "offset-sm0": "",
      "offset-md1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Ash collection time",
      "prepend-icon": "alarm",
      "value": "12:30:00",
      "type": "time"
    },
    model: {
      value: (_vm.feedbackForm.ashCollectionTime),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "ashCollectionTime", $$v)
      },
      expression: "feedbackForm.ashCollectionTime"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Send ash to"
    },
    model: {
      value: (_vm.feedbackForm.sendAshTo),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "sendAshTo", $$v)
      },
      expression: "feedbackForm.sendAshTo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": "",
      "offset-sm0": "",
      "offset-md1": ""
    }
  }, [_c('v-menu', {
    model: {
      value: (_vm.menuSendAshToDate),
      callback: function($$v) {
        _vm.menuSendAshToDate = $$v
      },
      expression: "menuSendAshToDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Send ash to date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.feedbackForm.sendAshToDate),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "sendAshToDate", $$v)
      },
      expression: "feedbackForm.sendAshToDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": ""
    },
    model: {
      value: (_vm.feedbackForm.sendAshToDate),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "sendAshToDate", $$v)
      },
      expression: "feedbackForm.sendAshToDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": "",
      "offset-sm0": "",
      "offset-md1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Send ash to time",
      "prepend-icon": "alarm",
      "value": "12:30:00",
      "type": "time"
    },
    model: {
      value: (_vm.feedbackForm.sendAshToTime),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "sendAshToTime", $$v)
      },
      expression: "feedbackForm.sendAshToTime"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Sea burial at"
    },
    model: {
      value: (_vm.feedbackForm.seaBurialAt),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "seaBurialAt", $$v)
      },
      expression: "feedbackForm.seaBurialAt"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": "",
      "offset-sm0": "",
      "offset-md1": ""
    }
  }, [_c('v-menu', {
    model: {
      value: (_vm.menuSeaBurialAtDate),
      callback: function($$v) {
        _vm.menuSeaBurialAtDate = $$v
      },
      expression: "menuSeaBurialAtDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Sea burial at date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.feedbackForm.seaBurialAtDate),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "seaBurialAtDate", $$v)
      },
      expression: "feedbackForm.seaBurialAtDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": ""
    },
    model: {
      value: (_vm.feedbackForm.seaBurialAtDate),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "seaBurialAtDate", $$v)
      },
      expression: "feedbackForm.seaBurialAtDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": "",
      "offset-sm0": "",
      "offset-md1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Sea burial at time",
      "prepend-icon": "alarm",
      "value": "12:30:00",
      "type": "time"
    },
    model: {
      value: (_vm.feedbackForm.seaBurialAtTime),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "seaBurialAtTime", $$v)
      },
      expression: "feedbackForm.seaBurialAtTime"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tear down of Tentage will be after",
      "prepend-icon": "alarm",
      "value": "12:30:00",
      "type": "time"
    },
    model: {
      value: (_vm.feedbackForm.tentageAfter),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "tentageAfter", $$v)
      },
      expression: "feedbackForm.tentageAfter"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm8": "",
      "md10": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-label', {
    attrs: {
      "gray": ""
    }
  }, [_vm._v("Satisfied with set up?")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.feedbackForm.satisfiedWithSetUp),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "satisfiedWithSetUp", $$v)
      },
      expression: "feedbackForm.satisfiedWithSetUp"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Yes",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "No",
      "value": false
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": "",
      "offset-sm0": "",
      "offset-md1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Why?"
    },
    model: {
      value: (_vm.feedbackForm.satisfiedWithSetUpWhy),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "satisfiedWithSetUpWhy", $$v)
      },
      expression: "feedbackForm.satisfiedWithSetUpWhy"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-label', {
    attrs: {
      "gray": ""
    }
  }, [_vm._v("Satisfied with catering?")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.feedbackForm.satisfiedWithCatering),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "satisfiedWithCatering", $$v)
      },
      expression: "feedbackForm.satisfiedWithCatering"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Yes",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "No",
      "value": false
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": "",
      "offset-sm0": "",
      "offset-md1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Why?"
    },
    model: {
      value: (_vm.feedbackForm.satisfiedWithCateringWhy),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "satisfiedWithCateringWhy", $$v)
      },
      expression: "feedbackForm.satisfiedWithCateringWhy"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-label', {
    attrs: {
      "gray": ""
    }
  }, [_vm._v("Satisfied with night service?")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.feedbackForm.satisfiedWithNightService),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "satisfiedWithNightService", $$v)
      },
      expression: "feedbackForm.satisfiedWithNightService"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Yes",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "No",
      "value": false
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": "",
      "offset-sm0": "",
      "offset-md1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Why?"
    },
    model: {
      value: (_vm.feedbackForm.satisfiedWithNightServiceWhy),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "satisfiedWithNightServiceWhy", $$v)
      },
      expression: "feedbackForm.satisfiedWithNightServiceWhy"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-label', {
    attrs: {
      "gray": ""
    }
  }, [_vm._v("Satisfied with information provided?")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.feedbackForm.satisfiedWithInformationProvided),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "satisfiedWithInformationProvided", $$v)
      },
      expression: "feedbackForm.satisfiedWithInformationProvided"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Yes",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "No",
      "value": false
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": "",
      "offset-sm0": "",
      "offset-md1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Why?"
    },
    model: {
      value: (_vm.feedbackForm.satisfiedWithInformationProvidedWhy),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "satisfiedWithInformationProvidedWhy", $$v)
      },
      expression: "feedbackForm.satisfiedWithInformationProvidedWhy"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-title', [_c('h3', [_vm._v("Client Agreement Sign")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": "",
      "icon": ""
    },
    on: {
      "click": _vm.clearSignature
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("undo")])], 1), _vm._v("\n        Clear signature\n      ")], 1), _vm._v(" "), _c('div', {
    staticClass: "sign-pad",
    attrs: {
      "id": "signature-pad"
    }
  }, [_c('VueSignaturePad', {
    ref: "signaturePad",
    attrs: {
      "height": "250px",
      "width": "500px"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "block": "",
      "loading": _vm.loading.signBtn,
      "disabled": _vm.loading.signBtn
    },
    on: {
      "click": _vm.saveFeedback
    }
  }, [_vm._v("\n        Save feedback\n      ")]), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "bottom": "",
      "color": "success",
      "multi-line": "",
      "timeout": 2000
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("Feedback saved!")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 994 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "update:returnValue": _vm.setEditItemIdZero
    },
    model: {
      value: (_vm.dialogResult),
      callback: function($$v) {
        _vm.dialogResult = $$v
      },
      expression: "dialogResult"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "loading": _vm.loading.plan,
      "label": "Name"
    },
    model: {
      value: (_vm.itemData.name),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "name", $$v)
      },
      expression: "itemData.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "loading": _vm.loading.plan,
      "label": "Price",
      "prefix": "$",
      "suffix": _vm.selectedCasket ? '(includes casket price $ ' + _vm.casketById(_vm.selectedCasket).price + ')' : ''
    },
    model: {
      value: (_vm.itemData.price),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "price", $$v)
      },
      expression: "itemData.price"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.allCaskets,
      "loading": _vm.loading.plan,
      "clearable": "",
      "label": "Select Casket Model"
    },
    model: {
      value: (_vm.selectedCasket),
      callback: function($$v) {
        _vm.selectedCasket = $$v
      },
      expression: "selectedCasket"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.products,
      "loading": _vm.loading.plan,
      "hide-selected": "",
      "multiple": "",
      "persistent-hint": "",
      "small-chips": "",
      "label": "Select Products"
    },
    model: {
      value: (_vm.selectedServices),
      callback: function($$v) {
        _vm.selectedServices = $$v
      },
      expression: "selectedServices"
    }
  })], 1), _vm._v(" "), (_vm.selectedServices && _vm.selectedServices.length) ? _c('v-data-table', {
    attrs: {
      "items": _vm.selectedServices,
      "headers": _vm.productsTableHeaders,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', {
          staticClass: "quantity_bgcolor"
        }, [_c('v-edit-dialog', {
          attrs: {
            "return-value": props.item.amount,
            "large": "",
            "lazy": "",
            "persistent": ""
          },
          on: {
            "update:returnValue": function($event) {
              return _vm.$set(props.item, "amount", $event)
            },
            "update:return-value": function($event) {
              return _vm.$set(props.item, "amount", $event)
            }
          },
          scopedSlots: _vm._u([{
            key: "input",
            fn: function() {
              return [_c('v-text-field', {
                attrs: {
                  "label": "Quantity",
                  "single-line": "",
                  "autofocus": ""
                },
                model: {
                  value: (props.item.amount),
                  callback: function($$v) {
                    _vm.$set(props.item, "amount", $$v)
                  },
                  expression: "props.item.amount"
                }
              })]
            },
            proxy: true
          }], null, true)
        }, [_c('div', [_vm._v(_vm._s(props.item.amount))])])], 1), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(props.item.price))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(props.item.amount * props.item.price))])]
      }
    }], null, false, 399487055)
  }) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editItemDataDecorator($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.dialogClose($event)
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.showAlert),
      callback: function($$v) {
        _vm.showAlert = $$v
      },
      expression: "showAlert"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', {
    staticClass: "flex-alert-center"
  }, [_c('v-icon', {
    staticClass: "flex-alert-notification-check",
    attrs: {
      "dark": "",
      "right": ""
    }
  }, [_vm._v("error")]), _vm._v(" " + _vm._s(_vm.alertMessage) + "\n      ")], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 995 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-3": "",
      "tag": "h3"
    }
  }, [_vm._v("\n    User services:\n  ")]), _vm._v(" "), _vm._l((_vm.servicesList), function(service, i) {
    return _c('v-flex', {
      key: i
    }, [_c('v-flex', {
      attrs: {
        "d-inline-flex": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "mr-4": "",
        "mt-3": "",
        "tag": "h4"
      }
    }, [_vm._v("\n        #" + _vm._s(i + 1) + "\n      ")]), _vm._v(" "), _c('v-flex', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteService(service.id)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.editService(service.id, service.description, service.price, service.name)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "icon": ""
      }
    }, [_vm._v("save")])], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
      attrs: {
        "label": "Service name"
      },
      model: {
        value: (service.name),
        callback: function($$v) {
          _vm.$set(service, "name", $$v)
        },
        expression: "service.name"
      }
    })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
      attrs: {
        "label": "Service description"
      },
      model: {
        value: (service.description),
        callback: function($$v) {
          _vm.$set(service, "description", $$v)
        },
        expression: "service.description"
      }
    })], 1), _vm._v(" "), _c('v-flex', [(_vm.isVendor) ? _c('v-text-field', {
      attrs: {
        "label": "Price (only for vendors)",
        "type": "number"
      },
      model: {
        value: (service.price),
        callback: function($$v) {
          _vm.$set(service, "price", $$v)
        },
        expression: "service.price"
      }
    }) : _vm._e()], 1)], 1)], 1)
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Add new service",
      "append-icon": "save",
      "append-icon-cb": _vm.saveService
    },
    model: {
      value: (_vm.newServiceDescription),
      callback: function($$v) {
        _vm.newServiceDescription = $$v
      },
      expression: "newServiceDescription"
    }
  })], 1), _vm._v(" "), _c('v-flex', [(_vm.servicesList.length > 0) ? _c('v-select', {
    attrs: {
      "items": _vm.servicesList,
      "item-text": "description",
      "label": "Select service to edit checklist"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n      ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n      ")]
      }
    }], null, false, 3537881564),
    model: {
      value: (_vm.selectedService),
      callback: function($$v) {
        _vm.selectedService = $$v
      },
      expression: "selectedService"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedService) ? _c('ItemCheckList', {
    attrs: {
      "item-id": _vm.selectedService.id,
      "item-type": _vm.serviceTypeID
    }
  }) : _vm._e()], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 996 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-navigation-drawer', {
    attrs: {
      "fixed": "",
      "clipped": _vm.$vuetify.breakpoint.mdAndUp,
      "app": ""
    },
    model: {
      value: (_vm.$store.state.mainMenuDrawer),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "mainMenuDrawer", $$v)
      },
      expression: "$store.state.mainMenuDrawer"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.items), function(item, i) {
    return _c('div', {
      key: i
    }, [(item.heading) ? _c('v-layout', {
      key: item.heading,
      attrs: {
        "row": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [(item.heading) ? _c('v-subheader', [_vm._v("\n            " + _vm._s(item.heading) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-center",
      attrs: {
        "xs6": ""
      }
    }, [_c('a', {
      staticClass: "body-2 black--text",
      attrs: {
        "href": "#!"
      }
    }, [_vm._v("EDIT")])])], 1) : (item.children) ? _c('v-list-group', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.$can('view', item.id)),
        expression: "$can('view', item.id)"
      }],
      key: item.text,
      attrs: {
        "prepend-icon": item.model ? item.iconalt : item.icon,
        "append-icon": ""
      },
      model: {
        value: (item.model),
        callback: function($$v) {
          _vm.$set(item, "model", $$v)
        },
        expression: "item.model"
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n              " + _vm._s(item.text) + "\n            ")])], 1)], 1), _vm._v(" "), _vm._l((item.children), function(child, i) {
      return _c('v-list-tile', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.$can('view', child.id)),
          expression: "$can('view', child.id)"
        }],
        key: i,
        attrs: {
          "to": child.url
        }
      }, [(child.icon) ? _c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(child.icon))])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n              " + _vm._s(child.text) + "\n            ")])], 1)], 1)
    })], 2) : _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.$can('view', item.id)),
        expression: "$can('view', item.id)"
      }],
      key: item.text
    }, [_c('v-list-tile', {
      attrs: {
        "to": item.url,
        "disabled": _vm.isAssignCrewAndTiming(item)
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n              " + _vm._s(item.text) + "\n            ")])], 1)], 1)], 1)], 1)
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 997 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('v-card-title', [_c('h3', [_vm._v("Commissions")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    attrs: {
      "items": _vm.caseLogManagersFlow,
      "headers": _vm.managersTableHeaders,
      "disable-initial-sort": "",
      "no-data-text": "No managers",
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.created_at || _vm.caseModel.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.manager.name + ' (' + props.item.manager.email + ')'))]), _vm._v(" "), _c('td', {
          class: _vm.canAddCommissions ? 'quantity_bgcolor' : ''
        }, [_c('v-edit-dialog', {
          attrs: {
            "large": "",
            "lazy": "",
            "persistent": ""
          },
          scopedSlots: _vm._u([(_vm.canAddCommissions) ? {
            key: "input",
            fn: function() {
              return [_c('v-text-field', {
                attrs: {
                  "label": "Commissions",
                  "single-line": "",
                  "autofocus": ""
                },
                on: {
                  "change": _vm.updateCommissions
                },
                model: {
                  value: (props.item.commissions),
                  callback: function($$v) {
                    _vm.$set(props.item, "commissions", $$v)
                  },
                  expression: "props.item.commissions"
                }
              })]
            },
            proxy: true
          } : null], null, true)
        }, [(_vm.caseModel.status === 'closed') ? _c('div', [_vm._v("$" + _vm._s(props.item.commissions))]) : _c('div', [_vm._v("Case not closed")])])], 1)]
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 998 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pb9"
  }, [_c('v-card', [_c('v-card-text', [_c('v-flex', [_c('v-layout', [_c('v-flex', [_c('v-select', {
    attrs: {
      "items": _vm.displayPeriodList,
      "label": "Select period"
    },
    model: {
      value: (_vm.displayPeriod),
      callback: function($$v) {
        _vm.displayPeriod = $$v
      },
      expression: "displayPeriod"
    }
  })], 1)], 1), _vm._v(" "), _c('v-calendar', {
    ref: "calendar",
    staticClass: "theme-default",
    attrs: {
      "now": _vm.showDate,
      "value": _vm.calendarValue,
      "type": _vm.displayPeriod,
      "events": _vm.eventsData,
      "color": "primary"
    },
    on: {
      "click:date": _vm.onClickDate,
      "moved": _vm.onMove
    },
    scopedSlots: _vm._u([{
      key: "day",
      fn: function(ref) {
        var date = ref.date;

        return [_vm._l((_vm.eventsMap[date]), function(event) {
          return [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({
                  directives: [{
                    name: "ripple",
                    rawName: "v-ripple"
                  }],
                  staticClass: "my-event",
                  class: {
                    'manager-class': _vm.isCaseManagerEqual(event),
                      'not-manager': !_vm.isCaseManagerEqual(event), 'first': event.firstEvent, 'last': event.lastEvent, 'mid': event.midEvent
                  },
                  domProps: {
                    "innerHTML": _vm._s(event.time + ' ' + event.title)
                  },
                  on: {
                    "click": function($event) {
                      return _vm.onClickEvent(event)
                    }
                  }
                }, on))]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', {
            domProps: {
              "innerHTML": _vm._s(event.title)
            }
          })])]
        })]
      }
    }, {
      key: "dayBody",
      fn: function(ref) {
        var date = ref.date;
        var timeToY = ref.timeToY;
        var minutesToPixels = ref.minutesToPixels;

        return [_vm._l((_vm.eventsMap[date]), function(event) {
          return [(event.time) ? _c('div', {
            key: event.id,
            staticClass: "my-event with-time",
            class: {
              'manager-class': _vm.isCaseManagerEqual(event),
                'not-manager': !_vm.isCaseManagerEqual(event), 'first': event.firstEvent, 'last': event.lastEvent, 'mid': event.midEvent
            },
            style: ({
              top: timeToY(event.time) + 'px',
              height: minutesToPixels(event.duration) + 'px'
            }),
            domProps: {
              "innerHTML": _vm._s(event.title)
            },
            on: {
              "click": function($event) {
                return _vm.onClickEvent(event)
              }
            }
          }) : _vm._e()]
        })]
      }
    }])
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "text-sm-left text-xs-center",
    attrs: {
      "md6": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.$refs.calendar.prev()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": ""
    }
  }, [_vm._v("keyboard_arrow_left")]), _vm._v("\n            Prev\n          ")], 1), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.$refs.calendar.next()
      }
    }
  }, [_vm._v("\n            Next\n            "), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("keyboard_arrow_right")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "legend-box case-manager"
  }), _vm._v(" – you assigned to this case\n    "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "legend-box not-case-manager"
  }), _vm._v(" – you aren't assigned to this case\n    "), _c('br'), _c('br')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 999 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "update:returnValue": _vm.setEditItemIdZero
    },
    model: {
      value: (_vm.dialogResult),
      callback: function($$v) {
        _vm.dialogResult = $$v
      },
      expression: "dialogResult"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "text-md-center"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Name"
    },
    model: {
      value: (_vm.itemData.name),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "name", $$v)
      },
      expression: "itemData.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "Amount"
    },
    model: {
      value: (_vm.itemData.amount),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "amount", $$v)
      },
      expression: "itemData.amount"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Is available"
    },
    model: {
      value: (_vm.itemData.is_available),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "is_available", $$v)
      },
      expression: "itemData.is_available"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Is external vendor"
    },
    model: {
      value: (_vm.itemData.is_vendor),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "is_vendor", $$v)
      },
      expression: "itemData.is_vendor"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-md-left",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [(_vm.itemLoaded) ? _c('ItemCheckList', {
    attrs: {
      "item-id": _vm.itemData.id,
      "item-type": _vm.itemType
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editItemData($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.dialogClose($event)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    attrs: {
      "fab": "",
      "bottom": "",
      "right": "",
      "color": "pink",
      "dark": "",
      "fixed": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialog = !_vm.dialog
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "800px",
      "persistent": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-4 py-4 title"
  }, [_vm._v("\n        Add Plan\n      ")]), _vm._v(" "), _c('v-container', {
    staticClass: "pa-4",
    attrs: {
      "grid-list-sm": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "raw": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Plan name"
    },
    model: {
      value: (_vm.modelName),
      callback: function($$v) {
        _vm.modelName = $$v
      },
      expression: "modelName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Plan price",
      "type": "number",
      "prefix": "$",
      "persistent-hint": "",
      "suffix": _vm.selectedCasket ? '(includes casket price $ ' + _vm.casketById(_vm.selectedCasket).price + ')' : ''
    },
    model: {
      value: (_vm.planPrice),
      callback: function($$v) {
        _vm.planPrice = $$v
      },
      expression: "planPrice"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.allCaskets,
      "label": "Select Casket Model",
      "clearable": ""
    },
    model: {
      value: (_vm.selectedCasket),
      callback: function($$v) {
        _vm.selectedCasket = $$v
      },
      expression: "selectedCasket"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.products,
      "hide-selected": "",
      "multiple": "",
      "persistent-hint": "",
      "small-chips": "",
      "label": "Select Products"
    },
    model: {
      value: (_vm.selectedProducts),
      callback: function($$v) {
        _vm.selectedProducts = $$v
      },
      expression: "selectedProducts"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [(_vm.selectedProducts && _vm.selectedProducts.length) ? _c('v-data-table', {
    attrs: {
      "items": _vm.selectedProducts,
      "headers": _vm.productsTableHeaders,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', {
          staticClass: "quantity_bgcolor"
        }, [_c('v-edit-dialog', {
          attrs: {
            "return-value": props.item.amount,
            "large": "",
            "lazy": "",
            "persistent": ""
          },
          on: {
            "update:returnValue": function($event) {
              return _vm.$set(props.item, "amount", $event)
            },
            "update:return-value": function($event) {
              return _vm.$set(props.item, "amount", $event)
            }
          },
          scopedSlots: _vm._u([{
            key: "input",
            fn: function() {
              return [_c('v-text-field', {
                attrs: {
                  "label": "Quantity",
                  "single-line": "",
                  "autofocus": ""
                },
                model: {
                  value: (props.item.amount),
                  callback: function($$v) {
                    _vm.$set(props.item, "amount", $$v)
                  },
                  expression: "props.item.amount"
                }
              })]
            },
            proxy: true
          }], null, true)
        }, [_c('div', [_vm._v(_vm._s(props.item.amount))])])], 1), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(props.item.price))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(props.item.amount * props.item.price))])]
      }
    }], null, false, 399487055)
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.saveNew
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.showAlert),
      callback: function($$v) {
        _vm.showAlert = $$v
      },
      expression: "showAlert"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', {
    staticClass: "flex-alert-center"
  }, [_c('v-icon', {
    staticClass: "flex-alert-notification-check",
    attrs: {
      "dark": "",
      "right": ""
    }
  }, [_vm._v("error")]), _vm._v(" " + _vm._s(_vm.alertMessage) + "\n      ")], 1)], 1)], 1), _vm._v(" "), _c('AppMainDialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "message": _vm.dialogMessage
    },
    on: {
      "closedialog": function($event) {
        _vm.dialogOpen = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-select', {
    attrs: {
      "items": _vm.servicesList,
      "label": "Add on items select",
      "item-value": "id",
      "item-text": "name",
      "return-object": "",
      "multiple": "",
      "attach": "",
      "clearable": "",
      "hide-selected": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n      Product: " + _vm._s(props.item.name) + " | Category: " + _vm._s(props.item.category.name) + "\n    ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_c('span', {
          staticClass: "v-chip v-chip--select-multi theme--light"
        }, [_c('span', {
          staticClass: "v-chip__content"
        }, [_vm._v("\n          " + _vm._s(props.item.name) + "\n        ")])])]
      }
    }]),
    model: {
      value: (_vm.mutableSelectedServices),
      callback: function($$v) {
        _vm.mutableSelectedServices = $$v
      },
      expression: "mutableSelectedServices"
    }
  }), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "items": _vm.mutableSelectedServices,
      "headers": _vm.productsTableHeaders,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_c('v-layout', {
          attrs: {
            "justify-space-between": "",
            "align-center": ""
          }
        }, [(_vm.upgrade_id === props.item.id) ? _c('v-select', {
          attrs: {
            "items": _vm.getProductsByCategoryId(props.item.categories_id),
            "label": "Select Another Product from same category"
          },
          on: {
            "change": function($event) {
              return _vm.changeProductFromCategory(props.item)
            }
          },
          model: {
            value: (_vm.change_product_from_category_model),
            callback: function($$v) {
              _vm.change_product_from_category_model = $$v
            },
            expression: "change_product_from_category_model"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.upgrade_id !== props.item.id) ? _c('span', [_vm._v("\n                  " + _vm._s(props.item.name) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.upgrade_id !== props.item.id) ? _c('v-btn', {
          attrs: {
            "small": "",
            "align-rigth": ""
          },
          on: {
            "click": function($event) {
              _vm.upgrade_id = props.item.id
            }
          }
        }, [_vm._v("Upgrade")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('td', {
          staticClass: "quantity_bgcolor"
        }, [_c('v-edit-dialog', {
          attrs: {
            "return-value": props.item.amount,
            "large": "",
            "lazy": "",
            "persistent": ""
          },
          on: {
            "update:returnValue": function($event) {
              return _vm.$set(props.item, "amount", $event)
            },
            "update:return-value": function($event) {
              return _vm.$set(props.item, "amount", $event)
            }
          },
          scopedSlots: _vm._u([{
            key: "input",
            fn: function() {
              return [_c('v-text-field', {
                attrs: {
                  "label": "Quantity",
                  "single-line": "",
                  "autofocus": ""
                },
                model: {
                  value: (props.item.amount),
                  callback: function($$v) {
                    _vm.$set(props.item, "amount", $$v)
                  },
                  expression: "props.item.amount"
                }
              })]
            },
            proxy: true
          }], null, true)
        }, [_c('div', [_vm._v(_vm._s(props.item.amount))])])], 1), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(props.item.price))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(props.item.amount * props.item.price))]), _vm._v(" "), _c('td', {
          staticClass: "justify-center layout px-0"
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteItem(props.item)
            }
          }
        }, [_vm._v("\n          delete\n        ")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('template', {
    slot: "footer"
  }, [(_vm.discount) ? _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Remarks in $",
      "type": "number"
    },
    model: {
      value: (_vm.discountValue),
      callback: function($$v) {
        _vm.discountValue = $$v
      },
      expression: "discountValue"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.price) ? _c('v-flex', {
    attrs: {
      "tag": "h3"
    }
  }, [_vm._v("\n        Final price: $" + _vm._s(_vm.finalPrice) + "\n      ")]) : _vm._e()], 1)], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_c('h3', {
    staticClass: "mt-2 mb-2"
  }, [_vm._v("Client data")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Name")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.caseModel.client ? _vm.caseModel.client.name : 'N/A') + "\n      ")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-title', [_c('h3', [_vm._v("Client Agreement And Invoice")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.$can('view', 'cases-detail-actions-tab') && _vm.caseInvoices && _vm.caseInvoices.length) ? _c('v-tooltip', {
    attrs: {
      "left": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "color": 'green',
      "block": "",
      "loading": _vm.loading.paidInvoiceBtn,
      "disabled": _vm.markPaidDisabled
    },
    nativeOn: {
      "click": function($event) {
        return _vm.markPaid($event)
      }
    }
  }, [_vm._v("done")])], 1), _vm._v(" "), _c('span', [_vm._v("Mark Invoice Paid")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('b', [_vm._v("Agreement")])]), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "loading": _vm.loadingAgreement,
      "disabled": !_vm.caseModel.answers.length,
      "outline": "",
      "color": "blue"
    },
    on: {
      "click": _vm.downloadAgreement
    }
  }, [_vm._v("PDF\n          "), _c('v-icon', [_vm._v("list")])], 1)], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('b', [_vm._v("Latest " + _vm._s((_vm.caseModel.status === 'closed') ? 'Invoice' : 'Quotation') + "\n          "), (_vm.caseInvoices.length) ? _c('span', [_vm._v("(" + _vm._s(_vm.caseInvoices[_vm.caseInvoices.length - 1].status) + ")")]) : _vm._e()])]), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "loading": _vm.loadingInvoice,
      "disabled": _vm.disabled.invoice,
      "outline": "",
      "color": "blue"
    },
    on: {
      "click": _vm.downloadInvoice
    }
  }, [_vm._v("PDF\n          "), _c('v-icon', [_vm._v("list")])], 1)], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('b', [_vm._v("Final Receipt")])]), _vm._v(" "), _c('v-list-tile-action', {
    staticClass: "mr-2"
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.loadingReceiptEmail,
      "disabled": _vm.disabled.receipt,
      "outline": "",
      "color": "blue"
    },
    on: {
      "click": _vm.sendReceipt
    }
  }, [_vm._v("SEND\n          "), _c('v-icon', [_vm._v("email")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "loading": _vm.loadingReceiptDownload,
      "disabled": _vm.disabled.receipt,
      "outline": "",
      "color": "blue"
    },
    on: {
      "click": _vm.downloadReceipt
    }
  }, [_vm._v("PDF\n          "), _c('v-icon', [_vm._v("list")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.items,
      "hide-actions": "",
      "no-data-text": "No invoices."
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_c('v-btn', {
          attrs: {
            "flat": "",
            "depressed": "",
            "small": "",
            "left": "",
            "href": props.item.invoice_path,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s((_vm.caseModel.status === 'closed') && (props.item.id === _vm.items[_vm.items.length - 1].id) ? 'view invoice' : 'view quotation'))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status ? props.item.status : 'pending'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.created_at))]), _vm._v(" "), _c('td', [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [(_vm.$can('mark-paid', 'invoices') && props.item.status === 'pending') ? _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.markPaidInvoice(props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("done")])], 1) : _vm._e(), _vm._v("\n          Mark paid\n        ")], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('AppMainDialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "message": _vm.dialogMessage,
      "rawHtml": ""
    },
    on: {
      "closedialog": function($event) {
        _vm.dialogOpen = false
      }
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.showAlert),
      callback: function($$v) {
        _vm.showAlert = $$v
      },
      expression: "showAlert"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', {
    staticClass: "flex-alert-center"
  }, [_c('v-icon', {
    staticClass: "flex-alert-notification-check",
    attrs: {
      "dark": "",
      "right": ""
    }
  }, [_vm._v("check_circle")]), _vm._v(" " + _vm._s(_vm.alertMessage) + "\n      ")], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "80%"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "text-md-center"
  }, [(_vm.itemId > 0) ? _c('ItemCheckList', {
    attrs: {
      "item-id": _vm.itemId,
      "item-type": _vm.itemType,
      "cases-id": _vm.casesId
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "",
      "block": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeDialog($event)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.items,
      "hide-actions": "",
      "loading": _vm.loadingInProgress,
      "no-data-text": _vm.loadingItemsText
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.updated_at))]), _vm._v(" "), _c('td', [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "slot": "activator",
            "icon": "",
            "loading": _vm.loading
          },
          on: {
            "click": function($event) {
              return _vm.downloadPDF(props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "orange accent-2"
          }
        }, [_vm._v("picture_as_pdf")])], 1), _vm._v("\n          Get PDF invoice\n        ")], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('AppMainDialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "message": _vm.dialogMessage,
      "rawHtml": ""
    },
    on: {
      "closedialog": function($event) {
        _vm.dialogOpen = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500px"
    },
    on: {
      "update:returnValue": _vm.setEditItemIdPermissionsZero
    },
    model: {
      value: (_vm.dialogPermissions),
      callback: function($$v) {
        _vm.dialogPermissions = $$v
      },
      expression: "dialogPermissions"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "text-md-center"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "label": "Select Permissions",
      "items": _vm.permissionsList
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [_c('v-chip', [_c('span', [_vm._v(_vm._s(item.description || item.name))])])]
      }
    }]),
    model: {
      value: (_vm.selectedPermissions),
      callback: function($$v) {
        _vm.selectedPermissions = $$v
      },
      expression: "selectedPermissions"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editItemData(_vm.roleId)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.dialogClose($event)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.items,
      "hide-actions": "",
      "no-data-text": "No invoices."
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_c('v-btn', {
          attrs: {
            "flat": "",
            "depressed": "",
            "small": "",
            "left": "",
            "href": props.item.invoice_path,
            "target": "_blank"
          }
        }, [_vm._v("view invoice")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.user ? props.item.user.name : 'N/A'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status ? props.item.status : 'pending'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.created_at))]), _vm._v(" "), _c('td', [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [(_vm.$can('mark-paid', 'invoices') && props.item.status === 'pending') ? _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.markPaid(props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("done")])], 1) : _vm._e(), _vm._v("\n          Mark paid\n        ")], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('AddCaseInvoiceButton', _vm._g({
          attrs: {
            "casesid": _vm.casesid
          }
        }, on))]
      }
    }])
  }, [_vm._v("\n    Add Case Invoice\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    attrs: {
      "fab": "",
      "bottom": "",
      "right": "",
      "color": "pink",
      "dark": "",
      "fixed": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialog = !_vm.dialog
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "800px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-4 py-4 title"
  }, [_vm._v("\n        Add User\n      ")]), _vm._v(" "), _c('v-container', {
    staticClass: "pa-4",
    attrs: {
      "grid-list-sm": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Login"
    },
    model: {
      value: (_vm.userLogin),
      callback: function($$v) {
        _vm.userLogin = $$v
      },
      expression: "userLogin"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "User name"
    },
    model: {
      value: (_vm.modelName),
      callback: function($$v) {
        _vm.modelName = $$v
      },
      expression: "modelName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "User email"
    },
    model: {
      value: (_vm.userEmail),
      callback: function($$v) {
        _vm.userEmail = $$v
      },
      expression: "userEmail"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "password",
      "placeholder": "User password"
    },
    model: {
      value: (_vm.userPassword),
      callback: function($$v) {
        _vm.userPassword = $$v
      },
      expression: "userPassword"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Description (bio)",
      "textarea": ""
    },
    model: {
      value: (_vm.userDescription),
      callback: function($$v) {
        _vm.userDescription = $$v
      },
      expression: "userDescription"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [(_vm.avatar) ? _c('v-img', {
    attrs: {
      "size": "50",
      "aspect-ratio": "1",
      "src": _vm.avatar
    }
  }) : _vm._e(), _vm._v(" "), (_vm.uploadPercentage !== 0 && _vm.uploadPercentage !== 100) ? _c('v-progress-linear', {
    attrs: {
      "value": _vm.uploadPercentage,
      "color": "light-blue"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-btn', {
    staticClass: "mt-3 ml-0",
    attrs: {
      "color": "primary",
      "disabled": _vm.disabled.uploadPhotoForEmbalmersBtn,
      "loading": _vm.disabled.uploadPhotoForEmbalmersBtn,
      "prepend-icon": _vm.uploadStatus,
      "type": "file"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.inputUpload.click()
      }
    }
  }, [_vm._v("Upload Optional Photo\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "inputUpload",
    attrs: {
      "accept": "image/*, .jpg, .jpeg, .png",
      "type": "file"
    },
    on: {
      "change": _vm.onChange
    }
  }), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "bottom": "",
      "color": "success",
      "multi-line": "",
      "timeout": 2000
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Is vendor"
    },
    model: {
      value: (_vm.userIsVendor),
      callback: function($$v) {
        _vm.userIsVendor = $$v
      },
      expression: "userIsVendor"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": _vm.saveNewDisabled
    },
    on: {
      "click": _vm.saveNew
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('AppMainDialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "message": _vm.dialogMessage
    },
    on: {
      "closedialog": function($event) {
        _vm.dialogOpen = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "update:returnValue": _vm.setEditItemIdZero
    },
    model: {
      value: (_vm.dialogResult),
      callback: function($$v) {
        _vm.dialogResult = $$v
      },
      expression: "dialogResult"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "text-md-center"
  }, [_c('v-flex', [_c('v-select', {
    attrs: {
      "label": "Event",
      "items": _vm.eventsList
    },
    model: {
      value: (_vm.itemData.events_id),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "events_id", $$v)
      },
      expression: "itemData.events_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-select', {
    attrs: {
      "label": "Type",
      "items": _vm.notificationTypesList
    },
    model: {
      value: (_vm.itemData.vendor),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "vendor", $$v)
      },
      expression: "itemData.vendor"
    }
  })], 1), _vm._v(" "), _c('v-flex', [(_vm.itemData.vendor === 'email') ? _c('v-text-field', {
    attrs: {
      "outline": "",
      "label": "Subject"
    },
    model: {
      value: (_vm.itemData.subject),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "subject", $$v)
      },
      expression: "itemData.subject"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', [_c('v-textarea', {
    attrs: {
      "outline": "",
      "label": "Message"
    },
    model: {
      value: (_vm.itemData.message),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "message", $$v)
      },
      expression: "itemData.message"
    }
  })], 1), _vm._v(" "), (!_vm.isLeadAddedEvent) ? _c('v-flex', {
    staticClass: "text-md-left"
  }, [_c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$case_id!!}')
      }
    }
  }, [_vm._v("Case ID")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$case_name!!}')
      }
    }
  }, [_vm._v("Case name")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$client_salutation!!}')
      }
    }
  }, [_vm._v("Client salutation")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$client_name!!}')
      }
    }
  }, [_vm._v("Client name")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$quotation_link!!}')
      }
    }
  }, [_vm._v("Quotation link")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$agreement_link!!}')
      }
    }
  }, [_vm._v("Agreement link")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$date_time_of_funerals!!}')
      }
    }
  }, [_vm._v("Date time of funerals")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$amount_of_days!!}')
      }
    }
  }, [_vm._v("Amount of days")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$location!!}')
      }
    }
  }, [_vm._v("Location")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$selected_package!!}')
      }
    }
  }, [_vm._v("Selected Package")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$selected_casket!!}')
      }
    }
  }, [_vm._v("Selected Casket")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$selected_products!!}')
      }
    }
  }, [_vm._v("Selected Products")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$selected_products_list_text!!}')
      }
    }
  }, [_vm._v("Selected Products-Amount List Text")])], 1) : _vm._e(), _vm._v(" "), _c('v-flex', [_c('v-combobox', {
    attrs: {
      "label": "Recipients",
      "items": _vm.notificationRecipients,
      "item-value": "id",
      "multiple": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_vm._v("\n            " + _vm._s(!_vm.isEmailType ? data.item.email : data.item.phone) + "\n          ")]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [_vm._v("\n            " + _vm._s(!_vm.isEmailType ? data.item.email : data.item.phone) + "\n          ")]
      }
    }]),
    model: {
      value: (_vm.selectedRecipients),
      callback: function($$v) {
        _vm.selectedRecipients = $$v
      },
      expression: "selectedRecipients"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-select', {
    attrs: {
      "items": _vm.roles,
      "label": "Roles",
      "multiple": ""
    },
    model: {
      value: (_vm.selectedRoles),
      callback: function($$v) {
        _vm.selectedRoles = $$v
      },
      expression: "selectedRoles"
    }
  })], 1), _vm._v(" "), (!_vm.isLeadAddedEvent) ? _c('v-flex', [_c('v-checkbox', {
    attrs: {
      "label": "Send to case Client?"
    },
    model: {
      value: (_vm.itemData.send_to_client),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "send_to_client", $$v)
      },
      expression: "itemData.send_to_client"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', [_c('v-checkbox', {
    attrs: {
      "label": "Is active"
    },
    model: {
      value: (_vm.itemData.is_active),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "is_active", $$v)
      },
      expression: "itemData.is_active"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editItemDataDecorator($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": [function($event) {
        return _vm.clearDialogForm()
      }, function($event) {
        $event.stopPropagation();
        return _vm.dialogClose($event)
      }]
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('AppAddBookingButton', {
    scopedSlots: _vm._u([{
      key: "CaseAndAmount",
      fn: function(props) {
        return [_c('v-flex', {
          attrs: {
            "xs12": "",
            "align-center": "",
            "justify-space-between": ""
          }
        }, [_c('v-select', {
          attrs: {
            "items": props.casesList,
            "label": "Select case"
          },
          model: {
            value: (props.selectedCase.id),
            callback: function($$v) {
              _vm.$set(props.selectedCase, "id", $$v)
            },
            expression: "props.selectedCase.id"
          }
        })], 1)]
      }
    }, {
      key: "ItemsSelection",
      fn: function(props) {
        return [_c('v-flex', {
          attrs: {
            "md12": ""
          }
        }, [_c('v-select', {
          attrs: {
            "items": props.servicesList,
            "label": "Select whom to book"
          },
          scopedSlots: _vm._u([{
            key: "item",
            fn: function(props) {
              return [_vm._v("\n              " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n            ")]
            }
          }, {
            key: "selection",
            fn: function(props) {
              return [_vm._v("\n              " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n            ")]
            }
          }], null, true),
          model: {
            value: (props.selectedService.id),
            callback: function($$v) {
              _vm.$set(props.selectedService, "id", $$v)
            },
            expression: "props.selectedService.id"
          }
        })], 1)]
      }
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    attrs: {
      "fab": "",
      "bottom": "",
      "right": "",
      "color": "pink",
      "dark": "",
      "fixed": ""
    },
    on: {
      "click": function($event) {
        return _vm.onClickEvent()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "px-3": "",
      "py-3": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.notificationTypesList,
      "label": "Select notification type"
    },
    model: {
      value: (_vm.selectedNotificationTypes),
      callback: function($$v) {
        _vm.selectedNotificationTypes = $$v
      },
      expression: "selectedNotificationTypes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.eventsList,
      "label": "Select an event"
    },
    model: {
      value: (_vm.selectedEvent),
      callback: function($$v) {
        _vm.selectedEvent = $$v
      },
      expression: "selectedEvent"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": ""
    }
  }, [(_vm.selectedNotificationTypes === 'email') ? _c('v-text-field', {
    attrs: {
      "outline": "",
      "label": "Subject"
    },
    model: {
      value: (_vm.notificationSubject),
      callback: function($$v) {
        _vm.notificationSubject = $$v
      },
      expression: "notificationSubject"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "outline": "",
      "label": "Message",
      "rows": "5"
    },
    model: {
      value: (_vm.notificationMessage),
      callback: function($$v) {
        _vm.notificationMessage = $$v
      },
      expression: "notificationMessage"
    }
  })], 1), _vm._v(" "), (!_vm.isLeadAddedEvent) ? _c('v-flex', {
    staticClass: "pl-2",
    attrs: {
      "xs12": "",
      "md5": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$case_id!!}')
      }
    }
  }, [_vm._v("Case ID")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$case_name!!}')
      }
    }
  }, [_vm._v("Case name")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$quotation_link!!}')
      }
    }
  }, [_vm._v("Quotation link")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$agreement_link!!}')
      }
    }
  }, [_vm._v("Agreement link")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$date_time_of_funerals!!}')
      }
    }
  }, [_vm._v("Date time of funerals")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$amount_of_days!!}')
      }
    }
  }, [_vm._v("Amount of days")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$location!!}')
      }
    }
  }, [_vm._v("Location")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$selected_package!!}')
      }
    }
  }, [_vm._v("Selected Package")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$selected_casket!!}')
      }
    }
  }, [_vm._v("Selected Casket")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$selected_products!!}')
      }
    }
  }, [_vm._v("Selected Products")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.pasteVar('{!!$selected_products_list_text!!}')
      }
    }
  }, [_vm._v("Selected Products-Amount List Text")])], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "outline": "",
      "label": "Recipients (comma-separated values)",
      "rows": "2"
    },
    model: {
      value: (_vm.notificationRecipients),
      callback: function($$v) {
        _vm.notificationRecipients = $$v
      },
      expression: "notificationRecipients"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.roles,
      "chips": "",
      "label": "Roles",
      "multiple": "",
      "outline": ""
    },
    model: {
      value: (_vm.selectedRoles),
      callback: function($$v) {
        _vm.selectedRoles = $$v
      },
      expression: "selectedRoles"
    }
  })], 1), _vm._v(" "), (!_vm.isLeadAddedEvent) ? _c('v-flex', [_c('v-checkbox', {
    attrs: {
      "label": "Send to case Client?"
    },
    model: {
      value: (_vm.sendToClient),
      callback: function($$v) {
        _vm.sendToClient = $$v
      },
      expression: "sendToClient"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Is active?"
    },
    model: {
      value: (_vm.notificationIsActive),
      callback: function($$v) {
        _vm.notificationIsActive = $$v
      },
      expression: "notificationIsActive"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.saveNotification
    }
  }, [_vm._v("Save settings")])], 1)], 1), _vm._v(" "), _c('AppEditTwilioNotificationsDialog'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mt-5": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.items,
      "hide-actions": "",
      "loading": _vm.loadingInProgress,
      "no-data-text": _vm.loadingItemsText
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.vendor))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.message))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.event.description || props.item.event.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.recipients_string))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRoleNamesByIds(props.item.roles)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.send_to_client))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.is_active))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.updated_at))]), _vm._v(" "), _c('td', {
          staticClass: "justify-left layout px-0"
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.editElement(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteDialog(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("delete")])], 1), _vm._v(" "), _c('ConfirmationDialog', {
          ref: "confirm"
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mt-5": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "teal",
      "dark": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "text-xs-center"
  }, [_vm._v("Built in notifications")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "color": "green"
    }
  }, [_vm._v("chat_bubble")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Case Manager Changed")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Old manager and new will receive sms message: \"Hello! Case Manager for case #x has been changed.\"")])], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "color": "green"
    }
  }, [_vm._v("chat_bubble")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Products Changed In Case")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Case manager (email) and each attached vendor (sms and email) will receive notification with information about changed product")])], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "color": "green"
    }
  }, [_vm._v("chat_bubble")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Products Detached From Case")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Each attached vendor will receive sms with information about detached product")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('AppMainDialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "message": _vm.dialogMessage
    },
    on: {
      "closedialog": function($event) {
        _vm.dialogOpen = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.items,
      "loading": _vm.loadingInProgress,
      "no-data-text": _vm.loadingItemsText,
      "rows-per-page-items": _vm.rowsPerPageItems,
      "pagination": _vm.pagination,
      "hide-actions": ""
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.invoice_number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getAnswerItem(props.item.answers, 'main_form', 'deceased_location_of_wake')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.plan ? props.item.plan.name : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.manager_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.wake_start))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
          staticClass: "justify-left layout px-0"
        }, [(!_vm.crewSelecting) ? _c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [(_vm.detailCaseButtonActionIsDefault) ? _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.goCasesDetail(props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "indigo"
          }
        }, [_vm._v("remove_red_eye")])], 1) : _vm._e(), _vm._v(" "), (_vm.detailCaseButtonActionIsGoToCheckListsTab) ? _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.goCasesDetailCheckListsTab(props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "indigo"
          }
        }, [_vm._v("remove_red_eye")])], 1) : _vm._e(), _vm._v(" "), (_vm.detailCaseButtonActionIsGoToInvoicesTab) ? _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.goCasesDetailInvoicesTab(props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "indigo"
          }
        }, [_vm._v("remove_red_eye")])], 1) : _vm._e(), _vm._v("\n          View details\n        ")], 1) : _vm._e(), _vm._v(" "), (_vm.crewSelecting) ? _c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "slot": "activator",
            "icon": "",
            "disabled": props.item.status === 'closed'
          },
          on: {
            "click": function($event) {
              return _vm.selectCrew(props.item.id)
            }
          },
          slot: "activator"
        }, [(props.item.status === 'closed') ? _c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("group")]) : _c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("group_add")])], 1), _vm._v("\n          " + _vm._s(props.item.status === 'closed' ? 'Case Closed' : 'Select Crew') + "\n        ")], 1) : _vm._e(), _vm._v(" "), (_vm.$can('send', 'cases-client-email') && !_vm.crewSelecting) ? _c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "slot": "activator",
            "icon": "",
            "disabled": _vm.disabled.sendQuotationMailToClientBtn
          },
          on: {
            "click": function($event) {
              return _vm.sendQuotationMailToClient(props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("mail")])], 1), _vm._v("\n          Email quotation to client\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.crewSelecting) ? _c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.$can('close', 'cases-item') && props.item.status !== 'closed'),
            expression: "$can('close', 'cases-item') && props.item.status !== 'closed'"
          }],
          staticClass: "mx-0",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.closeCase(props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "light-green"
          }
        }, [_vm._v("done")])], 1), _vm._v("\n          Close case\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.crewSelecting) ? _c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.$can('delete', 'cases-item')),
            expression: "$can('delete', 'cases-item')"
          }],
          staticClass: "mx-0",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteCaseElement(props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("delete")])], 1), _vm._v("\n          Delete case\n        ")], 1) : _vm._e(), _vm._v(" "), _c('ConfirmationDialog', {
          ref: "confirm"
        })], 1)]
      }
    }])
  }), _vm._v(" "), (!_vm.loadingInProgress) ? _c('v-layout', {
    staticClass: "mt-4"
  }, [_c('v-flex', {
    staticClass: "text-sm-center"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pagination.total
    },
    on: {
      "input": _vm.onPageChange
    },
    model: {
      value: (_vm.pagination.current),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "current", $$v)
      },
      expression: "pagination.current"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('AppEditCasesDialog'), _vm._v(" "), _c('CrewDialog'), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.showAlert),
      callback: function($$v) {
        _vm.showAlert = $$v
      },
      expression: "showAlert"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', {
    staticClass: "flex-alert-center"
  }, [_c('v-icon', {
    staticClass: "flex-alert-notification-check",
    attrs: {
      "dark": "",
      "right": ""
    }
  }, [_vm._v("check_circle")]), _vm._v(" " + _vm._s(_vm.alertMessage) + "\n      ")], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "md3": "",
      "px-1": "",
      "mt-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "date__picker"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Date",
            "prepend-icon": "event",
            "readonly": ""
          },
          model: {
            value: (_vm.date),
            callback: function($$v) {
              _vm.date = $$v
            },
            expression: "date"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "input": function($event) {
        _vm.menu = false
      }
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": "",
      "px-1": "",
      "mt-2": ""
    }
  }, [_c('div', {
    staticClass: "flex-items"
  }, [_c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "legend-box case-manager"
  }), _vm._v(" – My Schedule\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "legend-box not-case-manager"
  }), _vm._v(" – Overall Schedule\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "legend-box current-time"
  }), _vm._v(" – Current hour\n        ")])])])], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.items,
      "loading": _vm.loadingInProgress,
      "no-data-text": _vm.loadingItemsText,
      "rows-per-page-items": _vm.rowsPerPageItems,
      "pagination": _vm.pagination,
      "hide-actions": true
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "slotTime",
          class: ("" + (props.item.timeline) + (_vm.checkInvolve(props.item.services)))
        }, [_vm._v(_vm._s(props.item.time))]), _vm._v(" "), _c('td', {
          class: ("" + (props.item.timeline) + (_vm.checkInvolve(props.item.services)) + (_vm.checkActive(props.item.case_id)))
        }, [_vm._v(_vm._s(props.item.start_time))]), _vm._v(" "), _c('td', {
          class: ("" + (props.item.timeline) + (_vm.checkInvolve(props.item.services)) + (_vm.checkActive(props.item.case_id))),
          on: {
            "click": function($event) {
              return _vm.onEventClick(props.item.case_id)
            }
          }
        }, [_vm._v(_vm._s(props.item.type))]), _vm._v(" "), _c('td', {
          class: ("" + (props.item.timeline) + (_vm.checkInvolve(props.item.services)) + (_vm.checkActive(props.item.case_id))),
          on: {
            "click": function($event) {
              return _vm.onEventClick(props.item.case_id)
            }
          }
        }, [_vm._v(_vm._s(props.item.case_manager))]), _vm._v(" "), _c('td', {
          class: ("" + (props.item.timeline) + (_vm.checkInvolve(props.item.services)) + (_vm.checkActive(props.item.case_id))),
          on: {
            "click": function($event) {
              return _vm.onEventClick(props.item.case_id)
            }
          }
        }, [_vm._v(_vm._s(_vm.getCaseCrew(props.item)))]), _vm._v(" "), _c('td', {
          class: ("" + (props.item.timeline) + (_vm.checkInvolve(props.item.services)) + (_vm.checkActive(props.item.case_id))),
          on: {
            "click": function($event) {
              return _vm.onEventClick(props.item.case_id)
            }
          }
        }, [_vm._v(_vm._s(props.item.description))]), _vm._v(" "), _c('td', {
          class: ("" + (props.item.timeline) + (_vm.checkInvolve(props.item.services)) + (_vm.checkActive(props.item.case_id))),
          on: {
            "click": function($event) {
              return _vm.onEventClick(props.item.case_id)
            }
          }
        }, [_vm._v(_vm._s(props.item.case_id))])]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('v-card-title', [_c('h3', [_vm._v("Deposit")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": !_vm.$can('edit', 'case-deposit'),
      "rules": _vm.depositRules,
      "label": "Amount",
      "prefix": "$"
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('v-btn', {
          attrs: {
            "color": "primary",
            "disabled": !_vm.$can('edit', 'case-deposit'),
            "flat": "",
            "loading": _vm.loading
          },
          on: {
            "click": _vm.changeDeposit
          }
        }, [_vm._v("Save deposit and send receipt")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.deposit),
      callback: function($$v) {
        _vm.deposit = $$v
      },
      expression: "deposit"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "description"
  }, [_vm._v("\n            No spaces allowed. Only \"-\", \".\", \"0-9\". Correct values examples: \"-10.99\", \"23.35\", \"16\"\n          ")])])], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('v-card-title', [_c('h3', [_vm._v("Balance Payable (excluding readjustment value)")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    staticClass: "disabled-active",
    attrs: {
      "disabled": true,
      "value": _vm.leftToPay,
      "label": "Amount",
      "prefix": "$"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('v-card-title', [_c('h3', [_vm._v("Readjustment")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": !_vm.$can('edit', 'case-readjustment'),
      "rules": _vm.readjustmentRules,
      "label": "Amount",
      "prefix": "$"
    },
    model: {
      value: (_vm.readjustment),
      callback: function($$v) {
        _vm.readjustment = $$v
      },
      expression: "readjustment"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "description"
  }, [_vm._v("\n            No spaces allowed. Only \"-\", \".\", \"0-9\". Correct values examples: \"-10.99\", \"23.35\", \"16\"\n          ")])])], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('v-card-title', [_c('h3', [_vm._v("New Tax Invoice Total after GST")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-container', [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-space-between": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md8": ""
    }
  }, [_c('v-text-field', {
    staticClass: "disabled-active",
    attrs: {
      "disabled": true,
      "value": _vm.leftToPay,
      "label": "Amount",
      "prefix": "$"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.$can('edit', 'case-readjustment'),
      "flat": "",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.changeDeposit
    }
  }, [_vm._v("Save and send new tax invoice")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "inspire"
    }
  }, [_c('v-content', [(_vm.appIsLoaded) ? _c('v-container', {
    ref: "main_container",
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "fill-height": ""
    }
  }, [_c('AppMainMenu'), _vm._v(" "), _c('router-view')], 1)], 1)], 1) : _c('v-container', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "md12": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary",
      "size": 100,
      "width": 7
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("sync")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.showLoading) ? _c('Loading') : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  })
},staticRenderFns: []}

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('AppEditServicesDialog'), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.items,
      "hide-actions": "",
      "loading": _vm.loadingInProgress,
      "no-data-text": _vm.loadingItemsText
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.is_available))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.is_vendor))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.amount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.updated_at))]), _vm._v(" "), _c('td', {
          staticClass: "justify-left layout px-0"
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.editElement(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteDialog(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("delete")])], 1), _vm._v(" "), _c('confirmation-dialog', {
          ref: "confirm"
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('AddServiceButton')], 1)
},staticRenderFns: []}

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pb9"
  }, [_c('AppEditUsersDialog'), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.items,
      "loading": _vm.loadingInProgress,
      "no-data-text": _vm.loadingItemsText,
      "rows-per-page-items": _vm.rowsPerPageItems,
      "pagination": _vm.pagination
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("filterRoleNames")(props.item.roles)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.calculateCommonCoursesCompletionPercent(props.item.courses_completion_percent)) + "%")]), _vm._v(" "), _c('td', {
          staticClass: "justify-left layout px-0"
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.editElement(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteDialog(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("delete")])], 1), _vm._v(" "), _c('ConfirmationDialog', {
          ref: "confirm"
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('AddUserButton')], 1)
},staticRenderFns: []}

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pb9"
  }, [_c('AppEditRolesDialog'), _vm._v(" "), _c('AppEditRolesPermissionsDialog', {
    attrs: {
      "role-id": _vm.$store.getters.editItemIdPermissions
    }
  }), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.items,
      "hide-actions": "",
      "loading": _vm.loadingInProgress,
      "no-data-text": _vm.loadingItemsText
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.guard_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.updated_at))]), _vm._v(" "), _c('td', {
          staticClass: "justify-left layout px-0"
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.editElementPermissions(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "purple accent-4"
          }
        }, [_vm._v("lock")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.editElement(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteDialog(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("delete")])], 1), _vm._v(" "), _c('ConfirmationDialog', {
          ref: "confirm"
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('AddRoleButton')], 1)
},staticRenderFns: []}

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": "",
      "row": "",
      "fill-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md4": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-12"
  }, [_c('v-toolbar', {
    staticClass: "darken-3",
    attrs: {
      "dark": "",
      "color": "info"
    }
  }, [_c('v-toolbar-title', [_vm._v("Login form")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    attrs: {
      "id": "loginForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkLogin($event)
      }
    }
  }, [_c('v-text-field', {
    attrs: {
      "prepend-icon": "person",
      "id": "userLogin",
      "placeholder": "login"
    },
    model: {
      value: (_vm.userLogin),
      callback: function($$v) {
        _vm.userLogin = $$v
      },
      expression: "userLogin"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "lock",
      "id": "userPassword",
      "placeholder": "password",
      "type": "password"
    },
    model: {
      value: (_vm.userPassword),
      callback: function($$v) {
        _vm.userPassword = $$v
      },
      expression: "userPassword"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  }, [_vm._v("\n          Hard Refresh\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "darken-3",
    attrs: {
      "form": "loginForm",
      "type": "submit",
      "color": "info"
    }
  }, [_vm._v("Login")])], 1)], 1)], 1), _vm._v(" "), _c('AppMainDialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "message": _vm.dialogMessage
    },
    on: {
      "closedialog": function($event) {
        _vm.dialogOpen = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "290",
      "persistent": ""
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.cancel($event)
      }
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-card-text', {
    staticClass: "text-md-center"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-card-actions', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.agree($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.sbmtText))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    attrs: {
      "fab": "",
      "bottom": "",
      "right": "",
      "color": "pink",
      "dark": "",
      "fixed": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialog = !_vm.dialog
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "800px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-4 py-4 title"
  }, [_vm._t("title")], 2), _vm._v(" "), _c('v-container', {
    staticClass: "pa-4",
    attrs: {
      "grid-list-sm": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_vm._t("itemInputField", null, {
    "model": _vm.model
  })], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "Amount"
    },
    model: {
      value: (_vm.amount),
      callback: function($$v) {
        _vm.amount = $$v
      },
      expression: "amount"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Is available"
    },
    model: {
      value: (_vm.isAvailable),
      callback: function($$v) {
        _vm.isAvailable = $$v
      },
      expression: "isAvailable"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Is external vendor"
    },
    model: {
      value: (_vm.isVendor),
      callback: function($$v) {
        _vm.isVendor = $$v
      },
      expression: "isVendor"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Edit checklist for the item after saving"
    },
    model: {
      value: (_vm.editCheckListAfterSave),
      callback: function($$v) {
        _vm.editCheckListAfterSave = $$v
      },
      expression: "editCheckListAfterSave"
    }
  })], 1), _vm._v(" "), (_vm.savedItemId > 0) ? _c('ItemCheckList', {
    attrs: {
      "item-id": _vm.savedItemId,
      "item-type": _vm.itemTypeID
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', [(_vm.savedItemId === 0) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.saveNew
    }
  }, [_vm._v("Save")]) : _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": ""
    }
  }, [_vm._v("Saved")]), _vm._v(" "), (_vm.savedItemId === 0) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancel")]) : _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Close dialog")])], 1)], 1)], 1), _vm._v(" "), _c('AppMainDialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "message": _vm.dialogMessage
    },
    on: {
      "closedialog": function($event) {
        _vm.dialogOpen = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$can('view', 'cases-details')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('h2', [_vm._v("Case Description")]), _vm._v(" "), _c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [(_vm.caseData && _vm.caseData.id) ? _c('div', [(_vm.$can('view', 'cases-detail-case-description-tab')) ? _c('v-layout', {
    attrs: {
      "id": "case-description-tab",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('CaseUserCreatedDataTable', {
    attrs: {
      "caseid": _vm.caseData.id,
      "caseModel": _vm.caseData
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('CaseCrewDataTable', {
    attrs: {
      "case": _vm.caseData,
      "caseid": _vm.caseData.id
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.caseData.plans_id > 0) ? _c('CasePlanDataTable', {
    attrs: {
      "caseData": _vm.caseData,
      "plansid": _vm.caseData.plans_id,
      "casesid": _vm.id
    },
    on: {
      "updatePaymentMethod": _vm.updatePaymentMethod,
      "updatePaymentInfo": _vm.updatePaymentInfo
    }
  }) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'vendor')) ? _c('v-layout', {
    attrs: {
      "id": "case-description-tab",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('v-list', [(_vm.formAnswer) ? _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Location of Wake")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [_c('span', [_vm._v("\n                        " + _vm._s(_vm.formAnswer.form_answers.main_form.deceased_location_of_wake) + "\n                      ")])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Wake Start Date")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [(_vm.caseData.is_preplan) ? _c('span', [_vm._v("\n                        N/A (preplan)\n                      ")]) : _c('span', [_vm._v("\n                        " + _vm._s(_vm.moment(_vm.caseData.wake_start).format('YYYY-MM-DD')) + "\n                      ")])])], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Wake End Date")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [(_vm.caseData.is_preplan) ? _c('span', [_vm._v("\n                        N/A (preplan)\n                      ")]) : _c('span', [_vm._v("\n                        " + _vm._s(_vm.moment(_vm.caseData.wake_end).format('YYYY-MM-DD')) + "\n                      ")])])], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Sending Time")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [(_vm.caseData.is_preplan) ? _c('span', [_vm._v("\n                        N/A (preplan)\n                      ")]) : _c('span', [_vm._v("\n                        " + _vm._s(_vm.caseData.wake_sending_time ? _vm.caseData.wake_sending_time : '-') + "\n                      ")])])], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Leave Office Time")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [(_vm.caseData.is_preplan) ? _c('span', [_vm._v("\n                        N/A (preplan)\n                      ")]) : _c('span', [_vm._v("\n                        " + _vm._s(_vm.caseData.leave_office_time ? _vm.caseData.leave_office_time : '-') + "\n                      ")])])], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Leave Wake Time")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [(_vm.caseData.is_preplan) ? _c('span', [_vm._v("\n                        N/A (preplan)\n                      ")]) : _c('span', [_vm._v("\n                        " + _vm._s(_vm.caseData.leave_wake_time ? _vm.caseData.leave_wake_time : '-') + "\n                      ")])])], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Cremation / Burial Time")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [(_vm.caseData.is_preplan) ? _c('span', [_vm._v("\n                        N/A (preplan)\n                      ")]) : _c('span', [_vm._v("\n                        " + _vm._s(_vm.caseData.leave_funeral_time ? _vm.caseData.leave_funeral_time : '-') + "\n                      ")])])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$can('view', 'cases-manager-details')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('h2', [_vm._v("Case Manager")]), _vm._v(" "), _c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [(_vm.caseData && _vm.caseData.id) ? _c('v-tabs', {
    attrs: {
      "show-arrows": ""
    },
    model: {
      value: (_vm.selectedTab1),
      callback: function($$v) {
        _vm.selectedTab1 = $$v
      },
      expression: "selectedTab1"
    }
  }, [(_vm.$can('view', 'cases-detail-plan-tab')) ? _c('v-tab', {
    attrs: {
      "href": "#plan-tab"
    }
  }, [_vm._v("\n            Package\n          ")]) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-client-tab')) ? _c('v-tab', {
    attrs: {
      "href": "#client-tab"
    }
  }, [_vm._v("\n            Client\n          ")]) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-services-tab')) ? _c('v-tab', {
    attrs: {
      "href": "#services-tab"
    }
  }, [_vm._v("\n            Vendors\n          ")]) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-embalming-tab')) ? _c('v-tab', {
    attrs: {
      "href": "#embalming-tab"
    }
  }, [_vm._v("\n            Embalming\n          ")]) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-agreement-feedback-tab')) ? _c('v-tab', {
    attrs: {
      "href": "#agreement-feedback-tab"
    }
  }, [_vm._v("\n            Customer Feedback\n          ")]) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-plan-tab')) ? _c('v-tab-item', {
    attrs: {
      "id": "plan-tab"
    }
  }, [_c('SelectPlanAndVendors', {
    attrs: {
      "caseData": _vm.caseData,
      "case-id": _vm.caseData.id,
      "editable": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-client-tab')) ? _c('v-tab-item', {
    attrs: {
      "id": "client-tab"
    }
  }, [_c('CaseClientDataTable', {
    attrs: {
      "caseModel": _vm.caseData
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-services-tab')) ? _c('v-tab-item', {
    attrs: {
      "id": "services-tab"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('CaseServicesDataTable', {
    attrs: {
      "casesid": _vm.caseData.id
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-embalming-tab')) ? _c('v-tab-item', {
    attrs: {
      "id": "embalming-tab"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h3', [_vm._v("\n                    Photo\n                  ")]), _vm._v(" "), (_vm.caseData.embalmers_photo) ? _c('v-img', {
    attrs: {
      "aspect-ratio": "1",
      "src": _vm.caseData.embalmers_photo
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h3', [_vm._v("\n                    Remarks\n                  ")]), _vm._v("\n                  " + _vm._s(_vm.caseData.embalmers_remarks) + "\n                ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-agreement-feedback-tab')) ? _c('v-tab-item', {
    attrs: {
      "id": "agreement-feedback-tab"
    }
  }, [_c('CaseAgreementFeedback', {
    attrs: {
      "caseModel": _vm.caseData,
      "selectedTab1": _vm.selectedTab1
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('h2', [_vm._v("Finance/Admin")]), _vm._v(" "), _c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [(_vm.caseData && _vm.caseData.id) ? _c('v-tabs', {
    attrs: {
      "show-arrows": ""
    },
    model: {
      value: (_vm.selectedTab2),
      callback: function($$v) {
        _vm.selectedTab2 = $$v
      },
      expression: "selectedTab2"
    }
  }, [(_vm.$can('view', 'cases-detail-pdf-tab')) ? _c('v-tab', {
    attrs: {
      "href": "#pdf-tab"
    }
  }, [_vm._v("\n            Vendor Invoices\n          ")]) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-actions-log-tab')) ? _c('v-tab', {
    attrs: {
      "href": "#actions-log-tab"
    }
  }, [_vm._v("\n            Actions Log\n          ")]) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-deposits-tab')) ? _c('v-tab', {
    attrs: {
      "href": "#deposits-tab"
    }
  }, [_vm._v("\n            Deposit\n          ")]) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-commissions-tab')) ? _c('v-tab', {
    attrs: {
      "href": "#commissions-tab"
    }
  }, [_vm._v("\n            Commissions\n          ")]) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-chat-tab')) ? _c('v-tab', {
    attrs: {
      "href": "#chat-tab"
    }
  }, [_vm._v("\n            Chat\n          ")]) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-readjustment-tab')) ? _c('v-tab', {
    attrs: {
      "href": "#readjustment-tab"
    }
  }, [_vm._v("\n            Readjustment\n          ")]) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-pdf-tab')) ? _c('v-tab-item', {
    attrs: {
      "id": "pdf-tab"
    }
  }, [(_vm.$can('view', 'cases-detail-invoices')) ? _c('v-card', [_c('v-card-text', [_c('CaseInvoicesDataTable', {
    attrs: {
      "casesid": _vm.caseData.id
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-actions-log-tab')) ? _c('v-tab-item', {
    attrs: {
      "id": "actions-log-tab"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('CaseActionsLogDataTable', {
    attrs: {
      "casesid": _vm.caseData.id,
      "is-personal": ""
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-deposits-tab')) ? _c('v-tab-item', {
    attrs: {
      "id": "deposits-tab"
    }
  }, [_c('CaseDeposit', {
    attrs: {
      "caseModel": _vm.caseData
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-commissions-tab')) ? _c('v-tab-item', {
    attrs: {
      "id": "commissions-tab"
    }
  }, [_c('CaseCommissions', {
    attrs: {
      "caseModel": _vm.caseData
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-chat-tab')) ? _c('v-tab-item', {
    attrs: {
      "id": "chat-tab"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('CaseFormsChat', {
    attrs: {
      "casesid": _vm.caseData.id
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-readjustment-tab')) ? _c('v-tab-item', {
    attrs: {
      "id": "readjustment-tab"
    }
  }, [_c('CaseReadjustment', {
    attrs: {
      "caseModel": _vm.caseData
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('h2', [_vm._v("Lunar Calendar Conversion Test Page")]), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-container', {
    staticClass: "pa-4",
    attrs: {
      "grid-list-sm": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md4": "",
      "xs12": "",
      "align-left": "",
      "justify-space-between": ""
    }
  }, [_c('h3', [_vm._v("Gregorian Input")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-menu', {
    model: {
      value: (_vm.menuDateStart),
      callback: function($$v) {
        _vm.menuDateStart = $$v
      },
      expression: "menuDateStart"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Select Gregorian Date",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": ""
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Number of days to deduct",
      "value": "7 days",
      "type": "text"
    },
    model: {
      value: (_vm.days),
      callback: function($$v) {
        _vm.days = $$v
      },
      expression: "days"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.calc($event)
      }
    }
  }, [_vm._v("Calculate Lunar Date")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "offset-md1": "",
      "xs12": "",
      "align-left": "",
      "justify-space-between": ""
    }
  }, [_c('h3', [_vm._v("Lunar Result")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.resultsLoaded) ? _c('v-text-field', {
    attrs: {
      "label": "Lunar date",
      "type": "text",
      "disabled": ""
    },
    model: {
      value: (_vm.lunarStartDate),
      callback: function($$v) {
        _vm.lunarStartDate = $$v
      },
      expression: "lunarStartDate"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.resultsLoaded) ? _c('v-text-field', {
    attrs: {
      "label": ("Lunar date minus " + _vm.days),
      "value": "7 days",
      "type": "text",
      "disabled": ""
    },
    model: {
      value: (_vm.lunarFinalDate),
      callback: function($$v) {
        _vm.lunarFinalDate = $$v
      },
      expression: "lunarFinalDate"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loggedAndGotRoles) ? _c('div', [_c('AppNavigation', {
    attrs: {
      "items": _vm.items
    }
  }), _vm._v(" "), _c('AppToolbar')], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    attrs: {
      "fab": "",
      "bottom": "",
      "right": "",
      "color": "pink",
      "dark": "",
      "fixed": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialog = !_vm.dialog
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "800px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-container', {
    staticClass: "pa-4",
    attrs: {
      "grid-list-sm": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.inventoriesList,
      "label": "Select inventories",
      "multiple": ""
    },
    model: {
      value: (_vm.selectedInventories),
      callback: function($$v) {
        _vm.selectedInventories = $$v
      },
      expression: "selectedInventories"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.saveNew
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "700px",
      "persistent": ""
    },
    on: {
      "update:returnValue": _vm.setEditItemIdZero
    },
    model: {
      value: (_vm.dialogResult),
      callback: function($$v) {
        _vm.dialogResult = $$v
      },
      expression: "dialogResult"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Login"
    },
    model: {
      value: (_vm.itemData.username),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "username", $$v)
      },
      expression: "itemData.username"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Name"
    },
    model: {
      value: (_vm.itemData.name),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "name", $$v)
      },
      expression: "itemData.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Phone",
      "rules": _vm.contactNumberRules
    },
    model: {
      value: (_vm.itemData.phone),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "phone", $$v)
      },
      expression: "itemData.phone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "outline": "",
      "label": "Description"
    },
    model: {
      value: (_vm.itemData.description),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "description", $$v)
      },
      expression: "itemData.description"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Email",
      "rules": _vm.emailRules
    },
    model: {
      value: (_vm.itemData.email),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "email", $$v)
      },
      expression: "itemData.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.rolesList,
      "multiple": "",
      "label": "Roles"
    },
    model: {
      value: (_vm.selectedRoles),
      callback: function($$v) {
        _vm.selectedRoles = $$v
      },
      expression: "selectedRoles"
    }
  })], 1), _vm._v(" "), (_vm.itemData.id) ? _c('UserServices', {
    attrs: {
      "user-id": _vm.itemData.id,
      "is-vendor": _vm.vendorIsSelected
    }
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "password",
      "type": "password"
    },
    model: {
      value: (_vm.itemData.password),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "password", $$v)
      },
      expression: "itemData.password"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Is vendor"
    },
    model: {
      value: (_vm.itemData.is_vendor),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "is_vendor", $$v)
      },
      expression: "itemData.is_vendor"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": ""
    }
  }, [(_vm.avatar) ? _c('v-img', {
    attrs: {
      "size": "50",
      "aspect-ratio": "1",
      "src": _vm.avatar
    }
  }) : _vm._e(), _vm._v(" "), (_vm.uploadPercentage !== 0 && _vm.uploadPercentage !== 100) ? _c('v-progress-linear', {
    attrs: {
      "value": _vm.uploadPercentage,
      "color": "light-blue"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-3 ml-0",
    attrs: {
      "color": "primary",
      "disabled": _vm.disabled.uploadPhotoForEmbalmersBtn,
      "loading": _vm.disabled.uploadPhotoForEmbalmersBtn,
      "prepend-icon": _vm.uploadStatus,
      "type": "file"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.inputUpload.click()
      }
    }
  }, [_vm._v("Upload Optional Photo\n      ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "inputUpload",
    attrs: {
      "accept": "image/*, .jpg, .jpeg, .png",
      "type": "file"
    },
    on: {
      "change": _vm.onChange
    }
  }), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "bottom": "",
      "color": "success",
      "multi-line": "",
      "timeout": 2000
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n        Image uploaded\n      ")]), _vm._v(" "), (_vm.courses.length > 0) ? _c('v-flex', {
    staticClass: "text-md-left",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "items": _vm.courses,
      "headers": _vm.coursesTableHeaders,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.course_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.course_completion_percent))])]
      }
    }], null, false, 3030427828)
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editItemDataDecorator($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.dialogClose($event)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.items,
      "loading": _vm.loadingInProgress,
      "no-data-text": _vm.loadingItemsText,
      "rows-per-page-items": _vm.rowsPerPageItems,
      "pagination": _vm.pagination,
      "hide-actions": ""
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.invoice_number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.deceased_location_of_wake))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.plan ? props.item.plan.name : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.manager_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.wake_end ? props.item.wake_end : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
          staticClass: "justify-left layout px-0"
        }, [(!_vm.crewSelecting) ? _c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [(_vm.detailCaseButtonActionIsDefault) ? _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.goCasesDetail(props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "indigo"
          }
        }, [_vm._v("remove_red_eye")])], 1) : _vm._e(), _vm._v(" "), (_vm.detailCaseButtonActionIsGoToCheckListsTab) ? _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.goCasesDetailCheckListsTab(props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "indigo"
          }
        }, [_vm._v("remove_red_eye")])], 1) : _vm._e(), _vm._v(" "), (_vm.detailCaseButtonActionIsGoToInvoicesTab) ? _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.goCasesDetailInvoicesTab(props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "indigo"
          }
        }, [_vm._v("remove_red_eye")])], 1) : _vm._e(), _vm._v("\n          View details\n        ")], 1) : _vm._e(), _vm._v(" "), (_vm.$can('send', 'cases-client-email') && !_vm.crewSelecting) ? _c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "slot": "activator",
            "icon": "",
            "disabled": _vm.disabled.sendReceiptToClient
          },
          on: {
            "click": function($event) {
              return _vm.sendReceiptToClient(props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("mail")])], 1), _vm._v("\n          Send receipt\n        ")], 1) : _vm._e(), _vm._v(" "), _c('ConfirmationDialog', {
          ref: "confirm"
        })], 1)]
      }
    }])
  }), _vm._v(" "), (!_vm.loadingInProgress) ? _c('v-layout', {
    staticClass: "mt-4"
  }, [_c('v-flex', {
    staticClass: "text-sm-center"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pagination.total
    },
    on: {
      "input": _vm.onPageChange
    },
    model: {
      value: (_vm.pagination.current),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "current", $$v)
      },
      expression: "pagination.current"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('AppEditCasesDialog'), _vm._v(" "), _c('CrewDialog'), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.showAlert),
      callback: function($$v) {
        _vm.showAlert = $$v
      },
      expression: "showAlert"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', {
    staticClass: "flex-alert-center"
  }, [_c('v-icon', {
    staticClass: "flex-alert-notification-check",
    attrs: {
      "dark": "",
      "right": ""
    }
  }, [_vm._v("check_circle")]), _vm._v(" " + _vm._s(_vm.alertMessage) + "\n      ")], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "update:returnValue": _vm.setEditItemIdZero
    },
    model: {
      value: (_vm.dialogResult),
      callback: function($$v) {
        _vm.dialogResult = $$v
      },
      expression: "dialogResult"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "text-md-center"
  }, [_c('v-flex', [_c('v-select', {
    attrs: {
      "label": "Event",
      "items": _vm.eventsList
    },
    model: {
      value: (_vm.itemData.events_id),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "events_id", $$v)
      },
      expression: "itemData.events_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "textarea": "",
      "label": "Message"
    },
    model: {
      value: (_vm.itemData.message),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "message", $$v)
      },
      expression: "itemData.message"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-select', {
    attrs: {
      "label": "Recipients",
      "multiple": "",
      "items": _vm.notificationRecipients
    },
    model: {
      value: (_vm.selectedRecipients),
      callback: function($$v) {
        _vm.selectedRecipients = $$v
      },
      expression: "selectedRecipients"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-checkbox', {
    attrs: {
      "label": "Is active"
    },
    model: {
      value: (_vm.itemData.is_active),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "is_active", $$v)
      },
      expression: "itemData.is_active"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editItemDataDecorator($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.dialogClose($event)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', [_c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": 'mdi-map-marker-off',
      "rules": _vm.clientNameRules,
      "label": "Client"
    },
    model: {
      value: (_vm.clientModel),
      callback: function($$v) {
        _vm.clientModel = $$v
      },
      expression: "clientModel"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('AppAddItemButtonBase', {
    attrs: {
      "itemTypeID": _vm.itemType
    },
    scopedSlots: _vm._u([{
      key: "itemInputField",
      fn: function(props) {
        return [_c('v-text-field', {
          attrs: {
            "placeholder": "Service name"
          },
          model: {
            value: (props.model.name),
            callback: function($$v) {
              _vm.$set(props.model, "name", $$v)
            },
            expression: "props.model.name"
          }
        })]
      }
    }])
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("\n    Add Service\n  ")])], 2)
},staticRenderFns: []}

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    attrs: {
      "fab": "",
      "bottom": "",
      "right": "",
      "color": "pink",
      "dark": "",
      "fixed": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialog = !_vm.dialog
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "800px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-4 py-4 title"
  }, [_vm._v("\n        Add PDF Template\n      ")]), _vm._v(" "), _c('v-container', {
    staticClass: "pa-4",
    attrs: {
      "grid-list-sm": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.formsList,
      "label": "Form ID"
    },
    model: {
      value: (_vm.selectedForm),
      callback: function($$v) {
        _vm.selectedForm = $$v
      },
      expression: "selectedForm"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "HTML Body",
      "textarea": ""
    },
    model: {
      value: (_vm.templateBody),
      callback: function($$v) {
        _vm.templateBody = $$v
      },
      expression: "templateBody"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.saveNew
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('AppMainDialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "message": _vm.dialogMessage
    },
    on: {
      "closedialog": function($event) {
        _vm.dialogOpen = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "align-content-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md8": ""
    }
  }, [(_vm.isManagement) ? _c('v-select', {
    attrs: {
      "items": _vm.vendorsList,
      "item-text": "name",
      "item-value": "id",
      "placeholder": "Select the vendor"
    },
    model: {
      value: (_vm.selectedVendor),
      callback: function($$v) {
        _vm.selectedVendor = $$v
      },
      expression: "selectedVendor"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "md8": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "file",
      "accept": ".jpeg,.jpg,.png,.doc,.docx,.pdf,.xls,.xlsx"
    },
    nativeOn: {
      "change": function($event) {
        return _vm.onInvoiceFileChange($event)
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md2": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "type": "submit",
      "block": ""
    },
    on: {
      "click": _vm.uploadInvoice
    }
  }, [_vm._v("Upload")])], 1)], 1)], 1), _vm._v(" "), _c('AppMainDialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "message": _vm.dialogMessage
    },
    on: {
      "closedialog": function($event) {
        _vm.dialogOpen = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "update:returnValue": _vm.setEditItemIdZero
    },
    model: {
      value: (_vm.dialogResult),
      callback: function($$v) {
        _vm.dialogResult = $$v
      },
      expression: "dialogResult"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "text-md-center"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Name"
    },
    model: {
      value: (_vm.itemData.name),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "name", $$v)
      },
      expression: "itemData.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "Amount"
    },
    model: {
      value: (_vm.itemData.amount),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "amount", $$v)
      },
      expression: "itemData.amount"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Is available"
    },
    model: {
      value: (_vm.itemData.is_available),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "is_available", $$v)
      },
      expression: "itemData.is_available"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Is external vendor"
    },
    model: {
      value: (_vm.itemData.is_vendor),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "is_vendor", $$v)
      },
      expression: "itemData.is_vendor"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-md-left",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [(_vm.itemLoaded) ? _c('ItemCheckList', {
    attrs: {
      "item-id": _vm.itemData.id,
      "item-type": _vm.itemType
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editItemData($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.dialogClose($event)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card-text', [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "pb-3": ""
    }
  }, [_c('h3', [_vm._v("Important: Terms and Conditions 条款及条件")])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('ul', {
    staticClass: "dashed"
  }, [_c('li', [_vm._v("Embalming results may vary depending on the condition of the deceased. 遗体修复和定妆因人而异。")]), _vm._v(" "), _c('li', [_vm._v("Items listed are not exchangeable or refundable for cash.  无论在任何情况下，所购契约不能退回或对换成现金。")]), _vm._v(" "), _c('li', [_vm._v("Full payment to be collected on the final day of the funeral. 礼仪结束后，必须交付所购契约的价格。")]), _vm._v(" "), _c('li', [_vm._v("Use of parlour subject to availability. 追思礼堂使用悉视其屈时供应的情况而定。")]), _vm._v(" "), _c('li', [_vm._v("Package excludes burial plots, niches and tombstone. 此契约不包括福地,骨灰神主牌位及墓碑。")]), _vm._v(" "), _c('li', [_vm._v("Additional nights and/or items are chargeable. 若超过限定的殡葬礼仪服务或者额外的物品，公司将附加收费。")]), _vm._v(" "), _c('li', [_vm._v("Items listed are subjected to change without prior notice and may be substituted with an item of similar value at the company’s sole discretion.  所列项目如有更改，恕不另行通知，公司自行决定并可能取代同等价值的项目。")]), _vm._v(" "), _c('li', [_vm._v("Clearance of condolence stands can be arranged with our vendor at $150 per trip. 葬礼结束后，清理花圈服务为每趟，$150.")]), _vm._v(" "), _c('li', [_vm._v("Some items are on rental basis. 某些物品是以出租模式进行。")]), _vm._v(" "), _c('li', [_vm._v("Payment via cash, cheque, visa or master only. 付款方式只限于现金，支票或信用卡。")]), _vm._v(" "), _c('li', [_vm._v("The company shall not be liable for any direct, indirect or consequential losses in the event that the specified hearse  or vehicle is not available as a result of circumstances beyond its control, provided that an alternative mode of conveyance or transport is made available.  任何由于某些无可预測的缘故或是发生任何超出公司所能控制的状况，即使指定的灵车或交通工具无法被使用，公司将有权以其他运输或交通方式代替，而无需承担任何责任。")]), _vm._v(" "), _c('li', [_vm._v("All prices listed subjected prevailing GST rate. 价格需加消费税. 消费税会以出殡日当天的百分率作为标准。")]), _vm._v(" "), _c('li', [_vm._v("All prices listed are in Singapore dollars. 价格都以新元计算")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "pb-3": ""
    }
  }, [_c('br'), _vm._v(" "), _c('h3', [_vm._v("Terms and Conditions for Pre - planning client 条款及条件:")])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('ul', {
    staticClass: "dashed"
  }, [_c('li', [_vm._v("Package excludes burial plots, niches, urns and tombstone. 此契约不包括福地，骨灰神主牌位, 骨灰瓮及墓碑。")]), _vm._v(" "), _c('li', [_vm._v("Full payment and any additional fees not included in the stipulated package will be payable by next in kin/executor on funeral day. 差额和外加的费用由近亲属在出殡日当天付清。")]), _vm._v(" "), _c('li', [_vm._v("A fixed rate of $1000 deposit will be collected upon confirmation of this agreement. 签订契约时必需交付$1000押金。")]), _vm._v(" "), _c('li', [_vm._v("Deposit is refundable. 存款可退还。")]), _vm._v(" "), _c('li', [_vm._v("Administration charge of $250 will be applicable upon cancellation of agreement. 取消契约必需交付$250的手续费。")]), _vm._v(" "), _c('li', [_vm._v("All prices listed are true and will only be valid for 5 years from the date of agreement. Upon the 5 years due date, client will be updated of any change in package, prices, products or terms and conditions. ")]), _vm._v(" "), _c('li', [_vm._v("价格的有效日期为五年。有效日期过后，若配套，价格，产品，条件有任何改变，公司会通知受益者或近亲属。")]), _vm._v(" "), _c('li', [_vm._v("All prices listed are in Singapore Dollars and includes prevailing GST rate. 价格是以新币计算也包括消费税。消费税会以出殡日当天的百分率作为标准。")]), _vm._v(" "), _c('li', [_vm._v("Both beneficiary and executor fully understand the package, terms and conditions and both parties is present to sign this agreement in the presence of a Direct Funeral Services representative. 我们完全理解配套和契约的条款及条件，并在双方的同意和见证下签下此契约。")]), _vm._v(" "), _c('li', [_vm._v("Both beneficiary and executor have confirmed and agreed that you have given consent to Direct Funeral Services Pte Ltd on the collection, use and disclosure of my personal data for administrative and marketing purposes. 我们同意将本资料交由郑海船生命礼仪作为行政和营销用途。")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "pb-3": ""
    }
  }, [_c('br'), _vm._v(" "), _c('h3', [_vm._v("Terms and Conditions for export client 条款及条件:")])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('ul', {
    staticClass: "dashed"
  }, [_c('li', [_vm._v("Direct Funeral Services will be discharge of all responsibilities of the deceased upon sending him/her to the airport/ferry terminal.")]), _vm._v(" "), _c('li', [_vm._v("Direct Funeral Services will not be liable for any form of body discolouration, damage and loss of belongings, during transit.")]), _vm._v(" "), _c('li', [_vm._v("Client has to arranged for a funeral director in their home country to receive the deceased from the airport/ferry terminal.")]), _vm._v(" "), _c('li', [_vm._v("All payment have to made prior to sending the deceased to the airport/ferry terminal.")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "pb-3": ""
    }
  }, [_c('br'), _vm._v(" "), _c('h3', [_vm._v("Terms and Conditions for import client 条款及条件:")])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('ul', {
    staticClass: "dashed"
  }, [_c('li', [_vm._v("Direct Funeral Services will not be responsible for booking of flight/ferry into Singapore.")]), _vm._v(" "), _c('li', [_vm._v("Client is to provide all documents necessary for Direct Funeral Services to apply for Singapore import permit.")]), _vm._v(" "), _c('li', [_vm._v("Direct Funeral Services will not be liable for any form of body discolouration, damage and loss of belongings, during transit.")]), _vm._v(" "), _c('li', [_vm._v("Touch up of the embalming will be performed at Direct Funeral Services discretion.")]), _vm._v(" "), _c('li', [_vm._v("All embalming, funeral services will be charged separately.")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "pb-3": ""
    }
  }, [_c('br'), _vm._v(" "), _c('h3', [_vm._v("Terms and Conditions for at need client 条款及条件:")])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('p', [_c('b', [_vm._v("WITH EMBALMING")]), _c('br'), _vm._v("\nI (We) acknowledge that this authorisation encompasses permission to embalm my/our beloved one at the designated embalming facility. I (We) acknowledge and understand that the embalming process is irreversible and that it may involve reconstructive surgery and other practices deemed necessary to prepare the body for burial or cremation.  I (We) acknowledge and understand the body and skin condition post embalming varies accordingly to the pre existing body condition.")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('p', [_c('b', [_vm._v("WITHOUT EMBALMING")]), _c('br'), _vm._v("\nI (We) acknowledge that this authorisation encompasses permission for preparation of my/our beloved one. I (We) acknowledge and understand that this does not include any process of preservation and the deceased is not presented for public viewing. I (We) acknowledge and understand that due to the natural breaking process of the body, we may encounter unfamiliar smell and observe changes on the body.")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('p', [_vm._v("\n        I fully understand all cost for ashes placement, rites and arrangement is not included in the package."), _c('br'), _vm._v("\n  I have been briefed that funeral packages start from:"), _c('br'), _vm._v("\n$4,900.60 (Buddhist Simplicity package without tentage) and up."), _c('br'), _vm._v("\n$7,584.16  (Taoist Basic package without tentage) and up."), _c('br'), _vm._v("\n$4,278.93 (Christian Peace package without tentage) and up.\n      ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "pb-3": ""
    }
  }, [_c('br'), _vm._v(" "), _c('h3', [_vm._v("Payment Terms")])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('p', [_vm._v("Please take note for settlement of invoice, you have the convenience of settling it on the funeral day or within 3 working days at our office, located at 127 Lavender Street Singapore 338735. Our office opening hours is from 8.00am to 7.00pm, Monday to Friday, excluding public holidays. Do call us at 6555 1115 to make an appointment with our Funeral Director or Finance office prior to coming over for payment settlement.")]), _vm._v(" "), _c('ul', {
    staticClass: "dashed"
  }, [_c('li', [_vm._v("Cash Payment: 127 Lavender Street Singapore 338735, by appointment only")]), _vm._v(" "), _c('li', [_vm._v("Cheque Payment: Issue a crossed cheque and mail to 127 Lavender Street Singapore 338735")]), _vm._v(" "), _c('li', [_vm._v("Credit card payment: 127 Lavender Street Singapore 338735, Visa or Master cards, by appointment only")]), _vm._v(" "), _c('li', [_vm._v("Bank transfer to the following:"), _c('br'), _vm._v("\n          DBS Current Account 025 903 313 7"), _c('br'), _vm._v("\n  Bank account name Direct Funeral Services Pte Ltd"), _c('br'), _vm._v("\n  Bank code 7171"), _c('br'), _vm._v("\n  Branch code 025"), _c('br'), _vm._v("\n  Swift code DBSSSGSG"), _c('br'), _vm._v(" \n  Bank address: 12 Marina Boulevard, DBS Asia Central, MBFC Tower 3, Singapore 018982"), _c('br')])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('br'), _vm._v(" "), _c('p', [_vm._v("\n        We, have acknowledged receipt and accepted the above mentioned Service Agreement that outlines the terms and conditions of the services provided. We acknowledge that the funeral director has explained the packages and services adequately, provided me with a quotation and gone through the preparation list*. In addition, I/We confirm and consent to give Direct Funeral Services on the collection, use and disclosure of my/our personal data for administrative, invoicing and marketing purposes. I/We hereby authorise “Direct Funeral Services Pte Ltd” to bill ourselves based on the above information provided.\n      ")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-4 py-4 title"
  }, [_vm._v("\n      Select Shifting Crew\n      "), _c('v-spacer')], 1), _vm._v(" "), _c('v-container', {
    staticClass: "pa-4",
    attrs: {
      "grid-list-sm": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "row": "",
      "wrap": ""
    }
  }, [(_vm.servicesList.length > 0 && _vm.caseManagersList.length > 0) ? _c('v-flex', [_c('v-checkbox', {
    attrs: {
      "label": "Preplan"
    },
    model: {
      value: (_vm.isPreplan),
      callback: function($$v) {
        _vm.isPreplan = $$v
      },
      expression: "isPreplan"
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.filterCaseManagers(_vm.servicesList),
      "label": "Select case manager"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n                " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n              ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_vm._v("\n                " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n              ")]
      }
    }], null, false, 2095008220),
    model: {
      value: (_vm.selectedCaseManager.id),
      callback: function($$v) {
        _vm.$set(_vm.selectedCaseManager, "id", $$v)
      },
      expression: "selectedCaseManager.id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-select', {
    attrs: {
      "disabled": _vm.isPreplan,
      "items": _vm.filterPalBearers(_vm.servicesList),
      "item-text": "description",
      "attach": "",
      "chips": "",
      "multiple": "",
      "label": "Select shifting crew"
    },
    on: {
      "input": _vm.limiter
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n                " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n              ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_c('span', {
          staticClass: "v-chip v-chip--select-multi theme--light"
        }, [_c('span', {
          staticClass: "v-chip__content"
        }, [_vm._v("\n                    " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n                  ")])])]
      }
    }], null, false, 1132691999),
    model: {
      value: (_vm.selectedPalbearers),
      callback: function($$v) {
        _vm.selectedPalbearers = $$v
      },
      expression: "selectedPalbearers"
    }
  })], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": "#ff5353",
      "multi-line": "",
      "top": "",
      "right": "",
      "timeout": 6000
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n            You can select no more than three\n            "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("\n              Close\n            ")])], 1)], 1) : _c('v-flex', [_vm._v("Loading...")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "xs12": "",
      "align-left": "",
      "justify-space-between": ""
    }
  }, [_c('v-menu', {
    model: {
      value: (_vm.menuDateStart),
      callback: function($$v) {
        _vm.menuDateStart = $$v
      },
      expression: "menuDateStart"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Select date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateStart),
      callback: function($$v) {
        _vm.dateStart = $$v
      },
      expression: "dateStart"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": ""
    },
    model: {
      value: (_vm.dateStart),
      callback: function($$v) {
        _vm.dateStart = $$v
      },
      expression: "dateStart"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Time",
      "prepend-icon": "alarm",
      "value": "12:30:00",
      "type": "time"
    },
    model: {
      value: (_vm.timeStart),
      callback: function($$v) {
        _vm.timeStart = $$v
      },
      expression: "timeStart"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "outline": "",
      "label": "Details about the upcoming venue"
    },
    model: {
      value: (_vm.venueDescription),
      callback: function($$v) {
        _vm.venueDescription = $$v
      },
      expression: "venueDescription"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary",
      "loading": _vm.loading.saveNewBtn
    },
    on: {
      "click": _vm.saveNew
    }
  }, [_vm._v("Notify staff")])], 1)], 1), _vm._v(" "), _c('AppMainDialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "message": _vm.dialogMessage
    },
    on: {
      "closedialog": function($event) {
        _vm.dialogOpen = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-height"
  }, [_c('v-card-title', [_c('v-flex', {
    attrs: {
      "tag": "h3"
    }
  }, [_vm._v("\n      Case Crew\n    ")])], 1), _vm._v(" "), _c('v-list', {
    staticClass: "no-padding"
  }, [_c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    staticClass: "auth-height",
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Shifting Crew")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [_c('v-select', {
    staticClass: "case-crew-select",
    attrs: {
      "disabled": _vm.disabled.caseCrewSelect || _vm.closed,
      "items": _vm.filterPallBearers(_vm.servicesList, 0),
      "item-text": "description",
      "attach": "",
      "chips": "",
      "clearable": "",
      "multiple": "",
      "disabled": ""
    },
    on: {
      "blur": function($event) {
        return _vm.updatePallbearers(0)
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n          ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_c('span', {
          staticClass: "v-chip v-chip--select-multi theme--light"
        }, [_c('span', {
          staticClass: "v-chip__content"
        }, [_vm._v("\n                " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n              ")])])]
      }
    }]),
    model: {
      value: (_vm.selectedShiftingCrew),
      callback: function($$v) {
        _vm.selectedShiftingCrew = $$v
      },
      expression: "selectedShiftingCrew"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticClass: "no-padding"
  }, [_c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    staticClass: "auth-height",
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Sending Crew")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [_c('v-select', {
    staticClass: "case-crew-select",
    attrs: {
      "disabled": _vm.disabled.caseCrewSelect || _vm.closed,
      "items": _vm.filterPallBearers(_vm.servicesList, 1),
      "item-text": "description",
      "attach": "",
      "chips": "",
      "clearable": "",
      "multiple": "",
      "disabled": ""
    },
    on: {
      "blur": function($event) {
        return _vm.updatePallbearers(1)
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n          ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_c('span', {
          staticClass: "v-chip v-chip--select-multi theme--light"
        }, [_c('span', {
          staticClass: "v-chip__content"
        }, [_vm._v("\n                " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n              ")])])]
      }
    }]),
    model: {
      value: (_vm.selectedSendingCrew),
      callback: function($$v) {
        _vm.selectedSendingCrew = $$v
      },
      expression: "selectedSendingCrew"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticClass: "no-padding"
  }, [_c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    staticClass: "auth-height",
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Funeral Crew")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [_c('v-select', {
    staticClass: "case-crew-select",
    attrs: {
      "disabled": _vm.disabled.caseCrewSelect || _vm.closed,
      "items": _vm.filterPallBearers(_vm.servicesList, 2),
      "item-text": "description",
      "attach": "",
      "chips": "",
      "clearable": "",
      "multiple": "",
      "disabled": ""
    },
    on: {
      "blur": function($event) {
        return _vm.updatePallbearers(2)
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n          ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_c('span', {
          staticClass: "v-chip v-chip--select-multi theme--light"
        }, [_c('span', {
          staticClass: "v-chip__content"
        }, [_vm._v("\n                " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n              ")])])]
      }
    }]),
    model: {
      value: (_vm.selectedFuneralCrew),
      callback: function($$v) {
        _vm.selectedFuneralCrew = $$v
      },
      expression: "selectedFuneralCrew"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "pb-3": ""
    }
  }, [_c('h3', [_vm._v("\n      Terms and Conditions 条款及条件\n    ")])]), _vm._v(" "), _c('v-flex', [_vm._v("\n    Embalming results may vary depending on the condition of the deceased. 遗体修复和定妆因⼈⽽异。\n  ")]), _vm._v(" "), _c('v-flex', [_vm._v("\n    Items listed are not exchangeable or refundable for cash. ⽆论在任何情况下，所购契约不能退回或对换成现⾦。\n  ")]), _vm._v(" "), _c('v-flex', [_vm._v("\n    Full payment to be collected on the final day of the funeral. 礼仪结束后，必须交付所购契约的价格。\n  ")]), _vm._v(" "), _c('v-flex', [_vm._v("\n    Use of parlour subject to availability. 追思礼堂使⽤悉视其屈时供应的情况⽽定。\n  ")]), _vm._v(" "), _c('v-flex', [_vm._v("\n    Package excludes burial plots, niches and tombstone. 此契约不包括福地,⻣灰神主牌位及墓碑。\n  ")]), _vm._v(" "), _c('v-flex', [_vm._v("\n    Additional nights and/or items are chargeable. 若超过限定的殡葬礼仪服务或者额外的物品，公司将附加收费。\n\n  ")]), _vm._v(" "), _c('v-flex', [_vm._v("\n    Items listed are subjected to change without prior notice and may be substituted with an item of similar value at\n  the company’s sole discretion. 所列项⽬如有更改，恕不另⾏通知，公司⾃⾏决定并可能取代同等价值的项⽬。\n  ")]), _vm._v(" "), _c('v-flex', [_vm._v("\n    Some items are on rental basis. 某些物品是以出租模式进⾏。\n\n  ")]), _vm._v(" "), _c('v-flex', [_vm._v("\n    Payment via cash or cheque only. 付款⽅式只限于现⾦和⽀票。\n\n  ")]), _vm._v(" "), _c('v-flex', [_vm._v("\n    The company shall not be liable for any direct, indirect or consequential losses in the event that the specified hearse or vehicle is not available as a result of circumstances beyond its control, provided that an alternative mode of conveyance or transport is made available. 任何由于某些⽆可预測的缘故或是发⽣任何超出公司所能控制的状况，即使指定的灵⻋或交通⼯具⽆法被使⽤，公司将有权以其他运输或交通⽅式代替，⽽⽆需承担任何责任。\n  ")]), _vm._v(" "), _c('v-flex', [_vm._v("\n    All prices are inclusive of 7%GST. 价格包括7%消费税。\n\n  ")]), _vm._v(" "), _c('v-flex', [_vm._v("\n    All prices listed are in Singapore dollars. 价格都以新元计算。\n\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "md3": "",
      "px-1": "",
      "mt-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "date__picker"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Date",
            "prepend-icon": "event",
            "readonly": ""
          },
          model: {
            value: (_vm.date),
            callback: function($$v) {
              _vm.date = $$v
            },
            expression: "date"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "input": function($event) {
        _vm.menu = false
      }
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.items,
      "loading": _vm.loadingInProgress,
      "no-data-text": _vm.loadingItemsText,
      "rows-per-page-items": _vm.rowsPerPageItems,
      "pagination": _vm.pagination,
      "hide-actions": true
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "slotTime",
          class: ("" + (props.item.timeline) + (_vm.checkInvolve(props.item.services)))
        }, [_vm._v(_vm._s(props.item.time))]), _vm._v(" "), _c('td', {
          class: ("" + (props.item.timeline) + (_vm.checkInvolve(props.item.services)))
        }, [_vm._v(_vm._s(props.item.start_time))]), _vm._v(" "), _c('td', {
          class: ("" + (props.item.timeline) + (_vm.checkInvolve(props.item.services)))
        }, [_vm._v(_vm._s(props.item.type))]), _vm._v(" "), _c('td', {
          class: ("" + (props.item.timeline) + (_vm.checkInvolve(props.item.services)))
        }, [_vm._v(_vm._s(props.item.case_manager))]), _vm._v(" "), _c('td', {
          class: ("" + (props.item.timeline) + (_vm.checkInvolve(props.item.services)))
        }, [_vm._v(_vm._s(_vm.getCaseCrew(props.item)))]), _vm._v(" "), _c('td', {
          class: ("" + (props.item.timeline) + (_vm.checkInvolve(props.item.services)))
        }, [_vm._v(_vm._s(props.item.description))]), _vm._v(" "), _c('td', {
          class: ("" + (props.item.timeline) + (_vm.checkInvolve(props.item.services)))
        }, [_vm._v(_vm._s(props.item.case_id))])]
      }
    }])
  }), _vm._v(" "), _c('AddScheduledCaseButton'), _vm._v(" "), (_vm.dateForNewLead) ? _c('AddCaseNameAndDateDialog', {
    attrs: {
      "date": _vm.dateForNewLead
    },
    on: {
      "input": _vm.loadSchedules
    },
    model: {
      value: (_vm.dialogModel),
      callback: function($$v) {
        _vm.dialogModel = $$v
      },
      expression: "dialogModel"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.showAlert),
      callback: function($$v) {
        _vm.showAlert = $$v
      },
      expression: "showAlert"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', {
    staticClass: "flex-center"
  }, [_c('v-icon', {
    staticClass: "notification-check",
    attrs: {
      "dark": "",
      "right": ""
    }
  }, [_vm._v("check_circle")]), _vm._v(" Staff has been notified. "), _c('v-icon', {
    staticClass: "notification-cancel",
    attrs: {
      "dark": "",
      "left": ""
    },
    on: {
      "click": function($event) {
        _vm.alert = false
      }
    }
  }, [_vm._v("cancel")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })
],[432]);


// WEBPACK FOOTER //
// static/js/app.f417fc9eb046920908e9.js